export const STYLES = `
  /* Variable defaults must live on BOTH the root (for the trigger button)
     and the overlay (which is React-portaled to <body> and therefore not
     a descendant of .ps-tryon-root, so the cascade is broken). Without
     this duplication the slider track gradient and the thumb border —
     both var(--ps-accent) — render as unset and become invisible. */
  .ps-tryon-root,
  .ps-tryon-overlay {
    --ps-accent: #3B82F6;
    --ps-accent-hover: #2563EB;
    --ps-accent-light: #BFDBFE;
    --ps-text-primary: #1C1D1E;
    --ps-text-secondary: #454545;
    --ps-text-muted: #84898C;
    --ps-text-dim: #696E71;
    --ps-border-color: #E7E7E7;
    --ps-border-subtle: #F0F0F0;
    --ps-bg-primary: #FFFFFF;
    --ps-bg-secondary: #F8FAFF;
    --ps-bg-tertiary: #F0F0F0;
    --ps-input-bg: #FFFFFF;
    --ps-input-border: #E7E7E7;
    --ps-input-focus-border: var(--ps-accent);
    --ps-error-color: #E7000B;
    --ps-success-color: #1C9D4C;
    --ps-warning-color: #DF8400;
    --ps-logo-height: 2.8vw;
  }
  .ps-tryon-root { display: inline-block; visibility: visible !important; }

  .ps-tryon-btn {
    display: inline-flex; align-items: center; gap: max(6px, 0.42vw);
    padding: var(--ps-btn-padding, max(10px, 0.63vw) max(16px, 1.25vw));
    background: var(--ps-btn-bg, var(--ps-accent)); color: var(--ps-btn-color, #FFFFFF);
    font-family: var(--ps-btn-font, system-ui, -apple-system, sans-serif);
    font-size: var(--ps-btn-font-size, max(13px, 0.73vw)); font-weight: var(--ps-btn-font-weight, 600);
    border: var(--ps-btn-border, none); border-radius: var(--ps-btn-radius, max(6px, 0.42vw));
    cursor: pointer; transition: all 0.2s ease;
    width: var(--ps-btn-width, auto); min-width: var(--ps-btn-min-width, 0);
    max-width: var(--ps-btn-max-width, none); height: var(--ps-btn-height, auto);
    box-shadow: var(--ps-btn-shadow, none); line-height: 1; white-space: nowrap;
    box-sizing: border-box; justify-content: center;
    text-decoration: var(--ps-btn-text-decoration, none);
    text-underline-offset: var(--ps-btn-underline-offset, 3px);
  }
  .ps-tryon-btn svg { width: var(--ps-btn-icon-size, max(16px, 1.1vw)); height: var(--ps-btn-icon-size, max(16px, 1.1vw)); flex-shrink: 0; }
	  .ps-tryon-btn:hover {
	    background: var(--ps-btn-hover-bg, var(--ps-accent-hover));
	    color: var(--ps-btn-hover-color, var(--ps-btn-color, #FFFFFF));
	    transform: translateY(-1px);
	  }
	  .ps-tryon-btn:disabled,
	  .ps-tryon-btn--loading {
	    cursor: wait;
	    opacity: 0.92;
	    transform: none;
	  }
	  .ps-tryon-btn:disabled:hover,
	  .ps-tryon-btn--loading:hover {
	    transform: none;
	  }
	  .ps-tryon-btn-spinner {
	    width: max(14px, 0.95vw);
	    height: max(14px, 0.95vw);
	    border: 2px solid color-mix(in srgb, currentColor 30%, transparent);
	    border-top-color: currentColor;
	    border-radius: 999px;
	    animation: ps-spin 0.72s linear infinite;
	    flex: 0 0 auto;
	  }
	  .ps-tryon-btn:active { transform: translateY(0); }
  .ps-tryon-btn--text {
    background: transparent !important; border: 0 !important; border-radius: 0 !important;
    box-shadow: none !important; padding: 0 !important; min-height: 0; height: auto;
    width: auto; min-width: 0; max-width: none; color: var(--ps-btn-color, var(--ps-accent));
  }
  .ps-tryon-btn--text:hover {
    background: transparent !important;
    color: var(--ps-btn-hover-color, var(--ps-btn-color, var(--ps-accent-hover)));
    transform: none;
  }

  .ps-tryon-overlay {
    position: fixed; inset: 0; background: var(--ps-modal-overlay, rgba(0,0,0,0.6));
    display: flex; align-items: center; justify-content: center;
    z-index: 2147483647;
    pointer-events: auto;
    isolation: isolate;
    contain: layout style;
    padding: 0.83vw;
    padding: max(0.83vw, env(safe-area-inset-top)) max(0.83vw, env(safe-area-inset-right)) max(0.83vw, env(safe-area-inset-bottom)) max(0.83vw, env(safe-area-inset-left));
    animation: ps-fade-in 0.2s ease;
    overflow-y: auto; -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    font-family: system-ui, -apple-system, sans-serif;
    -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }
  .ps-tryon-overlay, .ps-tryon-overlay *, .ps-tryon-overlay *::before, .ps-tryon-overlay *::after { box-sizing: border-box; }
  @keyframes ps-fade-in { from { opacity: 0; } to { opacity: 1; } }

  .ps-tryon-modal {
    background: var(--ps-modal-bg, #FFFFFF); color: var(--ps-modal-color, #1C1D1E);
    border-radius: clamp(8px, 0.83vw, 16px); width: var(--ps-modal-width, 100%);
    max-width: var(--ps-modal-max-width, 36vw); max-height: 92dvh; overflow-y: auto;
    font-family: var(--ps-modal-font, system-ui, -apple-system, sans-serif);
    box-shadow: 0 8px 40px rgba(0,0,0,0.12); animation: ps-slide-up 0.3s ease;
    scrollbar-width: thin; scrollbar-color: var(--ps-border-color) transparent;
    flex-shrink: 0;
    container-type: inline-size;
    overscroll-behavior: contain;
  }
  .ps-tryon-modal-wide {
    /* Use the SMALLER of 55vw or 92dvh×(16/10) for width so the modal
       never gets wider than the height can support. Height bumped from
       70dvh → 82dvh to fit the longer accessory photo step (guidelines +
       legal notice + nav) without pushing content under the Analyze CTA. */
    width: min(55vw, calc(92dvh * 1.6));
    max-width: min(55vw, calc(92dvh * 1.6));
    height: min(82dvh, calc(55vw / 1.35));
    max-height: min(92dvh, calc(55vw / 1.35));
    display: flex; flex-direction: column; overflow: hidden;
    transition: height 0.45s cubic-bezier(0.32, 0.72, 0, 1), max-height 0.45s cubic-bezier(0.32, 0.72, 0, 1);
  }
  .ps-tryon-modal-tall.ps-tryon-modal-wide {
    height: min(92dvh, calc(55vw / 1.2));
    max-height: min(95dvh, calc(55vw / 1.2));
  }
  .ps-tryon-modal:has(.ps-tryon-drawer-open) { overflow: hidden; }
  @keyframes ps-slide-up { from { opacity: 0; } to { opacity: 1; } }

  /* Header */
  .ps-tryon-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: max(8px, 0.7vw) max(12px, 1.25vw);
    background: var(--ps-modal-header-bg, rgba(255,255,255,0.95));
    border-bottom: 1px solid var(--ps-border-color);
    border-radius: max(8px, 0.83vw) max(8px, 0.83vw) 0 0;
    backdrop-filter: blur(12px); flex-shrink: 0;
  }
  .ps-tryon-header-minimal {
    justify-content: flex-end; gap: 0.4vw; padding: 0.4vw 0.8vw;
  }
  .ps-tryon-back-btn {
    display: flex; align-items: center; gap: 0.35vw;
    background: none; border: none; color: var(--ps-text-secondary); cursor: pointer;
    font-size: 0.73vw; padding: 0; margin-bottom: 0.63vw;
    transition: color 0.2s;
  }
  .ps-tryon-back-btn:hover { color: var(--ps-text-primary); }
  .ps-tryon-back-btn svg { width: 1vw; height: 0.63vw; stroke: currentColor; flex-shrink: 0; }

  /* Regen progress bar — absolutely-positioned fill div inside the
     "Generating new try-on…" button. Animation runs at the browser's
     refresh rate (smooth) instead of via React state ticks. The button
     itself sets position: relative + overflow: hidden so the fill is
     clipped to the button's rounded shape. */
  @keyframes ps-tryon-regen-fill {
    from { width: 0%; }
    to { width: 100%; }
  }
  .ps-tryon-regen-fill {
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 0%;
    background: rgba(255, 255, 255, 0.28);
    animation: ps-tryon-regen-fill 22s linear forwards;
    pointer-events: none;
    z-index: 0;
  }
  .ps-tryon-title { display: flex; align-items: center; }
  .ps-tryon-logo-img { height: var(--ps-logo-height); width: auto; }
  .ps-tryon-header-actions { display: flex; align-items: center; gap: 0.42vw; }
  .ps-tryon-header-icon {
    /* Pure vw sizing collapsed to ~8 px on 375 px mobile. Clamp so the icon
       stays finger-tappable (min 30 px) while scaling up on large screens. */
    width: clamp(30px, 2.2vw, 34px); height: clamp(30px, 2.2vw, 34px);
    display: flex; align-items: center; justify-content: center;
    border: 1.5px solid var(--ps-border-color); border-radius: clamp(6px, 0.52vw, 10px); background: transparent;
    cursor: pointer; color: var(--ps-text-secondary); transition: all 0.2s;
  }
  .ps-tryon-header-icon:hover { border-color: var(--ps-accent); color: var(--ps-accent); }
  .ps-tryon-header-icon svg { stroke: currentColor; fill: none; width: clamp(14px, 0.9vw, 16px); height: clamp(14px, 0.9vw, 16px); }
  /* Labeled variant — icon + text. Auto width, vw-scaled padding/gap so the
     glyph and the label baseline-align cleanly across breakpoints. */
  .ps-tryon-header-icon-labeled {
    width: auto !important;
    padding: 0 clamp(8px, 0.6vw, 12px);
    gap: clamp(5px, 0.42vw, 8px);
    font-size: clamp(11px, 0.73vw, 13px);
    font-family: inherit;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;
  }
  .ps-tryon-header-icon-label { line-height: 1; }
  /* "Powered by PrimeStyleAI" — left-aligned tag in the modal header,
     links out to primestyleai.com in a new tab. */
  .ps-tryon-powered-by {
    margin-right: auto;
    font-size: clamp(10px, 0.68vw, 12px);
    color: #9aa0a6;
    letter-spacing: 0.04em;
    font-weight: 400;
    line-height: 1.4;
    text-transform: uppercase;
    white-space: nowrap;
    text-decoration: none;
    transition: color 0.2s;
  }
  .ps-tryon-powered-by:hover { color: #5a6168; }
  .ps-tryon-powered-by:hover strong { color: var(--ps-accent); }
  .ps-tryon-powered-by strong { color: #5a6168; font-weight: 600; letter-spacing: 0.02em; text-transform: none; transition: color 0.2s; }
  /* Mobile hamburger button (desktop: hidden — inline buttons handle this) */
  .ps-tryon-header-mobile-menu-btn { display: none; }
  .ps-tryon-header-mobile-backdrop { display: none; }
  .ps-tryon-header-mobile-menu { display: none; }
  .ps-tryon-close {
    width: 2.2vw; height: 2.2vw; display: flex; align-items: center; justify-content: center;
    background: none; border: none; color: var(--ps-modal-close-color, #999);
    cursor: pointer; border-radius: 0.31vw; transition: background 0.15s;
  }
  .ps-tryon-close:hover { background: rgba(0,0,0,0.06); }
  .ps-tryon-close svg { width: 1vw; height: 1vw; }

  /* Language switcher */
  .ps-tryon-lang-wrap { position: relative; z-index: 99999; }
  .ps-tryon-lang-trigger {
    display: flex; align-items: center; gap: clamp(5px, 0.36vw, 7px);
    padding: clamp(6px, 0.36vw, 8px) clamp(10px, 0.73vw, 14px);
    border: 1.5px solid var(--ps-border-color); border-radius: clamp(8px, 0.57vw, 10px);
    background: transparent; cursor: pointer; color: var(--ps-text-secondary);
    transition: all 0.25s ease; font-family: inherit; white-space: nowrap;
    min-height: clamp(28px, 2.2vw, 38px);
  }
  .ps-tryon-lang-trigger:hover, .ps-tryon-lang-trigger.ps-active {
    border-color: var(--ps-accent); color: var(--ps-accent); background: rgba(33,84,239,0.06);
  }
  .ps-tryon-lang-trigger svg { stroke: currentColor; fill: none; flex-shrink: 0; width: clamp(13px, 0.8vw, 16px); height: clamp(13px, 0.8vw, 16px); }
  .ps-tryon-lang-current {
    font-size: clamp(12px, 0.68vw, 14px); font-weight: 500; letter-spacing: 0.01em;
  }
  .ps-tryon-lang-arrow {
    width: clamp(17px, 1.05vw, 20px); height: clamp(17px, 1.05vw, 20px);
    display: inline-flex; align-items: center; justify-content: center;
    flex-shrink: 0; margin-left: 1px;
    transition: transform 0.25s ease;
  }
  .ps-tryon-lang-arrow svg {
    width: 100% !important; height: 100% !important;
    stroke: currentColor; fill: none; stroke-width: 2.4;
  }
  .ps-tryon-lang-arrow.ps-open { transform: rotate(180deg); }

  /* Dropdown is portaled to document.body — uses hardcoded colors (no CSS vars available) */
  .ps-tryon-lang-dropdown {
    min-width: min(13vw, 180px);
    background: #FFFFFF; border: 1.5px solid rgba(0,0,0,0.1);
    border-radius: clamp(8px, 0.73vw, 12px);
    box-shadow: 0 clamp(6px, 0.5vw, 10px) clamp(16px, 2vw, 32px) rgba(0,0,0,0.15),
                0 0 0 1px rgba(0,0,0,0.03);
    overflow: hidden;
    animation: ps-lang-open 0.2s ease both;
    font-family: system-ui, -apple-system, sans-serif;
  }
  @keyframes ps-lang-open {
    from { opacity: 0; transform: translateY(-0.42vw) scale(0.96); }
    to { opacity: 1; transform: none; }
  }

  .ps-tryon-lang-list {
    /* max(...) picks the larger of the two values so the dropdown is tall
       enough to scroll through a handful of languages on any viewport.
       Pure min(18vw, 280px) collapsed to ~67 px on 375 px mobile. */
    max-height: max(260px, min(18vw, 280px)); overflow-y: auto; padding: clamp(3px, 0.31vw, 5px);
    scrollbar-width: thin; scrollbar-color: rgba(0,0,0,0.15) transparent;
  }
  .ps-tryon-lang-item {
    display: flex; align-items: center; gap: clamp(6px, 0.57vw, 10px);
    width: 100%; padding: clamp(6px, 0.57vw, 10px) clamp(8px, 0.83vw, 14px);
    border: none; background: transparent; color: #555; cursor: pointer;
    border-radius: clamp(5px, 0.47vw, 8px); transition: all 0.15s ease;
    font-family: inherit; text-align: left;
  }
  .ps-tryon-lang-item:hover { background: rgba(0,0,0,0.04); color: #1C1D1E; }
  .ps-tryon-lang-item.ps-selected { background: rgba(59,130,246,0.1); color: #3B82F6; }
  .ps-tryon-lang-name {
    flex: 1; font-size: clamp(12px, 0.73vw, 14px); font-weight: 500;
  }
  .ps-tryon-lang-code {
    font-size: clamp(10px, 0.52vw, 11px); color: #999; font-weight: 600;
    letter-spacing: 0.05em; font-family: ui-monospace, monospace;
  }
  .ps-tryon-lang-item.ps-selected .ps-tryon-lang-code { color: #3B82F6; opacity: 0.7; }
  .ps-tryon-lang-check { color: #3B82F6; display: flex; align-items: center; }

  /* Stepper */
  /* Dots progress */
  .ps-tryon-dots { display: none; }
  .ps-tryon-dot { display: none; }

  /* Body */
  .ps-tryon-body { padding: clamp(12px, 1.25vw, 20px); flex: 1; min-height: 0; overflow-y: auto; overflow-x: hidden; display: flex; flex-direction: column; overscroll-behavior: contain; -webkit-overflow-scrolling: touch; }
  @keyframes ps-fade-up { from { opacity: 0; } to { opacity: 1; } }
  .ps-tryon-view-enter { animation: ps-fade-up 0.18s ease-out both; flex: 1; display: flex; flex-direction: column; min-height: 0; transform: none; filter: none; }

  /* Welcome */
  .ps-tryon-welcome { text-align: center; padding: 0.5vw 0; }
  .ps-tryon-welcome-hero { margin-bottom: 1.3vw; }
  .ps-tryon-welcome-img-wrap { position: relative; display: inline-block; }
  .ps-tryon-welcome-product { width: 9vw; height: 10.5vw; object-fit: contain; background: var(--ps-modal-bg, #FFFFFF); border-radius: 0.9vw; border: 2px solid var(--ps-border-color); box-shadow: 0 8px 30px rgba(0,0,0,0.08); }
  .ps-tryon-welcome-sparkle { position: absolute; top: -0.5vw; right: -0.5vw; width: 1.8vw; height: 1.8vw; background: var(--ps-accent); border-radius: 50%; display: flex; align-items: center; justify-content: center; animation: ps-float 3s ease-in-out infinite; }
  .ps-tryon-welcome-sparkle svg { stroke: #111; width: 0.9vw; height: 0.9vw; }
  @keyframes ps-float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-4px); } }
  .ps-tryon-welcome-title { font-size: 1.4vw; font-weight: 700; color: var(--ps-text-primary); margin: 1vw 0 0.3vw; letter-spacing: -0.01em; }
  .ps-tryon-welcome-sub { font-size: 0.9vw; color: var(--ps-text-secondary); margin: 0; }
  .ps-tryon-features { display: flex; gap: 0.7vw; margin: 1.3vw 0; }
  .ps-tryon-feature { flex: 1; padding: 1vw 0.7vw; border: 1px solid var(--ps-border-color); border-radius: 0.8vw; text-align: center; transition: border-color 0.2s; }
  .ps-tryon-feature:hover { border-color: #555; }
  .ps-tryon-feature-icon { margin-bottom: 0.4vw; color: var(--ps-accent); display: flex; justify-content: center; }
  .ps-tryon-feature-icon svg { stroke: currentColor; fill: none; width: 1.2vw; height: 1.2vw; }
  .ps-tryon-feature-title { font-size: 0.85vw; font-weight: 600; color: var(--ps-text-primary); margin-bottom: 2px; }
  .ps-tryon-feature-desc { font-size: 0.7vw; color: var(--ps-text-secondary); }
  .ps-tryon-cta {
    width: 100%; padding: 1vw; background: var(--ps-accent); color: #fff; border: none;
    border-radius: 0.8vw; font-size: 1vw; font-weight: 700; cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 0.5vw; transition: all 0.2s;
    font-family: var(--ps-modal-font, system-ui, sans-serif);
  }
  .ps-tryon-cta:hover { background: var(--ps-accent-hover); transform: translateY(-1px); }
  .ps-tryon-cta svg { stroke: #111; }
  .ps-tryon-welcome-note { font-size: 0.7vw; color: var(--ps-text-muted); margin-top: 0.7vw; }

  /* Upload */
  .ps-tryon-upload {
    border: 2px dashed var(--ps-upload-border, var(--ps-border-color)); border-radius: 0.63vw;
    padding: 2.08vw 1.25vw; text-align: center; cursor: pointer; transition: all 0.2s;
    background: var(--ps-upload-bg, transparent); display: flex; flex-direction: column; align-items: center;
  }
  .ps-tryon-upload:hover, .ps-tryon-drag-over { border-color: var(--ps-accent); background: rgba(33,84,239,0.05); }
  .ps-tryon-upload svg { color: var(--ps-upload-icon-color, var(--ps-accent)); margin-bottom: 0.63vw; }
  .ps-tryon-upload-text { font-size: 0.73vw; color: var(--ps-upload-color, var(--ps-text-primary)); margin: 0 0 0.21vw; }
  .ps-tryon-upload-hint { font-size: 0.63vw; color: var(--ps-text-secondary); margin: 0; }
  .ps-tryon-preview {
    position: relative; margin-bottom: 0.21vw;
    height: 20vw; border-radius: 0.63vw;
    overflow: hidden; background: var(--ps-bg-tertiary);
  }
  .ps-tryon-preview-blur {
    position: absolute; inset: -20px; background-size: cover; background-position: center;
    filter: blur(25px) brightness(0.4); transform: scale(1.2);
  }
  .ps-tryon-preview img { position: relative; z-index: 1; width: 100%; height: 100%; object-fit: contain; display: block; }
  .ps-tryon-preview-remove {
    position: absolute; top: 0.42vw; right: 0.42vw; width: 1.46vw; height: 1.46vw;
    border-radius: 50%; background: rgba(0,0,0,0.6); border: none; color: white;
    cursor: pointer; display: flex; align-items: center; justify-content: center;
    font-size: 0.83vw; transition: background 0.15s;
  }
  .ps-tryon-preview-remove:hover { background: rgba(0,0,0,0.8); }
  .ps-tryon-submit {
    width: 100%; padding: 0.73vw; margin-top: 0.83vw;
    background: var(--ps-modal-primary-bg, var(--ps-accent)); color: var(--ps-modal-primary-color, #111);
    font-family: var(--ps-modal-font, system-ui, sans-serif);
    font-size: 0.73vw; font-weight: 600; border: none;
    border-radius: var(--ps-modal-primary-radius, 0.52vw);
    cursor: pointer; transition: all 0.2s;
    display: flex; align-items: center; justify-content: center; gap: 0.42vw;
  }
  .ps-tryon-submit:hover { opacity: 0.9; transform: translateY(-1px); }
  .ps-tryon-submit:disabled { opacity: 0.55; cursor: wait; transform: none; }
  .ps-tryon-submit svg { stroke: currentColor; }

  /* Profile bar */
  .ps-tryon-profile-bar { margin-bottom: 0.83vw; }
  .ps-tryon-profile-select {
    width: 100%; padding: 0.52vw 1.88vw 0.52vw 0.73vw; border: 1.5px solid var(--ps-border-color); border-radius: 0.52vw;
    background: var(--ps-bg-secondary); color: var(--ps-text-primary); font-size: 0.68vw; font-family: inherit;
    appearance: none; -webkit-appearance: none; cursor: pointer; outline: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.5 4.5L6 8L9.5 4.5' stroke='%23999' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat; background-position: right 0.73vw center;
  }
  .ps-tryon-profile-select:focus { border-color: var(--ps-accent); }

  /* Sizing — split layout (product image left, form right) */
  .ps-tryon-sizing-split {
    display: flex; gap: 1.8vw;
    flex: 1; min-height: 0; position: relative;
    height: 30vw;
  }
  .ps-tryon-sizing-img-col {
    flex: 1.15; position: relative;
    background: transparent;
    border-radius: 0.8vw; overflow: hidden;
  }
  .ps-tryon-sizing-img-col > img, .ps-tryon-sizing-img-col > .ps-tryon-sizing-measure-img {
    display: block; width: 100%; height: 100%;
    object-fit: contain; object-position: center center;
    background: transparent;
    border-radius: 1vw;
    transition: opacity 0.3s ease;
  }
  .ps-tryon-sizing-product-img { opacity: 1; transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1); }
  .ps-tryon-sizing-product-img.ps-tryon-img-hidden { opacity: 0.08; }
  .ps-tryon-sizing-measure-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain; object-position: center center; opacity: 0; transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1); z-index: 2; will-change: opacity; }
  .ps-tryon-sizing-measure-img.ps-tryon-img-visible { opacity: 1; }
  .ps-tryon-sizing-height-img { position: absolute; inset: 0; object-fit: contain !important; background: #f5f5f5; opacity: 0; transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1); z-index: 2; will-change: opacity; }
  .ps-tryon-sizing-height-img.ps-tryon-img-visible { opacity: 1; }

  /* Model overlay — positioned on top of the image column */
  .ps-tryon-model-overlay {
    grid-area: 1 / 1; position: relative; opacity: 0; transition: opacity 0.5s ease;
    width: 100%; aspect-ratio: 896 / 1200; overflow: hidden;
  }
  .ps-tryon-model-overlay.ps-tryon-img-visible { opacity: 1; }
  .ps-tryon-model-raw { width: 100%; height: 100%; object-fit: contain; }

  /* Measurement overlay group — each measurement is one group */
  .ps-tryon-mline-group { position: absolute; inset: 0; pointer-events: none; }

  /* Horizontal dashed line */
  .ps-tryon-mline-h {
    position: absolute; height: 0;
    border-top: 2.5px dashed var(--ps-border-color);
    animation: ps-dash-draw 0.5s ease 0.1s both;
  }
  /* Vertical dashed line (inseam, sleeve) */
  .ps-tryon-mline-v {
    position: absolute; width: 0;
    border-left: 2.5px dashed var(--ps-border-color);
    animation: ps-vdash-draw 0.5s ease 0.1s both;
  }
  /* Tick marks at line endpoints — vertical ticks for horizontal lines */
  .ps-tryon-mline-tick {
    position: absolute; width: 0;
    border-left: 2.5px solid var(--ps-border-color);
    animation: ps-label-pop 0.3s ease 0.2s both;
  }
  /* Horizontal ticks for vertical lines */
  .ps-tryon-mline-htick {
    position: absolute; height: 0;
    border-top: 2.5px solid var(--ps-border-color);
    animation: ps-label-pop 0.3s ease 0.2s both;
  }

  /* Label box — matches reference: black title box + left-bordered description */
  .ps-tryon-mline-label {
    position: absolute;
    animation: ps-label-pop 0.35s ease 0.25s both;
    max-width: 33%;
  }
  .ps-tryon-mline-title {
    display: inline-block; background: #222; color: var(--ps-text-primary);
    font-size: 0.55vw; font-weight: 800; letter-spacing: 0.06em;
    padding: 0.12vw 0.35vw; margin-bottom: 0.2vw;
  }
  .ps-tryon-mline-desc {
    font-size: 0.42vw; color: #444; line-height: 1.4;
    font-style: italic;
    border-left: 1.5px solid var(--ps-border-color); padding-left: 0.3vw;
    margin-top: 0.1vw;
  }

  /* Per-field measurement guide overlay */
  .ps-tryon-measure-overlay {
    position: absolute; inset: 0; z-index: 5; pointer-events: none;
    animation: ps-measure-in 0.3s ease both;
  }
  .ps-tryon-measure-dot {
    position: absolute; width: 0.55vw; height: 0.55vw;
    background: #222;
    border: 2px solid var(--ps-border-color);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 0 2px rgba(0,0,0,0.15);
    z-index: 6;
  }
  .ps-tryon-measure-callout {
    position: absolute; top: 3%; left: 4%; z-index: 7;
    animation: ps-label-pop 0.35s ease 0.15s both;
    max-width: 55%;
  }
  .ps-tryon-measure-title {
    display: inline-block; background: #222; color: var(--ps-text-primary);
    font-size: 1.1vw; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase;
    padding: 0.3vw 0.65vw; margin-bottom: 0.35vw;
  }
  .ps-tryon-measure-desc {
    font-size: 0.85vw; color: #222; line-height: 1.55;
    font-style: italic; font-weight: 500;
    border-left: 2.5px solid var(--ps-border-color); padding-left: 0.55vw;
    margin-top: 0.15vw;
  }
  @keyframes ps-dot-pulse {
    0%, 100% { box-shadow: 0 0 0 2px rgba(0,0,0,0.15); }
    50% { box-shadow: 0 0 0 5px rgba(0,0,0,0.06); }
  }

  @keyframes ps-measure-in {
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes ps-dash-draw {
    from { clip-path: inset(0 100% 0 0); }
    to { clip-path: inset(0 0 0 0); }
  }
  @keyframes ps-vdash-draw {
    from { clip-path: inset(0 0 100% 0); }
    to { clip-path: inset(0 0 0 0); }
  }
  @keyframes ps-label-pop {
    from { opacity: 0; transform: scale(0.9); }
    to { opacity: 1; transform: scale(1); }
  }

  /* ═══════════ V2 Redesign — Editorial luxury ═══════════ */
  .ps-tryon-v2 {
    display: flex; align-items: stretch; gap: 1.2vw; flex: 1 1 auto; min-height: 0;
    height: 100%; overflow: hidden;
  }
  .ps-tryon-v2-media-stack {
    flex: 0 0 43%;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 0.45vw;
  }
  .ps-tryon-v2-media-stack .ps-tryon-v2-bg {
    flex: 1 1 auto;
    width: 100%;
    min-height: 0;
  }

  /* Left image column — proper contained display.
     No background — the product/try-on image sits directly on the modal
     surface without a gray placeholder box behind it. */
  .ps-tryon-v2-bg {
    flex: 0 0 43%; position: relative; min-width: 0;
    border-radius: 0.9vw; overflow: hidden;
    display: flex; align-items: center; justify-content: center;
  }
  .ps-tryon-v2-bg-img {
    width: 100%; height: 100%; object-fit: contain; object-position: center center;
    transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .ps-tryon-v2-bg-img.ps-tryon-img-hidden { opacity: 0.06; }
  .ps-tryon-v2-guide {
    position: absolute; inset: 0; width: 100%; height: 100%;
    object-fit: contain; object-position: center center;
    opacity: 0; z-index: 1;
    transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: opacity;
  }
  .ps-tryon-v2-guide.ps-visible { opacity: 1; }

  /* Right form panel */
  .ps-tryon-v2-panel {
    flex: 1 1 0; min-width: 0; min-height: 0;
    display: flex; flex-direction: column;
    padding: 0.2vw 0;
    justify-content: center;
    animation: ps-v2-fade 0.18s ease-out forwards;
  }
  .ps-tryon-v2-result-panel {
    align-self: stretch;
    height: 100%;
    justify-content: flex-start;
    gap: clamp(8px, 0.48vw, 12px);
    padding-bottom: clamp(4px, 0.35vw, 8px);
    overflow: hidden;
  }
  .ps-tryon-v2-result-panel .ps-tryon-v2-sep {
    margin-bottom: 0;
  }
  .ps-tryon-v2-multi-result-panel .ps-tryon-v2-result-copy {
    flex: 0 0 auto;
  }
  .ps-tryon-v2-result-panel .ps-tryon-sr-cards-v2 {
    flex: 0 0 auto;
    min-height: 0;
  }
  .ps-tryon-v2-result-panel .ps-tryon-photo-strip {
    flex: 1 1 auto;
    min-height: 0;
    margin-top: clamp(18px, 1.25vw, 26px);
    margin-bottom: clamp(4px, 0.35vw, 8px);
    overflow: hidden;
  }
  .ps-tryon-v2-result-panel .ps-tryon-sr-card-v2 {
    min-height: clamp(118px, 8.6vw, 142px);
  }
  .ps-tryon-v2-result-panel .ps-tryon-sr-card-v2.ps-full {
    min-height: clamp(118px, 8.6vw, 142px);
  }
  .ps-rag-result-garments {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: clamp(10px, 0.72vw, 14px);
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    padding-right: clamp(2px, 0.25vw, 5px);
    scrollbar-width: thin;
    scrollbar-color: rgba(15,23,42,0.18) transparent;
  }
  .ps-rag-result-garment-card {
    position: relative;
    min-height: clamp(150px, 11vw, 210px);
    border: 1px solid rgba(15,23,42,0.08);
    border-radius: clamp(12px, 0.76vw, 15px);
    overflow: hidden;
    padding: 0;
    background: #f7f7f7;
    cursor: pointer;
    font-family: inherit;
    box-shadow: 0 12px 30px -26px rgba(15,23,42,0.6);
    transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
  }
  .ps-rag-result-garment-card:hover {
    transform: translateY(-2px);
    border-color: rgba(33,84,239,0.42);
    box-shadow: 0 18px 36px -28px rgba(33,84,239,0.65);
  }
  .ps-rag-result-garment-img {
    width: 100%;
    height: 100%;
    min-height: inherit;
    display: block;
    object-fit: cover;
    object-position: center;
    transform: scale(1.01);
    transition: transform 0.28s ease;
  }
  .ps-rag-result-garment-card:hover .ps-rag-result-garment-img {
    transform: scale(1.045);
  }
  .ps-rag-result-garment-overlay {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(
        180deg,
        rgba(0,0,0,0.04) 0%,
        rgba(0,0,0,0.08) 38%,
        rgba(0,0,0,0.46) 68%,
        rgba(0,0,0,0.94) 100%
      );
    pointer-events: none;
  }
  .ps-rag-result-garment-copy {
    position: absolute;
    left: clamp(10px, 0.72vw, 14px);
    right: clamp(10px, 0.72vw, 14px);
    bottom: clamp(10px, 0.72vw, 14px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: clamp(3px, 0.18vw, 5px);
    color: #fff;
    text-align: left;
    z-index: 1;
  }
  .ps-rag-result-garment-color {
    font-size: clamp(9px, 0.54vw, 10px);
    font-weight: 780;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    opacity: 0.74;
  }
  .ps-rag-result-garment-title {
    font-size: clamp(14px, 0.92vw, 17px);
    font-weight: 820;
    line-height: 1.08;
    text-shadow: 0 1px 2px rgba(0,0,0,0.22);
  }
  .ps-rag-result-garment-size,
  .ps-rag-result-garment-details {
    font-size: clamp(10px, 0.58vw, 11px);
    font-weight: 680;
    opacity: 0.86;
  }
  .ps-rag-result-garment-details {
    margin-top: clamp(2px, 0.12vw, 4px);
    color: #fff;
    opacity: 0.98;
  }
  .ps-tryon-v2-result-panel .ps-tryon-photo-strip-cell {
    aspect-ratio: 1 / 1;
    height: auto;
  }
  .ps-tryon-v2-result-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
    padding-top: clamp(6px, 0.45vw, 10px);
    padding-bottom: clamp(2px, 0.25vw, 6px);
    gap: 0.5vw;
    flex-shrink: 0;
    width: 100%;
    min-height: clamp(42px, 3.1vw, 52px);
    box-sizing: border-box;
    border-top: 1px solid rgba(15,23,42,0.06);
  }
  .ps-tryon-v2-result-actions > .ps-tryon-v2-action-group {
    flex: 0 1 min(26vw, 390px);
    min-width: 0;
    max-width: min(100%, 390px);
    margin-left: auto;
  }
  .ps-tryon-v2-result-actions .ps-tryon-v2-cta {
    flex: 1 1 0;
    min-width: 0;
    min-height: clamp(38px, 2.55vw, 44px);
    padding: 0 clamp(10px, 0.75vw, 14px);
  }
  .ps-tryon-v2-result-actions > .ps-tryon-v2-cta {
    flex: 0 1 min(18vw, 240px);
    margin-left: auto;
  }
  .ps-tryon-v2-result-actions > .ps-tryon-v2-action-group .ps-tryon-v2-cta {
    flex: 1 1 0;
  }
  @keyframes ps-v2-fade {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes ps-panel-slide {
    from { transform: translateX(2vw); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  /* Top bar */
  .ps-tryon-v2-top {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 0.6vw;
  }
  .ps-tryon-v2-title {
    font-size: 1.2vw; font-weight: 300; color: var(--ps-text-primary);
    letter-spacing: 0.2em; text-transform: uppercase; margin: 0;
    font-family: inherit;
  }
  .ps-tryon-v2-subtitle {
    font-size: 0.65vw; font-weight: 400; color: rgba(0,0,0,0.25);
    margin: 0.15vw 0 0; letter-spacing: 0.03em;
  }
  .ps-tryon-v2-result-head {
    display: flex; align-items: flex-start; justify-content: space-between;
    gap: 0.8vw; margin-bottom: 0.55vw;
  }
  .ps-tryon-v2-result-copy { min-width: 0; flex: 1 1 auto; }
  .ps-single-result-copy {
    margin: 0 0 clamp(24px, 1.8vw, 34px);
  }
  .ps-tryon-v2-profile-head {
    flex: 0 0 min(18vw, 48%);
    min-width: 15vw;
  }
  .ps-tryon-v2-profile-head.ps-expanded {
    flex: 1 1 100%;
    min-width: 0;
    width: 100%;
  }
  .ps-tryon-v2-unit-toggle {
    display: flex; gap: 0;
    border: 1px solid rgba(0,0,0,0.06); border-radius: 2vw; overflow: hidden;
  }
  .ps-tryon-v2-unit {
    background: none; border: none; padding: 0.22vw 0.7vw;
    font-size: 0.55vw; font-weight: 700; color: rgba(0,0,0,0.2);
    cursor: pointer; font-family: inherit; letter-spacing: 0.1em;
    transition: all 0.25s;
  }
  .ps-tryon-v2-unit.ps-on {
    background: rgba(33,84,239,0.15); color: var(--ps-accent);
  }

  /* Body type card selector */
  .ps-tryon-bodytype-cards {
    display: flex; gap: 0.35vw; width: 100%;
    overflow-x: auto; padding: 0.15vw 0;
    scrollbar-width: none;
  }
  .ps-tryon-bodytype-cards::-webkit-scrollbar { display: none; }
  .ps-tryon-bodytype-card {
    flex: 1; min-width: 0;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 0.2vw; padding: 0.4vw 0.2vw;
    border: 1.5px solid rgba(0,0,0,0.06); border-radius: 0.35vw;
    background: transparent; color: rgba(0,0,0,0.3);
    cursor: pointer; font-family: inherit; transition: all 0.2s;
  }
  .ps-tryon-bodytype-card:hover {
    border-color: var(--ps-accent); background: rgba(33,84,239,0.06);
  }
  .ps-tryon-bodytype-card.ps-active {
    border-color: var(--ps-accent); background: rgba(33,84,239,0.12);
    color: #111;
  }
  .ps-tryon-bodytype-label {
    font-size: 0.5vw; font-weight: 600; letter-spacing: 0.05em; text-transform: uppercase;
  }

  /* Separator */
  .ps-tryon-v2-sep {
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(33,84,239,0.2), transparent);
    margin-bottom: 0.8vw;
  }

  /* Profile select */
  .ps-tryon-v2-profile {
    width: 100%; padding: 0.3vw 0.5vw; margin-bottom: 0.6vw;
    background: rgba(0,0,0,0.02); border: 1px solid rgba(0,0,0,0.04);
    border-radius: 0.3vw; color: rgba(0,0,0,0.08);
    font-size: 0.6vw; font-family: inherit; cursor: pointer; outline: none;
    appearance: none; -webkit-appearance: none;
    transition: border-color 0.2s;
  }
  .ps-tryon-v2-profile:focus { border-color: rgba(33,84,239,0.3); }

  /* Fields container — scrollable */
  .ps-tryon-v2-fields {
    flex: 1; min-height: 0; overflow-y: auto;
    display: flex; flex-direction: column; gap: 0;
    scrollbar-width: thin; scrollbar-color: rgba(0,0,0,0.04) transparent;
  }

  /* Override float-row for inline look inside v2 */
  .ps-tryon-v2-fields .ps-tryon-sf-float-row {
    width: 100%;
  }
  /* Label inline with input line */
  .ps-tryon-v2-fields .ps-tryon-sf-float-field {
    display: flex; align-items: center; gap: 0.8vw;
    width: 100%; padding: 0.9vw 0.8vw;
  }
  .ps-tryon-v2-fields .ps-tryon-sf-float-label {
    flex-shrink: 0;
    font-size: 0.75vw; font-weight: 500;
    color: rgba(0,0,0,0.08);
    letter-spacing: 0.04em;
    margin: 0; white-space: nowrap;
    transition: color 0.25s;
  }
  .ps-tryon-v2-fields .ps-tryon-sf-float-field:focus-within .ps-tryon-sf-float-label {
    color: #111;
  }
  .ps-tryon-v2-fields .ps-tryon-sf-input {
    flex: 1; border: none;
    border-bottom: 1.5px solid rgba(0,0,0,0.1);
    background: none; padding: 0.25vw 0;
    font-size: 1vw; font-weight: 400; color: var(--ps-text-primary);
    font-family: inherit; outline: none;
    -moz-appearance: textfield;
    transition: border-color 0.3s;
  }
  .ps-tryon-v2-fields .ps-tryon-sf-input:focus {
    border-bottom-color: var(--ps-accent);
  }
  .ps-tryon-v2-fields .ps-tryon-sf-input::placeholder {
    color: rgba(0,0,0,0.08);
  }
  .ps-tryon-v2-fields .ps-tryon-sf-input::-webkit-outer-spin-button,
  .ps-tryon-v2-fields .ps-tryon-sf-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }

  /* CTA button */
  .ps-tryon-v2-cta {
    margin-top: 0.8vw; padding: 0.55vw 1.05vw;
    width: auto; min-width: 9.2vw; min-height: 2.35vw; display: flex; align-items: center; justify-content: center; gap: 0.35vw;
    background: var(--ps-accent); color: #fff;
    border: none; border-radius: 0.42vw;
    font-size: clamp(10px, 0.64vw, 12px); font-weight: 750; font-family: inherit;
    letter-spacing: 0.07em; text-transform: uppercase;
    cursor: pointer; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
  }
  .ps-tryon-v2-cta svg { width: 0.75vw; height: 0.75vw; }
  .ps-tryon-v2-cta:hover {
    background: var(--ps-accent-hover);
    box-shadow: 0 0.3vw 1.5vw rgba(33,84,239,0.25);
    transform: translateY(-1px);
  }
  .ps-tryon-v2-cta svg { width: 0.8vw; height: 0.8vw; stroke: currentColor; }
	  .ps-tryon-v2-action-group {
	    display: flex;
	    align-items: center;
	    justify-content: flex-end;
	    gap: clamp(8px, 0.55vw, 12px);
	    min-width: 0;
	    flex-wrap: wrap;
	  }
	  .ps-tryon-add-bag-error {
	    flex: 1 0 100%;
	    color: var(--ps-error-color);
	    font-size: clamp(11px, 0.62vw, 12px);
	    font-weight: 650;
	    line-height: 1.35;
	    text-align: right;
	    margin-top: -2px;
	    text-transform: none;
	    letter-spacing: 0;
	  }
  .ps-tryon-v2-action-group-history {
    flex: 0 0 auto !important;
    width: auto !important;
    max-width: none !important;
  }
  .ps-tryon-v2-cta-compact,
  .ps-tryon-v2-history-product-cta {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: 0 !important;
    min-height: clamp(34px, 2.25vw, 40px) !important;
    padding: 0 clamp(10px, 0.75vw, 14px) !important;
    letter-spacing: 0.03em;
    text-transform: none;
    font-weight: 750;
  }
  .ps-tryon-v2-history-product-cta {
    justify-content: center;
  }
  .ps-tryon-v2-add-bag-cta svg,
  .ps-tryon-v2-history-product-cta svg {
    flex: 0 0 auto;
    width: clamp(16px, 1vw, 18px);
    height: clamp(16px, 1vw, 18px);
    stroke-width: 2.1;
  }
  .ps-tryon-v2-add-bag-cta.is-added {
    background: #16a34a;
    color: #fff;
  }
  .ps-tryon-v2-add-bag-cta.is-added:disabled {
    opacity: 1;
    cursor: default;
  }
  .ps-tryon-v2-add-bag-cta.is-added svg {
    animation: ps-added-check 0.42s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes ps-added-check {
    0% { transform: scale(0.45); opacity: 0; }
    55% { transform: scale(1.18); opacity: 1; }
    100% { transform: scale(1); opacity: 1; }
  }
  .ps-tryon-v2-cta-secondary {
    background: #FFFFFF;
    color: #111;
    border: 1px solid rgba(33,84,239,0.38);
    box-shadow: none;
  }
  .ps-tryon-v2-cta-secondary:hover {
    background: rgba(33,84,239,0.06);
    color: #111;
    border-color: var(--ps-accent);
    box-shadow: 0 0.25vw 1vw rgba(33,84,239,0.12);
  }
  @media (max-width: 768px) {
    .ps-tryon-v2-action-group {
      width: 100%;
      gap: 8px;
    }
    .ps-tryon-v2-action-group-history {
      width: auto !important;
      margin-left: auto;
    }
    .ps-tryon-v2-action-group .ps-tryon-v2-cta,
    .ps-msr-commerce-row > .ps-tryon-v2-cta {
      flex: 1 1 0;
      min-width: 0;
      padding: 11px 12px;
      border-radius: 10px;
      font-size: 11px;
      letter-spacing: 0.08em;
      white-space: nowrap;
    }
    .ps-tryon-v2-action-group-history .ps-tryon-v2-cta {
      flex: 0 0 auto !important;
      width: auto !important;
      padding: 10px 12px !important;
      letter-spacing: 0.02em;
    }
    .ps-tryon-v2-add-bag-cta svg,
    .ps-tryon-v2-history-product-cta svg {
      width: 17px;
      height: 17px;
    }
  }

  /* ── Size result card rows (split layout) ── */
  .ps-tryon-sr-cards-stack {
    display: flex; flex-wrap: wrap; gap: 0.4vw;
    flex: 1; min-height: 0; justify-content: center;
  }
  /* Cards inside stack: 2 per row, compact, dark */
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard {
    flex: 1 1 45%; max-width: 49%; min-height: 0; border-radius: 0.5vw;
    background: #0a0a0a; max-height: 8vw;
  }
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard:not(.ps-has-img) {
    min-height: 5vw; padding: 0.4vw; max-height: 8vw;
  }
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard-bg {
    max-height: 8vw; width: 100%; height: 100%;
    object-fit: contain; object-position: center center;
  }
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard-overlay {
    height: 100%;
    background: rgba(0,0,0,0.6);
  }
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard-content {
    padding: 0.4vw;
  }
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard-name { font-size: 0.5vw; }
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard-size { font-size: 1.2vw; }
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard-badge { font-size: 0.35vw; }
  .ps-tryon-sr-cards-stack .ps-tryon-sec-bigcard-icon { width: 1.8vw; height: 1.8vw; }
  .ps-tryon-sr-card-row {
    display: flex; align-items: center; gap: 0.6vw;
    padding: 0.6vw 0.7vw;
    background: rgba(255,255,255,0.02);
    border: 1px solid rgba(0,0,0,0.04);
    border-radius: 0.5vw;
    cursor: pointer; font-family: inherit;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    animation: ps-card-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    opacity: 0;
  }
  .ps-tryon-sr-card-row:nth-child(1) { animation-delay: 0s; }
  .ps-tryon-sr-card-row:nth-child(2) { animation-delay: 0.06s; }
  .ps-tryon-sr-card-row:nth-child(3) { animation-delay: 0.12s; }
  .ps-tryon-sr-card-row:nth-child(4) { animation-delay: 0.18s; }
  .ps-tryon-sr-card-row:hover {
    border-color: var(--ps-accent);
    background: rgba(33,84,239,0.04);
    transform: translateX(0.15vw);
  }
  .ps-tryon-sr-card-icon {
    width: 2vw; height: 2vw; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    background: rgba(33,84,239,0.06); border: 1px solid rgba(33,84,239,0.1);
    border-radius: 50%; color: var(--ps-accent);
  }
  .ps-tryon-sr-card-icon svg { stroke: currentColor; }
  .ps-tryon-sr-card-info {
    flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 0.05vw;
  }
  .ps-tryon-sr-card-name {
    font-size: 0.72vw; font-weight: 500; color: var(--ps-text-primary);
    text-transform: capitalize;
  }
  .ps-tryon-sr-card-fit {
    font-size: 0.55vw; color: var(--ps-text-muted); letter-spacing: 0.03em;
  }
  .ps-tryon-sr-card-size {
    font-size: 1.3vw; font-weight: 300; color: var(--ps-accent);
    letter-spacing: -0.01em;
  }
  .ps-tryon-sr-card-row > svg { color: rgba(0,0,0,0.1); flex-shrink: 0; transition: color 0.2s; }
  .ps-tryon-sr-card-row:hover > svg { color: var(--ps-accent); }

  /* ── Result cards v2: bold, clear, unmissable ── */
  .ps-tryon-sr-cards-v2 {
    display: flex; flex-wrap: wrap; gap: 0.4vw;
    flex: 1; min-height: 0;
  }
  .ps-tryon-sr-card-v2 {
    flex: 1 1 45%; max-width: 49%;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    text-align: center;
    background: linear-gradient(180deg, #FFFFFF 0%, #FBFCFF 100%);
    border: 1px solid rgba(15,23,42,0.08);
    border-radius: clamp(12px, 0.72vw, 14px); padding: clamp(14px, 0.82vw, 18px);
    cursor: pointer; font-family: inherit;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    animation: ps-card-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    opacity: 0; overflow: hidden; position: relative;
    min-height: 7vw;
  }
  .ps-tryon-sr-card-v2::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
    background: radial-gradient(circle at 50% 0%, rgba(33,84,239,0.08), transparent 38%);
    opacity: 0.6;
  }
  .ps-tryon-sr-card-v2.ps-full { flex: 1 1 100%; max-width: 100%; min-height: 5vw; padding: clamp(14px, 0.82vw, 18px); }
  .ps-tryon-sr-card-v2.ps-summary-card {
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: clamp(154px, 10.4vw, 184px);
    padding: clamp(16px, 1vw, 22px) clamp(18px, 1.18vw, 26px);
    background: #FFFFFF;
    box-shadow: none;
  }
  .ps-tryon-sr-card-v2.ps-summary-card::after {
    display: none;
  }
  .ps-tryon-sr-card-v2:hover {
    border-color: var(--ps-accent);
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(33,84,239,0.045) 100%);
    transform: translateY(-2px);
    box-shadow: 0 0.45vw 1.4vw rgba(15,23,42,0.08);
  }
  .ps-tryon-sr-card-v2-text {
    display: flex; flex-direction: column; align-items: center; gap: clamp(5px, 0.22vw, 7px); z-index: 1;
  }
  .ps-summary-card-layout {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: clamp(6px, 0.36vw, 10px);
  }
  .ps-summary-card-copy {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
    gap: clamp(8px, 0.48vw, 12px);
  }
  .ps-tryon-sr-card-v2-heading {
    grid-area: heading;
    display: flex;
    align-items: center;
    gap: clamp(8px, 0.55vw, 12px);
    min-width: 0;
  }
  .ps-tryon-sr-card-v2-main {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: clamp(9px, 0.6vw, 14px);
    min-width: 0;
  }
  .ps-summary-card-layout .ps-tryon-sr-card-v2-open-pill {
    margin-top: 0;
    white-space: nowrap;
  }
  .ps-tryon-sr-card-outside-label {
    margin: 0 0 clamp(8px, 0.5vw, 11px);
    font-size: clamp(10px, 0.62vw, 12px);
    font-weight: 780;
    color: rgba(15,23,42,0.56);
    letter-spacing: 0.13em;
    text-transform: uppercase;
  }
  .ps-tryon-sr-card-v2-summary-title {
    font-size: clamp(11px, 0.66vw, 12px);
    font-weight: 760;
    color: rgba(15,23,42,0.56);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    line-height: 1.2;
    margin-bottom: clamp(2px, 0.08vw, 4px);
  }
  .ps-summary-card-layout .ps-tryon-sr-card-v2-summary-title {
    margin-bottom: clamp(1px, 0.08vw, 3px);
    white-space: nowrap;
    color: rgba(15,23,42,0.58);
    font-size: clamp(11px, 0.66vw, 12px);
    font-weight: 780;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .ps-tryon-sr-card-v2-summary-subtitle {
    font-size: clamp(10px, 0.56vw, 11px);
    font-weight: 400;
    color: rgba(0,0,0,0.32);
    letter-spacing: 0.02em;
    line-height: 1.25;
    text-transform: none;
    margin-bottom: 0.35vw;
  }
  .ps-tryon-sr-card-v2-label {
    font-size: clamp(10px, 0.56vw, 11px); font-weight: 650; color: rgba(15,23,42,0.58);
    text-transform: uppercase; letter-spacing: 0.08em;
    display: inline-flex; align-items: center; gap: 0.5vw;
  }
  .ps-summary-card-layout .ps-tryon-sr-card-v2-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ps-tryon-sr-card-v2-label-icon {
    width: 4.8vw; height: 4.8vw; object-fit: contain;
    opacity: 1;
  }
  .ps-tryon-sr-card-v2-value {
    font-size: clamp(30px, 2.18vw, 38px); font-weight: 260; color: var(--ps-text-primary);
    line-height: 1; letter-spacing: -0.02em;
    overflow-wrap: anywhere;
  }
  .ps-tryon-sr-card-v2.ps-full .ps-tryon-sr-card-v2-value { font-size: clamp(30px, 2vw, 36px); }
  .ps-summary-card-layout .ps-tryon-sr-card-v2-value {
    font-size: clamp(34px, 2.2vw, 42px);
    min-width: 0;
    text-align: center;
  }
  /* Long combined labels ("MISSY 12 / Standard", "PLUS 16W / Extra Length")
     overflow the card at 2vw. Drop to ~1.3vw whenever the label is more
     than ~12 chars so the whole thing fits on one line. */
  .ps-tryon-sr-card-v2-value.ps-long  { font-size: 1.4vw; }
  .ps-tryon-sr-card-v2.ps-full .ps-tryon-sr-card-v2-value.ps-long { font-size: 1.2vw; }
  .ps-tryon-sr-card-v2-value-suffix {
    font-size: 0.75vw; font-weight: 500; color: var(--ps-text-secondary);
    letter-spacing: 0; margin-left: 0.25vw; white-space: nowrap;
  }
  .ps-tryon-sr-card-v2-rec {
    font-size: 0.5vw; font-weight: 600; color: var(--ps-accent);
    text-transform: uppercase; letter-spacing: 0.1em;
    margin-top: 0.15vw;
    border: 1px solid rgba(33,84,239,0.25); border-radius: 2vw;
    padding: 0.1vw 0.5vw;
  }
  .ps-tryon-sr-card-v2-rec-pill {
    align-self: center;
    font-size: clamp(9px, 0.52vw, 10px); font-weight: 780; color: var(--ps-accent);
    text-transform: uppercase; letter-spacing: 0.07em;
    background: rgba(33, 84, 239, 0.10);
    border: 1px solid rgba(33, 84, 239, 0.18);
    border-radius: 2vw;
    padding: clamp(3px, 0.18vw, 4px) clamp(9px, 0.58vw, 12px);
    margin-top: clamp(2px, 0.12vw, 4px);
  }
  .ps-summary-card-layout .ps-tryon-sr-card-v2-rec-pill {
    align-self: center;
    margin-top: clamp(1px, 0.1vw, 3px);
    white-space: nowrap;
    background: #fff;
  }
  .ps-tryon-sr-card-v2-rec-pill.is-overridden {
    color: #b45309;
    background: rgba(180, 83, 9, 0.10);
    border-color: rgba(180, 83, 9, 0.25);
  }
  .ps-tryon-sr-card-v2-view {
    align-self: center;
    margin-top: clamp(2px, 0.18vw, 5px);
    font-size: clamp(10px, 0.58vw, 11px); font-weight: 700;
    color: var(--ps-accent);
    text-transform: none; letter-spacing: 0.02em;
    display: inline-flex; align-items: center; justify-content: center; gap: 0.2vw;
    transition: gap 0.2s ease;
  }
  .ps-tryon-sr-card-v2:hover .ps-tryon-sr-card-v2-view {
    gap: 0.4vw;
  }
  .ps-tryon-sr-card-v2-view > span {
    font-size: 0.85vw; line-height: 1; color: var(--ps-accent);
    transform: translateY(-0.05vw);
  }
  .ps-tryon-sr-card-v2-open-pill {
    margin-top: clamp(4px, 0.26vw, 7px);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: clamp(4px, 0.25vw, 6px);
    min-height: clamp(26px, 1.65vw, 32px);
    padding: 0 clamp(10px, 0.68vw, 14px);
    border-radius: 999px;
    background: #fff;
    border: 1px solid rgba(33,84,239,0.22);
    color: var(--ps-accent);
    font-size: clamp(10px, 0.58vw, 11px);
    font-weight: 760;
    letter-spacing: 0.01em;
    box-shadow: 0 0.18vw 0.8vw rgba(33,84,239,0.08);
    transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  }
  .ps-tryon-sr-card-v2-open-pill > span[aria-hidden="true"] {
    font-size: clamp(14px, 0.85vw, 16px);
    line-height: 1;
    transform: translateY(-0.03vw);
  }
  .ps-tryon-sr-card-v2:hover .ps-tryon-sr-card-v2-open-pill {
    transform: translateY(-1px);
    border-color: rgba(33,84,239,0.45);
    box-shadow: 0 0.24vw 1vw rgba(33,84,239,0.13);
  }
  @media (max-width: 768px) {
    .ps-tryon-sr-card-v2.ps-summary-card {
      min-height: 108px;
      padding: 16px;
    }
    .ps-summary-card-layout {
      gap: 8px;
      align-items: center;
    }
    .ps-summary-card-layout .ps-tryon-sr-card-v2-main {
      width: 100%;
      justify-content: center;
      gap: 12px;
    }
    .ps-summary-card-layout .ps-tryon-sr-card-v2-value {
      font-size: 34px;
    }
    .ps-summary-card-layout .ps-tryon-sr-card-v2-open-pill {
      min-height: 38px;
    }
  }
  .ps-tryon-sr-card-v2-img { display: none; }
  .ps-tryon-sr-card-v2-icon {
    position: absolute; bottom: 0.35vw; right: 0.45vw;
    opacity: 0.1; color: var(--ps-accent);
    pointer-events: none;
    transform: scale(1.5); transform-origin: bottom right;
  }

  /* ── Photo guide v2 ── */
  .ps-tryon-guide-drop-v2 {
    width: 90%; height: 90%; border-radius: 0.6vw;
    border: 1.5px dashed rgba(0,0,0,0.08);
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 0.3vw; cursor: pointer; transition: all 0.25s;
    position: relative; overflow: hidden;
  }
  .ps-tryon-guide-drop-v2:hover, .ps-tryon-guide-drop-v2.ps-drag {
    border-color: var(--ps-accent); background: rgba(33,84,239,0.04);
  }
  .ps-tryon-guide-drop-v2.ps-has { border-style: solid; border-color: rgba(0,0,0,0.06); cursor: default; }
  .ps-tryon-guide-drop-v2 svg { color: rgba(0,0,0,0.2); }
  .ps-tryon-guide-drop-v2-text { font-size: 0.8vw; font-weight: 500; color: rgba(0,0,0,0.5); }
  .ps-tryon-guide-drop-v2-hint { font-size: 0.55vw; color: rgba(0,0,0,0.15); }
  .ps-tryon-guide-drop-v2-img {
    width: 100%; height: 100%; object-fit: contain; border-radius: 0.5vw;
  }
  .ps-tryon-guide-drop-v2-remove {
    position: absolute; top: 0.4vw; right: 0.4vw;
    width: 1.4vw; height: 1.4vw; border-radius: 50%;
    background: rgba(0,0,0,0.7); border: 1px solid rgba(0,0,0,0.08);
    color: var(--ps-text-muted); font-size: 0.6vw; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: background 0.2s;
  }
  .ps-tryon-guide-drop-v2-remove:hover { background: rgba(239,68,68,0.7); }

  .ps-tryon-guide-v2-tips {
    display: flex; flex-direction: column; gap: 0.4vw;
    margin: 0.5vw 0;
  }
  .ps-tryon-guide-v2-tip {
    display: flex; align-items: center; gap: 0.4vw;
    font-size: 0.65vw; color: rgba(0,0,0,0.5);
  }
  .ps-tryon-guide-v2-tip-icon {
    width: 1.2vw; height: 1.2vw; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    font-size: 0.55vw; border-radius: 50%;
    background: rgba(74,222,128,0.1); color: #4ade80;
  }
  .ps-tryon-guide-v2-tip.ps-dont .ps-tryon-guide-v2-tip-icon {
    background: rgba(239,68,68,0.1); color: #f87171;
  }
  .ps-tryon-v2-cta:disabled {
    opacity: 0.4; cursor: not-allowed; transform: none;
    box-shadow: none;
  }

  /* Try-on processing overlay on image */
  .ps-tryon-v2-bg-img.ps-tryon-blur {
    filter: blur(8px) brightness(0.5); transform: scale(1.05);
    transition: filter 0.5s ease, transform 0.5s ease;
  }
  /* ── Try-on generation badge (left-side overlay during VTO) ── */
  .ps-tryon-badge {
    position: absolute; bottom: 16px; left: 16px; right: 16px;
    z-index: 5;
    background: #ffffff;
    border-radius: 14px;
    padding: 14px 18px;
    max-width: 420px;
    box-shadow: 0 8px 28px rgba(20, 30, 60, 0.14), 0 2px 6px rgba(20, 30, 60, 0.08);
    display: flex; flex-direction: column; gap: 10px;
    font-family: inherit;
    pointer-events: none;
  }
  .ps-tryon-badge-row {
    display: flex; align-items: center; gap: 12px;
  }
  .ps-tryon-badge-spinner {
    display: inline-flex; flex-shrink: 0;
    animation: ps-tryon-badge-spin 1s linear infinite;
  }
  .ps-tryon-badge-title {
    flex: 1; min-width: 0;
    font-size: 15px; font-weight: 600; color: #0f172a;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .ps-tryon-badge-pct {
    flex-shrink: 0;
    background: linear-gradient(135deg, var(--ps-accent) 0%, var(--ps-accent-hover) 100%);
    color: #fff; font-size: 12px; font-weight: 700;
    padding: 4px 11px; border-radius: 999px;
    letter-spacing: 0.02em;
  }
  .ps-tryon-badge-bar {
    height: 5px;
    background: #eef2f8;
    border-radius: 999px; overflow: hidden;
  }
  .ps-tryon-badge-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--ps-accent) 0%, var(--ps-accent-hover) 100%);
    border-radius: 999px;
    transition: width 0.3s ease;
  }
  .ps-tryon-badge-foot {
    display: flex; align-items: center; justify-content: space-between; gap: 10px;
    font-size: 12px; color: #6b7280;
  }
  .ps-tryon-badge-status {
    display: inline-flex; align-items: center; gap: 6px;
    font-weight: 500;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .ps-tryon-badge-status-icon {
    display: inline-flex; flex-shrink: 0; color: var(--ps-accent);
  }
  .ps-tryon-badge-eta {
    display: inline-flex; align-items: center; gap: 5px;
    font-weight: 500; flex-shrink: 0;
  }
  @keyframes ps-tryon-badge-spin {
    to { transform: rotate(360deg); }
  }
  /* Mobile sizing for the try-on badge — desktop's max-width: 420px lives
     inside a roughly 360 px image hero, leaving the pill awkwardly clipped.
     Stretch it edge-to-edge with smaller text so it always fits. */
  @media (max-width: 768px) {
    .ps-tryon-badge {
      left: 12px; right: 12px; bottom: 12px;
      max-width: none;
      padding: 12px 14px;
      gap: 8px;
      border-radius: 12px;
    }
    .ps-tryon-badge-row { gap: 10px; }
    .ps-tryon-badge-title { font-size: 13px; }
    .ps-tryon-badge-pct { font-size: 11px; padding: 3px 9px; }
    .ps-tryon-badge-foot { font-size: 11px; gap: 8px; }
  }

  /* ── Product photo strip (single-garment, below the size card) ──
     Two thumbnails per row, evenly spaced, auto-advances. Lives at
     the bottom of the right panel as decoration / entertainment. */
  .ps-tryon-photo-strip {
    margin-top: 0.65vw;
    display: flex; flex-direction: column; gap: 0.5vw;
    flex-shrink: 0;
  }
  .ps-tryon-photo-strip-head {
    display: flex; align-items: center; justify-content: space-between;
    min-height: 0.8vw;
  }
  .ps-tryon-photo-strip-badge {
    color: var(--ps-accent);
    font-size: clamp(10px, 0.64vw, 12px); font-weight: 750;
    display: inline-flex; align-items: center; gap: 0.3vw;
    letter-spacing: 0.12em; text-transform: uppercase;
  }
  .ps-tryon-photo-strip-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.45vw;
    animation: ps-tryon-photo-strip-fade 0.5s ease;
  }
  .ps-tryon-photo-strip-row.ps-count-1 {
    grid-template-columns: minmax(0, calc((100% - 0.45vw) / 2));
    justify-content: center;
  }
  .ps-tryon-photo-strip-row.ps-count-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ps-tryon-photo-strip-cell {
    position: relative;
    display: block;
    aspect-ratio: 1 / 1;
    min-height: 0;
    overflow: hidden;
    border-radius: 0.5vw;
    background: #f3f5f9;
    box-shadow: 0 0.15vw 0.5vw rgba(20, 30, 60, 0.08);
    text-decoration: none;
    color: inherit;
    transition: transform 0.25s ease;
  }
  .ps-tryon-photo-strip-cell:hover {
    transform: translateY(-0.15vw);
  }
  .ps-tryon-photo-strip-cell > img {
    width: 100%; height: 100%;
    object-fit: cover;
    object-position: center center;
    padding: 0;
    box-sizing: border-box;
    transform: none;
    transform-origin: center center;
    user-select: none;
    pointer-events: none;
  }
  .ps-tryon-photo-strip-dots {
    display: flex; justify-content: center; align-items: center; gap: 0.3vw;
    padding-top: 0.2vw;
  }
  .ps-tryon-photo-strip-dot {
    width: 0.3vw; height: 0.3vw; min-width: 4px; min-height: 4px;
    border-radius: 999px;
    background: #d6dbe4;
    transition: background-color 0.3s ease, width 0.3s ease;
  }
  .ps-tryon-photo-strip-dot.is-active {
    background: var(--ps-accent);
    width: 0.9vw; min-width: 14px;
  }
  @keyframes ps-tryon-photo-strip-fade {
    from { opacity: 0; transform: translateY(0.3vw); }
    to { opacity: 1; transform: translateY(0); }
  }
  @media (max-width: 768px) {
    .ps-tryon-v2-result-head {
      flex-direction: column; gap: 10px; margin-bottom: 12px;
    }
    .ps-tryon-v2-profile-head {
      flex: 0 0 auto; width: 100%; min-width: 0;
    }
    .ps-tryon-photo-strip {
      margin-top: 12px; gap: 8px;
    }
    .ps-tryon-photo-strip-row {
      gap: 8px;
    }
    .ps-tryon-photo-strip-row {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .ps-tryon-photo-strip-row.ps-count-1 {
      grid-template-columns: minmax(0, calc((100% - 8px) / 2));
      justify-content: center;
    }
    .ps-tryon-photo-strip-row.ps-count-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .ps-tryon-photo-strip-cell {
      aspect-ratio: 1 / 1; border-radius: 12px;
    }
    .ps-tryon-photo-strip-cell > img {
      object-position: center center;
      transform: none;
    }
  }

  /* ── No-fit empty state (single-garment, sizing match% < 50%) ── */
  .ps-tryon-nofit {
    background: #ffffff;
    border: 1px solid #eef2f8;
    border-radius: 1vw;
    padding: 3vw 2.4vw 2.6vw;
    text-align: center;
    display: flex; flex-direction: column; align-items: center;
    box-shadow: 0 0.4vw 1.2vw rgba(20, 30, 60, 0.05);
  }
  .ps-tryon-nofit-icon {
    width: 4.4vw; height: 4.4vw; min-width: 56px; min-height: 56px;
    border-radius: 50%;
    background: #fef2f2;
    color: #dc2626;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.2vw;
  }
  .ps-tryon-nofit-icon svg { width: 50%; height: 50%; }
  .ps-tryon-nofit-title {
    font-size: 1.15vw; font-weight: 700; color: #0f172a;
    margin: 0 0 0.7vw;
    line-height: 1.3;
    letter-spacing: -0.01em;
  }
  .ps-tryon-nofit-sub {
    font-size: 0.78vw; color: #6b7280;
    margin: 0 0 2vw;
    max-width: 22vw;
    line-height: 1.6;
  }
  .ps-tryon-nofit-actions {
    display: flex; align-items: center; justify-content: space-between;
    width: 100%; gap: 1vw;
    padding-top: 1.2vw;
    border-top: 1px solid #f1f4fa;
  }

  /* "I don't know" link */
  .ps-tryon-v2-dontknow {
    background: none; border: none;
    color: var(--ps-accent); font-size: 0.72vw; font-weight: 500;
    cursor: pointer; font-family: inherit;
    padding: 0.5vw 0.8vw; text-align: left;
    transition: color 0.2s;
  }
  .ps-tryon-v2-dontknow:hover { color: var(--ps-accent-light); text-decoration: underline; }

  /* Alternative links */
  .ps-tryon-v2-alt {
    display: flex; align-items: center; justify-content: center; gap: 0.4vw;
    margin-top: 0.5vw; flex-shrink: 0;
  }
  .ps-tryon-v2-alt button {
    background: none; border: none; color: rgba(33,84,239,0.5);
    font-size: 0.58vw; font-weight: 500; cursor: pointer;
    font-family: inherit; letter-spacing: 0.04em;
    transition: color 0.2s; padding: 0;
  }
  .ps-tryon-v2-alt button:hover { color: var(--ps-accent); }
  .ps-tryon-v2-alt span { color: rgba(0,0,0,0.06); font-size: 0.55vw; }

  /* Active field row highlight (legacy) */
  .ps-tryon-sf-row-active { border-bottom-color: var(--ps-accent); }
  .ps-tryon-sf-row-active .ps-tryon-sf-label { color: var(--ps-accent); }
  .ps-tryon-sizing-form-col {
    flex: 1; display: flex; flex-direction: column; justify-content: flex-start;
    padding: 0.3vw 0; min-height: 0;
  }
  .ps-tryon-sf-title {
    font-size: 1.1vw; font-weight: 300; color: var(--ps-text-primary);
    margin: 0 0 0.8vw; letter-spacing: 0.12em; text-transform: uppercase;
    text-align: left;
    background: linear-gradient(90deg, #fff 0%, rgba(0,0,0,0.5) 100%);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .ps-tryon-sf-unit-tabs {
    display: inline-flex; gap: 0; border: 1px solid rgba(0,0,0,0.06);
    border-radius: 0.3vw; overflow: hidden; margin-bottom: 1vw; align-self: flex-start;
  }
  .ps-tryon-sf-unit-tab {
    background: none; border: none; padding: 0.3vw 0.9vw;
    font-size: 0.62vw; font-weight: 600; color: rgba(0,0,0,0.25); cursor: pointer;
    font-family: inherit; transition: all 0.25s; letter-spacing: 0.06em; text-transform: uppercase;
  }
  .ps-tryon-sf-unit-tab:hover { color: rgba(0,0,0,0.5); }
  .ps-tryon-sf-unit-tab.ps-active { color: var(--ps-accent); background: rgba(33,84,239,0.08); }

  .ps-tryon-sf-profile-bar { margin-bottom: 0.7vw; }
  .ps-tryon-sf-profile-select {
    width: 100%; padding: 0.4vw; background: var(--ps-bg-secondary); color: var(--ps-text-secondary);
    border: 1px solid var(--ps-border-color); border-radius: 0.4vw;
    font-size: 0.75vw; font-family: inherit; cursor: pointer;
  }

  .ps-tryon-sf-scroll {
    flex: 1; min-height: 0; overflow-y: auto;
    scrollbar-width: thin; scrollbar-color: var(--ps-border-color) transparent;
  }
  .ps-tryon-sf-fields {
    display: flex; flex-direction: column; gap: 0.8vw;
  }
  .ps-tryon-sf-footer {
    flex-shrink: 0; padding-top: 0.6vw;
    display: flex; flex-direction: column; gap: 0.4vw;
  }

  /* ── Refined line inputs ── */
  .ps-tryon-sf-float-row {
    width: 100%;
  }
  .ps-tryon-sf-float-field {
    width: 100%; position: relative;
  }

  /* Label — subtle, editorial */
  .ps-tryon-sf-float-label {
    display: block;
    font-size: 0.58vw; font-weight: 500; color: var(--ps-text-secondary);
    letter-spacing: 0.1em; text-transform: uppercase;
    margin-bottom: 0.15vw;
    transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .ps-tryon-sf-float-field:focus-within .ps-tryon-sf-float-label {
    color: var(--ps-accent);
  }

  /* Input — elegant underline */
  .ps-tryon-sf-input {
    width: 100%; box-sizing: border-box;
    background: none; border: none;
    border-bottom: 1.5px solid rgba(0,0,0,0.15);
    color: var(--ps-text-primary);
    font-size: 0.85vw; font-weight: 300; font-family: inherit;
    padding: 0.4vw 0; letter-spacing: 0.02em;
    outline: none;
    -moz-appearance: textfield;
    transition: border-color 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .ps-tryon-sf-input:focus {
    border-bottom-color: var(--ps-accent);
  }
  .ps-tryon-sf-input:not(:placeholder-shown) {
    border-bottom-color: rgba(0,0,0,0.1);
  }
  .ps-tryon-sf-input:focus:not(:placeholder-shown) {
    border-bottom-color: var(--ps-accent);
  }
  .ps-tryon-sf-input::placeholder { color: rgba(0,0,0,0.08); }
  .ps-tryon-sf-input::-webkit-outer-spin-button,
  .ps-tryon-sf-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }

  .ps-tryon-sf-ft-group {
    display: flex; align-items: stretch; gap: 1vw; width: 100%;
  }
  .ps-tryon-sf-ft-group .ps-tryon-sf-float-field { flex: 1; }

  /* Legacy (keep for skeleton/review) */
  .ps-tryon-sf-row {
    display: flex; align-items: center; justify-content: center; gap: 1.2vw;
    padding: 1.3vw 0; max-width: 100%; margin: 0 auto;
  }
  .ps-tryon-sf-label {
    font-size: 0.78vw; font-weight: 700; color: var(--ps-text-secondary);
    letter-spacing: 0.1em; text-transform: uppercase;
    flex-shrink: 0; min-width: 5vw;
  }
  .ps-tryon-sf-input-wrap { flex: 1; display: flex; align-items: center; gap: 0.4vw; }
  .ps-tryon-sf-inline { flex: 1; display: flex; align-items: center; gap: 0.4vw; }
  .ps-tryon-sf-unit {
    font-size: 0.73vw; color: var(--ps-text-secondary); font-weight: 500; flex-shrink: 0;
  }

  .ps-tryon-sf-optional { border-top: 1px solid var(--ps-border-color); margin-top: 0.52vw; padding-top: 0.52vw; }
  .ps-tryon-sf-optional-toggle {
    display: flex; align-items: center; justify-content: space-between;
    width: 100%; padding: 0.52vw 0.73vw;
    font-size: 0.83vw; font-weight: 600; color: var(--ps-text-primary); cursor: pointer;
    font-family: inherit;
    border: 1px solid var(--ps-border-color); border-radius: 0.52vw;
    background: #161616; transition: all 0.2s;
  }
  .ps-tryon-sf-optional-toggle:hover { border-color: #555; background: #1a1a1a; }
  .ps-tryon-sf-optional-arrow {
    font-size: 0.83vw; color: var(--ps-text-secondary); transition: transform 0.3s ease; display: inline-block;
  }
  .ps-tryon-sf-optional-arrow.ps-open { transform: rotate(180deg); }
  .ps-tryon-sf-optional-fields {
    display: flex; flex-direction: column; gap: 0.8vw;
    max-height: 0; overflow: hidden; opacity: 0;
    transition: max-height 0.35s ease, opacity 0.25s ease, padding 0.35s ease;
    padding-top: 0;
  }
  .ps-tryon-sf-optional-fields.ps-open {
    max-height: 30vw; opacity: 1; padding-top: 0.7vw;
  }

  /* Mode switch — below button */
  .ps-tryon-sf-mode-switch { margin-top: 0.5vw; display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 0.25vw; }
  .ps-tryon-sf-switch-btn {
    background: none; border: none; color: rgba(33,84,239,0.7); font-size: 0.65vw;
    font-weight: 500; cursor: pointer; font-family: inherit;
    display: inline-flex; align-items: center; gap: 0.2vw;
    transition: color 0.25s; padding: 0.15vw 0; letter-spacing: 0.03em;
  }
  .ps-tryon-sf-switch-btn:hover { color: var(--ps-accent); }
  .ps-tryon-sf-switch-divider { color: rgba(0,0,0,0.08); font-size: 0.65vw; font-weight: 300; }
  .ps-tryon-sf-switch-btn svg { stroke: currentColor; width: 0.8vw; height: 0.8vw; }

  /* How to measure — overlaid on product image bottom-left */
  .ps-tryon-sf-measure-overlay {
    position: absolute; bottom: 0.6vw; left: 0.6vw;
    background: rgba(0,0,0,0.7); backdrop-filter: blur(6px);
    border: 1px solid var(--ps-border-color); color: var(--ps-text-secondary); font-size: 0.75vw;
    font-weight: 500; cursor: pointer; font-family: inherit;
    display: inline-flex; align-items: center; gap: 0.35vw;
    padding: 0.4vw 0.8vw; border-radius: 0.45vw; transition: all 0.2s;
  }
  .ps-tryon-sf-measure-overlay:hover { border-color: var(--ps-accent); color: var(--ps-text-primary); }
  .ps-tryon-sf-measure-overlay.ps-active { border-color: var(--ps-accent); color: var(--ps-accent); background: rgba(33,84,239,0.15); }
  .ps-tryon-sf-measure-overlay svg { stroke: currentColor; }

  /* Estimation review view */
  .ps-tryon-est-subtitle {
    font-size: 0.7vw; color: var(--ps-text-dim); margin: 0 0 0.8vw; line-height: 1.5; text-align: center;
  }
  .ps-tryon-est-label-group {
    display: flex; flex-direction: column; gap: 0.1vw; flex-shrink: 0; min-width: 5vw;
  }
  .ps-tryon-sf-estimated-badge {
    display: inline-block; font-size: 0.45vw; padding: 0.08vw 0.25vw;
    border-radius: 0.2vw; background: rgba(33,84,239,0.15); color: var(--ps-accent);
    letter-spacing: 0.05em; text-transform: uppercase; font-weight: 600; width: fit-content;
  }
  .ps-tryon-sf-edit-icon {
    width: 0.85vw; height: 0.85vw; stroke: #555; flex-shrink: 0; cursor: pointer;
    transition: stroke 0.2s;
  }
  .ps-tryon-sf-edit-icon:hover { stroke: var(--ps-accent); }
  .ps-tryon-est-actions {
    display: flex; align-items: center; gap: 0.8vw; margin-top: 0.6vw;
  }
  .ps-tryon-est-back {
    background: none; border: none; color: var(--ps-text-dim); cursor: pointer; font-size: 0.75vw;
    font-family: inherit; padding: 0; transition: color 0.2s; flex-shrink: 0; white-space: nowrap;
  }
  .ps-tryon-est-back:hover { color: var(--ps-accent); }
  .ps-tryon-est-submit { flex: 1; min-width: 0; }

  /* Save profile */
  .ps-tryon-sf-save { margin-top: 0.42vw; display: flex; flex-direction: column; gap: 0.36vw; }
  .ps-tryon-sf-save-check {
    display: flex; align-items: center; gap: 0.42vw; font-size: 0.73vw; color: var(--ps-text-secondary); cursor: pointer; user-select: none;
  }
  .ps-tryon-sf-save-check input[type="checkbox"] { width: 0.83vw; height: 0.83vw; accent-color: var(--ps-accent); cursor: pointer; }
  .ps-tryon-sf-save-name {
    padding: 0.42vw 0.63vw; border: 1.5px solid var(--ps-border-color); border-radius: 0.42vw;
    background: #111; color: var(--ps-text-primary); font-size: 0.73vw; font-family: inherit; outline: none;
    transition: border-color 0.2s; animation: ps-fade-up 0.2s ease both;
  }
  .ps-tryon-sf-save-name:focus { border-color: var(--ps-accent); }

  .ps-tryon-sf-error {
    color: var(--ps-error-color); font-size: 0.75vw; text-align: center; margin-top: 0.3vw;
  }
  .ps-tryon-sf-next {
    margin-top: 0.6vw; padding: 0.65vw 2vw;
    width: 100%;
    background: linear-gradient(135deg, var(--ps-accent) 0%, var(--ps-accent-light) 100%);
    color: #0c0c0c; border: none;
    border-radius: 0.4vw; font-size: 0.78vw;
    font-weight: 600; cursor: pointer; font-family: inherit;
    flex-shrink: 0; letter-spacing: 0.06em; text-transform: uppercase;
    transition: background 0.2s ease, opacity 0.2s ease;
    box-shadow: 0 0.2vw 1vw rgba(33,84,239,0.15);
    display: inline-flex; align-items: center; gap: 0.35vw;
  }
  .ps-tryon-sf-next:hover { background: var(--ps-accent-hover); }
  .ps-tryon-sf-next svg { width: 0.85vw; height: 0.85vw; stroke: currentColor; fill: none; }

  /* ══════════ Height Picker ══════════ */
  .ps-hpk {
    display: flex; flex-direction: column; align-items: center;
    height: 100%; min-height: 26vw;
  }
  .ps-hpk-title {
    font-size: 1.2vw; font-weight: 700; color: var(--ps-text-primary); margin: 0 0 0.2vw;
  }
  .ps-hpk-desc {
    font-size: 0.65vw; color: var(--ps-text-dim); margin: 0 0 0.5vw;
  }

  /* Shared toggle */
  .ps-hpk-toggle {
    display: inline-flex; border: 1.5px solid var(--ps-border-color); border-radius: 2vw; overflow: hidden;
    margin-bottom: 0.3vw;
  }
  .ps-hpk-toggle button {
    background: transparent; border: none; color: var(--ps-text-dim); font-size: 0.72vw; font-weight: 600;
    padding: 0.3vw 1.4vw; cursor: pointer; font-family: inherit; transition: all 0.15s;
  }
  .ps-hpk-toggle button.ps-on {
    background: var(--ps-accent); color: #fff; border-radius: 2vw;
  }

  /* Main visual area */
  .ps-hpk-area {
    position: relative; width: 100%; flex: 1; min-height: 18vw;
    cursor: ns-resize; touch-action: none; user-select: none;
    display: flex; align-items: flex-end; justify-content: center;
  }

  /* Value — positioned left, floats at indicator height */
  .ps-hpk-val {
    position: absolute; left: 0.5vw; transform: translateY(50%);
    display: flex; align-items: baseline; gap: 0.2vw; z-index: 4;
    pointer-events: none;
  }
  .ps-hpk-num {
    font-size: 2vw; font-weight: 800; color: var(--ps-text-primary); letter-spacing: -0.02em;
  }
  .ps-hpk-unit {
    font-size: 0.85vw; color: var(--ps-text-secondary); font-weight: 500;
  }

  /* Model — center */
  .ps-hpk-model {
    display: flex; align-items: flex-end; justify-content: center;
    transition: height 0.1s ease-out; flex-shrink: 0;
    position: relative; z-index: 1;
  }
  .ps-hpk-model img {
    height: 100%; width: auto; max-width: 10vw; object-fit: contain;
    opacity: 0.7;
    border-radius: 0.4vw;
  }

  /* Ruler — right side */
  .ps-hpk-ruler {
    position: absolute; right: 0.5vw; top: 0; bottom: 0;
    width: 4vw; z-index: 2;
  }
  .ps-hpk-ruler-line {
    position: absolute; left: 0; top: 0; bottom: 0; width: 1.5px; background: #666;
  }
  .ps-hpk-mark {
    position: absolute; left: 0; display: flex; align-items: center;
    transform: translateY(50%);
  }
  .ps-hpk-mark-tick {
    width: 0.8vw; height: 1.5px; background: #aaa;
  }
  .ps-hpk-mark-label {
    margin-left: 0.35vw; font-size: 0.75vw; color: var(--ps-text-secondary); font-weight: 600;
    white-space: nowrap;
  }
  .ps-hpk-mark-sm {
    position: absolute; left: 0; width: 0.45vw; height: 1px; background: #555;
    transform: translateY(50%);
  }

  /* Horizontal indicator line — spans full width */
  .ps-hpk-line {
    position: absolute; left: 0; right: 0; height: 2px;
    background: rgba(33,84,239,0.5); z-index: 3;
    transform: translateY(50%); pointer-events: none;
    box-shadow: 0 0 8px rgba(33,84,239,0.3);
  }
  .ps-hpk-line::before {
    content: ''; position: absolute; left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    width: 10px; height: 10px; border-radius: 50%;
    border: 2px solid var(--ps-accent); background: var(--ps-bg-secondary);
    box-shadow: 0 0 8px rgba(33,84,239,0.6);
  }

  /* ══════════ Weight Picker ══════════ */
  .ps-wpk {
    display: flex; flex-direction: column; align-items: center;
    height: 100%; justify-content: center; gap: 0.4vw;
  }
  .ps-wpk-title {
    font-size: 1.2vw; font-weight: 700; color: var(--ps-text-primary); margin: 0 0 0.2vw;
  }
  .ps-wpk-desc {
    font-size: 0.65vw; color: var(--ps-text-dim); margin: 0 0 0.5vw;
  }
  .ps-wpk-val {
    display: flex; align-items: baseline; gap: 0.3vw; margin: 1.5vw 0 1vw;
  }
  .ps-wpk-num {
    font-size: 2.8vw; font-weight: 800; color: var(--ps-text-primary); letter-spacing: -0.02em;
  }
  .ps-wpk-unit {
    font-size: 1vw; color: var(--ps-text-dim); font-weight: 500;
  }

  /* Scale */
  .ps-wpk-scale-wrap { width: 100%; padding: 0 1vw; }
  .ps-wpk-track {
    position: relative; width: 100%; height: 3.5vw;
    cursor: ew-resize; touch-action: none; user-select: none;
    border-bottom: 1.5px solid var(--ps-border-color);
  }
  .ps-wpk-tick {
    position: absolute; bottom: 0; width: 1px; height: 0.6vw; background: #444;
  }
  .ps-wpk-tick.ps-md { height: 1.1vw; background: #666; }
  .ps-wpk-tick.ps-mj { height: 1.8vw; background: #aaa; }

  .ps-wpk-indicator {
    position: absolute; top: 0; bottom: 0; transform: translateX(-50%); z-index: 3;
    display: flex; flex-direction: column; align-items: center; pointer-events: none;
  }
  .ps-wpk-ind-line { flex: 1; width: 2px; background: var(--ps-accent); }
  .ps-wpk-ind-dot {
    width: 10px; height: 10px; border-radius: 50%;
    background: var(--ps-accent); border: 2px solid var(--ps-accent); flex-shrink: 0;
    box-shadow: 0 0 8px rgba(33,84,239,0.7);
  }

  .ps-wpk-labels {
    position: relative; width: 100%; height: 1.4vw; margin-top: 0.3vw;
  }
  .ps-wpk-labels span {
    position: absolute; transform: translateX(-50%);
    font-size: 0.65vw; color: #bbb; font-weight: 600; pointer-events: none;
  }

  /* Mobile: stack vertically */
  @media (max-width: 600px) {
    .ps-tryon-sizing-split { flex-direction: column; }
    .ps-tryon-sizing-img-col { max-height: 280px; }
    .ps-tryon-sf-next { width: 100%; text-align: center; display: flex; justify-content: center; }
    .ps-tryon-sf-measure-overlay { font-size: 12px; padding: 6px 12px; gap: 5px; bottom: 8px; left: 8px; border-radius: 8px; }
    .ps-tryon-sf-mode-switch { margin-top: 8px; }
    .ps-tryon-sf-switch-btn { font-size: 12px; }
    .ps-hpk-title, .ps-wpk-title { font-size: 18px; }
    .ps-hpk-desc, .ps-wpk-desc { font-size: 11px; }
    .ps-hpk-num { font-size: 32px; }
    .ps-hpk-unit { font-size: 14px; }
    .ps-hpk-toggle button { font-size: 13px; padding: 5px 18px; }
    .ps-hpk-area { min-height: 240px; }
    .ps-hpk-model img { max-width: 100px; }
    .ps-hpk-mark-label { font-size: 12px; }
    .ps-hpk-mark-tick { width: 12px; }
    .ps-wpk-num { font-size: 38px; }
    .ps-wpk-unit { font-size: 14px; }
    .ps-wpk-track { height: 50px; }
    .ps-wpk-labels span { font-size: 10px; }
  }

  /* Keep old class names for backwards compat */
  .ps-tryon-section-title { font-size: 0.95vw; font-weight: 600; color: var(--ps-text-primary); margin: 0 0 0.8vw; }
  .ps-tryon-sg-checking { display: flex; flex-direction: column; align-items: center; padding: 2.5vw 1vw; text-align: center; }
  .ps-tryon-sg-checking-icon { color: var(--ps-accent); margin-bottom: 0.8vw; animation: ps-pulse-ruler 1.5s ease-in-out infinite; }
  .ps-tryon-sg-checking-icon svg { stroke: currentColor; fill: none; }
  @keyframes ps-pulse-ruler { 0%, 100% { transform: scale(1); opacity: 0.7; } 50% { transform: scale(1.15); opacity: 1; } }
  .ps-tryon-sg-checking-bar-wrap { width: 9vw; height: 4px; background: var(--ps-border-color); border-radius: 2px; overflow: hidden; margin-bottom: 1vw; }
  .ps-tryon-sg-checking-bar { height: 100%; width: 40%; background: linear-gradient(90deg, var(--ps-accent), var(--ps-accent-light)); border-radius: 2px; animation: ps-sg-bar 1.5s ease-in-out infinite; }
  @keyframes ps-sg-bar { 0% { transform: translateX(-100%); } 100% { transform: translateX(350%); } }
  .ps-tryon-sg-checking .ps-tryon-section-title { margin-bottom: 0.3vw; }
  .ps-tryon-sg-checking-sub { font-size: 0.75vw; color: var(--ps-text-secondary); margin: 0; }

  /* Back button */
  .ps-tryon-back { display: flex; align-items: center; gap: 0.3vw; background: none; border: none; color: var(--ps-text-secondary); font-size: 0.8vw; cursor: pointer; padding: 0; margin-bottom: 0.7vw; font-family: inherit; transition: color 0.2s; }
  .ps-tryon-back:hover { color: var(--ps-text-primary); }
  .ps-tryon-back svg { stroke: currentColor; fill: none; }

  /* Sizing form (legacy — redirect to split view) */
  .ps-tryon-sizing-form { display: flex; flex-direction: column; gap: 0.7vw; }
  .ps-tryon-input-row { display: flex; align-items: center; gap: 0.52vw; }
  .ps-tryon-input-row label { font-size: 0.68vw; font-weight: 500; color: var(--ps-text-secondary); min-width: 4.7vw; flex-shrink: 0; }
  .ps-tryon-input-row input {
    flex: 1; padding: 0.52vw 0.73vw; border: 1.5px solid var(--ps-border-color); border-radius: 0.52vw;
    background: var(--ps-bg-secondary); color: var(--ps-text-primary); font-size: 0.73vw; font-family: inherit; outline: none;
    transition: border-color 0.2s; -moz-appearance: textfield;
  }
  .ps-tryon-input-row input::-webkit-outer-spin-button,
  .ps-tryon-input-row input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  .ps-tryon-input-row input:focus { border-color: var(--ps-accent); }
  .ps-tryon-input-unit { font-size: 0.63vw; color: var(--ps-text-muted); flex-shrink: 0; }
  .ps-tryon-height-ft { display: flex; align-items: center; gap: 0.31vw; flex: 1; }
  .ps-tryon-height-ft input { width: 3.13vw; padding: 0.52vw; border: 1.5px solid var(--ps-border-color); border-radius: 0.52vw; background: var(--ps-bg-secondary); color: var(--ps-text-primary); font-size: 0.73vw; font-family: inherit; outline: none; text-align: center; -moz-appearance: textfield; }
  .ps-tryon-height-ft input::-webkit-outer-spin-button, .ps-tryon-height-ft input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  .ps-tryon-height-ft input:focus { border-color: var(--ps-accent); }
  .ps-tryon-height-ft span { font-size: 0.63vw; color: var(--ps-text-muted); }
  .ps-tryon-country-select {
    flex: 1; padding: 0.52vw 1.88vw 0.52vw 0.73vw; border: 1.5px solid var(--ps-border-color); border-radius: 0.52vw;
    background: var(--ps-bg-secondary); color: var(--ps-text-primary); font-size: 0.68vw; font-family: inherit;
    appearance: none; -webkit-appearance: none; cursor: pointer; outline: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.5 4.5L6 8L9.5 4.5' stroke='%23999' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat; background-position: right 0.73vw center;
  }
  .ps-tryon-country-select:focus { border-color: var(--ps-accent); }
  .ps-tryon-unit-toggle { display: flex; gap: 0; border: 1.5px solid var(--ps-border-color); border-radius: 0.42vw; overflow: hidden; }
  .ps-tryon-unit-btn {
    padding: 0.31vw 0.73vw; background: transparent; border: none; color: var(--ps-text-secondary);
    font-size: 0.63vw; font-weight: 600; cursor: pointer; transition: all 0.2s; font-family: inherit;
  }
  .ps-tryon-unit-btn.ps-active { background: var(--ps-accent); color: #fff; }

  /* Unit tabs (cm / inches) */
  .ps-tryon-unit-tabs {
    display: flex; gap: 0; background: var(--ps-bg-secondary); border: 1.5px solid var(--ps-border-color);
    border-radius: 0.63vw; overflow: hidden; margin-bottom: 0.83vw;
  }
  .ps-tryon-unit-tab {
    flex: 1; padding: 0.57vw 0.83vw; background: transparent; border: none;
    color: var(--ps-text-muted); font-size: 0.78vw; font-weight: 700; cursor: pointer;
    transition: all 0.2s ease; font-family: inherit; letter-spacing: 0.04em;
    position: relative;
  }
  .ps-tryon-unit-tab:first-child { border-right: 1px solid var(--ps-border-color); }
  .ps-tryon-unit-tab:hover { color: var(--ps-text-secondary); background: rgba(0,0,0,0.02); }
  .ps-tryon-unit-tab.ps-active {
    background: var(--ps-accent); color: #fff;
  }
  .ps-tryon-section-label { font-size: 0.57vw; font-weight: 700; color: var(--ps-accent); text-transform: uppercase; letter-spacing: 0.08em; margin: 0.21vw 0 0.1vw; }
  .ps-tryon-optional-section { border-top: 1px solid var(--ps-border-color); padding-top: 0.52vw; margin-top: 0.31vw; }
  .ps-tryon-optional-toggle { display: flex; align-items: center; justify-content: space-between; width: 100%; background: none; border: 1px solid var(--ps-border-color); border-radius: 0.52vw; padding: 0.52vw 0.73vw; color: var(--ps-text-secondary); font-size: 0.68vw; font-weight: 600; cursor: pointer; font-family: inherit; transition: all 0.2s; }
  .ps-tryon-optional-toggle:hover { border-color: #555; color: var(--ps-text-secondary); }
  .ps-tryon-chevron { transition: transform 0.2s; font-size: 0.73vw; }
  .ps-tryon-optional-fields { display: flex; flex-direction: column; gap: 0.52vw; padding-top: 0.63vw; }
  .ps-tryon-shoe-section { border-top: 1px solid var(--ps-border-color); padding-top: 0.73vw; margin-top: 0.31vw; display: flex; flex-direction: column; gap: 0.52vw; }
  .ps-tryon-shoe-title { font-size: 0.68vw; font-weight: 600; color: var(--ps-text-secondary); }
  .ps-tryon-disclaimer { font-size: 0.57vw; color: var(--ps-text-muted); margin: 0.21vw 0 0; }
  .ps-tryon-form-save-toggle { margin-top: 0.52vw; display: flex; flex-direction: column; gap: 0.42vw; }
  .ps-tryon-form-save-check {
    display: flex; align-items: center; gap: 0.42vw; font-size: 0.68vw; color: var(--ps-text-secondary); cursor: pointer; user-select: none;
  }
  .ps-tryon-form-save-check input[type="checkbox"] {
    width: 0.83vw; height: 0.83vw; accent-color: var(--ps-accent); cursor: pointer;
  }
  .ps-tryon-form-save-name {
    padding: 0.42vw 0.63vw; border: 1.5px solid var(--ps-border-color); border-radius: 0.52vw;
    background: var(--ps-bg-secondary); color: var(--ps-text-primary); font-size: 0.68vw; font-family: inherit; outline: none;
    transition: border-color 0.2s;
  }
  .ps-tryon-form-save-name:focus { border-color: var(--ps-accent); }

  /* Processing */
  .ps-tryon-processing { text-align: center; padding: 1.25vw; display: flex; flex-direction: column; align-items: center; }

  .ps-tryon-processing-image-wrap {
    position: relative; width: 11.5vw; height: 14.6vw; margin: 0 auto 1.25vw;
    border-radius: 0.83vw; overflow: hidden; border: 2px solid var(--ps-border-color);
  }
  .ps-tryon-processing-blur {
    position: absolute; inset: -1.04vw; background-size: cover; background-position: center;
    filter: blur(25px) brightness(0.5); transform: scale(1.2);
  }
  .ps-tryon-processing-model {
    position: relative; z-index: 1; width: 100%; height: 100%; object-fit: contain; display: block;
  }
  .ps-tryon-scan-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(180deg, rgba(33,84,239,0.05) 0%, transparent 40%, transparent 60%, rgba(33,84,239,0.05) 100%);
    pointer-events: none;
  }
  .ps-tryon-scan-line {
    position: absolute; left: 0; right: 0; height: 3px;
    background: linear-gradient(90deg, transparent, #bb945c 20%, var(--ps-accent-light) 50%, #bb945c 80%, transparent);
    box-shadow: 0 0 0.78vw rgba(33,84,239,0.6), 0 0 2.08vw rgba(33,84,239,0.2);
    animation: ps-scan 2.5s ease-in-out infinite;
    pointer-events: none; z-index: 2;
  }
  @keyframes ps-scan {
    0% { top: 0; opacity: 0; }
    5% { opacity: 1; }
    95% { opacity: 1; }
    100% { top: calc(100% - 3px); opacity: 0; }
  }

  /* Snap processing step cards */
  .ps-tryon-snap-steps {
    display: flex; flex-direction: column; gap: 1.2vw;
    justify-content: center; padding: 2vw 1.5vw;
  }
  .ps-tryon-snap-step {
    display: flex; align-items: center; gap: 0.8vw;
    padding: 0.8vw 1vw; border-radius: 0.5vw;
    background: var(--ps-bg-secondary);
    border: 1px solid var(--ps-border-subtle);
    color: var(--ps-text-muted);
    font-size: 0.83vw; font-weight: 500; font-family: inherit;
    opacity: 0.4;
    transition: all 0.4s ease;
  }
  .ps-tryon-snap-step.ps-active {
    opacity: 1; color: var(--ps-text-primary);
    border-color: var(--ps-border-color);
    animation: ps-pose-fade 0.4s ease both;
  }
  .ps-tryon-snap-step.ps-done {
    opacity: 0.7; color: var(--ps-text-secondary);
    border-color: rgba(74,222,128,0.2);
  }
  .ps-tryon-snap-step-icon {
    width: 1.4vw; height: 1.4vw;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .ps-tryon-snap-check {
    color: var(--ps-success-color); font-size: 0.9vw; font-weight: 700;
  }
  .ps-tryon-snap-num {
    color: var(--ps-text-muted); font-size: 0.7vw; font-weight: 600;
  }

  /* Pose measurement overlay — animated SVG rings on result image */
  .ps-tryon-pose-overlay {
    position: absolute; inset: 0; width: 100%; height: 100%;
    pointer-events: none; z-index: 2;
  }
  @keyframes ps-pose-draw {
    to { stroke-dashoffset: 0; }
  }
  @keyframes ps-pose-fade {
    to { opacity: 1; }
  }
  @keyframes ps-dot-pulse {
    0%, 100% { r: 8; opacity: 0.8; }
    50% { r: 12; opacity: 1; }
  }

  .ps-tryon-progress-section {
    display: flex; align-items: center; gap: 0.63vw; width: 100%; max-width: 18vw; margin-bottom: 0.83vw;
  }
  /* Shared progress layout used inside StageCycler (desktop) and
     MobileScanningView — row of ring + bar + percent, same tokens. */
  .ps-tryon-progress-wrap {
    display: flex; align-items: center; gap: 12px;
    /* Fixed width — the parent StageCycler shrinks to fit its text content,
       so any % width would reflow the bar every 2s when the stage label
       swaps. Hard 320px keeps the ring + bar + % visually stable. */
    width: 320px;
    max-width: calc(100vw - 48px);
    margin-top: 18px;
  }
  .ps-tryon-progress-wrap .ps-tryon-progress-bar-wrap {
    flex: 1; height: 6px; border-radius: 4px; overflow: hidden;
    position: relative; background: var(--ps-border-color);
  }
  .ps-tryon-progress-wrap .ps-tryon-progress-bar-fill {
    height: 100%; width: 0%;
    background: linear-gradient(90deg, var(--ps-accent), var(--ps-accent-light));
    border-radius: 4px; transition: width 0.3s ease;
  }
  .ps-tryon-progress-wrap .ps-tryon-progress-pct {
    font-size: 13px; font-weight: 700; color: var(--ps-accent);
    min-width: 36px; text-align: right;
    font-variant-numeric: tabular-nums;
  }
  .ps-tryon-progress-bar-wrap {
    flex: 1; height: 0.31vw; background: var(--ps-border-color); border-radius: 3px; overflow: hidden;
    position: relative;
  }
  .ps-tryon-progress-bar-wrap::after {
    content: ""; position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.45) 50%, transparent 100%);
    transform: translateX(-100%);
    animation: ps-progress-shimmer 2s linear infinite;
    pointer-events: none;
  }
  @keyframes ps-progress-shimmer {
    0%   { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
  .ps-tryon-progress-bar-fill {
    height: 100%; background: linear-gradient(90deg, var(--ps-accent), var(--ps-accent-light));
    border-radius: 3px; transition: width 0.3s ease; width: 0%;
    position: relative; z-index: 1;
  }
  .ps-tryon-progress-pct {
    font-size: 0.68vw; font-weight: 700; color: var(--ps-accent); min-width: 1.88vw; text-align: right;
    font-variant-numeric: tabular-nums;
  }

  /* Circular ETA ring — 64×64 px SVG with a track + progress circle; ETA
     text centered. strokeDashoffset is driven by the ticker in
     PrimeStyleTryonInner, so CSS only styles the appearance. */
  .ps-tryon-progress-ring {
    position: relative; width: 64px; height: 64px; flex: 0 0 64px;
    display: flex; align-items: center; justify-content: center;
  }
  .ps-tryon-progress-ring svg { transform: rotate(-90deg); }
  .ps-tryon-progress-ring-track {
    fill: none; stroke: var(--ps-border-color); stroke-width: 5;
  }
  .ps-tryon-progress-ring-fill {
    fill: none; stroke: var(--ps-accent); stroke-width: 5;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.3s ease;
  }
  .ps-tryon-progress-eta {
    position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 700; color: var(--ps-accent);
    font-variant-numeric: tabular-nums; letter-spacing: 0.01em;
    pointer-events: none;
  }

  @keyframes ps-scale-in { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }
  .ps-tryon-processing-text {
    font-size: 0.73vw; color: var(--ps-text-primary); margin: 0 0 0.21vw;
    opacity: 1; transition: opacity 0.18s ease;
  }
  .ps-tryon-processing-sub { font-size: 0.63vw; color: var(--ps-text-secondary); margin: 0; }

  /* ──────────────────────────────────────────────
     ProcessingView v2 — split (image left ~65%,
     panel right ~35%) with engaging cards while
     the user waits 25s for the try-on to complete.
     ────────────────────────────────────────────── */
  .ps-tryon-processing-v2 {
    display: flex; gap: 1.2vw;
    padding: 1.2vw;
    width: 100%; height: 100%;
    align-items: stretch;
  }
  .ps-tryon-processing-v2-image {
    flex: 0 0 62%;
    position: relative;
    border-radius: 0.6vw;
    overflow: hidden;
    background: var(--ps-bg-tertiary, #f3f4f6);
    min-height: 28vw;
  }
  .ps-tryon-processing-v2-image .ps-tryon-processing-blur,
  .ps-tryon-processing-v2-image .ps-tryon-processing-model {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
  }
  .ps-tryon-processing-v2-image .ps-tryon-processing-blur {
    background-size: cover; background-position: center;
    filter: blur(40px) brightness(0.8); opacity: 0.65;
  }
  .ps-tryon-processing-v2-image .ps-tryon-processing-model {
    object-fit: contain; z-index: 1;
  }
  .ps-tryon-processing-v2-badge {
    position: absolute; top: 0.8vw; left: 0.8vw; z-index: 3;
    display: inline-flex; align-items: center; gap: 0.4vw;
    padding: 0.4vw 0.7vw;
    background: rgba(33, 84, 239, 0.10);
    color: var(--ps-accent);
    border: 1px solid rgba(33, 84, 239, 0.20);
    border-radius: 999px;
    font-size: 0.6vw; font-weight: 700;
    letter-spacing: 0.12em;
  }
  .ps-tryon-processing-v2-badge-dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: var(--ps-accent);
    animation: ps-pulse-dot 1.4s ease-in-out infinite;
  }
  @keyframes ps-pulse-dot {
    0%, 100% { opacity: 0.3; transform: scale(0.85); }
    50%      { opacity: 1;   transform: scale(1.1); }
  }

  .ps-tryon-processing-v2-panel {
    flex: 1 1 38%;
    display: flex; flex-direction: column;
    gap: 0.9vw;
    padding: 0.6vw 0.4vw;
    min-width: 0;
  }
  .ps-tryon-processing-v2-head {
    text-align: center;
  }
  .ps-tryon-processing-v2-title {
    margin: 0;
    font-size: 1.1vw; font-weight: 700;
    color: var(--ps-text-primary);
    line-height: 1.25;
  }
  .ps-tryon-processing-v2-sub {
    margin: 0.3vw 0 0;
    font-size: 0.68vw; line-height: 1.45;
    color: var(--ps-text-secondary);
  }

  .ps-tryon-processing-v2-ring-wrap {
    position: relative;
    width: 180px; height: 180px;
    margin: 0.6vw auto 0;
  }
  .ps-tryon-processing-v2-ring-wrap svg {
    transform: rotate(-90deg);
    width: 180px; height: 180px;
  }
  .ps-tryon-processing-v2-ring-wrap .ps-tryon-progress-ring-track {
    fill: none; stroke: var(--ps-border-color); stroke-width: 6;
  }
  .ps-tryon-processing-v2-ring-wrap .ps-tryon-progress-ring-fill {
    fill: none; stroke: var(--ps-accent); stroke-width: 6;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.3s ease;
  }
  .ps-tryon-processing-v2-ring-text {
    position: absolute; inset: 0;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .ps-tryon-processing-v2-pct {
    font-size: 34px; font-weight: 700;
    color: var(--ps-accent);
    font-variant-numeric: tabular-nums;
    line-height: 1;
  }
  .ps-tryon-processing-v2-status {
    display: block;
    font-size: 13px; font-weight: 700;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--ps-text-muted);
    text-align: center;
    margin: 14px auto 0;
    line-height: 1.3;
  }

  .ps-tryon-processing-v2-bar-hidden {
    display: none;
  }

  .ps-tryon-processing-v2-sep {
    height: 1px; width: 100%;
    background: var(--ps-border-subtle, rgba(0,0,0,0.06));
    margin: 0.4vw 0 0;
  }

  .ps-tryon-processing-v2-section-label {
    font-size: 0.6vw; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--ps-text-muted);
    margin-bottom: 0.5vw;
  }
  .ps-tryon-processing-v2-cards {
    display: flex; flex-direction: column; gap: 0.5vw;
  }
  .ps-tryon-processing-v2-card {
    display: flex; align-items: flex-start; gap: 0.6vw;
    padding: 0.7vw 0.8vw;
    background: var(--ps-bg-secondary, #f9fafb);
    border: 1px solid var(--ps-border-subtle, rgba(0,0,0,0.06));
    border-radius: 0.55vw;
  }
  .ps-tryon-processing-v2-card-icon {
    width: 1.7vw; height: 1.7vw;
    min-width: 28px; min-height: 28px;
    display: flex; align-items: center; justify-content: center;
    border-radius: 50%;
    flex-shrink: 0;
  }
  .ps-tryon-processing-v2-card-icon.ps-style    { background: rgba(33, 84, 239, 0.10); color: var(--ps-accent); }
  .ps-tryon-processing-v2-card-icon.ps-spotlight { background: rgba(168, 85, 247, 0.10); color: #9333ea; }
  .ps-tryon-processing-v2-card-icon.ps-fact     { background: rgba(16, 185, 129, 0.10); color: #059669; }
  .ps-tryon-processing-v2-card-text {
    flex: 1; min-width: 0;
  }
  .ps-tryon-processing-v2-card-head {
    font-size: 0.7vw; font-weight: 700;
    color: var(--ps-text-primary);
    margin-bottom: 2px;
  }
  .ps-tryon-processing-v2-card-body {
    font-size: 0.65vw; line-height: 1.5;
    color: var(--ps-text-secondary);
    animation: ps-fade-in 0.4s ease;
  }
  @keyframes ps-fade-in {
    from { opacity: 0; transform: translateY(2px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .ps-tryon-processing-v2-cancel {
    margin-top: auto;
    background: transparent; border: none;
    color: var(--ps-text-muted);
    font-family: inherit;
    font-size: 0.68vw; font-weight: 600;
    cursor: pointer;
    padding: 0.3vw 0;
    text-align: center;
    width: 100%;
    transition: color 0.15s;
  }
  .ps-tryon-processing-v2-cancel:hover { color: var(--ps-text-primary); }

  /* Result — split layout */
  .ps-tryon-result-split {
    display: flex; gap: 1.5vw; text-align: left; align-items: flex-start;
  }
  .ps-tryon-result-img-col {
    flex: 0 0 48%; min-width: 0; min-height: 0; display: flex; flex-direction: column; align-items: center; gap: 0.63vw;
  }
  .ps-tryon-result-img-col img {
    width: 100%; max-height: calc(80vh - 8vw); object-fit: contain; border-radius: 0.73vw;
    box-shadow: 0 0.42vw 1.67vw rgba(0,0,0,0.3); animation: ps-scale-in 0.5s ease both;
  }
  .ps-tryon-result-dl-btn {
    display: inline-flex; align-items: center; gap: 0.31vw;
    padding: 0.36vw 0.83vw; background: transparent; border: 1px solid var(--ps-border-color);
    border-radius: 0.42vw; color: var(--ps-text-secondary); font-size: 0.68vw; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: all 0.2s;
  }
  .ps-tryon-result-dl-btn:hover { border-color: var(--ps-accent); color: var(--ps-accent); }
  .ps-tryon-result-dl-btn svg { stroke: currentColor; }
  .ps-tryon-result-info-col {
    flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1vw;
  }
  .ps-tryon-result-fit {
    display: flex; flex-direction: column; gap: 0.36vw;
  }
  .ps-tryon-result-fit-row {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0.42vw 0; border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-tryon-result-fit-area { font-size: 0.78vw; font-weight: 600; color: var(--ps-text-secondary); }
  .ps-tryon-result-actions-col {
    display: flex; flex-direction: column; gap: 0.42vw; margin-top: 0.52vw;
  }
  .ps-tryon-result-startover {
    background: none; border: none; color: var(--ps-text-muted); font-size: 0.68vw;
    font-weight: 600; cursor: pointer; font-family: inherit; transition: color 0.2s;
    text-align: center;
  }
  .ps-tryon-result-startover:hover { color: var(--ps-text-secondary); }
  /* Legacy result layout */
  .ps-tryon-result-layout { text-align: center; }
  .ps-tryon-result-layout img { width: 100%; border-radius: 0.63vw; margin-bottom: 0.83vw; }
  .ps-tryon-result-actions { display: flex; gap: 0.42vw; margin-top: 0.83vw; }
  .ps-tryon-result-actions button {
    flex: 1; padding: 0.63vw; font-family: var(--ps-modal-font, system-ui, sans-serif);
    font-size: 0.68vw; font-weight: 600; border-radius: 0.52vw; cursor: pointer; transition: all 0.2s; border: none;
  }
  .ps-tryon-btn-download { background: var(--ps-accent); color: #fff; }
  .ps-tryon-btn-download:hover { opacity: 0.9; }
  .ps-tryon-btn-retry { background: rgba(0,0,0,0.06); color: var(--ps-text-primary); border: 1px solid var(--ps-border-color) !important; }
  .ps-tryon-btn-retry:hover { background: rgba(0,0,0,0.08); }

  /* ── Size Result ── */
  .ps-tryon-sr { flex: 1; display: flex; flex-direction: column; min-height: 0; overflow: hidden; }
  .ps-tryon-sr-loading { text-align: center; padding: 3vw 0; }
  .ps-tryon-sr-loading p { font-size: 0.83vw; color: var(--ps-text-muted); margin-top: 0.6vw; }
  .ps-tryon-size-loading-spinner {
    width: 1.8vw; height: 1.8vw; border: 2px solid var(--ps-border-color);
    border-top-color: var(--ps-accent); border-radius: 50%;
    animation: ps-spin 0.7s linear infinite; margin: 0 auto;
  }
  .ps-bp-profile-hydrating {
    min-height: min(52vh, 420px);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: clamp(10px, 0.7vw, 14px);
    color: var(--ps-text-secondary);
    font-size: clamp(13px, 0.82vw, 15px);
    font-weight: 650;
  }
  .ps-bp-profile-hydrating .ps-tryon-size-loading-spinner {
    width: clamp(18px, 1.25vw, 22px);
    height: clamp(18px, 1.25vw, 22px);
    flex-shrink: 0;
    margin: 0;
  }
  @keyframes ps-spin { to { transform: rotate(360deg); } }
  .ps-tryon-sr-loading-pulse { animation: ps-loading-pulse 2s ease-in-out infinite; }
  @keyframes ps-loading-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.6; } }

  .ps-tryon-sr-split { display: grid; grid-template-columns: 1fr 1.2fr; gap: 1.5vw; flex: 1; min-height: 0; overflow: hidden; }

  /* Left: product image */
  .ps-tryon-sr-img-col {
    position: relative; border-radius: 0.8vw; overflow: hidden; background: transparent;
  }
	  .ps-tryon-sr-product-img {
	    width: 100%; height: 100%;
	    object-fit: contain; object-position: center center;
	    display: block; border-radius: 0.8vw;
	  }
	  .ps-result-image-pending {
	    opacity: 0;
	  }
	  .ps-result-image-loading {
	    position: absolute;
	    inset: 0;
	    z-index: 4;
	    display: flex;
	    flex-direction: column;
	    align-items: center;
	    justify-content: center;
	    gap: max(8px, 0.55vw);
	    background:
	      radial-gradient(circle at 50% 36%, rgba(33,84,239,0.12), transparent 34%),
	      rgba(248,250,255,0.94);
	    color: var(--ps-accent);
	    font-size: max(12px, 0.72vw);
	    font-weight: 700;
	    letter-spacing: 0.01em;
	    text-align: center;
	    pointer-events: none;
	  }
	  .ps-result-image-loading-spinner {
	    width: max(22px, 1.35vw);
	    height: max(22px, 1.35vw);
	    border: 2px solid rgba(33,84,239,0.18);
	    border-top-color: var(--ps-accent);
	    border-radius: 999px;
	    animation: ps-spin 0.72s linear infinite;
	  }
  .ps-tryon-sr-chart-btn {
    position: absolute; bottom: 1vw; left: 1vw;
    background: rgba(255,255,255,0.95); color: var(--ps-text-primary); border: none;
    padding: 0.4vw 0.8vw; border-radius: 0.3vw; font-size: 0.7vw; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: all 0.2s;
  }
  .ps-tryon-sr-chart-btn:hover { background: #fff; }

  /* Right column — scrolls independently */
  .ps-tryon-sr-right-col {
    display: flex; flex-direction: column; gap: 0.8vw;
    overflow-y: auto; min-height: 0;
    scrollbar-width: thin; scrollbar-color: var(--ps-border-color) transparent;
  }
  .ps-tryon-sr-right-fixed {
    overflow: hidden;
  }
  .ps-tryon-sr-right-scroll {
    flex: 1; min-height: 0; overflow-y: auto;
    scrollbar-width: thin; scrollbar-color: var(--ps-border-color) transparent;
  }

  /* Size hero — big letter + label */
  .ps-tryon-sr-size-hero { display: flex; align-items: flex-start; gap: 0.8vw; }
  .ps-tryon-sr-size-letter {
    font-size: 3vw; font-weight: 800; color: var(--ps-text-primary); line-height: 1; letter-spacing: -0.02em;
  }
  .ps-tryon-sr-size-meta { display: flex; flex-direction: column; gap: 0.15vw; padding-top: 0.3vw; }
  .ps-tryon-sr-size-label { font-size: 0.65vw; font-weight: 700; color: var(--ps-text-dim); text-transform: uppercase; letter-spacing: 0.1em; }
  .ps-tryon-sr-size-label.ps-not-rec { color: var(--ps-error-color); }
  .ps-tryon-sr-edit-link {
    background: none; border: none; color: var(--ps-accent); font-size: 0.7vw; font-weight: 500;
    cursor: pointer; font-family: inherit; text-decoration: underline; padding: 0; text-align: left;
  }
  .ps-tryon-sr-edit-link:hover { color: var(--ps-accent-light); }

  /* Size changed */
  .ps-tryon-sr-size-changed {
    display: inline-flex; align-items: center; gap: 0.3vw;
    padding: 0.3vw 0.6vw; border-radius: 0.3vw;
    background: rgba(33,84,239,0.08); border: 1px solid rgba(33,84,239,0.2);
    font-size: 0.7vw; color: var(--ps-accent-light);
  }
  .ps-tryon-sr-size-changed svg { stroke: var(--ps-accent); }
  .ps-tryon-sr-size-changed strong { color: var(--ps-text-primary); }

  /* Tabs */
  .ps-tryon-sr-tabs { display: flex; border-bottom: 1.5px solid var(--ps-border-color); margin-top: 3.5vh; }
  .ps-tryon-sr-tab {
    background: none; border: none; padding: 0.4vw 0.8vw; margin-bottom: -1.5px;
    font-size: 0.75vw; font-weight: 600; color: var(--ps-text-muted); cursor: pointer;
    font-family: inherit; border-bottom: 2px solid transparent; transition: all 0.2s;
  }
  .ps-tryon-sr-tab:hover { color: var(--ps-text-secondary); }
  .ps-tryon-sr-tab.ps-active { color: var(--ps-text-primary); border-bottom-color: var(--ps-accent); }

  /* Fit list — "Your fit" tab */
  /* ── Fit table ── */
  .ps-tryon-sr-fit-table {
    width: 100%; border-collapse: collapse; font-size: 0.85vw; margin-top: 0.8vw;
  }
  .ps-tryon-sr-fit-table thead th {
    font-size: 0.7vw; font-weight: 500; color: #aaa; text-transform: uppercase;
    letter-spacing: 0.05em; padding: 0.3vw 0 0.5vw; text-align: left;
    border-bottom: 1px solid var(--ps-border-color);
  }
  .ps-tryon-sr-fit-table thead th:last-child { text-align: right; }
  .ps-tryon-sr-fit-table tbody tr { border-bottom: 1px solid var(--ps-border-subtle); }
  .ps-tryon-sr-fit-table tbody tr:last-child { border-bottom: none; }
  .ps-tryon-sr-fit-table td { padding: 0.75vw 0; vertical-align: middle; color: var(--ps-text-primary); }
  .ps-tryon-sr-fit-table td:last-child { text-align: right; }
  .ps-tryon-sr-ft-area { font-weight: 600; color: var(--ps-text-primary); }
  .ps-tryon-sr-ft-you { color: var(--ps-text-primary); font-weight: 600; }
  .ps-tryon-sr-ft-garment { color: var(--ps-text-secondary); }
  .ps-tryon-sr-fit-status {
    font-size: 0.65vw; font-weight: 600; padding: 0.18vw 0.45vw; border-radius: 0.25vw;
    white-space: nowrap; display: inline-block;
  }
  .ps-tryon-sr-fit-status.ps-fit-good { color: #4ade80; background: rgba(74,222,128,0.12); }
  .ps-tryon-sr-fit-status.ps-fit-a-bit-tight { color: #f59e0b; background: rgba(245,158,11,0.12); }
  .ps-tryon-sr-fit-status.ps-fit-tight { color: #e87040; background: rgba(232,112,64,0.12); }
  .ps-tryon-sr-fit-status.ps-fit-too-tight { color: #dc2626; background: rgba(220,38,38,0.12); }
  .ps-tryon-sr-fit-status.ps-fit-a-bit-loose { color: #f59e0b; background: rgba(245,158,11,0.12); }
  .ps-tryon-sr-fit-status.ps-fit-loose { color: #e87040; background: rgba(232,112,64,0.12); }
  .ps-tryon-sr-fit-status.ps-fit-too-loose { color: #dc2626; background: rgba(220,38,38,0.12); }

  /* ── Size guide fit list (chart tab) ── */
  .ps-tryon-sr-fit-list { display: flex; flex-direction: column; gap: 0; }
  .ps-tryon-sr-fit-item {
    padding: 0.55vw 0; border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-tryon-sr-fit-item:last-child { border-bottom: none; }
  .ps-tryon-sr-fit-head {
    display: flex; justify-content: space-between; align-items: baseline;
  }
  .ps-tryon-sr-fit-area { font-size: 0.8vw; font-weight: 600; color: var(--ps-text-primary); }
  .ps-tryon-sr-fit-range { font-size: 0.8vw; font-weight: 600; color: var(--ps-text-dim); }
  .ps-tryon-sr-fit-note { font-size: 0.6vw; color: #555; margin-top: 0.5vw; text-align: center; }

  /* ── Upload photo modal (inline in size result) ── */
  .ps-tryon-upload-modal-overlay {
    position: absolute; inset: 0; z-index: 20;
    background: rgba(0,0,0,0.7); backdrop-filter: blur(4px);
    display: flex; align-items: center; justify-content: center;
    border-radius: var(--ps-modal-radius, 0.83vw);
  }
  .ps-tryon-upload-modal {
    background: var(--ps-bg-secondary); border: 1px solid var(--ps-border-color); border-radius: 0.83vw;
    padding: 1.2vw; width: 80%; max-width: 22vw;
    display: flex; flex-direction: column; gap: 0.8vw;
  }
  .ps-tryon-upload-modal-header {
    display: flex; justify-content: space-between; align-items: center;
  }
  .ps-tryon-upload-modal-header h3 {
    font-size: 0.85vw; font-weight: 600; color: var(--ps-text-primary); margin: 0;
  }
  .ps-tryon-upload-modal-close {
    background: none; border: none; color: var(--ps-text-secondary); font-size: 1.2vw;
    cursor: pointer; line-height: 1; padding: 0;
  }
  .ps-tryon-upload-modal-close:hover { color: var(--ps-text-primary); }
  .ps-tryon-upload-modal-dropzone {
    border: 1.5px dashed #444; border-radius: 0.6vw; padding: 1.5vw;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 0.4vw; cursor: pointer; transition: all 0.2s; min-height: 8vw;
  }
  .ps-tryon-upload-modal-dropzone:hover { border-color: var(--ps-accent); }
  .ps-tryon-upload-modal-dropzone.ps-drag-over { border-color: var(--ps-accent); background: rgba(33,84,239,0.06); }
  .ps-tryon-upload-modal-dropzone svg { color: var(--ps-text-muted); }
  .ps-tryon-upload-modal-dropzone p {
    font-size: 0.75vw; color: var(--ps-text-secondary); margin: 0; font-weight: 500;
  }
  .ps-tryon-upload-modal-dropzone span {
    font-size: 0.6vw; color: var(--ps-text-muted);
  }
  .ps-tryon-upload-modal-preview {
    position: relative; border-radius: 0.6vw; overflow: hidden;
    max-height: 14vw; display: flex; align-items: center; justify-content: center;
    background: #111;
  }
  .ps-tryon-upload-modal-preview img {
    width: 100%; max-height: 14vw; object-fit: contain;
  }
  .ps-tryon-upload-modal-remove {
    position: absolute; top: 0.3vw; right: 0.3vw;
    width: 1.3vw; height: 1.3vw; border-radius: 50%;
    background: rgba(0,0,0,0.7); border: none; color: var(--ps-text-primary);
    font-size: 0.8vw; cursor: pointer; display: flex;
    align-items: center; justify-content: center;
  }
  .ps-tryon-upload-modal-remove:hover { background: #dc2626; }

  .ps-tryon-sr-full-chart-btn {
    display: flex; align-items: center; justify-content: center; gap: 0.3vw;
    margin: 0.6vw auto 0; padding: 0.4vw 1vw;
    border: 1.5px solid var(--ps-border-color); border-radius: 0.4vw; background: transparent;
    color: var(--ps-text-secondary); font-size: 0.7vw; font-weight: 600; cursor: pointer;
    font-family: inherit; transition: all 0.2s;
  }
  .ps-tryon-sr-full-chart-btn:hover { border-color: var(--ps-accent); color: var(--ps-accent); }

  /* Chart table — "Size guide" tab */
  /* Full-screen overlay inside the modal */
  .ps-tryon-sr-chart-overlay {
    position: absolute; inset: 0; z-index: 50;
    background: var(--ps-modal-bg, #FFFFFF);
    display: flex; flex-direction: column;
    animation: ps-fade-in 0.2s ease;
    overflow: hidden;
  }
  .ps-tryon-sr-chart-modal, .ps-tryon-guide-modal {
    display: flex; flex-direction: column;
    flex: 1; min-height: 0; width: 100%; height: 100%;
  }
  .ps-tryon-sr-chart-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0.7vw 1.2vw; border-bottom: 1px solid var(--ps-border-color); flex-shrink: 0;
  }
  .ps-tryon-sr-chart-header h4 { margin: 0; font-size: 0.85vw; font-weight: 700; color: var(--ps-text-primary); }
  .ps-tryon-sr-chart-close {
    background: none; border: none; color: var(--ps-text-muted); font-size: 1.1vw; cursor: pointer; padding: 0.2vw;
    font-family: inherit; transition: color 0.2s;
  }
  .ps-tryon-sr-chart-close:hover { color: var(--ps-text-primary); }
  .ps-tryon-sr-chart-scroll { padding: 1vw 1.2vw; overflow-y: auto; flex: 1; min-height: 0; }

  /* Photo guide — side by side */
  .ps-tryon-guide-modal { }
  .ps-tryon-guide-split {
    display: flex; flex: 1; min-height: 0; gap: 0; overflow: hidden;
  }
  .ps-tryon-guide-left {
    flex: 1; display: flex; flex-direction: column; gap: 0.6vw;
    padding: 1vw; border-right: 1px solid #282828;
    justify-content: center; min-height: 0; overflow: hidden;
  }
  .ps-tryon-guide-right {
    flex: 1; display: flex; flex-direction: column; gap: 0.6vw;
    padding: 0.8vw; overflow-y: auto; min-height: 0;
    scrollbar-width: thin; scrollbar-color: var(--ps-border-color) transparent;
  }
  .ps-tryon-guide-right::-webkit-scrollbar { width: 4px; }
  .ps-tryon-guide-right::-webkit-scrollbar-track { background: transparent; }
  .ps-tryon-guide-right::-webkit-scrollbar-thumb { background: var(--ps-border-color); border-radius: 2px; }

  /* Upload dropzone */
  .ps-tryon-guide-dropzone {
    border: 1.5px dashed var(--ps-border-color); border-radius: 0.6vw; padding: 1.5vw 1vw;
    display: flex; flex-direction: column; align-items: center; gap: 0.3vw;
    cursor: pointer; transition: all 0.2s; text-align: center;
  }
  .ps-tryon-guide-dropzone:hover, .ps-tryon-guide-dropzone.ps-drag {
    border-color: var(--ps-accent); background: rgba(33,84,239,0.05);
  }
  .ps-tryon-guide-dropzone svg { color: #555; stroke: #555; }
  .ps-tryon-guide-dropzone-text { margin: 0; font-size: 0.9vw; color: var(--ps-text-primary); font-weight: 600; }
  .ps-tryon-guide-dropzone p { margin: 0; font-size: 0.65vw; color: var(--ps-text-secondary); font-weight: 500; }
  .ps-tryon-guide-dropzone span { font-size: 0.52vw; color: var(--ps-text-muted); }
  .ps-tryon-guide-dropzone.ps-has-file { padding: 0; cursor: default; border-style: solid; flex: 1; min-height: 0; overflow: hidden; }

  /* Preview inside dropzone */
  .ps-tryon-guide-preview { position: relative; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; overflow: hidden; }
  .ps-tryon-guide-preview img {
    max-width: 100%; max-height: 100%; object-fit: contain;
    display: block; border-radius: 0.5vw;
    background: var(--ps-modal-bg, #FFFFFF);
  }
  .ps-tryon-guide-preview-remove {
    position: absolute; top: 0.4vw; right: 0.4vw;
    width: 1.4vw; height: 1.4vw; display: flex; align-items: center; justify-content: center;
    background: rgba(0,0,0,0.7); border: 1px solid rgba(0,0,0,0.1); border-radius: 50%;
    color: var(--ps-text-primary); font-size: 0.65vw; cursor: pointer; font-family: inherit;
    transition: all 0.2s;
  }
  .ps-tryon-guide-preview-remove:hover { background: rgba(239,68,68,0.8); }


  /* Selected file row */
  .ps-tryon-guide-file {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0.45vw 0.7vw; background: #222; border-radius: 0.4vw; border: 1px solid var(--ps-border-color);
  }
  .ps-tryon-guide-file-name { font-size: 0.6vw; color: var(--ps-text-secondary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .ps-tryon-guide-file-remove {
    background: none; border: none; color: #e55; font-size: 0.55vw; cursor: pointer; font-family: inherit;
    padding: 0.1vw 0.3vw; transition: color 0.2s;
  }
  .ps-tryon-guide-file-remove:hover { color: #f77; }

  /* Tips section */
  .ps-tryon-guide-tips {
    border: 1px solid #282828; border-radius: 0.5vw; overflow: hidden;
  }
  .ps-tryon-guide-tips-header {
    display: flex; align-items: center; gap: 0.4vw;
    padding: 0.5vw 0.7vw; background: #1e1f1e; font-size: 0.75vw; font-weight: 700; color: var(--ps-text-primary);
  }
  .ps-tryon-guide-tips-header svg { stroke: var(--ps-accent); }
  .ps-tryon-guide-tips-grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 0;
  }
  .ps-tryon-guide-do, .ps-tryon-guide-dont { padding: 0.5vw 0.7vw; }
  .ps-tryon-guide-do { background: rgba(34,197,94,0.06); border-right: 1px solid #282828; }
  .ps-tryon-guide-dont { background: rgba(239,68,68,0.06); }
  .ps-tryon-guide-do-title { font-size: 0.68vw; font-weight: 700; color: #4ade80; display: block; margin-bottom: 0.3vw; }
  .ps-tryon-guide-dont-title { font-size: 0.68vw; font-weight: 700; color: #f87171; display: block; margin-bottom: 0.3vw; }
  .ps-tryon-guide-do ul, .ps-tryon-guide-dont ul {
    margin: 0; padding: 0 0 0 0.8vw; list-style: disc;
  }
  .ps-tryon-guide-do li, .ps-tryon-guide-dont li {
    font-size: 0.58vw; color: #bbb; line-height: 1.7;
  }
  .ps-tryon-guide-do li { color: #a7f3d0; }
  .ps-tryon-guide-dont li { color: #fca5a5; }

  /* Quick tip */
  .ps-tryon-guide-quicktip {
    display: flex; gap: 0.4vw; padding: 0.5vw 0.7vw;
    background: rgba(59,130,246,0.08); border: 1px solid rgba(59,130,246,0.2); border-radius: 0.5vw;
  }
  .ps-tryon-guide-quicktip-icon { font-size: 0.8vw; flex-shrink: 0; }
  .ps-tryon-guide-quicktip-title { font-size: 0.68vw; font-weight: 700; color: #60a5fa; display: block; }
  .ps-tryon-guide-quicktip p { margin: 0.15vw 0 0; font-size: 0.6vw; color: #93c5fd; line-height: 1.5; }

  /* Privacy note */
  .ps-tryon-guide-privacy {
    display: flex; gap: 0.4vw; padding: 0.5vw 0.7vw;
    background: rgba(239,68,68,0.05); border: 1px solid rgba(239,68,68,0.15); border-radius: 0.5vw;
  }
  .ps-tryon-guide-privacy-icon { font-size: 0.8vw; flex-shrink: 0; }
  .ps-tryon-guide-privacy-title { font-size: 0.68vw; font-weight: 700; color: #f87171; display: block; }
  .ps-tryon-guide-privacy p { margin: 0.15vw 0 0; font-size: 0.6vw; color: #fca5a5; line-height: 1.5; }

  /* Section title in full chart */
  .ps-tryon-chart-section { margin-bottom: 1.2vw; }
  .ps-tryon-chart-section:last-child { margin-bottom: 0; }
  .ps-tryon-chart-section-title {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0.4vw 0; margin-bottom: 0.4vw;
    border-bottom: 1px solid var(--ps-border-color); font-size: 0.75vw; font-weight: 700; color: var(--ps-text-primary);
  }
  .ps-tryon-chart-section-rec {
    font-size: 0.6vw; font-weight: 500; color: var(--ps-text-secondary);
  }
  .ps-tryon-chart-section-rec strong {
    color: var(--ps-accent); font-weight: 700; font-size: 0.7vw;
  }
  .ps-active-row td { color: var(--ps-text-primary) !important; background: rgba(33,84,239,0.1); }
  .ps-active-row .ps-size-col { color: var(--ps-accent) !important; font-weight: 700; }

  .ps-tryon-sr-chart-table-wrap { overflow-x: auto; max-height: 14vw; overflow-y: auto; }
  .ps-tryon-sr-chart-table { width: 100%; font-size: 0.7vw; border-collapse: collapse; }
  .ps-tryon-sr-chart-table th {
    text-align: left; padding: 0.35vw 0.5vw; color: var(--ps-text-muted); font-weight: 600;
    border-bottom: 1px solid var(--ps-border-color); position: sticky; top: 0; background: var(--ps-bg-secondary); color: var(--ps-text-primary);
  }
  .ps-tryon-sr-chart-table td { padding: 0.3vw 0.5vw; color: var(--ps-text-secondary); border-bottom: 1px solid var(--ps-border-subtle); }
  .ps-tryon-sr-chart-active td { color: var(--ps-text-primary); background: rgba(33,84,239,0.08); }

  /* Size chips */
  .ps-tryon-sr-chips { display: flex; flex-wrap: wrap; gap: 0.4vw; justify-content: center; margin-top: 3.5vh; }
  .ps-tryon-sr-chip {
    min-width: 2.2vw; height: auto; display: flex; flex-direction: column; align-items: center; justify-content: center;
    border: 1.5px solid var(--ps-border-color); border-radius: 0.4vw; background: transparent;
    color: var(--ps-text-secondary); font-size: 0.75vw; font-weight: 600; cursor: pointer;
    font-family: inherit; transition: all 0.2s; padding: 0.3vw 0.8vw; gap: 0.1vw;
  }
  .ps-tryon-sr-chip-hint { font-size: 0.58vw; font-weight: 400; color: var(--ps-text-muted); text-transform: lowercase; }
  .ps-tryon-sr-chip:hover { border-color: #555; color: var(--ps-text-secondary); }
  .ps-tryon-sr-chip.ps-active { background: var(--ps-accent); border-color: var(--ps-accent); color: #fff; }
  .ps-tryon-sr-chip.ps-active .ps-tryon-sr-chip-hint { color: #fff; }

  /* Multi-section layout (tuxedo, suit, set products) */
  .ps-tryon-sr-split-multi { grid-template-columns: 1fr 1fr; }
  .ps-tryon-sr-img-col-small { }
  .ps-tryon-sr-multi-top {
    display: flex; align-items: center; justify-content: space-between;
    padding-bottom: 0.5vw; margin-bottom: 0.4vw;
    border-bottom: 1px solid rgba(0,0,0,0.03);
  }
  .ps-tryon-sr-multi-title {
    font-size: 0.9vw; font-weight: 300; color: var(--ps-text-primary);
    letter-spacing: 0.15em; text-transform: uppercase;
  }

  /* ── Full-width section picker — redesigned ── */
  .ps-tryon-sr-picker {
    display: flex; flex-direction: column; gap: 0.6vw;
    padding: 0;
  }
  .ps-tryon-sr-picker-actions {
    display: flex; align-items: center; justify-content: flex-end; gap: 0.8vw;
  }

  /* Card row */
  .ps-tryon-sec-row {
    display: flex; gap: 0.5vw;
  }
  .ps-tryon-sec-row-compact { flex-wrap: wrap; }
  .ps-tryon-sec-row-compact .ps-tryon-sec-bigcard { min-width: 40%; flex: 1 1 40%; }

  .ps-tryon-sec-bigcard {
    position: relative; overflow: hidden;
    display: flex; flex-direction: column;
    background: #0e0e0e; border: 1px solid rgba(0,0,0,0.04); border-radius: 0.7vw;
    cursor: pointer; font-family: inherit;
    text-align: center; flex: 1; min-width: 0; padding: 0;
    transition: border-color 0.4s, transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s;
    animation: ps-card-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    opacity: 0;
  }
  .ps-tryon-sec-bigcard:nth-child(1) { animation-delay: 0s; }
  .ps-tryon-sec-bigcard:nth-child(2) { animation-delay: 0.08s; }
  .ps-tryon-sec-bigcard:nth-child(3) { animation-delay: 0.16s; }
  .ps-tryon-sec-bigcard:nth-child(4) { animation-delay: 0.24s; }
  @keyframes ps-card-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .ps-tryon-sec-bigcard:hover {
    border-color: var(--ps-accent);
    transform: translateY(-0.2vw) scale(1.015);
    box-shadow: 0 0.8vw 2.5vw rgba(0,0,0,0.5), 0 0 0 1px rgba(33,84,239,0.1);
  }
  .ps-tryon-sec-bigcard:not(.ps-has-img) {
    align-items: center; justify-content: center;
    padding: 1.2vw 0.8vw; min-height: 14vw; gap: 0.3vw;
  }

  /* Image */
  .ps-tryon-sec-bigcard-bg {
    width: 100%; height: 100%; max-height: 20vw; display: block;
    object-fit: contain; object-position: center center;
    border-radius: 0.7vw 0.7vw 0 0;
    transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  }
  .ps-tryon-sec-bigcard:hover .ps-tryon-sec-bigcard-bg {
    transform: scale(1.03);
  }

  /* Gradient overlay */
  .ps-tryon-sec-bigcard-overlay {
    position: absolute; bottom: 0; left: 0; right: 0;
    height: 65%;
    background: linear-gradient(to top, #0e0e0e 0%, rgba(14,14,14,0.85) 40%, transparent 100%);
    z-index: 1;
  }

  /* Text content */
  .ps-tryon-sec-bigcard-content {
    position: absolute; bottom: 0; left: 0; right: 0; z-index: 2;
    display: flex; flex-direction: column; align-items: center; gap: 0.15vw;
    padding: 0.8vw 0.5vw;
  }

  /* Fallback icon (no image) */
  .ps-tryon-sec-bigcard-icon {
    width: 2.8vw; height: 2.8vw;
    display: flex; align-items: center; justify-content: center;
    background: rgba(33,84,239,0.06); border: 1px solid rgba(33,84,239,0.12);
    border-radius: 50%;
    color: var(--ps-accent); transition: all 0.3s;
  }
  .ps-tryon-sec-bigcard:hover .ps-tryon-sec-bigcard-icon {
    background: rgba(33,84,239,0.12); border-color: rgba(33,84,239,0.25);
    transform: scale(1.06);
  }
  .ps-tryon-sec-bigcard-icon svg { stroke: currentColor; }

  .ps-tryon-sec-bigcard-name {
    font-size: 0.68vw; font-weight: 400; color: rgba(255,255,255,0.7);
    text-transform: uppercase; letter-spacing: 0.1em; line-height: 1.2;
    text-shadow: 0 1px 6px rgba(0,0,0,0.8);
  }
  .ps-tryon-sec-bigcard-size {
    font-size: 2.2vw; font-weight: 200; color: var(--ps-text-primary);
    text-shadow: 0 2px 8px rgba(0,0,0,0.5);
    line-height: 1; letter-spacing: -0.02em;
  }
  .ps-tryon-sec-bigcard-badge {
    font-size: 0.45vw; font-weight: 600; text-transform: uppercase;
    color: var(--ps-accent); background: none;
    border: 1px solid rgba(33,84,239,0.3);
    padding: 0.12vw 0.45vw; border-radius: 2vw; letter-spacing: 0.08em;
  }
  .ps-tryon-sec-bigcard-fit {
    font-size: 0.52vw; color: rgba(255,255,255,0.45); font-weight: 400;
    letter-spacing: 0.04em;
  }

  /* ── Section detail view (drill-down from card) ── */
  @keyframes ps-sec-detail-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .ps-tryon-sec-detail {
    display: flex; flex-direction: column; gap: 0.5vw;
    animation: ps-v2-fade 0.3s ease forwards;
    flex: 1; min-height: 0; overflow: hidden;
  }
  .ps-tryon-sec-detail-back {
    display: inline-flex; align-items: center; gap: 0.25vw;
    background: none; border: none; color: rgba(0,0,0,0.3); cursor: pointer;
    font-size: 0.6vw; font-family: inherit; padding: 0;
    transition: color 0.2s; align-self: flex-start;
    letter-spacing: 0.03em;
  }
  .ps-tryon-sec-detail-back:hover { color: var(--ps-accent); }
  .ps-tryon-sec-detail-back svg { width: 0.7vw; height: 0.7vw; stroke: currentColor; }
  .ps-tryon-sec-detail-header {
    display: flex; align-items: center; gap: 0.5vw;
    padding-bottom: 0.4vw;
    border-bottom: 1px solid rgba(0,0,0,0.04);
  }
  .ps-tryon-sec-detail-icon {
    width: 1.8vw; height: 1.8vw;
    display: flex; align-items: center; justify-content: center;
    background: rgba(33,84,239,0.08); border: 1px solid rgba(33,84,239,0.12);
    border-radius: 50%; color: var(--ps-accent);
  }
  .ps-tryon-sec-detail-icon svg { stroke: currentColor; }
  .ps-tryon-sec-detail-name {
    font-size: 0.8vw; font-weight: 400; color: var(--ps-text-primary);
    text-transform: uppercase; letter-spacing: 0.1em;
  }
  .ps-tryon-sec-detail .ps-tryon-sr-fit-table td { padding: 0.9vw 0; }
  .ps-tryon-sec-detail .ps-tryon-sr-fit-table th { padding: 0.4vw 0 0.6vw; }
  .ps-tryon-sec-detail .ps-tryon-sr-chips { gap: 0.4vw; margin: 0.3vw 0; }
  .ps-tryon-sec-detail-footer {
    gap: clamp(16px, 1.1vw, 22px);
    min-height: clamp(44px, 3vw, 54px);
  }
  .ps-tryon-sec-detail-footer .ps-bp-back-btn {
    flex: 0 0 auto;
    min-width: 0;
    white-space: nowrap;
  }
  .ps-tryon-sec-detail-footer .ps-tryon-v2-action-group {
    flex: 1 1 auto;
    max-width: min(430px, 100%);
    margin-left: auto;
    gap: clamp(16px, 1vw, 20px);
  }
  .ps-tryon-sec-detail-footer .ps-tryon-v2-action-group-single {
    flex: 0 0 auto;
    max-width: none;
  }
  .ps-tryon-sec-detail-footer .ps-tryon-v2-action-group > .ps-tryon-v2-cta {
    flex: 1 1 0;
    min-width: clamp(140px, 9.5vw, 178px);
    margin-top: 0;
  }
  .ps-tryon-sec-detail-footer .ps-tryon-v2-action-group-single > .ps-tryon-v2-cta {
    flex: 0 0 auto;
    min-width: clamp(150px, 10vw, 190px);
  }

  /* Length inline selector (inside section detail) */
  .ps-tryon-sec-length-row {
    display: flex; align-items: center; gap: 0.5vw;
    padding: 0.3vw 0; border-top: 1px solid var(--ps-border-color);
  }
  .ps-tryon-sec-length-label {
    font-size: 0.62vw; font-weight: 600; color: var(--ps-text-secondary);
    text-transform: uppercase; letter-spacing: 0.04em; white-space: nowrap;
  }

  /* Reasoning */
  .ps-tryon-sr-reasoning { padding: 0.8vw; border: 1px solid var(--ps-border-color); border-radius: 0.6vw; background: var(--ps-bg-secondary); }
  .ps-tryon-sr-reasoning p { font-size: 0.75vw; color: var(--ps-text-secondary); line-height: 1.6; margin: 0; }

  /* Result actions */
  /* Image action icons — bottom-left of image */
  .ps-tryon-sr-img-actions {
    position: absolute; bottom: 0.6vw; left: 0.6vw; z-index: 3;
    display: flex; flex-direction: column; gap: 0.3vw;
    align-items: flex-start;
  }
  .ps-tryon-feedback-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35vw;
    min-height: clamp(28px, 1.65vw, 34px);
    padding: 0 clamp(10px, 0.65vw, 13px);
    border-radius: clamp(7px, 0.42vw, 9px);
    border: 1px solid rgba(226, 232, 240, 0.9);
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    color: var(--ps-text-primary);
    font-family: inherit;
    font-size: clamp(10px, 0.58vw, 12px);
    font-weight: 800;
    cursor: pointer;
    white-space: nowrap;
  }
  .ps-tryon-feedback-toggle svg {
    width: clamp(13px, 0.72vw, 16px);
    height: clamp(13px, 0.72vw, 16px);
    fill: transparent;
    stroke: var(--ps-accent);
    stroke-width: 1.9;
  }
  .ps-tryon-feedback {
    width: clamp(190px, 12.2vw, 232px);
    padding: clamp(7px, 0.48vw, 10px);
    border-radius: clamp(8px, 0.55vw, 12px);
    border: 1px solid rgba(226, 232, 240, 0.9);
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    display: flex;
    flex-direction: column;
    gap: clamp(5px, 0.3vw, 7px);
  }
  .ps-tryon-feedback-top {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 5px;
  }
  .ps-tryon-feedback-title {
    color: var(--ps-text-primary);
    font-size: clamp(10px, 0.58vw, 12px);
    font-weight: 800;
    line-height: 1;
    white-space: nowrap;
  }
  .ps-tryon-feedback-stars {
    grid-column: 1 / -1;
    display: inline-flex; align-items: center; gap: 2px; flex-shrink: 0;
  }
  .ps-tryon-feedback-close {
    width: clamp(20px, 1.08vw, 24px);
    height: clamp(20px, 1.08vw, 24px);
    border: 0;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.12);
    color: #64748b;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .ps-tryon-feedback-close svg {
    width: 62%;
    height: 62%;
    fill: none;
    stroke: currentColor;
    stroke-width: 2.4;
    stroke-linecap: round;
  }
  .ps-tryon-feedback-close:hover {
    background: rgba(33,84,239,0.1);
    color: var(--ps-accent);
  }
  .ps-tryon-feedback-star {
    width: clamp(16px, 0.88vw, 19px);
    height: clamp(16px, 0.88vw, 19px);
    padding: 0;
    border: 0;
    background: transparent;
    color: #cbd5e1;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .ps-tryon-feedback-star svg {
    width: 100%; height: 100%;
    fill: transparent;
    stroke: currentColor;
    stroke-width: 1.8;
    transition: fill 0.16s ease, stroke 0.16s ease, transform 0.16s ease;
  }
  .ps-tryon-feedback-star:hover svg,
  .ps-tryon-feedback-star.is-active svg {
    fill: var(--ps-accent);
    stroke: var(--ps-accent);
    transform: translateY(-1px);
  }
  .ps-tryon-feedback-star:disabled {
    cursor: default;
  }
  .ps-tryon-feedback-form {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 6px;
    align-items: end;
  }
  .ps-tryon-feedback-note {
    width: 100%;
    min-width: 0;
    min-height: clamp(30px, 1.75vw, 36px);
    max-height: 78px;
    border: 1px solid #e6eaf2;
    border-radius: clamp(6px, 0.36vw, 8px);
    background: rgba(248, 250, 252, 0.88);
    color: var(--ps-text-primary);
    font-family: inherit;
    font-size: clamp(10px, 0.58vw, 12px);
    font-weight: 600;
    line-height: 1.35;
    padding: clamp(7px, 0.42vw, 9px) clamp(8px, 0.5vw, 10px);
    outline: none;
    box-sizing: border-box;
    resize: none;
    overflow-y: auto;
  }
  .ps-tryon-feedback-note::placeholder {
    color: #94a3b8;
    font-weight: 600;
  }
  .ps-tryon-feedback-note:focus {
    border-color: rgba(33,84,239,0.45);
    box-shadow: 0 0 0 3px rgba(33,84,239,0.1);
  }
  .ps-tryon-feedback-note:disabled {
    color: #64748b;
    background: rgba(248, 250, 252, 0.62);
    cursor: default;
  }
  .ps-tryon-feedback-submit {
    min-height: clamp(30px, 1.75vw, 36px);
    padding: 0 clamp(9px, 0.55vw, 12px);
    border: 0;
    border-radius: clamp(6px, 0.36vw, 8px);
    background: #fff;
    color: #111;
    font-family: inherit;
    font-size: clamp(10px, 0.56vw, 12px);
    font-weight: 800;
    cursor: pointer;
    white-space: nowrap;
  }
  .ps-tryon-feedback-submit:disabled {
    opacity: 0.48;
    cursor: default;
  }
  .ps-tryon-feedback-status {
    color: #dc2626;
    font-size: clamp(10px, 0.56vw, 12px);
    font-weight: 700;
    line-height: 1.2;
  }
  .ps-result-image-action-bar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: clamp(6px, 0.38vw, 9px);
    flex-wrap: wrap;
  }
  .ps-result-image-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: clamp(5px, 0.32vw, 7px);
    min-height: clamp(30px, 1.75vw, 36px);
    padding: 0 clamp(10px, 0.65vw, 14px);
    border-radius: clamp(7px, 0.42vw, 9px);
    border: 1px solid rgba(226, 232, 240, 0.92);
    background: #fff;
    color: var(--ps-text-primary);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
    font-family: inherit;
    font-size: clamp(10px, 0.58vw, 12px);
    font-weight: 800;
    cursor: pointer;
    white-space: nowrap;
  }
  .ps-result-image-action:hover {
    border-color: rgba(33,84,239,0.34);
    color: var(--ps-accent);
  }
  .ps-result-image-action-fit.is-active {
    border-color: rgba(33,84,239,0.42);
    background: rgba(33,84,239,0.08);
    color: var(--ps-accent);
  }
  .ps-result-image-action:focus-visible {
    outline: 2px solid rgba(33,84,239,0.34);
    outline-offset: 2px;
  }
  @media (hover: none) {
    .ps-result-image-action:hover {
      border-color: rgba(226, 232, 240, 0.92);
      background: #fff;
      color: var(--ps-text-primary);
    }
    .ps-result-image-action-fit.is-active,
    .ps-result-image-action-fit.is-active:hover {
      border-color: rgba(33,84,239,0.42);
      background: rgba(33,84,239,0.08);
      color: var(--ps-accent);
    }
  }
  .ps-result-image-action svg {
    flex: 0 0 auto;
  }
  .ps-tryon-sr-glass-btn {
    background: rgba(255,255,255,0.9); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
    border: 1px solid var(--ps-border-color); border-radius: 0.45vw;
    color: var(--ps-text-primary); font-size: 0.62vw; font-weight: 700; font-family: inherit;
    padding: 0.4vw 0.8vw; cursor: pointer; transition: all 0.2s;
    white-space: nowrap; letter-spacing: 0.02em;
    display: inline-flex; align-items: center;
  }
  /* When used standalone on an image (not inside actions container) */
  .ps-tryon-sr-img-col > .ps-tryon-sr-glass-btn {
    position: absolute; bottom: 0.5vw; left: 0.5vw; z-index: 3;
  }
  .ps-tryon-sr-glass-btn:hover {
    background: rgba(255,255,255,1); border-color: var(--ps-accent);
  }
  .ps-tryon-sr-glass-btn svg, .ps-tryon-sr-img-icon svg { width: 0.65vw; height: 0.65vw; }
  .ps-tryon-sr-img-icon {
    display: inline-flex; align-items: center; gap: 0.3vw;
    padding: 0.35vw 0.7vw;
    background: rgba(255,255,255,0.92); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
    border: 1px solid var(--ps-border-color); border-radius: 0.4vw;
    color: var(--ps-text-primary); font-size: 0.6vw; font-weight: 600; font-family: inherit;
    cursor: pointer; transition: all 0.2s; white-space: nowrap;
  }
  .ps-tryon-sr-img-icon:hover { background: #fff; border-color: var(--ps-accent); color: var(--ps-accent); }

  /* See fit visually — below size chips */
  .ps-tryon-sr-visual-btn {
    display: flex; align-items: center; justify-content: center; gap: 0.3vw;
    width: 100%; padding: 0.5vw; margin-top: 0.3vw;
    background: transparent; border: 1px solid var(--ps-border-color); border-radius: 0.5vw;
    color: var(--ps-text-secondary); font-size: 0.7vw; font-weight: 600; cursor: pointer;
    font-family: inherit; transition: all 0.2s;
  }
  .ps-tryon-sr-visual-btn:hover { border-color: var(--ps-accent); color: var(--ps-accent); }
  .ps-tryon-sr-visual-btn svg { stroke: currentColor; }

  /* Dark overlay behind SVG lines */
  .ps-tryon-pose-overlay {
    position: absolute; inset: 0; z-index: 1;
    background: rgba(0,0,0,0.35);
    animation: ps-fade-in 0.4s ease both;
    border-radius: inherit;
  }

  /* SVG pose overlay */
  .ps-tryon-pose-svg {
    position: absolute; inset: 0; width: 100%; height: 100%;
    pointer-events: none; z-index: 2;
  }

  /* Dotted curved line — draws in smoothly */
  .ps-tryon-pose-line {
    stroke-dashoffset: 80;
    animation: ps-pose-draw 1s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  /* HTML pill labels — positioned absolutely on the image */
  .ps-tryon-pose-pill {
    position: absolute; z-index: 3; transform: translateY(-50%);
    display: flex; align-items: center; gap: 0.4vw;
    background: rgba(15,15,15,0.85); backdrop-filter: blur(6px);
    border-radius: 0.5vw; padding: 0.35vw 0.6vw;
    opacity: 0;
    animation: ps-pose-pill-in 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }
  .ps-tryon-pose-pill-dot {
    width: 0.5vw; height: 0.5vw; border-radius: 50%; flex-shrink: 0;
  }
  .ps-tryon-pose-pill-text { display: flex; flex-direction: column; gap: 0.05vw; }
  .ps-tryon-pose-pill-name {
    font-size: 0.75vw; font-weight: 700; color: var(--ps-text-primary); line-height: 1.2;
    font-family: system-ui, -apple-system, sans-serif;
  }
  .ps-tryon-pose-pill-fit {
    font-size: 0.6vw; font-weight: 600; line-height: 1.2;
    font-family: system-ui, -apple-system, sans-serif;
  }

  @keyframes ps-pose-draw {
    from { stroke-dashoffset: 80; opacity: 0; }
    10% { opacity: 1; }
    to { stroke-dashoffset: 0; opacity: 1; }
  }
  @keyframes ps-pose-pill-in {
    from { opacity: 0; transform: translateX(-2px); }
    to { opacity: 1; transform: translateX(0); }
  }
  .ps-tryon-sr-cta {
    width: 100%; padding: 0.7vw;
    background: var(--ps-accent); color: #0a0a0a;
    border: none; border-radius: 0.4vw;
    font-size: 0.75vw; font-weight: 700; cursor: pointer;
    font-family: inherit; letter-spacing: 0.1em; text-transform: uppercase;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); margin-top: auto;
    display: flex; align-items: center; justify-content: center; gap: 0.4vw;
  }
  .ps-tryon-sr-cta:hover {
    background: var(--ps-accent-light);
    box-shadow: 0 0.3vw 1.5vw rgba(33,84,239,0.25);
    transform: translateY(-1px);
  }

  /* Size chip suggested dot */
  .ps-tryon-sr-chip { position: relative; }
  .ps-tryon-sr-rec-dot {
    position: absolute; bottom: -0.3vw; left: 50%; transform: translateX(-50%);
    width: 0.35vw; height: 0.35vw; border-radius: 50%; background: var(--ps-accent);
  }
  .ps-tryon-sr-chip.ps-active .ps-tryon-sr-rec-dot { background: #fff; }
  .ps-tryon-sr-chip.ps-recommended { border-color: var(--ps-accent); }

  /* ── Full Size Chart Overlay ── */
  .ps-tryon-fc-overlay {
    position: absolute; inset: 0; z-index: 10;
    background: #111211;
    display: flex; flex-direction: column;
    animation: ps-fade-in 0.2s ease;
  }
  @keyframes ps-fade-in { from { opacity: 0; } to { opacity: 1; } }
  .ps-tryon-fc-panel {
    background: #111211;
    width: 100%; height: 100%; overflow: hidden;
    display: flex; flex-direction: column;
  }
  .ps-tryon-fc-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0.8vw 1.2vw; border-bottom: 1px solid #282828;
  }
  .ps-tryon-fc-title {
    font-size: 0.8vw; font-weight: 700; color: var(--ps-text-primary);
    letter-spacing: 0.12em; margin: 0;
  }
  .ps-tryon-fc-close {
    background: none; border: none; color: var(--ps-text-muted); font-size: 1.4vw;
    cursor: pointer; line-height: 1; padding: 0; transition: color 0.2s;
  }
  .ps-tryon-fc-close:hover { color: var(--ps-text-primary); }

  /* Your measurements bar */
  .ps-tryon-fc-measures {
    padding: 0.7vw 1.2vw; background: #1a1a1a; border-bottom: 1px solid #282828;
  }
  .ps-tryon-fc-measures-label {
    display: flex; align-items: center; gap: 0.5vw;
    font-size: 0.6vw; font-weight: 700; color: var(--ps-text-dim);
    letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 0.4vw;
  }
  .ps-tryon-fc-measures-vals {
    display: flex; gap: 1.5vw;
  }
  .ps-tryon-fc-measures-val { font-size: 0.9vw; color: var(--ps-text-secondary); }
  .ps-tryon-fc-measures-val strong { font-weight: 700; color: var(--ps-text-primary); margin-right: 0.15vw; }
  .ps-tryon-fc-measures-val span { font-size: 0.65vw; color: var(--ps-text-muted); }

  /* Full table */
  .ps-tryon-fc-table-wrap {
    flex: 1; overflow: auto; padding: 0.5vw 1.2vw 1.2vw;
  }
  .ps-tryon-fc-table {
    width: 100%; border-collapse: collapse; font-size: 0.75vw;
  }
  .ps-tryon-fc-table th {
    text-align: center; padding: 0.5vw 0.6vw;
    font-size: 0.6vw; font-weight: 700; color: var(--ps-text-muted);
    text-transform: uppercase; letter-spacing: 0.06em;
    border-bottom: 1.5px solid var(--ps-border-color);
  }
  .ps-tryon-fc-table th:first-child { text-align: left; }
  .ps-tryon-fc-table td {
    text-align: center; padding: 0.45vw 0.6vw;
    color: var(--ps-text-secondary); border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-tryon-fc-table td:first-child { text-align: left; font-weight: 600; color: var(--ps-text-secondary); }
  .ps-tryon-fc-rec-row td { color: var(--ps-text-primary); font-weight: 600; background: rgba(33,84,239,0.05); }
  .ps-tryon-fc-rec-pill {
    display: inline-flex; align-items: center; justify-content: center;
    background: #fff; color: var(--ps-text-primary); padding: 0.15vw 0.5vw;
    border-radius: 1vw; font-weight: 800; font-size: 0.7vw;
  }

  .ps-conf-high { color: #4ade80; } .ps-conf-medium { color: var(--ps-accent); } .ps-conf-low { color: var(--ps-error-color); }
  .ps-tryon-size-compact { padding: 0.5vw 0; }
  .ps-tryon-size-compact-label { font-size: 0.78vw; color: var(--ps-text-secondary); font-weight: 500; }

  /* Save profile prompt */
  .ps-tryon-save-prompt { margin-top: 0.73vw; padding: 0.73vw; border: 1px solid var(--ps-border-color); border-radius: 0.63vw; background: var(--ps-bg-secondary); }
  .ps-tryon-save-label { font-size: 0.63vw; color: var(--ps-text-secondary); margin-bottom: 0.52vw; }
  .ps-tryon-save-row { display: flex; gap: 0.42vw; }
  .ps-tryon-save-row input {
    flex: 1; padding: 0.52vw 0.73vw; border: 1.5px solid var(--ps-border-color); border-radius: 0.52vw;
    background: #111211; color: var(--ps-text-primary); font-size: 0.68vw; font-family: inherit; outline: none;
  }
  .ps-tryon-save-row input:focus { border-color: var(--ps-accent); }
  .ps-tryon-save-row button {
    padding: 0.52vw 1.04vw; background: var(--ps-accent); color: #fff; border: none; border-radius: 0.52vw;
    font-size: 0.68vw; font-weight: 600; cursor: pointer; transition: opacity 0.2s; font-family: inherit;
  }
  .ps-tryon-save-row button:hover { opacity: 0.9; }
  .ps-tryon-save-btn-group { display: flex; gap: 0.31vw; }
  .ps-tryon-save-new-btn { background: transparent !important; border: 1.5px solid var(--ps-accent) !important; color: var(--ps-accent) !important; }
  .ps-tryon-save-new-btn:hover { background: rgba(33,84,239,0.1) !important; }
  .ps-tryon-save-done { font-size: 0.63vw; color: #4ade80; margin-top: 0.52vw; display: flex; align-items: center; gap: 0.31vw; justify-content: center; }
  .ps-tryon-save-done svg { stroke: currentColor; }

  /* Error */
  .ps-tryon-error { text-align: center; padding: 1.25vw; display: flex; flex-direction: column; align-items: center; }
  .ps-tryon-error svg { color: var(--ps-error-color); margin-bottom: 0.63vw; }
  .ps-tryon-error-text { font-size: 0.73vw; color: var(--ps-error-color); margin: 0 0 0.83vw; }

  /* ──────────────────────────────────────────────
     NoChartView — empty state when the merchant
     hasn't uploaded a size chart for this product.
     Desktop: split (image left, panel right).
     Mobile: stacked (image top, panel bottom).
     ────────────────────────────────────────────── */
  /* Right-column content wrapper — sits inside the existing
     .ps-tryon-sr-right-col so the modal width/height matches every other
     size-result screen. Only the column content swaps; the modal frame
     does not resize. */
  .ps-tryon-no-chart-right-col {
    align-items: flex-start; justify-content: center;
    gap: 0.8vw;
  }
  .ps-tryon-no-chart-content {
    display: flex; flex-direction: column;
    align-items: flex-start; justify-content: center;
    gap: 0.8vw;
    padding: 0.6vw 1vw;
    min-width: 0;
  }
  .ps-tryon-no-chart-icon {
    width: 3.2vw; height: 3.2vw;
    min-width: 48px; min-height: 48px;
    display: flex; align-items: center; justify-content: center;
    border-radius: 50%;
    background: var(--ps-bg-tertiary, #f3f4f6);
    color: var(--ps-text-secondary);
  }
  .ps-tryon-no-chart-icon svg {
    width: 60%; height: 60%;
  }
  .ps-tryon-no-chart-title {
    font-size: 1.1vw; font-weight: 700;
    color: var(--ps-text-primary);
    margin: 0;
    line-height: 1.25;
  }
  .ps-tryon-no-chart-msg {
    font-size: 0.72vw; line-height: 1.55;
    color: var(--ps-text-secondary);
    margin: 0;
  }
  .ps-tryon-no-chart-actions {
    display: flex; flex-direction: column;
    align-items: stretch; gap: 0.5vw;
    width: 100%; max-width: 22vw;
    margin-top: 0.4vw;
  }
  .ps-tryon-no-chart-cta {
    background: var(--ps-accent); color: #FFFFFF;
    border: none; border-radius: 0.5vw;
    padding: 0.8vw 1vw;
    font-family: inherit;
    font-size: 0.78vw; font-weight: 700;
    letter-spacing: 0.04em;
    cursor: pointer;
    transition: opacity 0.15s, transform 0.15s;
  }
  .ps-tryon-no-chart-cta:active { transform: scale(0.99); opacity: 0.94; }
  .ps-tryon-no-chart-secondary {
    background: transparent; color: var(--ps-text-secondary);
    border: 1px solid var(--ps-border-color);
    border-radius: 0.5vw;
    padding: 0.7vw 1vw;
    font-family: inherit;
    font-size: 0.7vw; font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
  }
  .ps-tryon-no-chart-secondary:hover { background: var(--ps-bg-secondary); }

  /* Footer */
  .ps-tryon-powered { text-align: center; padding: 0.63vw 1.25vw 0.83vw; font-size: 0.57vw; color: var(--ps-text-muted); }
  .ps-tryon-powered a { color: var(--ps-accent); text-decoration: none; }
  .ps-tryon-powered a:hover { text-decoration: underline; }

  /* Drawer */
  .ps-tryon-drawer {
    position: absolute; inset: 0; z-index: 20; background: var(--ps-modal-bg, #FFFFFF);
    overflow-y: auto; overflow-x: hidden; scrollbar-width: thin; padding: 1.04vw 1.25vw;
    transform: translateX(100%); transition: transform 0.25s cubic-bezier(0.4,0,0.2,1);
    box-sizing: border-box;
  }
  .ps-tryon-drawer-open { transform: translateX(0); }
  .ps-tryon-history-drawer {
    inset: 0;
    height: 100%;
    min-height: 0;
    padding: 1.04vw 1.25vw;
    border-radius: 0;
    transform: translateY(100%);
    box-shadow: none;
  }
  .ps-tryon-history-drawer.ps-tryon-drawer-open { transform: translateY(0); }
  .ps-tryon-drawer-header { display: flex; align-items: center; gap: 0.52vw; padding-bottom: 0.73vw; margin-bottom: 0.73vw; border-bottom: 1px solid var(--ps-border-color); }
  .ps-tryon-drawer-back {
    width: 1.67vw; height: 1.67vw; display: flex; align-items: center; justify-content: center;
    border: 1.5px solid var(--ps-border-color); border-radius: 0.52vw; background: transparent;
    cursor: pointer; color: var(--ps-text-secondary); transition: all 0.2s; flex-shrink: 0;
  }
  .ps-tryon-drawer-back:hover { border-color: var(--ps-accent); color: var(--ps-accent); }
  .ps-tryon-drawer-title { font-size: 0.83vw; font-weight: 600; color: var(--ps-text-primary); flex: 1; }
  .ps-tryon-drawer-add-btn {
    width: 1.6vw; height: 1.6vw; display: flex; align-items: center; justify-content: center;
    border: 1.5px solid var(--ps-border-color); border-radius: 0.42vw; background: transparent;
    color: var(--ps-accent); font-size: 1vw; font-weight: 600; cursor: pointer;
    font-family: inherit; transition: all 0.2s; flex-shrink: 0; line-height: 1;
  }
  .ps-tryon-drawer-add-btn:hover { border-color: var(--ps-accent); background: rgba(33,84,239,0.1); }
  .ps-tryon-drawer-close {
    width: 1.67vw; height: 1.67vw; display: flex; align-items: center; justify-content: center;
    border: 1.5px solid var(--ps-border-color); border-radius: 0.52vw; background: transparent;
    cursor: pointer; color: var(--ps-text-secondary); transition: all 0.2s; flex-shrink: 0;
  }
  .ps-tryon-drawer-close svg {
    width: 0.85vw; height: 0.85vw; fill: none; stroke: currentColor; stroke-width: 2.2; stroke-linecap: round;
  }
  .ps-tryon-drawer-close:hover { border-color: var(--ps-accent); color: var(--ps-accent); }
  .ps-tryon-drawer-list { display: flex; flex-direction: column; gap: 0.52vw; max-width: 100%; overflow-x: hidden; }
  .ps-tryon-drawer-empty { text-align: center; padding: 1.67vw 0.83vw; color: var(--ps-text-muted); font-size: 0.73vw; }

  /* Profile items */
  .ps-tryon-profile-item {
    display: flex; align-items: center; gap: 0.63vw; padding: 0.73vw;
    border: 1px solid var(--ps-border-color); border-radius: 0.63vw; cursor: pointer; transition: all 0.2s;
  }
  .ps-tryon-profile-item:hover { border-color: var(--ps-accent); }
  .ps-tryon-profile-avatar {
    width: 2.08vw; height: 2.08vw; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    background: rgba(33,84,239,0.1); flex-shrink: 0;
  }
  .ps-tryon-profile-avatar svg { stroke: var(--ps-accent); fill: none; }
  .ps-tryon-profile-info { flex: 1; min-width: 0; }
  .ps-tryon-profile-name { font-size: 0.73vw; font-weight: 600; color: var(--ps-text-primary); }
  .ps-tryon-profile-detail { font-size: 0.57vw; color: var(--ps-text-secondary); margin-top: 2px; }
  .ps-tryon-profile-item > svg:last-child { color: var(--ps-text-muted); flex-shrink: 0; transition: color 0.2s; }
  .ps-tryon-profile-item:hover > svg:last-child { color: var(--ps-accent); }

  /* History items */
  .ps-tryon-history-item {
    display: flex; gap: 0.73vw; padding: 0.73vw;
    border: 1px solid var(--ps-border-color); border-radius: 0.63vw; align-items: flex-start; transition: all 0.2s;
  }
  .ps-tryon-history-item:hover { border-color: var(--ps-accent); box-shadow: 0 0.21vw 0.63vw rgba(33,84,239,0.06); }
  .ps-tryon-history-images { display: flex; gap: 0.42vw; flex-shrink: 0; }
  .ps-tryon-history-thumb { width: 3.33vw; height: 4.17vw; border-radius: 0.52vw; object-fit: contain; background: var(--ps-modal-bg, #FFFFFF); flex-shrink: 0; }
  .ps-tryon-history-info { flex: 1; min-width: 0; }
  .ps-tryon-history-product { font-size: 0.68vw; font-weight: 600; color: var(--ps-text-primary); overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  .ps-tryon-history-meta { font-size: 0.57vw; color: var(--ps-text-muted); margin-top: 3px; }
  .ps-tryon-history-sizing { display: flex; align-items: center; gap: 0.42vw; margin-top: 0.31vw; }
  .ps-tryon-history-sizing-reason { font-size: 0.57vw; color: var(--ps-text-secondary); flex: 1; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  /* History badge — auto-grows for long combined-variant labels
     ("MISSY 12 / Standard"). Stays circular for short labels (S, M, L,
     2-digit numerics) via min-width = min-height. Long labels stretch
     into a rounded pill. */
  .ps-tryon-history-size-badge {
    flex-shrink: 0;
    min-width: 2.08vw; height: 2.08vw;
    padding: 0 0.6vw;
    border-radius: 999px;
    display: inline-flex; align-items: center; justify-content: center;
    background: linear-gradient(135deg, var(--ps-accent), var(--ps-accent-light));
    color: #fff; font-size: 0.68vw; font-weight: 700;
    white-space: nowrap; line-height: 1;
    max-width: 100%; overflow: hidden; text-overflow: ellipsis;
  }
  .ps-tryon-history-result-img { width: 3.33vw; height: 4.17vw; border-radius: 0.52vw; object-fit: contain; background: var(--ps-modal-bg, #FFFFFF); flex-shrink: 0; border: 2px solid var(--ps-accent); }
  .ps-tryon-history-delete {
    width: 1.46vw; height: 1.46vw; display: flex; align-items: center; justify-content: center;
    border: none; background: transparent; cursor: pointer; color: var(--ps-text-muted); border-radius: 0.31vw; transition: all 0.2s; flex-shrink: 0;
  }
  .ps-tryon-history-delete:hover { background: rgba(239,68,68,0.1); color: var(--ps-error-color); }
  .ps-tryon-history-delete svg { stroke: currentColor; fill: none; }
  .ps-tryon-history-clickable { cursor: pointer; }
  .ps-tryon-history-sections { display: flex; flex-wrap: wrap; gap: 0.3vw; margin-top: 0.31vw; }
  .ps-tryon-history-section-chip {
    font-size: 0.55vw; font-weight: 600; color: var(--ps-text-primary); background: rgba(33,84,239,0.18);
    border: 1px solid rgba(33,84,239,0.3); border-radius: 0.3vw; padding: 0.15vw 0.4vw;
  }
  .ps-tryon-history-tryon-badge {
    display: inline-block; font-size: 0.5vw; font-weight: 600; color: var(--ps-accent);
    background: rgba(33,84,239,0.12); border: 1px solid rgba(33,84,239,0.25);
    border-radius: 0.25vw; padding: 0.1vw 0.35vw; margin-top: 0.25vw;
  }
  .ps-tryon-history-gallery {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 0.72vw;
  }
  .ps-tryon-history-card {
    position: relative;
    min-width: 0;
  }
  .ps-tryon-history-card-main {
    width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.34vw;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font-family: inherit;
    text-align: left;
    cursor: pointer;
  }
  .ps-tryon-history-card-media {
    position: relative;
    width: 100%;
    aspect-ratio: 3 / 4;
    border-radius: 0.72vw;
    overflow: hidden;
    background: #f4f5f7;
    border: 1px solid rgba(226, 232, 240, 0.86);
    box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);
  }
  .ps-tryon-history-card-img,
  .ps-tryon-history-card-placeholder {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
  }
  .ps-tryon-history-card-placeholder {
    background: linear-gradient(135deg, rgba(241,245,249,1), rgba(226,232,240,0.7));
  }
  .ps-tryon-history-card-product {
    position: absolute;
    right: 0.42vw;
    bottom: 0.42vw;
    width: 28%;
    aspect-ratio: 1 / 1;
    border-radius: 0.42vw;
    object-fit: cover;
    background: #fff;
    border: 1px solid rgba(226, 232, 240, 0.92);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.14);
  }
  .ps-tryon-history-card-title {
    color: var(--ps-text-primary);
    font-size: 0.66vw;
    font-weight: 750;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ps-tryon-history-card-meta,
  .ps-tryon-history-card-sections {
    color: var(--ps-text-muted);
    font-size: 0.54vw;
    font-weight: 600;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ps-tryon-history-card-size {
    align-self: flex-start;
    color: var(--ps-accent);
    background: rgba(33,84,239,0.1);
    border: 1px solid rgba(33,84,239,0.2);
    border-radius: 999px;
    padding: 0.14vw 0.45vw;
    font-size: 0.52vw;
    font-weight: 800;
  }
  .ps-tryon-history-delete.ps-card-delete {
    position: absolute;
    top: 0.42vw;
    right: 0.42vw;
    width: 1.5vw;
    height: 1.5vw;
    border-radius: 999px;
    background: rgba(255,255,255,0.9);
    box-shadow: 0 8px 18px rgba(15,23,42,0.12);
  }

  /* Quiz view */
  .ps-tryon-quiz-progress { display: flex; gap: 0.4vw; margin-bottom: 1vw; }
  .ps-tryon-quiz-progress-dot {
    width: 1.5vw; height: 0.2vw; border-radius: 0.1vw;
    background: var(--ps-border-color); transition: background 0.3s;
  }
  .ps-tryon-quiz-progress-dot.ps-active { background: var(--ps-accent); }
  .ps-tryon-quiz-basics { display: flex; flex-direction: column; gap: 1.2vw; width: 100%; }
  .ps-tryon-quiz-options { display: flex; flex-direction: column; gap: 0.5vw; width: 100%; }
  .ps-tryon-quiz-options.ps-tryon-quiz-row { flex-direction: row; }
  .ps-tryon-quiz-option {
    display: flex; flex-direction: column; gap: 0.15vw;
    padding: 0.7vw 1vw; border: 1.5px solid var(--ps-border-color); border-radius: 0.5vw;
    background: transparent; color: var(--ps-text-primary); cursor: pointer;
    font-family: inherit; text-align: left; transition: all 0.2s;
    flex: 1;
  }
  .ps-tryon-quiz-option:hover { border-color: var(--ps-accent); background: rgba(33,84,239,0.06); }
  .ps-tryon-quiz-option.ps-active { border-color: var(--ps-accent); background: rgba(33,84,239,0.12); }
  .ps-tryon-quiz-option-label { font-size: 0.8vw; font-weight: 600; }
  .ps-tryon-quiz-option-desc { font-size: 0.6vw; color: var(--ps-text-secondary); }

  /* Profile edit view */
  .ps-tryon-profile-edit { display: flex; flex-direction: column; gap: 1.2vw; width: 100%; max-width: 100%; overflow-x: hidden; box-sizing: border-box; padding: 0.3vw 0.5vw; flex: 1; }
  .ps-tryon-pe-photo-row {
    display: flex; align-items: center; gap: 1vw;
    padding: 0.7vw; border: 1px solid var(--ps-border-color);
    border-radius: 0.7vw; background: rgba(15, 23, 42, 0.025);
  }
  .ps-tryon-pe-photo-preview {
    width: 4.7vw; height: 4.7vw; flex: 0 0 4.7vw;
    border-radius: 0.65vw; overflow: hidden;
    background: #fff; border: 1px solid var(--ps-border-color);
    display: flex; align-items: center; justify-content: center;
    color: var(--ps-text-muted); font-size: 0.58vw; font-weight: 650;
    text-align: center;
  }
  .ps-tryon-pe-photo-preview img {
    width: 100%; height: 100%; object-fit: cover; display: block;
  }
  .ps-tryon-pe-photo-actions {
    min-width: 0; display: flex; flex-wrap: wrap; align-items: center; gap: 0.55vw;
  }
  .ps-tryon-pe-photo-btn,
  .ps-tryon-pe-photo-remove {
    border-radius: 0.45vw; padding: 0.45vw 0.8vw;
    font-size: 0.62vw; font-weight: 700; cursor: pointer;
    font-family: inherit; transition: all 0.15s;
  }
  .ps-tryon-pe-photo-btn {
    border: 1px solid var(--ps-accent); background: var(--ps-accent); color: #fff;
  }
  .ps-tryon-pe-photo-remove {
    border: 1px solid var(--ps-border-color); background: #fff; color: var(--ps-text-secondary);
  }
  .ps-tryon-pe-photo-btn:disabled,
  .ps-tryon-pe-photo-remove:disabled {
    opacity: 0.55; cursor: not-allowed;
  }
  .ps-tryon-pe-photo-btn:not(:disabled):hover,
  .ps-tryon-pe-photo-remove:not(:disabled):hover {
    transform: translateY(-1px);
  }
  .ps-tryon-pe-row {
    display: flex; align-items: center; gap: 0.8vw;
  }
  .ps-tryon-pe-pill {
    display: inline-flex; border: 1px solid var(--ps-border-color); border-radius: 1.2vw; overflow: hidden;
  }
  .ps-tryon-pe-pill-btn {
    padding: 0.35vw 0.9vw; background: transparent; border: none;
    color: var(--ps-text-muted); font-size: 0.62vw; font-weight: 600; cursor: pointer;
    font-family: inherit; transition: all 0.15s; white-space: nowrap; line-height: 1.2;
  }
  .ps-tryon-pe-pill-btn.ps-active { background: var(--ps-accent); color: #fff; }
  .ps-tryon-pe-pill-btn:not(.ps-active):hover { color: var(--ps-text-secondary); background: rgba(0,0,0,0.03); }
  .ps-tryon-pe-fields { display: grid; grid-template-columns: 1fr 1fr; gap: 1vw 1.6vw; width: 100%; box-sizing: border-box; }
  .ps-tryon-pe-fields .ps-tryon-sf-float-field {
    min-width: 0; padding: 0.15vw 0.4vw;
    display: flex; align-items: center; gap: 0.6vw;
  }
  .ps-tryon-pe-fields .ps-tryon-sf-float-label {
    flex-shrink: 0; margin: 0; white-space: nowrap;
    font-size: 0.62vw; color: var(--ps-text-secondary);
  }
  .ps-tryon-pe-fields .ps-tryon-sf-float-field:focus-within .ps-tryon-sf-float-label { color: var(--ps-accent); }
  .ps-tryon-pe-fields .ps-tryon-sf-input {
    flex: 1; min-width: 0; padding: 0.3vw 0; font-size: 0.78vw;
  }
  .ps-tryon-pe-error {
    font-size: 0.62vw; color: var(--ps-error-color); font-weight: 500; text-align: center;
    padding: 0.3vw 0.6vw; background: rgba(239,68,68,0.08); border: 1px solid rgba(239,68,68,0.2);
    border-radius: 0.4vw;
  }
  .ps-tryon-pe-actions { display: flex; align-items: center; justify-content: flex-end; gap: 0.8vw; margin-top: auto; padding-top: 1.2vw; }
  .ps-tryon-pe-actions .ps-tryon-est-back { font-size: 0.65vw; }
  .ps-tryon-pe-save {
    padding: 0.45vw 1.2vw; background: var(--ps-accent); color: #fff; border: none;
    border-radius: 0.4vw; font-size: 0.65vw; font-weight: 600; cursor: pointer;
    font-family: inherit; letter-spacing: 0.06em; text-transform: uppercase;
    display: inline-flex; align-items: center; gap: 0.3vw;
  }
  .ps-tryon-pe-save:hover { opacity: 0.85; }
  .ps-tryon-drawer-create {
    width: 100%; padding: 0.6vw; margin-bottom: 0.5vw;
    background: transparent; border: 1.5px dashed var(--ps-border-color);
    border-radius: 0.5vw; color: var(--ps-accent); font-size: 0.73vw;
    font-weight: 600; cursor: pointer; font-family: inherit; transition: all 0.2s;
    display: flex; align-items: center; justify-content: center; gap: 0.3vw;
  }
  .ps-tryon-drawer-create:hover { border-color: var(--ps-accent); background: rgba(33,84,239,0.06); }
  .ps-tryon-drawer-clear {
    background: none; border: none; color: var(--ps-text-muted); font-size: 0.6vw;
    font-weight: 500; cursor: pointer; font-family: inherit; padding: 0.3vw 0;
    transition: color 0.2s; align-self: center;
  }
  .ps-tryon-drawer-clear:hover { color: var(--ps-error-color); }

  /* ──────────────────────────────────────────────────────────────────
     Mobile sizing for the My Profiles / History drawer. Desktop uses vw
     units which collapse to 1–4 px on a 375 px phone. Override every
     rule with px-based values so the list is actually readable.
     ────────────────────────────────────────────────────────────────── */
  @media (max-width: 768px) {
    .ps-tryon-drawer { padding: 16px 14px; }
    .ps-tryon-history-drawer {
      height: 100%;
      min-height: 0;
      padding: 16px 14px;
      border-radius: 0;
    }
    .ps-tryon-drawer-header { gap: 10px; padding-bottom: 12px; margin-bottom: 12px; }
    .ps-tryon-drawer-back {
      width: 36px; height: 36px; border-radius: 8px;
    }
    .ps-tryon-drawer-back svg { width: 18px; height: 18px; }
    .ps-tryon-drawer-title { font-size: 17px; font-weight: 600; }
    .ps-tryon-drawer-add-btn {
      width: 32px; height: 32px; border-radius: 8px; font-size: 20px;
    }
    .ps-tryon-drawer-close {
      width: 36px; height: 36px; border-radius: 8px;
    }
    .ps-tryon-drawer-close svg { width: 18px; height: 18px; }
    .ps-tryon-drawer-list { gap: 10px; }
    .ps-tryon-drawer-empty { padding: 32px 16px; font-size: 14px; }

    .ps-tryon-drawer-create {
      padding: 14px;
      border-radius: 10px;
      font-size: 14px;
      gap: 6px;
      margin-bottom: 4px;
    }
    .ps-tryon-drawer-clear {
      font-size: 13px; padding: 12px 0; margin-top: 6px;
    }

    .ps-tryon-profile-item {
      gap: 12px; padding: 14px; border-radius: 12px;
    }
    .ps-tryon-profile-avatar {
      width: 44px; height: 44px;
    }
    .ps-tryon-profile-avatar svg { width: 22px; height: 22px; }
    .ps-tryon-profile-name { font-size: 15px; }
    .ps-tryon-profile-detail { font-size: 12px; margin-top: 3px; }
    .ps-tryon-profile-item > svg:last-child { width: 18px; height: 18px; }

    .ps-tryon-history-item {
      gap: 12px; padding: 12px; border-radius: 12px;
    }
    .ps-tryon-history-images { gap: 6px; }
    .ps-tryon-history-thumb,
    .ps-tryon-history-result-img {
      width: 64px; height: 80px; border-radius: 8px;
    }
    .ps-tryon-history-product { font-size: 14px; line-height: 1.3; }
    .ps-tryon-history-meta { font-size: 11px; margin-top: 4px; }
    .ps-tryon-history-sizing { gap: 8px; margin-top: 6px; }
    .ps-tryon-history-sizing-reason { font-size: 11px; }
    .ps-tryon-history-size-badge {
      min-width: 32px; height: 32px; padding: 0 10px; font-size: 12px;
    }
    .ps-tryon-history-sections { gap: 6px; margin-top: 6px; }
    .ps-tryon-history-section-chip {
      font-size: 11px; padding: 3px 8px; border-radius: 6px;
    }
    .ps-tryon-history-tryon-badge {
      font-size: 10px; padding: 2px 7px; border-radius: 5px; margin-top: 6px;
    }
    .ps-tryon-history-delete {
      width: 32px; height: 32px; border-radius: 6px;
    }
    .ps-tryon-history-delete svg { width: 16px; height: 16px; }
    .ps-tryon-history-gallery {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px;
    }
    .ps-tryon-history-card-media {
      border-radius: 12px;
    }
    .ps-tryon-history-card-product {
      right: 7px;
      bottom: 7px;
      border-radius: 8px;
    }
    .ps-tryon-history-card-title {
      font-size: 13px;
    }
    .ps-tryon-history-card-meta,
    .ps-tryon-history-card-sections {
      font-size: 11px;
    }
    .ps-tryon-history-card-size {
      padding: 3px 8px;
      font-size: 10px;
    }
    .ps-tryon-history-delete.ps-card-delete {
      top: 7px;
      right: 7px;
      width: 30px;
      height: 30px;
      border-radius: 999px;
    }
  }

  /* Profile detail modal — portaled to body, sits ABOVE the main modal
     overlay (which has z-index 2147483647). Equal z-index + later DOM
     order means this stacks on top. Same trick as the language dropdown. */
  .ps-tryon-detail-overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,0.55);
    display: flex; align-items: center; justify-content: center;
    z-index: 2147483647; padding: 0.83vw; animation: ps-fade-in 0.2s ease;
    isolation: isolate;
    --ps-accent: #3B82F6;
    --ps-accent-hover: #2563EB;
    --ps-text-primary: #1C1D1E;
    --ps-text-secondary: #454545;
    --ps-text-muted: #84898C;
    --ps-border-color: #E7E7E7;
    --ps-border-subtle: #F0F0F0;
    --ps-bg-primary: #FFFFFF;
    --ps-bg-secondary: #F8FAFF;
    --ps-error-color: #E7000B;
  }
  .ps-tryon-detail-modal {
    background: var(--ps-bg-primary); border-radius: 14px; width: 100%; max-width: 480px; max-height: 85vh;
    overflow-y: auto; box-shadow: 0 24px 64px rgba(0,0,0,0.3); animation: ps-slide-up 0.25s ease;
    font-family: var(--ps-modal-font, system-ui, sans-serif); color: var(--ps-text-primary);
  }
  .ps-tryon-detail-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0.94vw 1.25vw; border-bottom: 1px solid var(--ps-border-color);
  }
  .ps-tryon-detail-header span { font-size: 0.78vw; font-weight: 600; }
  .ps-tryon-detail-header button { background: none; border: none; color: var(--ps-text-secondary); cursor: pointer; display: flex; align-items: center; border-radius: 0.31vw; padding: 0.21vw; transition: background 0.15s; }
  .ps-tryon-detail-header button:hover { background: rgba(0,0,0,0.06); }
  .ps-tryon-detail-body { padding: 1.04vw 1.25vw; }
  .ps-tryon-detail-gender { display: flex; align-items: center; gap: 0.42vw; font-size: 0.73vw; font-weight: 600; padding-bottom: 0.73vw; border-bottom: 1px solid var(--ps-border-color); margin-bottom: 0.73vw; }
  .ps-tryon-detail-gender svg { stroke: var(--ps-accent); fill: none; }
  .ps-tryon-detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.52vw; margin-bottom: 0.83vw; }
  .ps-tryon-detail-cell { background: var(--ps-bg-secondary); border-radius: 0.52vw; padding: 0.63vw 0.73vw; }
  .ps-tryon-detail-cell-label { font-size: 0.57vw; color: var(--ps-text-secondary); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 0.21vw; }
  .ps-tryon-detail-cell-value { font-size: 0.83vw; font-weight: 600; color: var(--ps-text-primary); }
  .ps-tryon-detail-date { font-size: 0.57vw; color: var(--ps-text-muted); text-align: center; margin-top: 0.42vw; }
  .ps-tryon-detail-delete {
    width: 100%; display: flex; align-items: center; justify-content: center; gap: 0.31vw;
    padding: 0.63vw; border: 1px solid var(--ps-border-color); border-radius: 0.52vw; background: none;
    color: var(--ps-error-color); font-size: 0.68vw; font-weight: 500; cursor: pointer; transition: all 0.2s;
    font-family: inherit; margin-top: 0.83vw;
  }
  .ps-tryon-detail-delete:hover { background: rgba(239,68,68,0.06); border-color: var(--ps-error-color); }
  .ps-tryon-detail-delete svg { stroke: currentColor; fill: none; }

  /* ── Accessory sizing views (foot / head / face) ── */
  .ps-acc-diagram { display: flex; justify-content: center; margin: max(10px, 0.8vw) 0; }
  .ps-acc-field { margin: max(8px, 0.7vw) 0; }
  .ps-acc-label {
    display: block;
    font-size: max(11px, 0.72vw);
    font-weight: 600;
    color: var(--ps-text-secondary);
    margin-bottom: max(4px, 0.3vw);
  }
  .ps-acc-input {
    width: 100%;
    padding: max(8px, 0.55vw) max(10px, 0.7vw);
    border: 1.5px solid var(--ps-border-color);
    border-radius: max(6px, 0.42vw);
    font-size: max(14px, 0.9vw);
    background: var(--ps-bg-secondary);
    color: var(--ps-text-primary);
    outline: none;
    transition: border-color 0.15s;
    box-sizing: border-box;
    font-family: inherit;
  }
  .ps-acc-input:focus { border-color: var(--ps-accent); }
  .ps-acc-hint { font-size: max(10px, 0.62vw); color: var(--ps-text-muted); margin-top: max(3px, 0.25vw); }
  .ps-acc-error { font-size: max(10px, 0.65vw); color: var(--ps-error-color); margin-top: max(3px, 0.25vw); font-weight: 500; }

  /* ════════════════════════════════════════════════════════════════
     Mobile (≤768px) — full-screen drawer, bigger touch targets,
     px-based sizing (vw becomes sub-pixel and unreadable on phones)
     ════════════════════════════════════════════════════════════════ */
  @media (max-width: 768px) {
    /* ProcessingView v2 mobile — stack: image on top (max 38vh), then
     * the progress + cards panel below. */
    .ps-tryon-processing-v2 {
      flex-direction: column !important;
      gap: 12px !important;
      padding: 12px !important;
      height: auto !important;
    }
    .ps-tryon-processing-v2-image {
      flex: 0 0 auto !important;
      width: 100% !important;
      height: 38vh !important; min-height: 280px !important;
      border-radius: 12px !important;
    }
    .ps-tryon-processing-v2-badge {
      top: 10px !important; left: 10px !important;
      padding: 5px 10px !important; gap: 6px !important;
      font-size: 10px !important;
    }
    .ps-tryon-processing-v2-panel {
      gap: 12px !important; padding: 4px 6px !important;
    }
    .ps-tryon-processing-v2-title { font-size: 17px !important; }
    .ps-tryon-processing-v2-sub { font-size: 12px !important; margin-top: 4px !important; }
    .ps-tryon-processing-v2-ring-wrap { width: 150px !important; height: 150px !important; }
    .ps-tryon-processing-v2-ring-wrap svg { width: 150px !important; height: 150px !important; }
    .ps-tryon-processing-v2-pct { font-size: 28px !important; }
    .ps-tryon-processing-v2-status { font-size: 12px !important; max-width: none !important; margin-top: 12px !important; }
    .ps-tryon-processing-v2-section-label { font-size: 10px !important; margin-bottom: 8px !important; }
    .ps-tryon-processing-v2-cards { gap: 8px !important; }
    .ps-tryon-processing-v2-card { padding: 10px 12px !important; gap: 10px !important; border-radius: 10px !important; }
    .ps-tryon-processing-v2-card-icon { width: 30px !important; height: 30px !important; min-width: 30px !important; min-height: 30px !important; }
    .ps-tryon-processing-v2-card-head { font-size: 12px !important; }
    .ps-tryon-processing-v2-card-body { font-size: 11px !important; }
    .ps-tryon-processing-v2-cancel { font-size: 12px !important; padding: 8px 0 !important; }

    /* NoChartView mobile — content centered, sized like other mobile screens. */
    .ps-tryon-no-chart-right-col,
    .ps-tryon-no-chart-content {
      align-items: center !important; text-align: center !important;
      gap: 12px !important;
      padding: 4px 12px !important;
    }
    .ps-tryon-no-chart-icon { width: 56px !important; height: 56px !important; min-width: 56px !important; min-height: 56px !important; }
    .ps-tryon-no-chart-icon svg { width: 28px !important; height: 28px !important; }
    .ps-tryon-no-chart-title { font-size: 18px !important; text-align: center !important; }
    .ps-tryon-no-chart-msg { font-size: 13px !important; text-align: center !important; max-width: 360px !important; margin: 0 auto !important; }
    .ps-tryon-no-chart-actions { max-width: 320px !important; gap: 10px !important; margin-top: 4px !important; }
    .ps-tryon-no-chart-cta { padding: 14px 18px !important; font-size: 13px !important; border-radius: 10px !important; }
    .ps-tryon-no-chart-secondary { padding: 12px 18px !important; font-size: 12px !important; border-radius: 10px !important; }

    /* ── Trigger button: minimum 44px touch target, readable text ── */
    .ps-tryon-btn {
      padding: max(12px, 3vw) max(20px, 5vw); font-size: max(14px, 3.6vw); gap: max(8px, 2vw);
      border-radius: max(8px, 2vw); min-height: 44px;
    }
    .ps-tryon-btn svg { width: var(--ps-btn-icon-size, max(24px, 7vw)); height: var(--ps-btn-icon-size, max(24px, 7vw)); }

    /* ── Overlay: full screen, no centering, slide-up drawer feel ── */
    .ps-tryon-overlay {
      padding: 0 !important;
      align-items: stretch !important; justify-content: stretch !important;
      overflow: hidden !important;
    }

    /* ── Modal: occupies entire viewport as a drawer ── */
    .ps-tryon-modal,
    .ps-tryon-modal-wide {
      max-width: 100vw !important; max-width: 100dvw !important;
      max-height: 100vh !important; max-height: 100dvh !important;
      width: 100vw !important; width: 100dvw !important;
      height: 100vh !important; height: 100dvh !important;
      min-height: 100vh !important; min-height: 100dvh !important;
      border-radius: 0 !important; box-shadow: none !important;
      margin: 0 !important;
      display: flex !important; flex-direction: column !important;
      overflow: hidden !important;
      animation: ps-mobile-slide-up 0.32s cubic-bezier(0.32, 0.72, 0, 1);
      padding-top: env(safe-area-inset-top);
      padding-bottom: env(safe-area-inset-bottom);
      padding-left: env(safe-area-inset-left);
      padding-right: env(safe-area-inset-right);
    }
    .ps-tryon-modal > :last-child { flex: 1; min-height: 0; }

    /* ── Header: bigger touch targets, fixed top ── */
    .ps-tryon-header {
      border-radius: 0 !important;
      padding: 2.5vw 3.6vw !important;
      flex-shrink: 0;
      background: var(--ps-modal-header-bg, rgba(255,255,255,0.95)) !important;
    }
    /* Mobile header icons: minimal flat glyphs, slightly bigger touch
     * targets than before so the icons read clearly at arms length, and
     * with extra spacing between adjacent buttons (gap below). Labels are
     * desktop-only — hide the inline text on mobile so it stays icon-only. */
    .ps-tryon-header-icon {
      width: 34px !important; height: 34px !important;
      border: none !important; background: transparent !important;
      border-radius: 0 !important; padding: 0 !important;
      gap: 0 !important;
    }
    .ps-tryon-header-icon svg { width: 20px !important; height: 20px !important; }
    .ps-tryon-header-icon-labeled { padding: 0 !important; font-size: 0 !important; }
    .ps-tryon-header-icon-label { display: none !important; }
    .ps-tryon-header-minimal { gap: 10px !important; }
    .ps-tryon-powered-by {
      font-size: 10px !important;
      letter-spacing: 0.05em !important;
    }
    /* Mobile-only header collapse: Profile + History + LangSwitcher move
       into the hamburger popover. The inline icons render NOTHING on
       mobile so the header reads "PoweredBy ... [☰] [×]". */
    .ps-tryon-header-icon-labeled,
    .ps-tryon-header-minimal > .ps-tryon-lang-trigger { display: none !important; }
    .ps-tryon-header-mobile-menu-btn {
      display: flex !important;
      width: 34px !important; height: 34px !important;
      border: none !important; background: transparent !important;
      align-items: center !important; justify-content: center !important;
      color: var(--ps-text-secondary) !important;
      padding: 0 !important; cursor: pointer !important;
    }
    .ps-tryon-header-mobile-menu-btn:hover { color: var(--ps-accent) !important; }
    .ps-tryon-header-mobile-backdrop {
      display: block !important;
      position: fixed !important; inset: 0 !important;
      z-index: 2147483646 !important;
      background: rgba(0,0,0,0.18) !important;
    }
    .ps-tryon-header-mobile-menu {
      display: flex !important;
      flex-direction: column;
      position: fixed !important;
      z-index: 2147483647 !important;
      min-width: 168px;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 10px 28px rgba(0,0,0,0.14), 0 1px 2px rgba(0,0,0,0.06);
      overflow: hidden;
      animation: ps-tryon-mobile-menu-in 0.18s ease-out both;
      padding: 4px 0;
    }
    @keyframes ps-tryon-mobile-menu-in {
      from { opacity: 0; }
      to   { opacity: 1; transform: none; }
    }
    .ps-tryon-header-mobile-menu-item {
      display: flex !important; align-items: center; gap: 10px;
      padding: 11px 14px !important;
      border: none !important; background: transparent !important;
      cursor: pointer !important;
      font: inherit; font-size: 14px !important; font-weight: 500 !important;
      color: var(--ps-text-primary, #111) !important;
      text-align: left !important;
      transition: background 0.15s;
    }
    .ps-tryon-header-mobile-menu-item:hover { background: rgba(0,0,0,0.04) !important; }
    .ps-tryon-header-mobile-menu-item svg {
      width: 18px !important; height: 18px !important;
      stroke: currentColor !important; fill: none !important;
    }
    .ps-tryon-header-mobile-menu-lang {
      border-top: 1px solid rgba(0,0,0,0.06);
    }
    /* Inside the popover, force the language trigger to match the
       Profile/History rows: same padding, gap, font-size, icon size. */
    .ps-tryon-header-mobile-menu-lang .ps-tryon-lang-trigger {
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      width: 100% !important;
      padding: 11px 14px !important;
      min-height: 0 !important;
      border: none !important;
      background: transparent !important;
      border-radius: 0 !important;
      font: inherit !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      color: var(--ps-text-primary, #111) !important;
      text-align: left !important;
      cursor: pointer !important;
      transition: background 0.15s !important;
    }
    .ps-tryon-header-mobile-menu-lang .ps-tryon-lang-trigger:hover { background: rgba(0,0,0,0.04) !important; }
    .ps-tryon-header-mobile-menu-lang .ps-tryon-lang-trigger svg {
      width: 18px !important; height: 18px !important;
      flex-shrink: 0 !important;
    }
    .ps-tryon-header-mobile-menu-lang .ps-tryon-lang-current {
      font-size: 14px !important;
      font-weight: 500 !important;
      flex: 1;
    }
    .ps-tryon-header-mobile-menu-lang .ps-tryon-lang-arrow {
      margin-left: auto;
      width: 20px !important; height: 20px !important;
    }
    .ps-tryon-close {
      width: 24px !important; height: 24px !important;
      border: none !important; background: transparent !important;
      border-radius: 0 !important;
    }
    .ps-tryon-close svg { width: 16px !important; height: 16px !important; }
    .ps-tryon-lang-trigger {
      border: none !important; background: transparent !important;
      border-radius: 0 !important;
      padding: 0 6px !important; min-height: 24px !important;
      gap: 3px !important;
    }
    .ps-tryon-lang-trigger:hover, .ps-tryon-lang-trigger.ps-active {
      background: transparent !important;
    }
    .ps-tryon-lang-trigger svg { width: 12px !important; height: 12px !important; }
    .ps-tryon-lang-trigger .ps-tryon-lang-arrow {
      width: 18px !important; height: 18px !important;
    }
    .ps-tryon-lang-trigger .ps-tryon-lang-arrow svg {
      width: 18px !important; height: 18px !important;
    }
    .ps-tryon-lang-current { font-size: 11px !important; }
    .ps-tryon-header-actions { gap: 0 !important; align-items: center !important; }
    /* Hairline separator between adjacent header icons (skip the very first). */
    .ps-tryon-header-actions > * + * {
      position: relative !important;
      padding-left: 8px !important;
      margin-left: 8px !important;
    }
    .ps-tryon-header-actions > * + *::before {
      content: "" !important;
      position: absolute !important;
      left: 0 !important; top: 25% !important; bottom: 25% !important;
      width: 1px !important;
      background: var(--ps-border-subtle) !important;
    }

    /* Mobile body-measurements step — single-page fit on iPhone (svh).
     * Layout rhythm: title → 3 sliders (compact) → "or" → upload card →
     * Next (sticky bottom) → tabs (sticky bottom).
     * No big spacer between upload card and Next: the upload card now feels
     * like the second action in the same group, both reading as primary
     * choices side-by-side vertically. */
    .ps-bpm-title { font-size: 17px !important; line-height: 1.2 !important; margin: 0 !important; }
    .ps-bpm-subtitle { display: none !important; }
    .ps-bpm-header { margin-bottom: 6px !important; padding: 0 !important; }
    .ps-bpm-fields { margin-top: 2px !important; }
    .ps-bpm-row { padding: 10px 0 !important; gap: 8px !important; }
    .ps-bpm-label { font-size: 10.5px !important; letter-spacing: 0.1em !important; }
    .ps-bpm-value-display { font-size: 14px !important; }
    .ps-bpm-slider-row { gap: 10px !important; }
    .ps-bpm-step-btn { width: 28px !important; height: 28px !important; }
    .ps-bpm-step-btn svg { width: 12px !important; height: 12px !important; }
    .ps-bpm-slider { height: 4px !important; }
    /* "or" divider: tight, no extra margin */
    .ps-bpm-or { margin: 10px 0 8px !important; font-size: 10px !important; letter-spacing: 0.15em !important; }
    /* Upload action — prominent card with dashed accent border + centered
     * icon-over-text layout. Reads as a real "drop zone" alternative to the
     * manual sliders above. Larger touch area, accent color cues affordance. */
    .ps-bpm-upload-link {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 6px !important;
      padding: 18px 14px !important;
      width: 100% !important;
      min-height: 92px !important;
      background: rgba(33, 84, 239, 0.04) !important;
      border: 1.5px dashed rgba(33, 84, 239, 0.45) !important;
      border-radius: 12px !important;
      color: var(--ps-accent) !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
    }
    .ps-bpm-upload-link:hover:not(:disabled) {
      background: rgba(33, 84, 239, 0.08) !important;
      border-color: var(--ps-accent) !important;
      opacity: 1 !important;
    }
    .ps-bpm-upload-link svg { width: 22px !important; height: 22px !important; color: var(--ps-accent) !important; flex-shrink: 0 !important; }
    /* Hide the trailing chevron in this taller layout — direction is implied. */
    .ps-bpm-upload-link svg:last-child:not(:first-of-type) { display: none !important; }
    /* Accessory manual screens use the same bottom action shell as
     * BasicsStepMobile, but their rows are numeric entry fields, not sliders.
     * Keep the styling scoped so hats, eyewear, bracelet/watch, and future
     * accessory fields do not inherit half of the apparel slider layout. */
    .ps-acc-mobile-wrap {
      overflow: hidden !important;
    }
    .ps-accm-root {
      padding: 0 !important;
      gap: 10px !important;
      overflow: hidden !important;
    }
    .ps-accm-header {
      margin: 0 !important;
      padding: 0 4% !important;
      text-align: center !important;
    }
    .ps-accm-toggle {
      padding: 0 4% !important;
      margin: 0 !important;
      gap: 26px !important;
    }
    .ps-accm-toggle .ps-bpm-toggle-btn {
      text-transform: uppercase !important;
      letter-spacing: 0.12em !important;
      min-width: 52px !important;
    }
    .ps-accm-fields {
      padding: 0 4% !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch;
      min-height: 0 !important;
      display: flex !important;
      flex-direction: column !important;
    }
    .ps-accm-row {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(118px, 44%) !important;
      align-items: center !important;
      gap: 6px 12px !important;
      padding: 14px 0 !important;
      border-bottom: 1px solid var(--ps-border-subtle) !important;
    }
    .ps-accm-row:last-child { border-bottom: none !important; }
    .ps-accm-label {
      min-width: 0 !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      letter-spacing: 0.12em !important;
      text-transform: uppercase !important;
      color: var(--ps-text-muted) !important;
      line-height: 1.25 !important;
    }
    .ps-accm-input-group {
      min-width: 0 !important;
      display: flex !important;
      align-items: baseline !important;
      justify-content: flex-end !important;
      gap: 7px !important;
    }
    .ps-accm-input {
      width: 100% !important;
      min-width: 0 !important;
      padding: 0 0 5px !important;
      border: none !important;
      border-bottom: 1px solid var(--ps-border-color) !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: var(--ps-text-primary) !important;
      font-family: inherit !important;
      font-size: 20px !important;
      font-weight: 700 !important;
      text-align: right !important;
      outline: none !important;
      box-shadow: none !important;
      font-variant-numeric: tabular-nums !important;
    }
    .ps-accm-input:focus {
      border-bottom-color: var(--ps-accent) !important;
    }
    .ps-accm-input::placeholder {
      color: var(--ps-text-muted) !important;
      opacity: 0.55 !important;
      font-size: 16px !important;
      font-weight: 500 !important;
    }
    .ps-accm-input::-webkit-outer-spin-button,
    .ps-accm-input::-webkit-inner-spin-button { -webkit-appearance: none !important; margin: 0 !important; }
    .ps-accm-input[type="number"] { -moz-appearance: textfield !important; }
    .ps-accm-unit {
      flex: 0 0 auto !important;
      min-width: 22px !important;
      font-size: 12px !important;
      font-weight: 700 !important;
      color: var(--ps-text-muted) !important;
      text-transform: lowercase !important;
    }
    .ps-accm-hint {
      grid-column: 1 / -1 !important;
      font-size: 12px !important;
      line-height: 1.4 !important;
      color: var(--ps-text-muted) !important;
    }
    .ps-accm-bottom {
      margin-top: auto !important;
    }
    @media (max-width: 360px) {
      .ps-accm-row {
        grid-template-columns: 1fr !important;
        gap: 8px !important;
      }
      .ps-accm-input-group {
        justify-content: flex-start !important;
      }
      .ps-accm-input {
        text-align: left !important;
        max-width: 170px !important;
      }
    }
    /* Spacer eats remaining vertical space so the bottom block is pushed to
     * the actual viewport bottom (sticky alone doesn't pin shorter content). */
    .ps-bpm-spacer { display: block !important; flex: 1 1 auto !important; min-height: 0 !important; }
    /* Bottom group sits at the viewport bottom with a top divider. */
    .ps-bpm-bottom {
      flex-shrink: 0 !important;
      padding: 12px 0 0 !important; gap: 8px !important;
      background: var(--ps-bg-primary) !important;
      border-top: 1px solid var(--ps-border-subtle) !important;
    }
    .ps-bpm-next-btn { height: 44px !important; font-size: 14px !important; border-radius: 10px !important; }
    .ps-bpm-bottom-tab { padding: 8px 6px !important; font-size: 10px !important; letter-spacing: 0.1em !important; }
    .ps-bpm-bottom-tab svg { width: 12px !important; height: 12px !important; }

    /* iOS-safe modal height: svh (small viewport) is stable when URL bar
     * shows/hides. dvh changes value as user scrolls and causes layout jumps. */
    .ps-tryon-modal,
    .ps-tryon-modal-wide {
      max-height: 100svh !important;
      height: 100svh !important;
      min-height: 100svh !important;
    }

    /* Photo step layout: stack the two columns vertically on mobile so the
     * upload area gets full width and the body-details column (height /
     * weight / bra / age + "?" pill) is fully readable instead of cramped at
     * 50% of viewport. */
    .ps-bp-wrapper > .ps-bp-layout:first-child {
      flex-direction: column !important;
      padding: 0 !important;
      gap: 16px !important;
      height: auto !important;
      min-height: 0 !important;
    }
    .ps-bp-wrapper > .ps-bp-layout:first-child > div {
      flex: 1 1 auto !important;
      width: 100% !important;
    }
    /* Re-size desktop vw-based body-details typography for mobile. */
    .ps-bp-wrapper h3 { font-size: 16px !important; }
    /* "How to take a good photo" pill button — readable size + tap target. */
    .ps-bp-wrapper button[aria-label="How to take a good photo"] {
      padding: 8px 12px !important;
      font-size: 11px !important;
      gap: 6px !important;
    }
    .ps-bp-wrapper button[aria-label="How to take a good photo"] > span:first-child {
      width: 16px !important; height: 16px !important;
      font-size: 11px !important;
      min-width: 16px !important; min-height: 16px !important;
    }
    .ps-bp-wrapper p {
      font-size: 12px !important;
    }

    /* Body details (height/weight/bra) inputs section on mobile photo step. */
    .ps-pm-body-details {
      display: flex; flex-direction: column;
      gap: 8px;
      padding: 12px 0;
    }
    .ps-pm-body-details-head {
      display: flex; align-items: center; justify-content: space-between;
      gap: 8px;
    }
    .ps-pm-body-details-head h3 {
      margin: 0;
      font-size: 15px; font-weight: 700;
      color: var(--ps-text-primary);
    }
    .ps-pm-body-details-sub {
      margin: 0;
      font-size: 11px;
      color: var(--ps-text-muted);
    }
    .ps-pm-help-pill {
      display: inline-flex; align-items: center; gap: 6px;
      padding: 6px 10px;
      background: transparent; color: var(--ps-accent);
      border: 1.5px solid var(--ps-accent);
      border-radius: 999px;
      cursor: pointer; font-family: inherit;
      font-size: 11px; font-weight: 700;
      letter-spacing: 0.04em; white-space: nowrap;
      flex-shrink: 0;
      transition: background 0.15s, color 0.15s;
    }
    .ps-pm-help-pill.ps-active {
      background: var(--ps-accent); color: #FFFFFF;
    }
    .ps-pm-help-pill-q {
      display: inline-flex; align-items: center; justify-content: center;
      width: 16px; height: 16px;
      border-radius: 50%;
      background: var(--ps-accent); color: #FFFFFF;
      font-size: 11px; font-weight: 700; line-height: 1;
    }
    .ps-pm-help-pill.ps-active .ps-pm-help-pill-q {
      background: #FFFFFF; color: var(--ps-accent);
    }
    /* Hide PhotoStepMobile's inline Do/Don't grid on mobile — content lives
     * in the help drawer now. Keeps the scan step compact. */
    .ps-pm-dodonts-grid, .ps-pm-dodonts-tip { display: none !important; }

    /* When the visual stepper is rendered above PhotoStepMobile (only the
     * BodyProfileView mobile flow does this), the stepper's "PHOTO" /
     * "DETAILS" labels already title the step, so PhotoStepMobile's own
     * "Review your photo" h2+subtitle header is redundant. Hide it to
     * reclaim vertical space and keep the upload zone uncropped.
     * AccessoryView (no stepper sibling) keeps its header. */
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-header { display: none !important; }
    .ps-bp-scan-progress ~ .ps-pm-root {
      gap: max(10px, 2.6vw) !important;
      padding-top: 0 !important;
    }
    /* The "tall" upload zone fills all remaining vertical space on
     * mobile Step 1 so the upload area is unmistakably the focal point.
     * .ps-pm-preview-tall is opted in by PhotoStepMobile when caller
     * passes compactAgeGate. Reference design has a dashed border and
     * a slightly lighter fill — applied here so other usages of
     * .ps-pm-preview (AccessoryView, etc.) aren't affected. */
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-preview.ps-pm-preview-tall {
      flex: 1 1 0% !important;
      height: auto !important;
      min-height: 180px !important;
      background: #F4F5F7 !important;
      border: 2px dashed #D5D8DD !important;
      border-radius: 18px !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-preview-compact-gate {
      flex-direction: column !important;
      gap: 12px !important;
      padding: 18px !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-preview-compact-gate .ps-pm-preview-empty {
      width: auto !important;
      height: auto !important;
      padding: 0 !important;
      flex: 0 0 auto !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-preview-empty-title {
      font-size: 16px !important; font-weight: 600 !important;
      color: var(--ps-text-secondary) !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-preview-empty-hint {
      font-size: 11px !important; color: var(--ps-text-muted) !important;
      letter-spacing: 0 !important; text-transform: none !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-preview-empty-format {
      font-size: 10px !important;
      color: var(--ps-text-dim) !important;
    }
    /* Single-page layout for the scan flow — kill the in-root spacer so
     * the preview grows naturally, and let the .ps-pm-root shrink to its
     * parent so total content stays inside the viewport. The bottom CTA
     * + tabs sit naturally pinned at the bottom of the column. */
    .ps-bp-scan-progress ~ .ps-pm-root {
      min-height: 0 !important;
      max-height: 100% !important;
      overflow: hidden !important;
      gap: 8px !important;
      padding: 0 !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-bpm-spacer {
      display: none !important;
    }
    /* Same for Step 2 (body details) — center content, pin the bottom. */
    .ps-bp-wrapper .ps-bp-scan-details-center { min-height: 0 !important; }
    /* The bottom block is sticky-style: always visible at the column
     * bottom. flex-shrink: 0 keeps it from collapsing if the upload
     * preview tries to grow past the available space. */
    .ps-bp-wrapper .ps-bpm-bottom {
      flex-shrink: 0 !important;
      margin-top: auto !important;
      background: var(--ps-bg-primary, #FFFFFF) !important;
    }
    /* Small-screen pass: tighten everything in the scan flow so the
     * full layout (stepper + help + upload + legal + CTA + tabs) fits
     * on a 568px iPhone-SE-sized viewport without scrolling. */
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-legal-notice {
      margin-top: 8px !important;
      padding: 8px 12px !important;
      gap: 4px !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-checklist {
      display: none !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-legal-notice-body {
      font-size: 11px !important; line-height: 1.4 !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-primary-btn {
      padding: 14px 18px !important;
      font-size: 13px !important;
      margin: 8px 16px 0 !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-bpm-bottom {
      padding-bottom: 4px !important;
    }
    /* On very short viewports (≤ 600px tall) collapse the upload zone
     * floor a bit further so the rest of the page still fits. */
    @media (max-height: 600px) {
      .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-preview.ps-pm-preview-tall {
        min-height: 140px !important;
      }
      .ps-bp-scan-progress { padding: 6px 12px 0 !important; margin-bottom: 16px !important; }
      .ps-bp-scan-help-row { padding-bottom: 6px !important; }
    }

    /* Prominent "How to take a good photo" pill row — sits between the
     * stepper and the upload zone so the user always sees how to get
     * help. Centered, FILLED light-accent background (matches the
     * reference design), with a darker "?" circle badge. */
    .ps-bp-scan-help-row {
      display: flex; justify-content: center;
      padding: 0 4px 12px;
    }
    .ps-bp-scan-help-pill {
      padding: 10px 18px !important;
      font-size: 13px !important;
      letter-spacing: 0.02em !important;
      background: rgba(33, 84, 239, 0.10) !important;
      color: var(--ps-accent) !important;
      border: 1px solid rgba(33, 84, 239, 0.18) !important;
      box-shadow: 0 2px 6px -2px rgba(33, 84, 239, 0.18);
      gap: 8px !important;
    }
    .ps-bp-scan-help-pill .ps-pm-help-pill-q {
      width: 18px !important; height: 18px !important;
      font-size: 12px !important;
      background: var(--ps-accent) !important;
      color: #FFFFFF !important;
    }
    .ps-bp-scan-help-pill.ps-active {
      background: var(--ps-accent) !important;
      color: #FFFFFF !important;
      border-color: var(--ps-accent) !important;
    }
    .ps-bp-scan-help-pill.ps-active .ps-pm-help-pill-q {
      background: #FFFFFF !important;
      color: var(--ps-accent) !important;
    }

    /* Mobile primary CTA — gradient purple/blue to match the reference.
     * Applied only when the photo step is rendered through the new
     * 2-step scan flow (i.e. .ps-bp-scan-progress is a sibling). */
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-primary-btn,
    .ps-bp-wrapper .ps-bp-scan-details-center ~ .ps-bpm-bottom .ps-bpm-next-btn {
      background: linear-gradient(135deg, #6E76F1 0%, #4F46E5 60%, #4338CA 100%) !important;
      box-shadow: 0 8px 18px -8px rgba(79, 70, 229, 0.42),
                  0 4px 8px -4px rgba(79, 70, 229, 0.25);
      color: #FFFFFF !important;
      border-radius: 14px !important;
      letter-spacing: 0.16em !important;
    }

    /* Compact, mobile-only age-gate overlay. Centered chip, tiny blur,
     * subtle white dim — keeps the upload icon visible behind so the
     * user sees the answer "yes" reveals the upload zone. */
    .ps-pm-age-overlay {
      position: absolute; inset: 0;
      display: flex; align-items: center; justify-content: center;
      padding: 16px;
      background: rgba(255, 255, 255, 0.45);
      backdrop-filter: blur(2px);
      -webkit-backdrop-filter: blur(2px);
      z-index: 2;
      animation: ps-pm-age-gate-in 0.22s ease-out both;
    }
    .ps-pm-age-overlay-chip {
      width: auto; max-width: 100%;
      padding: 12px 14px;
      background: #FFFFFF;
      border: 1px solid var(--ps-border-subtle);
      border-radius: 14px;
      box-shadow: 0 10px 24px -10px rgba(17,24,39,0.20),
                  0 4px 10px -6px rgba(17,24,39,0.10);
      display: flex; flex-direction: column;
      align-items: center; text-align: center;
      gap: 10px;
    }
    .ps-pm-age-overlay-error .ps-pm-age-overlay-chip {
      border-color: rgba(192,38,38,0.40);
      box-shadow: 0 10px 24px -10px rgba(192,38,38,0.22);
    }
    .ps-pm-age-overlay-q {
      font-size: 14px; font-weight: 600;
      color: var(--ps-text-primary); line-height: 1.3;
    }
    .ps-pm-age-overlay-error .ps-pm-age-overlay-q { color: #C02626; }
    .ps-pm-age-overlay-actions {
      display: flex; gap: 8px; justify-content: center;
    }
    .ps-pm-age-overlay-btn {
      padding: 7px 18px;
      border-radius: 999px;
      font-family: inherit;
      font-size: 12px; font-weight: 700;
      cursor: pointer;
      letter-spacing: 0.02em;
    }
    .ps-pm-age-overlay-yes {
      background: var(--ps-accent); color: #FFFFFF;
      border: 1px solid var(--ps-accent);
    }
    .ps-pm-age-overlay-no {
      background: transparent; color: var(--ps-text-secondary);
      border: 1px solid var(--ps-border-color);
    }

    /* Spinner overlay for the backend age-check / image-processing flow.
     * Sits on top of the upload zone (absolute, inset 0) while the backend
     * verifies the photo. Disappears the moment processing finishes. */
    .ps-pm-processing-overlay {
      position: absolute; inset: 0;
      display: flex; align-items: center; justify-content: center;
      padding: 16px;
      background: rgba(255, 255, 255, 0.78);
      backdrop-filter: blur(3px);
      -webkit-backdrop-filter: blur(3px);
      z-index: 3;
      animation: ps-mobile-fade-in 0.18s ease-out;
    }
    .ps-pm-processing-card {
      display: flex; flex-direction: column;
      align-items: center; gap: 12px;
      padding: 16px 18px;
      background: #FFFFFF;
      border: 1px solid var(--ps-border-subtle);
      border-radius: 14px;
      box-shadow: 0 10px 24px -10px rgba(17,24,39,0.18);
    }
    .ps-pm-processing-spinner {
      width: 28px; height: 28px;
      border: 3px solid var(--ps-bg-tertiary);
      border-top-color: var(--ps-accent);
      border-radius: 50%;
      animation: ps-pm-spin 0.85s linear infinite;
    }
    @keyframes ps-pm-spin {
      to { transform: rotate(360deg); }
    }
    .ps-pm-processing-label {
      font-size: 13px; font-weight: 600;
      color: var(--ps-text-primary);
      text-align: center;
    }

    /* Backend-rejection chip — same structure as the desktop "Photo
     * declined" card: red icon + uppercase title row, then the AI's
     * rejection reason, then a primary "Try another photo" CTA. Sits
     * BELOW the upload zone. */
    .ps-pm-photo-rejection {
      display: flex; flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      margin: 10px 0 0;
      padding: 12px 14px;
      background: #FFFFFF;
      border: 1px solid rgba(220, 38, 38, 0.35);
      border-radius: 12px;
      box-shadow: 0 6px 18px -10px rgba(220, 38, 38, 0.20);
    }
    .ps-pm-photo-rejection-head {
      display: flex; align-items: center;
      gap: 6px;
    }
    .ps-pm-photo-rejection-title {
      color: #dc2626;
      font-size: 11px; font-weight: 700;
      letter-spacing: 0.08em; text-transform: uppercase;
    }
    .ps-pm-photo-rejection-msg {
      margin: 0;
      font-size: 12px; line-height: 1.45;
      color: var(--ps-text-secondary);
    }
    .ps-pm-photo-rejection-retry {
      padding: 7px 14px;
      background: var(--ps-accent); color: #FFFFFF;
      border: none;
      border-radius: 8px;
      font-family: inherit;
      font-size: 12px; font-weight: 700;
      cursor: pointer;
    }
    .ps-pm-photo-rejection-retry:active { opacity: 0.92; }

    /* Close-up accessory photo screens (hats/eyewear) have no apparel
     * stepper wrapper, so keep their upload/details/checklist compact and
     * let the modal body scroll naturally instead of forcing body-profile
     * desktop row flex rules into the phone layout. */
    .ps-acc-mobile-photo {
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch;
    }
    .ps-acc-mobile-photo .ps-pm-root {
      padding: 0 !important;
      gap: 10px !important;
      min-height: auto !important;
      overflow: visible !important;
    }
    .ps-acc-mobile-photo .ps-pm-header {
      margin: 0 !important;
      text-align: left !important;
    }
    .ps-acc-mobile-photo .ps-pm-title {
      font-size: 18px !important;
      line-height: 1.22 !important;
      margin-bottom: 4px !important;
    }
    .ps-acc-mobile-photo .ps-pm-subtitle {
      font-size: 12px !important;
      line-height: 1.4 !important;
    }
    .ps-acc-mobile-photo .ps-pm-preview {
      height: min(42svh, 300px) !important;
      min-height: 188px !important;
      border-radius: 14px !important;
      flex-shrink: 0 !important;
    }
    .ps-acc-mobile-photo .ps-pm-legal-notice,
    .ps-acc-mobile-photo .ps-pm-checklist {
      margin-top: 0 !important;
      padding: 10px 12px !important;
      border-radius: 12px !important;
    }
    .ps-acc-mobile-photo .ps-pm-checklist {
      gap: 10px !important;
    }
    .ps-acc-mobile-photo .ps-pm-checklist-title {
      font-size: 12px !important;
      margin-bottom: 4px !important;
    }
    .ps-acc-mobile-photo .ps-pm-checklist-items li,
    .ps-acc-mobile-photo .ps-pm-legal-notice-body {
      font-size: 11.5px !important;
      line-height: 1.4 !important;
    }
    .ps-acc-mobile-photo .ps-bpm-bottom {
      margin-top: 2px !important;
    }
    .ps-acc-photo-context {
      padding: 0 !important;
      gap: 8px !important;
    }
    .ps-acc-photo-context .ps-bp-system-toggle {
      gap: 22px !important;
      margin: 0 !important;
    }
    .ps-acc-photo-context .ps-bp-system-btn {
      font-size: 13px !important;
      padding: 5px 0 !important;
    }
    .ps-acc-photo-context .ps-bp-inline-fields {
      flex: 0 0 auto !important;
      justify-content: flex-start !important;
      max-width: 360px !important;
      width: 100% !important;
      margin: 0 auto !important;
    }
    .ps-acc-photo-context .ps-bp-inline-row {
      padding: 9px 0 !important;
      gap: 12px !important;
      border-bottom: 1px solid var(--ps-border-subtle) !important;
    }
    .ps-acc-photo-context .ps-bp-inline-label {
      flex: 0 0 82px !important;
      font-size: 10.5px !important;
    }
    .ps-acc-photo-context .ps-bp-inline-input {
      font-size: 17px !important;
    }
    .ps-acc-photo-context .ps-bp-inline-unit {
      font-size: 12px !important;
    }

    /* Compact 2-step stepper — perfectly centered with numbered dots +
     * labels. Big bottom margin gives clear breathing room before the
     * "How to take a good photo" pill below it. */
    .ps-bp-scan-progress {
      display: flex; align-items: center; justify-content: center;
      width: 100%;
      gap: 6px;
      padding: 12px 12px 0;
      margin: 0 0 24px;
      position: relative;
      text-align: center;
    }
    .ps-bp-scan-progress-back {
      position: absolute; left: 4px; top: 12px;
      width: 28px; height: 28px;
      display: inline-flex; align-items: center; justify-content: center;
      border: none; background: transparent;
      color: var(--ps-text-primary);
      font-size: 18px; line-height: 1;
      cursor: pointer; border-radius: 50%;
      padding: 0;
    }
    .ps-bp-scan-progress-back:active { background: var(--ps-bg-tertiary); }
    .ps-bp-scan-progress-spacer { display: none; }
    .ps-bp-scan-progress-track {
      display: inline-flex; align-items: center; justify-content: center;
      gap: 10px;
      margin: 0 auto;
      flex: 0 1 auto;
    }
    .ps-bp-scan-progress-step {
      display: inline-flex; align-items: center; gap: 6px;
      flex-shrink: 0;
    }
    .ps-bp-scan-progress-dot {
      display: inline-flex; align-items: center; justify-content: center;
      width: 20px; height: 20px;
      border-radius: 50%;
      background: var(--ps-bg-tertiary);
      color: var(--ps-text-muted);
      border: 1px solid var(--ps-border-color);
      font-size: 10px; font-weight: 700;
      flex-shrink: 0;
    }
    .ps-bp-scan-progress-step.ps-active .ps-bp-scan-progress-dot,
    .ps-bp-scan-progress-step.ps-done .ps-bp-scan-progress-dot {
      background: var(--ps-accent); color: #FFFFFF;
      border-color: var(--ps-accent);
    }
    .ps-bp-scan-progress-label {
      display: inline;
      font-size: 11px; font-weight: 700;
      letter-spacing: 0.06em; text-transform: uppercase;
      color: var(--ps-text-muted);
    }
    .ps-bp-scan-progress-step.ps-active .ps-bp-scan-progress-label,
    .ps-bp-scan-progress-step.ps-done .ps-bp-scan-progress-label {
      color: var(--ps-text-primary);
    }
    .ps-bp-scan-progress-line {
      flex: 0 0 28px; height: 2px;
      background: var(--ps-border-color);
      border-radius: 2px;
    }
    .ps-bp-scan-progress-line.ps-active {
      background: var(--ps-accent);
    }

    /* Step 2 (body details) — centered single-screen layout. The wrapper
     * is a flex column with a centered content block; the bottom CTA +
     * tabs sit pinned at the bottom (handled by .ps-bpm-bottom). */
    .ps-bp-scan-details-center {
      flex: 1 1 auto;
      display: flex; flex-direction: column;
      align-items: stretch; justify-content: center;
      gap: 12px;
      padding: 8px 16px;
      min-height: 0;
    }
    .ps-bp-scan-details-title {
      margin: 0; text-align: center;
      font-size: 22px; font-weight: 700;
      color: var(--ps-text-primary);
    }
    .ps-bp-scan-details-sub {
      margin: 0; text-align: center;
      font-size: 13px; color: var(--ps-text-muted);
    }
    .ps-bp-scan-details-center .ps-bp-system-toggle {
      align-self: center;
    }
    .ps-bp-scan-details-center:not(.ps-shoe-scan-details) .ps-bp-system-toggle {
      margin-top: clamp(34px, 7vh, 78px) !important;
      margin-bottom: clamp(10px, 2.4vh, 28px) !important;
    }
    .ps-bp-scan-details-center .ps-bp-inline-fields {
      max-width: 360px; width: 100%; margin: 0 auto;
    }
    .ps-shoe-scan-details {
      justify-content: flex-start !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch;
      padding-top: 0 !important;
      padding-bottom: 12px !important;
    }
    .ps-shoe-scan-details .ps-shoe-ref {
      min-height: 0 !important;
      padding-bottom: 4px !important;
    }
    .ps-shoe-scan-details .ps-shoe-stage.ps-active {
      max-height: none !important;
      overflow: visible !important;
    }
    .ps-shoe-scan-details .ps-shoe-brand-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .ps-shoe-scan-details .ps-shoe-size-grid {
      grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .ps-shoe-scan-details .ps-shoe-size-toolbar {
      align-items: flex-start !important;
      justify-content: flex-end !important;
    }
    .ps-shoe-scan-details .ps-shoe-size-controls {
      width: 100% !important;
      justify-content: flex-end !important;
    }
    .ps-shoe-scan-details .ps-shoe-back-brand {
      display: none !important;
    }
    .ps-shoe-scan-details .ps-shoe-selected-brand {
      justify-content: space-between !important;
    }
    .ps-shoe-scan-details .ps-shoe-change-brand {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 7px 11px !important;
      font-size: 10px !important;
      border-radius: 999px !important;
    }
    .ps-shoe-scan-details .ps-shoe-size-chip.ps-selected {
      background: rgba(33, 84, 239, 0.12) !important;
      color: var(--ps-accent) !important;
      -webkit-text-fill-color: var(--ps-accent) !important;
      box-shadow: inset 0 0 0 1px rgba(33,84,239,0.20) !important;
    }
    @media (max-height: 640px) {
      .ps-shoe-scan-details {
        gap: 8px !important;
      }
      .ps-shoe-scan-details .ps-shoe-ref-title {
        font-size: 15px !important;
      }
      .ps-shoe-scan-details .ps-shoe-ref-copy {
        display: none !important;
      }
      .ps-shoe-scan-details .ps-shoe-brand-card {
        min-height: 48px !important;
        padding: 8px !important;
      }
      .ps-shoe-scan-details .ps-shoe-brand-logo {
        width: 30px !important;
        height: 30px !important;
      }
    }

    /* Desktop-style compact age chip on mobile. Sits BELOW the upload
     * zone (sibling, not overlay) so the upload area stays uncropped.
     * Mirrors desktop's two-state design (pre-answer + error). */
    .ps-pm-age-chip {
      display: flex; align-items: center;
      gap: 8px;
      margin: 8px 0 0;
      padding: 8px 12px;
      background: #FFFFFF;
      border: 1px solid var(--ps-border-subtle);
      border-radius: 12px;
      box-shadow: 0 6px 18px -10px rgba(17,24,39,0.18);
      animation: ps-cpw-age-gate-in 0.28s ease-out both;
    }
    .ps-pm-age-chip-error {
      border-color: rgba(192,38,38,0.35);
      box-shadow: 0 6px 18px -10px rgba(192,38,38,0.20);
    }
    .ps-pm-age-chip-q {
      flex: 1;
      font-size: 13px; font-weight: 600;
      color: var(--ps-text-primary);
      line-height: 1.3;
    }
    .ps-pm-age-chip-error .ps-pm-age-chip-q { color: #C02626; }
    .ps-pm-age-chip-btn {
      padding: 6px 14px;
      border-radius: 999px;
      font-family: inherit;
      font-size: 12px; font-weight: 700;
      cursor: pointer;
      flex-shrink: 0;
    }
    .ps-pm-age-chip-yes {
      background: var(--ps-accent); color: #FFFFFF;
      border: 1px solid var(--ps-accent);
    }
    .ps-pm-age-chip-no {
      background: transparent; color: var(--ps-text-secondary);
      border: 1px solid var(--ps-border-color);
    }

    /* Photo-help popover on mobile = bottom drawer with backdrop. */
    .ps-bp-photo-help-backdrop {
      display: block !important;
      position: fixed !important; inset: 0 !important;
      background: rgba(15, 23, 42, 0.5) !important;
      z-index: 20 !important;
      animation: ps-mobile-fade-in 0.2s ease;
    }
    .ps-bp-photo-help {
      position: fixed !important;
      left: 0 !important; right: 0 !important; bottom: 0 !important;
      top: auto !important;
      width: 100% !important; max-width: 100% !important;
      border-radius: 18px 18px 0 0 !important;
      padding: 8px 16px 24px !important; padding-bottom: max(24px, env(safe-area-inset-bottom)) !important;
      gap: 12px !important;
      max-height: 80svh !important; overflow-y: auto !important;
      z-index: 21 !important;
      animation: ps-mobile-slide-up 0.28s cubic-bezier(0.32, 0.72, 0, 1);
      box-shadow: 0 -10px 30px -8px rgba(17,24,39,0.2) !important;
    }
    .ps-bp-photo-help-handle {
      display: block !important;
      width: 36px; height: 4px; border-radius: 2px;
      background: var(--ps-border-subtle);
      margin: 0 auto 4px;
    }
    .ps-bp-photo-help-title { font-size: 16px !important; }
    .ps-bp-photo-help-close {
      width: 32px !important; height: 32px !important;
      font-size: 22px !important; border-radius: 50% !important;
    }
    .ps-bp-photo-help-section { border-radius: 10px !important; padding: 10px 12px !important; }
    .ps-bp-photo-help-section-label { font-size: 12px !important; margin-bottom: 6px !important; }
    .ps-bp-photo-help-section-body { font-size: 12px !important; line-height: 1.55 !important; }
    .ps-bp-photo-help-tip { font-size: 12px !important; line-height: 1.55 !important; }

    /* Mobile step roots are flex columns that fill the modal body — that
     * gives the spacer something to grow into and the bottom block lands at
     * the actual viewport bottom. Negative margins extend the bottom block
     * (and tabs) edge-to-edge inside the body's padding. */
    .ps-bpm-root, .ps-pm-root, .ps-bp-wrapper {
      display: flex !important; flex-direction: column !important;
      min-height: 100% !important;
      flex: 1 !important;
    }
    .ps-bpm-bottom {
      margin-left: calc(-1 * max(16px, 4vw)) !important;
      margin-right: calc(-1 * max(16px, 4vw)) !important;
      padding-left: max(16px, 4vw) !important;
      padding-right: max(16px, 4vw) !important;
    }
    .ps-bpm-bottom-tabs {
      margin-left: calc(-1 * max(16px, 4vw)) !important;
      margin-right: calc(-1 * max(16px, 4vw)) !important;
    }

    /* ── Body: scrollable, comfortable padding, momentum scroll ── */
    .ps-tryon-body {
      padding: max(16px, 4vw) !important;
      flex: 1 !important; min-height: 0 !important;
      overflow-y: auto !important; overflow-x: hidden !important;
      -webkit-overflow-scrolling: touch;
    }

    /* ── Back button: bigger, easier to tap ── */
    .ps-tryon-back-btn {
      font-size: 14px !important; gap: 6px !important;
      margin-bottom: 12px !important; padding: 6px 0 !important;
    }
    .ps-tryon-back-btn svg { width: 18px !important; height: 12px !important; }

    /* ── Preserve existing previews and modal-wide overrides ── */
    .ps-tryon-preview { height: 320px; }

    /* ── Drawer list (history / profiles / settings) ── */
    /* Pure vw gap (0.52vw = ~2 px on mobile) crushed list rows together. */
    .ps-tryon-drawer-list { gap: 12px !important; padding: 0 !important; }
    .ps-tryon-drawer { padding: 16px !important; }

    /* ── Profile cards inside the sizing-profiles drawer ── */
    .ps-msp-card {
      padding: 16px !important;
      border-radius: 14px !important;
    }
    .ps-msp-card-tag { font-size: 11px !important; padding: 4px 8px !important; border-radius: 999px !important; }
    .ps-msp-card-circle { width: 72px !important; height: 72px !important; margin: 8px auto 12px !important; }
    .ps-msp-card-name { font-size: 16px !important; margin-bottom: 6px !important; }
    .ps-msp-meta-row { padding: 6px 0 !important; gap: 8px !important; }
    .ps-msp-card-meta { font-size: 12px !important; }
    .ps-msp-card-actions { gap: 8px !important; margin-top: 10px !important; }
    .ps-msp-card-select { font-size: 13px !important; padding: 10px 12px !important; border-radius: 8px !important; }
    .ps-msp-card-edit, .ps-msp-card-delete { width: 36px !important; height: 36px !important; border-radius: 8px !important; }
    .ps-msp-card-create { min-height: 120px !important; font-size: 14px !important; }

    /* ── Language switcher dropdown ── */
    /* Default min(18vw, 280px) collapsed to ~67 px on mobile — unusable. */
    .ps-tryon-lang-list { max-height: 320px !important; }
    .ps-tryon-lang-item { padding: 10px 14px !important; gap: 10px !important; }
    .ps-tryon-lang-name { font-size: 14px !important; }
    .ps-tryon-lang-code { font-size: 11px !important; }
  }

  @keyframes ps-mobile-slide-up {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes ps-mobile-fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @media (max-width: 720px) {
    .ps-tryon-result-split { flex-direction: column; }
    .ps-tryon-result-image-col { flex: none; }
  }
  @media (max-width: 480px) {
    .ps-tryon-body { padding: 18px; }
    .ps-tryon-header { padding: 14px 18px; }
    .ps-tryon-stepper { padding: 14px 18px 8px; }
    .ps-tryon-stepper-circle { width: 24px; height: 24px; font-size: 10px; }
    .ps-tryon-stepper-label { font-size: 9px; }
    .ps-tryon-features { flex-direction: column; gap: 8px; }
    .ps-tryon-feature { flex-direction: row; gap: 10px; text-align: left; }
    .ps-tryon-feature-icon { margin-bottom: 0; }
    .ps-tryon-input-row { flex-wrap: wrap; }
    .ps-tryon-input-row label { min-width: 100%; margin-bottom: -4px; }
    .ps-tryon-drawer { padding: 16px; }
    .ps-tryon-detail-grid { gap: 8px; }
    .ps-tryon-detail-cell { padding: 10px 12px; }
    .ps-tryon-detail-cell-value { font-size: 14px; }
    .ps-tryon-detail-modal { max-width: 100%; }
    .ps-tryon-header-icon { width: 30px; height: 30px; border-radius: 8px; }
    .ps-tryon-back-btn { font-size: 13px; gap: 6px; margin-bottom: 10px; }
    .ps-tryon-back-btn svg { width: 16px; height: 10px; }
    .ps-tryon-sr-fit-table { font-size: 14px; margin-top: 12px; }
    .ps-tryon-sr-fit-table thead th { font-size: 11px; padding: 4px 0 8px; }
    .ps-tryon-sr-fit-table td { padding: 12px 0; }
    .ps-tryon-sr-fit-status { font-size: 10px; padding: 3px 6px; }
    .ps-tryon-sr-fit-area { font-size: 14px; }
    .ps-tryon-sr-fit-range { font-size: 14px; }
    .ps-tryon-upload-modal { width: 90%; max-width: none; padding: 18px; border-radius: 14px; gap: 12px; }
    .ps-tryon-upload-modal-header h3 { font-size: 15px; }
    .ps-tryon-upload-modal-close { font-size: 22px; }
    .ps-tryon-upload-modal-dropzone { padding: 24px; min-height: 120px; border-radius: 10px; }
    .ps-tryon-upload-modal-dropzone p { font-size: 14px; }
    .ps-tryon-upload-modal-dropzone span { font-size: 11px; }
    .ps-tryon-upload-modal-preview { max-height: 200px; border-radius: 10px; }
    .ps-tryon-upload-modal-preview img { max-height: 200px; }
    .ps-tryon-upload-modal-remove { width: 24px; height: 24px; font-size: 14px; top: 6px; right: 6px; }
    /* Multi-section mobile */
    .ps-tryon-sr-split-multi { grid-template-columns: 1fr; }
    .ps-tryon-sr-img-col-small { max-height: 200px; }
    .ps-tryon-sr-multi-title { font-size: 16px; }
    .ps-tryon-sr-picker { gap: 12px; padding: 4px; }
    .ps-tryon-sec-row { gap: 8px; }
    .ps-tryon-sec-bigcard:not(.ps-has-img) { padding: 16px 10px; gap: 6px; min-height: 180px; }
    .ps-tryon-sec-bigcard { border-radius: 10px; }
    .ps-tryon-sec-bigcard-content { padding: 12px 8px; }
    .ps-tryon-sec-bigcard-bg { border-radius: 10px 10px 0 0; }
    .ps-tryon-sec-bigcard-icon { width: 48px; height: 48px; }
    .ps-tryon-sec-bigcard-icon svg { width: 26px; height: 26px; }
    .ps-tryon-sec-bigcard-name { font-size: 13px; }
    .ps-tryon-sec-bigcard-size { font-size: 28px; }
    .ps-tryon-sec-bigcard-badge { font-size: 9px; padding: 2px 6px; }
    .ps-tryon-sec-bigcard-fit { font-size: 10px; }
    .ps-tryon-sec-detail-back { font-size: 13px; gap: 5px; }
    .ps-tryon-sec-detail-back svg { width: 14px; height: 14px; }
    .ps-tryon-sec-detail-header { gap: 10px; padding-bottom: 8px; }
    .ps-tryon-sec-detail-icon { width: 38px; height: 38px; }
    .ps-tryon-sec-detail-icon svg { width: 22px; height: 22px; }
    .ps-tryon-sec-detail-name { font-size: 16px; }
    .ps-tryon-section-name { font-size: 14px; }
    .ps-tryon-section-size { font-size: 18px; gap: 6px; }
    .ps-tryon-section-rec-badge,
    .ps-tryon-section-notrec-badge { font-size: 9px; padding: 2px 6px; border-radius: 4px; }
    .ps-tryon-sec-detail .ps-tryon-sr-size-letter { font-size: 32px; }
    .ps-tryon-sec-detail .ps-tryon-sr-chip { min-width: 36px; height: 36px; font-size: 13px; }
    .ps-tryon-sec-length-row { gap: 8px; padding: 6px 0; }
    .ps-tryon-sec-length-label { font-size: 11px; }
    /* Body type cards mobile */
    .ps-tryon-bodytype-cards { gap: 6px; }
    .ps-tryon-bodytype-card { padding: 8px 4px; border-radius: 8px; }
    .ps-tryon-bodytype-label { font-size: 10px; }
  }

  /* ═══════════════════════════════════════════════════════════
     Body Profile Onboarding (ps-bp-*)
     ═══════════════════════════════════════════════════════════ */

  /* Wrapper for title + split layout */
  .ps-bp-wrapper { display: flex; flex-direction: column; flex: 1; min-height: 0; overflow: hidden; }
  .ps-bp-shapes-header { flex-shrink: 0; margin-bottom: 0.6vw; text-align: left; }
  .ps-bp-shapes-header .ps-bp-title { font-size: 1vw; font-weight: 600; }
  .ps-bp-shapes-header .ps-bp-subtitle { font-size: 0.55vw; color: var(--ps-text-muted); font-weight: 400; }

  /* Split layout: product left, form right — FIXED vh height, never changes */
  .ps-bp-layout {
    display: flex; gap: 1.2vw; flex: 1; min-height: 0;
    overflow: hidden; align-items: center;
  }
  .ps-bp-image {
    flex: 0 0 43%; min-width: 0;
    height: 100%;
    background: var(--ps-bg-primary);
    border-radius: 0.9vw; overflow: hidden;
    display: flex;
  }
  .ps-bp-image-img {
    width: 100%; height: 100%;
    object-fit: contain; object-position: center center;
    flex: 1;
  }
  /* Upload zone — same element as .ps-bp-image, dashed border + centered content, full height */
  .ps-bp-image.ps-bp-upload-zone {
    cursor: pointer; border: 2px dashed var(--ps-border-color);
    align-self: stretch; align-items: center; justify-content: center;
  }
  .ps-bp-upload-zone:hover { border-color: var(--ps-accent); background: rgba(33,84,239,0.04); }
  .ps-bp-upload-placeholder {
    display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0.6vw;
    color: var(--ps-text-muted);
  }
  .ps-bp-upload-placeholder svg { width: 2.5vw; height: 2.5vw; stroke: var(--ps-accent); opacity: 0.7; }
  .ps-bp-upload-text { font-size: 0.85vw; font-weight: 600; color: var(--ps-text-secondary); }
  .ps-bp-upload-hint { font-size: 0.68vw; color: var(--ps-text-muted); }

  .ps-bp-image-remove {
    position: absolute; top: 0.5vw; right: 0.5vw;
    width: 1.6vw; height: 1.6vw; display: flex; align-items: center; justify-content: center;
    background: rgba(0,0,0,0.6); border: none; border-radius: 50%;
    color: var(--ps-text-primary); font-size: 1vw; cursor: pointer; line-height: 1;
    transition: background 0.15s; z-index: 2;
  }
  .ps-bp-image-remove:hover { background: rgba(0,0,0,0.8); }

  .ps-bp-photo-help-chip {
    position: absolute;
    top: clamp(8px, 0.65vw, 12px);
    left: clamp(8px, 0.65vw, 12px);
    z-index: 3;
    display: inline-flex;
    align-items: center;
    gap: clamp(5px, 0.35vw, 7px);
    max-width: calc(100% - clamp(58px, 4.2vw, 78px));
    padding: clamp(5px, 0.38vw, 7px) clamp(8px, 0.62vw, 12px);
    border: 1px solid rgba(33, 84, 239, 0.22);
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.92);
    color: var(--ps-accent);
    box-shadow: 0 8px 20px -16px rgba(17, 24, 39, 0.35);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    font-family: inherit;
    font-size: clamp(10px, 0.6vw, 12px);
    font-weight: 800;
    letter-spacing: 0.04em;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
  }
  .ps-bp-photo-help-chip.ps-active {
    background: var(--ps-accent);
    border-color: var(--ps-accent);
    color: #FFFFFF;
  }
  .ps-bp-photo-help-chip-mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: clamp(14px, 0.9vw, 16px);
    height: clamp(14px, 0.9vw, 16px);
    flex: 0 0 auto;
    border-radius: 999px;
    background: var(--ps-accent);
    color: #FFFFFF;
    font-size: clamp(10px, 0.58vw, 11px);
    font-weight: 900;
  }
  .ps-bp-photo-help-chip.ps-active .ps-bp-photo-help-chip-mark {
    background: #FFFFFF;
    color: var(--ps-accent);
  }

  .ps-bp-photo-details-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: clamp(10px, 0.8vw, 16px);
    padding: 0 0 clamp(5px, 0.35vw, 8px);
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-bp-photo-details-head h3 {
    margin: 0;
    color: var(--ps-text-primary);
    font-size: clamp(13px, 0.82vw, 16px);
    font-weight: 800;
    letter-spacing: 0.01em;
    line-height: 1.1;
  }
  .ps-bp-photo-details-head-simple {
    padding-bottom: clamp(8px, 0.55vw, 12px);
  }
  .ps-bp-photo-details-head-simple h3 {
    font-size: clamp(14px, 0.9vw, 17px);
  }
  .ps-bp-system-toggle-compact {
    margin: 0;
    gap: clamp(12px, 0.85vw, 18px);
    flex-shrink: 0;
  }
  .ps-bp-system-toggle-compact .ps-bp-system-btn {
    font-size: clamp(11px, 0.66vw, 13px);
    padding: 0 0 3px;
  }
  .ps-bp-system-toggle-large {
    gap: clamp(18px, 1.1vw, 24px);
  }
  .ps-bp-system-toggle-large .ps-bp-system-btn {
    font-size: clamp(13px, 0.78vw, 15px);
    padding-bottom: 4px;
  }

  .ps-bp-root {
    flex: 1; min-width: 0;
    display: flex; flex-direction: column; gap: 0.6vw; padding: 0.2vw 0.5vw 0.3vw 0;
    height: 100%; max-height: 100%; overflow: hidden;
    justify-content: center;
  }

  /* Step dots */
  .ps-bp-dots {
    display: flex; align-items: center; justify-content: center; gap: 0.4vw;
  }
  .ps-bp-dot {
    width: 0.42vw; height: 0.42vw; border-radius: 50%; background: var(--ps-border-color);
    transition: all 0.3s ease;
  }
  .ps-bp-dot-done { background: var(--ps-accent); }
  .ps-bp-dot-active {
    background: var(--ps-accent); width: 1.2vw; border-radius: 0.25vw;
  }

  /* Step container + animation — fade only, no layout shift */
  .ps-bp-step { display: flex; flex-direction: column; gap: 1vw; flex: 1; min-height: 0; margin-top: 3vw; }
  .ps-bp-step-enter { animation: ps-bp-fade 0.25s ease both; }
  @keyframes ps-bp-fade {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Active profile status above body details */
  .ps-bp-profile-hint {
    margin: 0; padding: 0;
    text-align: center;
    font-size: 11px; font-weight: 400;
    color: var(--ps-text-muted);
    letter-spacing: 0.01em;
    line-height: 1.4;
  }
  .ps-bp-profile-hint strong {
    color: var(--ps-text-secondary); font-weight: 600;
  }
  .ps-bp-profile-hint-link {
    background: none; border: none;
    color: var(--ps-text-muted);
    font-family: inherit; font-size: inherit; font-weight: 400;
    text-decoration: underline; text-underline-offset: 2px;
    cursor: pointer; padding: 0;
  }
  .ps-bp-profile-hint-link:hover { color: var(--ps-text-secondary); }
  .ps-bp-profile-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: clamp(10px, 0.74vw, 16px);
    width: min(100%, 500px);
    margin: 0 auto clamp(8px, 0.62vw, 13px);
    padding: clamp(8px, 0.62vw, 12px) clamp(12px, 0.9vw, 18px);
    border: 1px solid rgba(33, 84, 239, 0.18);
    border-radius: clamp(8px, 0.7vw, 12px);
    background: linear-gradient(135deg, rgba(33, 84, 239, 0.08), rgba(255, 255, 255, 0.96));
    box-shadow: 0 10px 28px -24px rgba(33, 84, 239, 0.55);
  }
  .ps-bp-profile-card-copy {
    display: flex;
    flex-direction: column;
    gap: clamp(1px, 0.12vw, 3px);
    min-width: 0;
  }
  .ps-bp-profile-card-eyebrow {
    font-size: clamp(9px, 0.58vw, 11px);
    font-weight: 800;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-bp-profile-card-copy strong {
    font-size: clamp(13px, 0.9vw, 16px);
    line-height: 1.1;
    color: var(--ps-text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ps-bp-profile-card-copy span:last-child {
    font-size: clamp(10px, 0.62vw, 12px);
    line-height: 1.25;
    color: var(--ps-text-secondary);
  }
  .ps-bp-profile-card-action {
    flex-shrink: 0;
    border: 1px solid rgba(33, 84, 239, 0.22);
    background: #FFFFFF;
    color: var(--ps-accent);
    border-radius: 999px;
    padding: clamp(7px, 0.5vw, 9px) clamp(10px, 0.76vw, 15px);
    font-family: inherit;
    font-size: clamp(10px, 0.66vw, 12px);
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s, transform 0.15s;
  }
  .ps-bp-profile-card-action:hover {
    border-color: var(--ps-accent);
    background: rgba(33, 84, 239, 0.06);
  }
  .ps-bp-profile-card-action:active { transform: scale(0.98); }
  .ps-bp-profile-card-compact {
    margin: 0 auto clamp(4px, 0.36vw, 7px);
    padding: clamp(5px, 0.4vw, 8px) clamp(10px, 0.72vw, 14px);
    border-radius: clamp(7px, 0.55vw, 10px);
    box-shadow: none;
  }
  .ps-bp-profile-card-compact .ps-bp-profile-card-copy {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: baseline;
    gap: 2px clamp(6px, 0.45vw, 9px);
  }
  .ps-bp-profile-card-compact .ps-bp-profile-card-eyebrow {
    grid-column: 1 / -1;
    font-size: clamp(8px, 0.5vw, 10px);
    letter-spacing: 0.16em;
    line-height: 1;
  }
  .ps-bp-profile-card-compact .ps-bp-profile-card-copy strong {
    font-size: clamp(12px, 0.78vw, 14px);
    line-height: 1.05;
  }
  .ps-bp-profile-card-compact .ps-bp-profile-card-copy span:last-child {
    font-size: clamp(9px, 0.54vw, 11px);
    line-height: 1.1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ps-bp-profile-card-compact .ps-bp-profile-card-action {
    padding: clamp(5px, 0.36vw, 7px) clamp(8px, 0.62vw, 12px);
    font-size: clamp(9px, 0.56vw, 11px);
  }

  /* Typography */
  .ps-bp-title {
    font-size: 1.25vw; font-weight: 700; color: var(--ps-text-primary);
    margin: 0; letter-spacing: -0.02em; text-align: center;
  }
  .ps-bp-subtitle {
    font-size: 0.78vw; color: var(--ps-text-secondary); margin: -0.4vw 0 0; text-align: center;
  }

  /* Unit system toggle (Imperial / Metric) */
  .ps-bp-system-toggle {
    display: flex; justify-content: center; gap: 1.5vw; margin: 0.3vw 0;
  }
  .ps-bp-system-btn {
    background: none; border: none; padding: 0.2vw 0;
    font-size: 0.78vw; font-weight: 500; color: var(--ps-text-muted);
    cursor: pointer; font-family: inherit;
    border-bottom: 2px solid transparent; transition: all 0.2s;
  }
  .ps-bp-system-btn:hover { color: var(--ps-text-secondary); }
  .ps-bp-system-active {
    color: var(--ps-text-primary); border-bottom-color: var(--ps-accent);
  }

  /* "Loaded from profile" pill — shows above the HEIGHT input when the
     active profile pre-populated the photo zone. Clear button next to it
     wipes the photo so the user can upload a new one. */
  .ps-bp-loaded-pill {
    display: inline-flex; align-items: center; gap: 0.5vw;
    align-self: center; margin: 0 auto 0.7vw;
    padding: 0.3vw 0.7vw; border-radius: 999px;
    background: rgba(33, 84, 239, 0.08); border: 1px solid rgba(33, 84, 239, 0.18);
    font-size: 0.7vw; color: var(--ps-text-secondary);
  }
  .ps-bp-loaded-pill-dot {
    color: var(--ps-accent); font-weight: 700; font-size: 0.75vw;
  }
  .ps-bp-loaded-pill-text { font-weight: 500; }
  .ps-bp-loaded-pill-clear {
    background: none; border: none; padding: 0 0 0 0.3vw;
    color: var(--ps-text-muted); font-size: 0.7vw; font-weight: 500;
    cursor: pointer; font-family: inherit; text-decoration: underline;
    text-underline-offset: 2px;
  }
  .ps-bp-loaded-pill-clear:hover { color: var(--ps-accent); }

  /* Inline field rows (WAIR style) */
  .ps-bp-inline-fields {
    display: flex; flex-direction: column; gap: 0; flex: 1;
    justify-content: center;
  }
  .ps-bp-inline-row {
    display: flex; align-items: center; gap: 1vw;
    padding: 1vw 0;
  }
  .ps-bp-inline-label {
    flex: 0 0 6.5vw; font-size: 0.68vw; font-weight: 700;
    color: var(--ps-text-muted); letter-spacing: 0.08em;
    text-transform: uppercase; white-space: nowrap;
  }
  .ps-bp-inline-input-group {
    flex: 1; display: flex; align-items: center; gap: 0.4vw;
  }
  .ps-bp-inline-input {
    flex: 1; min-width: 0; padding: 0;
    background: transparent; border: none; border-bottom: 1px solid var(--ps-border-color);
    color: var(--ps-text-primary); font-size: 1.1vw; font-weight: 500;
    font-family: inherit; outline: none;
    padding-bottom: 0.2vw; transition: border-color 0.2s;
  }
  .ps-bp-inline-input:focus { border-bottom-color: var(--ps-accent); }
  .ps-bp-inline-input::placeholder { color: var(--ps-text-muted); font-weight: 400; font-style: italic; opacity: 0.55; }
  .ps-bp-inline-input::-webkit-outer-spin-button,
  .ps-bp-inline-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  .ps-bp-inline-input[type="number"] { -moz-appearance: textfield; }
  .ps-bp-inline-unit {
    font-size: 0.73vw; color: var(--ps-text-muted); font-weight: 500;
    flex-shrink: 0;
  }

  /* Shoe reference flow — same upload screen, but the question panel asks
     for a familiar brand + size instead of manual foot measurements. */
  .ps-shoe-ref-desktop {
    display: flex;
    flex: 1;
    min-height: 0;
    align-items: center;
  }
  .ps-shoe-ref {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.85vw;
  }
  .ps-shoe-stage {
    display: flex;
    flex-direction: column;
    gap: 0.85vw;
    overflow: hidden;
    transition: opacity 0.24s ease, transform 0.24s ease, max-height 0.24s ease;
  }
  .ps-shoe-stage.ps-active {
    opacity: 1;
    transform: translateY(0);
    max-height: 42vw;
    pointer-events: auto;
  }
  .ps-shoe-stage.ps-hidden {
    opacity: 0;
    transform: translateY(0.5vw);
    max-height: 0;
    pointer-events: none;
  }
  .ps-shoe-ref-head,
  .ps-shoe-size-head {
    display: flex;
    flex-direction: column;
    gap: 0.25vw;
  }
  .ps-shoe-ref-kicker {
    font-size: 0.58vw;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-shoe-ref-title {
    margin: 0;
    font-size: 0.98vw;
    line-height: 1.2;
    font-weight: 750;
    color: var(--ps-text-primary);
    letter-spacing: -0.02em;
  }
  .ps-shoe-ref-copy {
    margin: 0;
    font-size: 0.66vw;
    line-height: 1.45;
    color: var(--ps-text-muted);
  }
  .ps-shoe-brand-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.48vw;
  }
  .ps-shoe-brand-card {
    min-height: 3.45vw;
    display: flex;
    align-items: center;
    gap: 0.55vw;
    padding: 0.55vw;
    background: #FFFFFF;
    border: 1px solid var(--ps-border-subtle);
    border-radius: 0.65vw;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
    transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease, background 0.16s ease;
  }
  .ps-shoe-brand-card:hover {
    border-color: rgba(33, 84, 239, 0.34);
    background: rgba(33, 84, 239, 0.035);
  }
  .ps-shoe-brand-card.ps-selected {
    border-color: var(--ps-accent);
    background: rgba(33, 84, 239, 0.08);
    box-shadow: 0 10px 22px -16px rgba(33, 84, 239, 0.42);
  }
  .ps-shoe-brand-logo {
    width: 2.25vw;
    height: 2.25vw;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 0.52vw;
    background: #FFFFFF;
    border: 1px solid rgba(17,24,39,0.10);
    padding: 0.34vw;
  }
  .ps-shoe-brand-card.ps-selected .ps-shoe-brand-logo {
    border-color: rgba(33,84,239,0.28);
  }
  .ps-shoe-brand-logo-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  .ps-shoe-brand-name {
    font-size: 0.72vw;
    font-weight: 700;
    color: var(--ps-text-primary);
  }
  .ps-shoe-size-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.8vw;
  }
  .ps-shoe-size-controls {
    display: inline-flex;
    align-items: center;
    gap: 0.55vw;
    margin-left: auto;
  }
  .ps-shoe-back-brand {
    display: inline-flex;
    align-items: center;
    gap: 0.35vw;
    padding: 0;
    background: transparent;
    border: 0;
    color: var(--ps-text-secondary);
    font-family: inherit;
    font-size: 0.64vw;
    font-weight: 750;
    cursor: pointer;
  }
  .ps-shoe-back-brand:hover {
    color: var(--ps-accent);
  }
  .ps-shoe-country-select {
    display: inline-flex;
    align-items: center;
    gap: 0.45vw;
    color: var(--ps-text-muted);
    font-size: 0.55vw;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .ps-shoe-country-select select {
    min-width: 5vw;
    padding: 0.42vw 0.6vw;
    border: 1px solid var(--ps-border-subtle);
    border-radius: 999px;
    background: #FFFFFF;
    color: var(--ps-text-primary);
    font-family: inherit;
    font-size: 0.64vw;
    font-weight: 750;
    outline: none;
    cursor: pointer;
  }
  .ps-shoe-country-select select:focus {
    border-color: var(--ps-accent);
    box-shadow: 0 0 0 3px rgba(33,84,239,0.10);
  }
  .ps-shoe-unit-toggle {
    display: inline-flex;
    align-items: center;
    padding: 0.12vw;
    border: 1px solid var(--ps-border-subtle);
    border-radius: 999px;
    background: #FFFFFF;
  }
  .ps-shoe-unit-toggle button {
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: var(--ps-text-muted);
    cursor: pointer;
    font-family: inherit;
    font-size: 0.62vw;
    font-weight: 800;
    line-height: 1;
    min-width: 1.7vw;
    padding: 0.35vw 0.48vw;
    text-transform: uppercase;
  }
  .ps-shoe-unit-toggle button.ps-active {
    background: var(--ps-accent);
    color: #FFFFFF;
    box-shadow: 0 6px 14px rgba(33,84,239,0.18);
  }
  .ps-shoe-selected-brand {
    display: flex;
    align-items: center;
    gap: 0.55vw;
    padding: 0.55vw 0.65vw;
    border-radius: 0.72vw;
    border: 1px solid rgba(33,84,239,0.14);
    background: rgba(33,84,239,0.055);
  }
  .ps-shoe-selected-brand > span:not(.ps-shoe-selected-logo) {
    min-width: 0;
    flex: 1 1 auto;
  }
  .ps-shoe-change-brand {
    display: none;
    flex-shrink: 0;
    padding: 0.35vw 0.7vw;
    border-radius: 999px;
    border: 1px solid rgba(33,84,239,0.22);
    background: #FFFFFF;
    color: var(--ps-accent);
    font-family: inherit;
    font-size: 0.58vw;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
  }
  .ps-shoe-selected-logo {
    width: 2.1vw;
    height: 2.1vw;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 0.5vw;
    background: #FFFFFF;
    border: 1px solid rgba(33,84,239,0.18);
    padding: 0.32vw;
  }
  .ps-shoe-selected-brand small {
    display: block;
    font-size: 0.52vw;
    font-weight: 800;
    letter-spacing: 0.13em;
    text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-shoe-selected-brand strong {
    display: block;
    margin-top: 0.08vw;
    font-size: 0.75vw;
    color: var(--ps-text-primary);
  }
  .ps-shoe-size-panel {
    display: flex;
    flex-direction: column;
    gap: 0.55vw;
    padding: 0.7vw;
    border-radius: 0.75vw;
    border: 1px solid var(--ps-border-subtle);
    background: var(--ps-bg-secondary, #F8FAFC);
    opacity: 0.72;
  }
  .ps-shoe-size-panel.ps-enabled {
    opacity: 1;
  }
  .ps-shoe-size-grid {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 0.35vw;
  }
  .ps-shoe-size-chip {
    min-height: 1.85vw;
    border: 1px solid var(--ps-border-subtle);
    border-radius: 999px;
    background: #FFFFFF;
    color: var(--ps-text-secondary);
    font-family: inherit;
    font-size: 0.62vw;
    font-weight: 750;
    cursor: pointer;
    transition: border-color 0.16s ease, background 0.16s ease, color 0.16s ease;
  }
  .ps-shoe-size-chip:hover:not(:disabled) {
    border-color: var(--ps-accent);
    color: var(--ps-accent);
  }
  .ps-shoe-size-chip:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  .ps-shoe-size-chip.ps-selected {
    border-color: var(--ps-accent);
    background: rgba(33, 84, 239, 0.12);
    color: var(--ps-accent);
    -webkit-text-fill-color: var(--ps-accent);
    box-shadow: inset 0 0 0 1px rgba(33,84,239,0.18);
  }
  .ps-shoe-ref-summary {
    display: flex;
    flex-direction: column;
    gap: 0.18vw;
    padding: 0.65vw 0.75vw;
    border-radius: 0.72vw;
    background: rgba(33, 84, 239, 0.08);
    border: 1px solid rgba(33, 84, 239, 0.16);
  }
  .ps-shoe-ref-summary span {
    font-size: 0.55vw;
    font-weight: 800;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-shoe-ref-summary strong {
    font-size: 0.78vw;
    color: var(--ps-text-primary);
  }
  .ps-shoe-ref-summary small {
    font-size: 0.62vw;
    color: var(--ps-text-muted);
  }

  /* Photo CTA link */
  .ps-bp-photo-cta {
    display: flex; align-items: center; gap: 0.5vw;
    background: none; border: none; padding: 0.6vw 0;
    color: var(--ps-accent); font-size: 0.78vw; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: all 0.2s;
    margin-top: 0.3vw;
  }
  .ps-bp-photo-cta:hover:not(:disabled) { color: var(--ps-accent-hover); }
  .ps-bp-photo-cta:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
  .ps-bp-photo-cta svg { width: 1vw; height: 1vw; stroke: currentColor; flex-shrink: 0; }
  .ps-bp-photo-cta-arrow { font-size: 0.9vw; transition: transform 0.2s; }
  .ps-bp-photo-cta:hover:not(:disabled) .ps-bp-photo-cta-arrow { transform: translateX(3px); }
  .ps-bp-photo-cta-hint {
    display: block; text-align: center;
    font-size: 0.6vw; color: var(--ps-text-muted);
    font-style: italic; margin-top: 0.25vw;
  }
  .ps-bp-photo-cta-done { color: var(--ps-success-color); }
  .ps-bp-photo-cta-done:hover { color: var(--ps-text-muted); }

  /* ════════════════════════════════════════════════════════════════
     Mobile basics step (BasicsStepMobile.tsx) — matches the reference
     design: product image at top, big editable numbers, RECOMMENDED
     upload card. NOT a slider — the values are real number inputs
     styled to look like big plain text, so the OS keyboard pops the
     digit pad on iOS/Android.
     These styles are scoped to .ps-bpm-* so they don't conflict with
     the existing desktop .ps-bp-* layout.
     ════════════════════════════════════════════════════════════════ */
  .ps-bpm-root {
    display: flex; flex-direction: column;
    gap: max(10px, 2.6vw); padding: max(8px, 2.1vw) max(4px, 1.0vw) 0;
    flex: 1; min-height: 0;
  }
  .ps-bpm-spacer { flex: 1 1 auto; min-height: max(8px, 2.1vw); }
  .ps-bpm-header { text-align: center; margin: max(4px, 1.0vw) 0 0; }
  .ps-bpm-title {
    font-size: max(18px, 4.6vw); font-weight: 700; color: var(--ps-text-primary);
    margin: 0 0 max(4px, 1.0vw); line-height: 1.3;
  }
  .ps-bpm-subtitle {
    font-size: max(12px, 3.1vw); color: var(--ps-text-muted);
    margin: 0 auto; max-width: max(260px, 66.7vw); line-height: 1.45; font-weight: 400;
  }

  /* Metric / Imperial pill toggle */
  .ps-bpm-toggle {
    display: flex; justify-content: center; gap: max(24px, 6.2vw);
    margin: 2px 0 max(4px, 1.0vw);
  }
  .ps-bpm-toggle-btn {
    background: none; border: none; padding: max(6px, 1.5vw) max(4px, 1.0vw);
    font-family: inherit; font-size: max(12px, 3.1vw); font-weight: 600;
    letter-spacing: 0.06em;
    color: var(--ps-text-muted); cursor: pointer;
    border-bottom: 1.5px solid transparent;
    transition: all 0.2s;
  }
  .ps-bpm-toggle-btn.ps-active {
    color: var(--ps-accent);
    border-bottom-color: var(--ps-accent);
  }

  /* Slider rows — label top-left, value top-right, then [-] [track] [+] */
  .ps-bpm-fields {
    display: flex; flex-direction: column;
    margin-top: max(4px, 1.0vw);
  }
  .ps-bpm-row {
    display: flex; flex-direction: column;
    padding: max(14px, 3.6vw) max(4px, 1.0vw);
    gap: max(12px, 3.1vw);
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-bpm-row:last-child { border-bottom: none; }
  .ps-bpm-row-top {
    display: flex; align-items: center; justify-content: space-between;
  }
  .ps-bpm-label {
    font-size: max(11px, 2.8vw); font-weight: 600;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-bpm-value-display {
    font-size: max(14px, 3.6vw); font-weight: 700;
    color: var(--ps-text-primary);
    font-feature-settings: "tnum" 1;
  }

  /* Slider row container: [-] [track] [+] */
  .ps-bpm-slider-row {
    display: flex; align-items: center; gap: max(12px, 3.1vw);
  }
  .ps-bpm-step-btn {
    flex-shrink: 0;
    width: max(34px, 8.7vw); height: max(34px, 8.7vw); border-radius: 50%;
    background: var(--ps-bg-tertiary); border: none;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    color: var(--ps-text-secondary);
    transition: background 0.15s, transform 0.1s;
  }
  .ps-bpm-step-btn:hover { background: var(--ps-border-color); }
  .ps-bpm-step-btn:active { transform: scale(0.92); }

  /* The slider — thicker track, dark navy thumb, monochrome */
  .ps-bpm-slider {
    -webkit-appearance: none; appearance: none;
    flex: 1; min-width: 0;
    height: max(4px, 1.0vw); outline: none;
    background: linear-gradient(
      to right,
      var(--ps-text-primary) 0%,
      var(--ps-text-primary) var(--ps-pct, 0%),
      var(--ps-border-color) var(--ps-pct, 0%),
      var(--ps-border-color) 100%
    );
    border-radius: max(999px, 256.2vw); cursor: pointer;
    margin: 0;
  }
  .ps-bpm-slider::-webkit-slider-thumb {
    -webkit-appearance: none; appearance: none;
    width: max(18px, 4.6vw); height: max(18px, 4.6vw); border-radius: 50%;
    background: var(--ps-text-primary); border: none;
    cursor: grab; transition: transform 0.15s ease;
    box-shadow: 0 1px 3px rgba(0,0,0,0.18);
  }
  .ps-bpm-slider::-webkit-slider-thumb:active { cursor: grabbing; transform: scale(1.1); }
  .ps-bpm-slider::-moz-range-thumb {
    width: max(18px, 4.6vw); height: max(18px, 4.6vw); border-radius: 50%;
    background: var(--ps-text-primary); border: none; cursor: grab;
    box-shadow: 0 1px 3px rgba(0,0,0,0.18);
  }
  .ps-bpm-slider::-moz-range-track { background: transparent; height: max(4px, 1.0vw); }

  /* "or" divider — flanked by hairlines */
  .ps-bpm-or {
    display: flex; align-items: center; gap: max(12px, 3.1vw);
    margin: max(14px, 3.6vw) max(4px, 1.0vw) max(4px, 1.0vw);
  }
  .ps-bpm-or::before, .ps-bpm-or::after {
    content: ""; flex: 1; height: 1px;
    background: var(--ps-border-subtle);
  }
  .ps-bpm-or span {
    font-size: max(10px, 2.6vw); font-weight: 600;
    text-transform: uppercase; letter-spacing: 0.16em;
    color: var(--ps-text-muted);
  }

  /* Minimal upload link — no card, no background, just text + icons */
  .ps-bpm-upload-link {
    display: flex; align-items: center; justify-content: center; gap: max(10px, 2.6vw);
    background: none; border: none;
    padding: max(8px, 2.1vw) max(4px, 1.0vw); margin: 0;
    cursor: pointer; font-family: inherit;
    color: var(--ps-text-primary); font-size: max(13px, 3.3vw); font-weight: 500;
    width: 100%;
    transition: opacity 0.15s;
  }
  .ps-bpm-upload-link:hover:not(:disabled) { opacity: 0.7; }
  .ps-bpm-upload-link:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
  .ps-bpm-upload-link svg { color: var(--ps-text-secondary); flex-shrink: 0; }
  /* Subtle helper text shown below the disabled upload link. */
  .ps-bpm-upload-link-hint {
    display: block; text-align: center;
    margin-top: max(2px, 0.5vw);
    font-size: max(10px, 2.6vw); color: var(--ps-text-muted);
    font-style: italic;
  }

  .ps-bpm-error {
    font-size: max(11px, 2.8vw); color: var(--ps-error-color);
    text-align: center; margin: max(4px, 1.0vw) 0 0;
  }

  /* ════════════════════════════════════════════════════════════════
     PhotoStepMobile (.ps-pm-*) — AI scan / photo upload step.
     Title + subtitle, large photo preview, "Checklist for accuracy"
     card, dark primary CTA, outlined RETAKE secondary, bottom tabs.
     ════════════════════════════════════════════════════════════════ */
  .ps-pm-root {
    display: flex; flex-direction: column;
    gap: max(14px, 3.6vw); padding: max(8px, 2.1vw) max(4px, 1.0vw) 0;
    flex: 1; min-height: 0;
  }
  .ps-pm-header { margin: max(4px, 1.0vw) 0 0; }
  .ps-pm-title {
    font-size: max(22px, 5.6vw); font-weight: 700; color: var(--ps-text-primary);
    margin: 0 0 max(6px, 1.5vw); line-height: 1.25;
  }
  .ps-pm-subtitle {
    font-size: max(13px, 3.3vw); color: var(--ps-text-muted);
    margin: 0; line-height: 1.45; font-weight: 400;
  }

  /* Photo preview / upload zone */
  .ps-pm-preview {
    background: var(--ps-bg-tertiary);
    border-radius: max(10px, 2.6vw);
    height: max(280px, 71.8vw);
    overflow: hidden;
    display: flex; align-items: center; justify-content: center;
    position: relative;
    flex-shrink: 0;
  }
  .ps-pm-preview-img {
    max-width: 100%; max-height: 100%;
    width: auto; height: 100%;
    object-fit: contain; display: block;
  }
  .ps-pm-preview-empty {
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: max(6px, 1.5vw); padding: max(24px, 6.2vw);
    background: none; border: none;
    color: var(--ps-text-muted); cursor: pointer;
    font-family: inherit; width: 100%; height: 100%;
  }
  .ps-pm-preview-empty svg { color: var(--ps-text-muted); }
  .ps-pm-preview-empty-title {
    font-size: max(14px, 3.6vw); font-weight: 600; color: var(--ps-text-secondary);
    margin-top: max(4px, 1.0vw);
  }
  .ps-pm-preview-empty-hint {
    font-size: max(11px, 2.8vw); color: var(--ps-text-muted);
  }
  .ps-pm-preview-empty-format {
    font-size: max(10px, 2.55vw); color: var(--ps-text-dim);
  }
  .ps-pm-preview-compact-gate {
    flex-direction: column;
    gap: max(12px, 3.1vw);
    padding: max(18px, 4.6vw);
  }
  .ps-pm-preview-compact-gate .ps-pm-preview-empty {
    width: auto;
    height: auto;
    min-width: 0;
    flex: 0 0 auto;
    padding: 0;
  }
  .ps-pm-preview-empty-static {
    cursor: default;
    pointer-events: none;
  }
  .ps-pm-age-inline {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: max(8px, 2.1vw);
    padding: max(10px, 2.6vw) max(12px, 3.1vw);
    background: #FFFFFF;
    border: 1px solid var(--ps-border-color);
    border-radius: max(12px, 3.1vw);
    box-shadow: 0 10px 28px -14px rgba(17, 24, 39, 0.28);
    position: relative;
    z-index: 2;
  }
  .ps-pm-age-inline-q {
    font-size: max(13px, 3.3vw);
    font-weight: 650;
    color: var(--ps-text-primary);
    line-height: 1.2;
  }
  .ps-pm-age-inline-actions {
    display: flex;
    align-items: center;
    gap: max(8px, 2.1vw);
  }
  .ps-pm-age-inline-btn {
    min-height: max(32px, 8.2vw);
    padding: 0 max(14px, 3.6vw);
    border-radius: 999px;
    border: 1px solid var(--ps-border-color);
    font-family: inherit;
    font-size: max(12px, 3.1vw);
    font-weight: 700;
    cursor: pointer;
  }
  .ps-pm-age-inline-yes {
    background: var(--ps-accent);
    border-color: var(--ps-accent);
    color: #FFFFFF;
  }
  .ps-pm-age-inline-no {
    background: #FFFFFF;
    color: var(--ps-text-secondary);
  }
  .ps-pm-age-inline-error {
    border-color: rgba(220, 38, 38, 0.32);
  }
  .ps-pm-preview-remove {
    position: absolute; top: max(10px, 2.6vw); right: max(10px, 2.6vw);
    width: max(28px, 7.2vw); height: max(28px, 7.2vw); border-radius: max(6px, 1.5vw);
    background: rgba(255,255,255,0.9); border: none;
    color: var(--ps-text-primary); cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 1px 4px rgba(0,0,0,0.15);
    transition: background 0.15s;
  }
  .ps-pm-preview-remove:hover { background: #FFFFFF; }

  /* ── Mobile age-gate overlay ── */
  .ps-pm-preview-blurred {
    filter: blur(6px) saturate(0.7);
    pointer-events: none;
    user-select: none;
  }
  .ps-pm-age-gate {
    position: absolute; inset: 0;
    display: flex; align-items: center; justify-content: center;
    padding: max(16px, 4vw);
    background: rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 2;
    animation: ps-pm-age-gate-in 0.28s ease-out both;
  }
  @keyframes ps-pm-age-gate-in {
    0%   { opacity: 0; transform: scale(0.97); }
    100% { opacity: 1; transform: scale(1); }
  }
  .ps-pm-age-gate-card {
    width: 100%; max-width: max(280px, 82vw);
    padding: max(18px, 4.6vw) max(16px, 4.2vw);
    background: #FFFFFF;
    border: 1px solid var(--ps-border-subtle);
    border-radius: max(12px, 3vw);
    box-shadow: 0 20px 40px -12px rgba(17, 24, 39, 0.25),
                0 8px 16px -8px rgba(17, 24, 39, 0.15);
    display: flex; flex-direction: column;
    align-items: center; text-align: center;
    gap: max(8px, 2vw);
  }
  .ps-pm-age-gate-eyebrow {
    font-size: max(10px, 2.6vw); font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-pm-age-gate-eyebrow-blocked { color: #C02626; }
  .ps-pm-age-gate-question {
    font-size: max(14px, 3.8vw); font-weight: 600;
    line-height: 1.35; color: var(--ps-text-primary); margin: 0;
  }
  .ps-pm-age-gate-actions {
    display: flex; flex-direction: column; gap: max(8px, 2vw);
    width: 100%; margin-top: max(4px, 1vw);
  }
  .ps-pm-age-gate-btn {
    width: 100%;
    padding: max(11px, 2.9vw) max(14px, 3.6vw);
    border-radius: 999px;
    font-family: inherit;
    font-size: max(12px, 3.2vw); font-weight: 700;
    letter-spacing: 0.02em;
    cursor: pointer;
    transition: background 0.18s, border-color 0.18s, color 0.18s;
  }
  .ps-pm-age-gate-btn-primary {
    background: var(--ps-accent);
    color: #FFFFFF;
    border: 1.5px solid var(--ps-accent);
  }
  .ps-pm-age-gate-btn-secondary {
    background: transparent;
    color: var(--ps-text-primary);
    border: 1.5px solid var(--ps-border-color);
  }
  .ps-pm-age-gate-btn-secondary:active {
    background: var(--ps-bg-secondary);
  }

  /* ── Mobile legal notice ── */
  .ps-pm-legal-notice {
    margin-top: max(10px, 2.6vw);
    background: rgba(33, 84, 239, 0.04);
    border: 1px solid rgba(33, 84, 239, 0.16);
    border-radius: max(10px, 2.6vw);
    padding: max(10px, 2.6vw) max(12px, 3.1vw);
    display: flex; flex-direction: column;
    gap: max(4px, 1vw);
  }
  .ps-pm-legal-notice-head {
    display: flex; align-items: center;
    gap: max(6px, 1.5vw);
    font-size: max(10px, 2.6vw); font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-pm-legal-notice-head svg { width: max(13px, 3.4vw); height: max(13px, 3.4vw); }
  .ps-pm-legal-notice-body {
    margin: 0;
    font-size: max(11px, 2.9vw);
    line-height: 1.5;
    color: var(--ps-text-secondary);
  }

  /* Checklist for accuracy card */
  .ps-pm-checklist {
    display: flex; gap: max(12px, 3.1vw);
    padding: max(12px, 3.1vw) max(14px, 3.6vw);
    background: var(--ps-bg-secondary);
    border-radius: max(10px, 2.6vw);
    border: 1px solid var(--ps-border-subtle);
  }
  .ps-pm-checklist-icon {
    flex-shrink: 0;
    width: max(22px, 5.6vw); height: max(22px, 5.6vw);
    color: var(--ps-text-primary);
    display: flex; align-items: center; justify-content: center;
    margin-top: 1px;
  }
  .ps-pm-checklist-body { flex: 1; min-width: 0; }
  .ps-pm-checklist-title {
    font-size: max(12px, 3.1vw); font-weight: 700;
    color: var(--ps-text-primary);
    margin-bottom: max(5px, 1.3vw);
  }
  .ps-pm-checklist-items {
    list-style: none; padding: 0; margin: 0;
  }
  .ps-pm-checklist-items li {
    font-size: max(11px, 2.8vw); color: var(--ps-text-secondary);
    padding: 1px 0 1px max(12px, 3.1vw);
    position: relative; line-height: 1.5;
  }
  .ps-pm-checklist-items li::before {
    content: "•"; position: absolute; left: 2px;
    color: var(--ps-text-muted);
  }

  /* ── Do / Don't grid (full-body photo step) ──
     Colour scheme mirrors the desktop guidelines in BodyProfileView so
     users see the same visual pattern on both form factors. Stacks to a
     single column on very narrow screens so the five-bullet lists stay
     readable. */
  .ps-pm-dodonts-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: max(8px, 2.1vw);
  }
  @media (max-width: 380px) {
    .ps-pm-dodonts-grid { grid-template-columns: 1fr; }
  }
  .ps-pm-do-card,
  .ps-pm-dont-card {
    border-radius: max(10px, 2.6vw);
    padding: max(10px, 2.6vw) max(12px, 3.1vw);
    min-width: 0;
  }
  .ps-pm-do-card { background: #ddfbe7; }
  .ps-pm-dont-card { background: #ffe2e2; }
  .ps-pm-do-card-head,
  .ps-pm-dont-card-head {
    display: flex; align-items: center; gap: max(6px, 1.5vw);
    font-size: max(11px, 2.8vw); font-weight: 700;
    letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: max(6px, 1.5vw);
  }
  .ps-pm-do-card-head { color: #1c9d4c; }
  .ps-pm-dont-card-head { color: #e7000b; }
  .ps-pm-do-card-list,
  .ps-pm-dont-card-list {
    list-style: none; padding: 0; margin: 0;
  }
  .ps-pm-do-card-list li,
  .ps-pm-dont-card-list li {
    position: relative;
    padding-left: max(12px, 3.1vw);
    font-size: max(11px, 2.8vw);
    line-height: 1.5;
    color: #1a1a1a;
  }
  .ps-pm-do-card-list li + li,
  .ps-pm-dont-card-list li + li {
    margin-top: max(3px, 0.8vw);
  }
  .ps-pm-do-card-list li::before {
    content: "✓"; position: absolute; left: 0; top: 0;
    color: #1c9d4c; font-weight: 700;
  }
  .ps-pm-dont-card-list li::before {
    content: "✗"; position: absolute; left: 0; top: 0;
    color: #e7000b; font-weight: 700;
  }

  /* Quick-Tip row below the Do/Don't cards. Surfaces the
     "simpler = more accurate" reminder that also lives on desktop. */
  .ps-pm-dodonts-tip {
    display: flex; align-items: flex-start; gap: max(8px, 2.1vw);
    padding: max(10px, 2.6vw) max(12px, 3.1vw);
    background: #c6e1f7;
    border-radius: max(10px, 2.6vw);
    font-size: max(11px, 2.8vw); line-height: 1.5;
    color: #1a1a1a;
  }
  .ps-pm-dodonts-tip-emoji { flex-shrink: 0; font-size: max(14px, 3.6vw); line-height: 1; }

  /* Compact height input row in the mobile photo step */
  .ps-pm-height-row {
    display: flex; align-items: center; gap: max(8px, 2.1vw);
    padding: 0 max(4px, 1.0vw);
  }
  .ps-pm-height-label {
    font-size: max(12px, 3.1vw); font-weight: 600; color: var(--ps-text-secondary);
    flex-shrink: 0;
  }
  .ps-pm-height-input {
    width: max(70px, 18vw); padding: max(7px, 1.8vw) max(10px, 2.6vw);
    font-size: max(13px, 3.3vw); border-radius: max(6px, 1.5vw);
    border: 1px solid var(--ps-border-color); background: var(--ps-bg-secondary);
    color: var(--ps-text-primary); font-family: inherit;
  }
  .ps-pm-height-unit {
    font-size: max(11px, 2.8vw); color: var(--ps-text-muted); flex-shrink: 0;
  }

  /* Primary CTA: ANALYZE MY SIZE — uses the user's brand accent */
  .ps-pm-primary-btn {
    margin: 0 max(16px, 4.1vw); width: calc(100% - max(32px, 8.2vw));
    background: var(--ps-accent); color: #FFFFFF;
    border: none; border-radius: max(8px, 2.1vw);
    padding: max(16px, 4.1vw) max(18px, 4.6vw);
    font-family: inherit; font-size: max(13px, 3.3vw); font-weight: 700;
    letter-spacing: 0.1em; text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.15s, transform 0.15s;
  }
  .ps-pm-primary-btn:active { transform: scale(0.98); }
  .ps-pm-primary-btn:disabled { opacity: 0.4; cursor: not-allowed; }

  /* Outlined secondary: RETAKE PHOTO */
  .ps-pm-secondary-btn {
    margin: max(8px, 2.1vw) max(16px, 4.1vw) max(12px, 3.1vw); width: calc(100% - max(32px, 8.2vw));
    background: transparent; color: var(--ps-text-secondary);
    border: 1px solid var(--ps-border-color); border-radius: 8px;
    padding: max(13px, 3.3vw) max(18px, 4.6vw);
    font-family: inherit; font-size: max(11px, 2.8vw); font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    cursor: pointer;
    transition: background 0.15s;
  }
  .ps-pm-secondary-btn:hover { background: var(--ps-bg-secondary); }

  /* When the bottom action area contains the primary button (photo step),
     it needs different padding than the basics step (which has the next btn
     baked in via .ps-bpm-next-btn). Both share .ps-bpm-bottom container. */
  .ps-bpm-bottom .ps-pm-primary-btn { margin: max(14px, 3.6vw) max(16px, 4.1vw) 0; }

  /* ════════════════════════════════════════════════════════════════
     MobileScanningView (.ps-msc-*) — AI scan processing screen.
     Dark photo viewfinder with corner brackets, scanning line, pose
     skeleton overlay, cycling stage text below with slide-fade.
     ════════════════════════════════════════════════════════════════ */
  .ps-msc-root {
    display: flex; flex-direction: column;
    gap: 18px; padding: 8px 4px 0;
    flex: 1; min-height: 0;
  }

  /* Photo container — transparent, no scanner, no chrome */
  .ps-msc-viewfinder {
    position: relative; flex-shrink: 0;
    background: transparent; border-radius: 12px; overflow: hidden;
    height: 64vh; max-height: 540px; min-height: 360px;
    display: flex; align-items: center; justify-content: center;
  }
  .ps-msc-photo {
    max-width: 100%; max-height: 100%;
    width: auto; height: 100%;
    object-fit: contain; display: block;
  }

  /* Live feed badge top-left */
  .ps-msc-feed-badge {
    position: absolute; top: 12px; left: 14px; z-index: 4;
    display: flex; align-items: center; gap: 6px;
    color: rgba(255,255,255,0.85);
    font-size: 10px; font-weight: 600;
    letter-spacing: 0.12em;
    font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  }
  .ps-msc-feed-dot {
    width: 7px; height: 7px; border-radius: 50%;
    background: #ef4444;
    box-shadow: 0 0 0 0 rgba(239,68,68,0.6);
    animation: ps-msc-rec 1.4s ease-in-out infinite;
  }
  @keyframes ps-msc-rec {
    0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(239,68,68,0.6); }
    50%      { opacity: 0.6; box-shadow: 0 0 0 5px rgba(239,68,68,0); }
  }

  /* Corner brackets — four absolutely positioned L-shapes */
  .ps-msc-corners {
    position: absolute; inset: 28px;
    pointer-events: none; z-index: 3;
  }
  .ps-msc-corner {
    position: absolute;
    width: 22px; height: 22px;
    border: 1.5px solid rgba(255,255,255,0.7);
  }
  .ps-msc-corner.ps-tl { top: 0; left: 0; border-right: none; border-bottom: none; }
  .ps-msc-corner.ps-tr { top: 0; right: 0; border-left: none; border-bottom: none; }
  .ps-msc-corner.ps-bl { bottom: 0; left: 0; border-right: none; border-top: none; }
  .ps-msc-corner.ps-br { bottom: 0; right: 0; border-left: none; border-top: none; }

  /* Scanning line that sweeps top-to-bottom — GPU-accelerated.
     Animating the top property caused first-paint stutter; switched
     to translate3d so the browser composites on its own layer
     without re-laying out the viewfinder on every frame. */
  .ps-msc-scanline {
    position: absolute; left: 28px; right: 28px;
    top: 28px; height: 1.5px; z-index: 3;
    background: linear-gradient(
      to right,
      transparent,
      rgba(180,220,255,0.9),
      rgba(180,220,255,0.9),
      transparent
    );
    will-change: transform, opacity;
    transform: translate3d(0, 0, 0);
    animation: ps-msc-scan 2.8s ease-in-out 0.4s infinite;
  }
  @keyframes ps-msc-scan {
    0%   { transform: translate3d(0, 0, 0);                       opacity: 0; }
    8%   { opacity: 1; }
    92%  { opacity: 1; }
    100% { transform: translate3d(0, min(calc(64vh - 60px), 480px), 0); opacity: 0; }
  }

  /* Pose skeleton overlay — sits over the photo */
  .ps-msc-pose-wrap {
    position: absolute; inset: 0; z-index: 2;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .ps-msc-pose-overlay {
    width: 100%; height: 100%;
  }
  @keyframes ps-msc-fade {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Bottom of viewfinder: stage label + progress bar + sub */
  .ps-msc-vf-bottom {
    position: absolute; left: 28px; right: 28px; bottom: 28px;
    z-index: 4; text-align: center;
    color: #FFFFFF;
  }
  .ps-msc-vf-text {
    font-size: 10px; font-weight: 700;
    letter-spacing: 0.16em;
    color: rgba(255,255,255,0.9);
    margin-bottom: 6px;
    font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  }
  .ps-msc-vf-bar {
    height: 2px; width: 100%;
    background: rgba(255,255,255,0.18);
    border-radius: 2px; overflow: hidden;
  }
  .ps-msc-vf-bar-fill {
    height: 100%; width: 30%;
    background: linear-gradient(to right, rgba(180,220,255,0.6), rgba(255,255,255,0.95));
    border-radius: 2px;
    animation: ps-msc-bar 2.2s ease-in-out infinite;
  }
  @keyframes ps-msc-bar {
    0%   { transform: translateX(-100%); }
    50%  { transform: translateX(150%); }
    100% { transform: translateX(350%); }
  }
  .ps-msc-vf-sub {
    margin-top: 8px;
    font-size: 9px; font-weight: 600;
    letter-spacing: 0.18em;
    color: rgba(255,255,255,0.55);
    font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
  }

  /* Cycling stage text below the viewfinder — slides + fades on change */
  .ps-msc-stage {
    text-align: center; padding: 4px 12px;
    min-height: 64px;
    /* Lock width so the cycling stage text (shorter/longer strings every
       ~2s) doesn't reflow the sibling TryOnProgress bar. align-self:
       center centers the 320px container inside the flex column — without
       it the container sat at the left edge of the screen on mobile. */
    width: 320px;
    max-width: 100%;
    align-self: center;
    overflow: hidden;
  }
  .ps-msc-stage-slot {
    animation: ps-msc-stage-in 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }
  @keyframes ps-msc-stage-in {
    0%   { opacity: 0; }
    100% { opacity: 1; }
  }
  .ps-msc-stage-title {
    font-size: 16px; font-weight: 700;
    letter-spacing: 0.06em;
    color: var(--ps-text-primary);
    margin-bottom: 6px;
  }
  .ps-msc-stage-desc {
    font-size: 12px; color: var(--ps-text-muted);
    line-height: 1.5; max-width: 300px; margin: 0 auto;
  }

  /* ════════════════════════════════════════════════════════════════
     MultiSectionMobile (.ps-msr-*) — mobile multi-section results
     screen. Eyebrow + product hero + match badge + section list + CTA.
     ════════════════════════════════════════════════════════════════ */
  /* Layout: header (modal-level) → flex column root → scroll content
     (flex: 1, overflow-y: auto) → fixed bottom bar (flex-shrink: 0).
     This is more reliable than position: sticky inside an
     overflow:auto flex column, which was floating mid-screen. */
  .ps-msr-root {
    display: flex; flex-direction: column;
    height: 100%; min-height: 0;
    margin: 0 -16px;
  }
  .ps-msr-scroll {
    flex: 1; min-height: 0;
    overflow-y: auto; -webkit-overflow-scrolling: touch;
    display: flex; flex-direction: column;
    gap: 14px; padding: 8px 16px 24px;
  }
  .ps-msr-eyebrow {
    font-size: 10px; font-weight: 600;
    letter-spacing: 0.16em; text-transform: uppercase;
    color: var(--ps-text-muted);
    text-align: center; margin: 4px 0 -4px;
  }

  /* Product hero — big centered image + title */
  .ps-msr-product {
    display: flex; flex-direction: column; align-items: center;
    gap: 14px;
  }
  @media (max-width: 768px) {
    .ps-tryon-feedback-toggle {
      min-height: 34px;
      padding: 0 12px;
      border-radius: 10px;
      gap: 6px;
      font-size: 11px;
    }
    .ps-tryon-feedback-toggle svg {
      width: 15px;
      height: 15px;
    }
    .ps-tryon-feedback {
      width: min(202px, calc(100vw - 48px));
      padding: 8px;
      border-radius: 12px;
      gap: 6px;
    }
    .ps-tryon-feedback-title { font-size: 11px; }
    .ps-tryon-feedback-star { width: 18px; height: 18px; }
    .ps-tryon-feedback-note {
      min-height: 34px;
      max-height: 86px;
      border-radius: 8px;
      font-size: 11px;
    }
    .ps-tryon-feedback-form {
      gap: 6px;
    }
    .ps-tryon-feedback-submit {
      min-height: 34px;
      padding: 0 10px;
      border-radius: 8px;
      font-size: 11px;
    }
    .ps-result-image-action-bar {
      max-width: 360px;
      justify-content: flex-start;
      gap: 7px;
    }
    .ps-result-image-action {
      min-height: 34px;
      padding: 0 11px;
      border-radius: 10px;
      font-size: 11px;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
    }
  }
  .ps-msr-product-img-wrap {
    position: relative; flex-shrink: 0;
    width: 100%; max-width: 360px; height: 420px;
    border-radius: 12px; overflow: hidden;
    background: var(--ps-bg-secondary);
    display: flex; align-items: center; justify-content: center;
  }
  /* Try-on result keeps the same neutral background as the product hero —
   *  no dark backdrop on mobile. */
  .ps-msr-product-img {
    width: 100%; height: 100%;
    object-fit: contain; display: block;
  }
  /* Show-Fit / mediapipe overlay toggle pill — bottom-left of try-on hero */
  .ps-msr-fit-toggle {
    position: absolute; bottom: 10px; left: 10px;
    display: flex; align-items: center; gap: 6px;
    padding: 8px 12px;
    background: rgba(255,255,255,0.92);
    color: var(--ps-text-primary);
    border: none; border-radius: 999px;
    font-family: inherit; font-size: 11px; font-weight: 700;
    letter-spacing: 0.04em;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.18);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    z-index: 2;
  }
  .ps-msr-fit-toggle:active { transform: scale(0.97); }
  .ps-msr-fit-toggle[aria-pressed="true"] {
    background: var(--ps-accent); color: #FFFFFF;
  }
  .ps-msr-media-actions {
    position: absolute; right: 10px; bottom: 10px;
    display: flex; gap: 8px; align-items: center;
    z-index: 3;
  }
  .ps-msr-feedback-slot {
    position: absolute;
    left: 10px;
    bottom: 10px;
    z-index: 3;
  }
  .ps-msr-media-btn {
    display: inline-flex; align-items: center; justify-content: center; gap: 6px;
    min-height: 34px;
    padding: 8px 11px;
    border: 0; border-radius: 999px;
    background: rgba(255,255,255,0.94);
    color: var(--ps-text-primary);
    box-shadow: 0 2px 8px rgba(0,0,0,0.18);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    font-family: inherit; font-size: 11px; font-weight: 800;
    letter-spacing: 0.04em;
    cursor: pointer;
    white-space: nowrap;
  }
  .ps-msr-media-btn:active { transform: scale(0.97); }
  @media (max-width: 380px) {
    .ps-msr-media-actions {
      flex-direction: column;
      align-items: flex-end;
      gap: 6px;
    }
    .ps-msr-media-btn {
      min-height: 32px;
      padding: 7px 10px;
      font-size: 10px;
    }
  }
  /* Bottom action row when try-on finished — Try Again + Done. Keep the
     close action compact on phones instead of stretching it across the bar. */
  .ps-msr-bottom-row {
    display: flex; gap: 8px; align-items: stretch; justify-content: flex-end;
  }
  .ps-msr-bottom-row.ps-msr-commerce-row {
    width: 100%;
  }
  .ps-msr-commerce-row .ps-tryon-v2-action-group {
    width: 100%;
  }
  .ps-msr-commerce-row .ps-tryon-v2-cta {
    flex: 1 1 0;
    min-width: 0;
  }
  .ps-msr-bottom-row .ps-msr-tryon-cta {
    flex: 0 0 auto; min-width: 94px; width: auto;
    padding: 11px 14px; font-size: 12px;
    white-space: nowrap;
  }
  .ps-msr-bottom-row .ps-msr-tryon-cta.ps-secondary {
    min-width: 108px;
  }
  @media (max-width: 360px) {
    .ps-msr-bottom-row .ps-msr-tryon-cta {
      padding: 10px 12px; font-size: 11px; min-width: 84px;
    }
    .ps-msr-bottom-row .ps-msr-tryon-cta.ps-secondary {
      min-width: 96px;
    }
  }
  .ps-msr-tryon-cta.ps-secondary {
    background: transparent;
    color: var(--ps-text-primary);
    border: 1.5px solid var(--ps-border-color);
  }
  .ps-msr-tryon-cta.ps-secondary:active {
    background: var(--ps-bg-secondary);
  }
  .ps-msr-bookmark {
    position: absolute; top: 10px; right: 10px;
    width: 30px; height: 30px; border-radius: 7px;
    background: rgba(255,255,255,0.92); border: none;
    color: var(--ps-text-primary); cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12);
  }
  .ps-msr-product-name {
    font-size: 15px; font-weight: 600;
    color: var(--ps-text-primary);
    text-align: center; margin: 0;
    letter-spacing: -0.005em;
  }

  /* Section cards — TALL, label small on top, BIG centered size value */
  .ps-msr-sections {
    display: flex; flex-direction: column;
    margin-top: 8px;
    border-top: 1px solid var(--ps-border-subtle);
  }
  .ps-msr-section-card {
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: 8px;
    background: none; border: none;
    border-bottom: 1px solid var(--ps-border-subtle);
    padding: 16px 20px;
    font-family: inherit; cursor: pointer;
    width: 100%;
    transition: background 0.15s, transform 0.15s;
  }
  .ps-msr-section-card:active { transform: scale(0.99); background: var(--ps-bg-secondary); }
  /* Bigger garment icon — same source as desktop (sizeGuide.sectionImages
   * → falls back to built-in line-art PNG via garmentIconForSection).
   * No background, no tinting — exact image asset shown at scale. */
  .ps-msr-section-icon-lg {
    width: 56px; height: 56px;
    object-fit: contain;
    background: none;
    margin: 0 auto 4px;
    display: block;
  }
  .ps-msr-section-name {
    font-size: 11px; font-weight: 600;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--ps-text-muted);
    text-align: center;
  }
  .ps-msr-section-size {
    font-size: 32px; font-weight: 600;
    color: var(--ps-text-primary);
    font-feature-settings: "tnum" 1;
    line-height: 1.1;
    text-align: center;
    letter-spacing: -0.01em;
  }

  /* Fixed bottom action bar — always visible, content scrolls above it */
  .ps-msr-bottom {
    flex-shrink: 0;
    background: var(--ps-bg-primary);
    border-top: 1px solid var(--ps-border-subtle);
    padding: 14px 16px;
    padding-bottom: calc(14px + env(safe-area-inset-bottom));
  }
  .ps-msr-tryon-cta {
    display: flex; align-items: center; justify-content: center; gap: 8px;
    width: 100%;
    background: var(--ps-accent); color: #FFFFFF;
    border: none; border-radius: 10px;
    padding: 14px 18px;
    font-family: inherit; font-size: 13px; font-weight: 700;
    letter-spacing: 0.04em;
    cursor: pointer;
    transition: opacity 0.15s, transform 0.15s;
  }
  .ps-msr-tryon-cta:active { transform: scale(0.98); }
  .ps-msr-tryon-cta:disabled { opacity: 0.4; cursor: not-allowed; }
  .ps-msr-tryon-cta svg { flex-shrink: 0; }

  /* ════════════════════════════════════════════════════════════════
     BodyShapeStepMobile (.ps-bsm-*) — vertical stacked option cards
     for body shape questions on mobile (chest / midsection / seat /
     hips). Matches the THE DIGITAL TAILOR reference design themed
     with the user's accent color.
     ════════════════════════════════════════════════════════════════ */
  .ps-bsm-root {
    display: flex; flex-direction: column;
    gap: 18px; padding: 8px 4px 24px;
    flex: 1; min-height: 0;
  }
  .ps-bsm-step {
    font-size: 11px; font-weight: 700;
    letter-spacing: 0.16em; text-transform: uppercase;
    color: var(--ps-text-muted);
    margin-bottom: -4px;
  }
  .ps-bsm-question {
    font-size: 26px; font-weight: 800;
    color: var(--ps-text-primary);
    line-height: 1.15;
    letter-spacing: -0.01em;
    margin: 0 0 6px;
  }
  /* Wrapper that vertically centers the cards in whatever space is left
   *  between the title at the top and the bottom navigation. */
  .ps-bsm-options-center {
    flex: 1 1 auto; min-height: 0;
    display: flex; flex-direction: column; justify-content: center;
  }
  .ps-bsm-options {
    display: flex; flex-direction: column; gap: 12px;
  }
  .ps-bsm-card {
    display: flex; align-items: center; justify-content: space-between;
    width: 100%;
    padding: 16px 18px;
    background: var(--ps-bg-secondary);
    border: 2px solid transparent;
    border-radius: 14px;
    cursor: pointer; font-family: inherit;
    text-align: left;
    transition: background 0.18s, border-color 0.18s, transform 0.15s;
  }
  .ps-bsm-card:active { transform: scale(0.985); }
  .ps-bsm-card.ps-active {
    background: var(--ps-accent);
    border-color: var(--ps-accent);
    box-shadow: 0 8px 24px rgba(33, 84, 239, 0.22);
  }
  .ps-bsm-card-content {
    display: flex; flex-direction: column; gap: 6px;
    min-width: 0;
  }
  .ps-bsm-card-eyebrow {
    font-size: 10px; font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-bsm-card.ps-active .ps-bsm-card-eyebrow {
    color: rgba(255, 255, 255, 0.7);
  }
  .ps-bsm-card-label {
    font-size: 22px; font-weight: 800;
    color: var(--ps-text-primary);
    letter-spacing: 0.02em;
  }
  .ps-bsm-card.ps-active .ps-bsm-card-label { color: #FFFFFF; }
  .ps-bsm-card-thumb {
    flex-shrink: 0;
    width: 64px; height: 64px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.6);
    display: flex; align-items: center; justify-content: center;
    overflow: hidden;
    margin-left: 14px;
  }
  .ps-bsm-card.ps-active .ps-bsm-card-thumb {
    background: rgba(255, 255, 255, 0.18);
  }
  .ps-bsm-card-thumb img {
    max-width: 100%; max-height: 100%;
    width: auto; height: 100%;
    object-fit: contain;
  }

  /* Mobile bra step — compact selector, not spreadsheet cells. */
  @media (max-width: 768px) {
    .ps-bp-bra-step {
      height: 100% !important;
      min-height: 0 !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: flex-start !important;
      overflow: hidden !important;
      padding: 44px 4px 0 !important;
    }
    .ps-bp-bra-step .ps-bp-title {
      margin: 0 0 18px !important;
      text-align: center !important;
      font-size: 21px !important;
      line-height: 1.15 !important;
      font-weight: 700 !important;
      letter-spacing: 0 !important;
    }
    .ps-bp-bra-section {
      margin: 0 auto 16px !important;
      width: 100% !important;
      max-width: 316px !important;
    }
    .ps-bp-bra-header {
      display: grid !important;
      grid-template-columns: auto minmax(0, 1fr) auto !important;
      align-items: center !important;
      gap: 8px !important;
      margin-bottom: 9px !important;
    }
    .ps-bp-bra-label {
      font-size: 9.5px !important;
      line-height: 1 !important;
      font-weight: 650 !important;
      letter-spacing: 0.13em !important;
      text-transform: uppercase;
      color: var(--ps-text-muted) !important;
    }
    .ps-bp-bra-region-wrap {
      justify-self: start !important;
      z-index: 120 !important;
    }
    .ps-bp-bra-region-trigger {
      min-height: 30px !important;
      padding: 0 10px !important;
      border-radius: 999px !important;
      border: 1px solid var(--ps-border-subtle) !important;
      background: #fff !important;
      color: var(--ps-text-primary) !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      gap: 5px !important;
    }
    .ps-bp-bra-region-arrow {
      font-size: 9px !important;
    }
    .ps-bp-bra-region-dropdown {
      position: absolute;
      right: auto !important;
      left: 0 !important;
      top: calc(100% + 6px) !important;
      width: 178px !important;
      min-width: 178px !important;
      display: grid !important;
      grid-template-columns: repeat(3, 1fr) !important;
      gap: 4px !important;
      padding: 6px !important;
      border-radius: 12px !important;
      border: 1px solid var(--ps-border-subtle) !important;
      background: #fff !important;
      box-shadow: 0 14px 32px -18px rgba(17, 24, 39, 0.45) !important;
      z-index: 200;
    }
    .ps-bp-bra-region-item {
      min-height: 30px !important;
      padding: 0 8px !important;
      border-radius: 8px !important;
      background: none; border: none;
      cursor: pointer; text-align: center !important;
      color: var(--ps-text-secondary);
      font-size: 11px !important;
    }
    .ps-bp-bra-region-item.ps-selected {
      background: var(--ps-accent); color: #FFFFFF;
    }
    .ps-bp-bra-inline-result {
      justify-self: end !important;
      margin-left: 0 !important;
      font-size: 10.5px !important;
      line-height: 1 !important;
      font-weight: 600 !important;
      color: var(--ps-accent) !important;
      white-space: nowrap !important;
    }
    .ps-bp-bra-grid {
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: center !important;
      gap: 7px !important;
    }
    .ps-bp-bra-btn {
      flex: 0 0 38px !important;
      width: 38px !important;
      height: 38px !important;
      min-height: 38px !important;
      padding: 0 !important;
      border-radius: 10px !important;
      border: 1px solid var(--ps-border-subtle) !important;
      background: #fff !important;
      color: var(--ps-text-secondary) !important;
      font-size: 12px !important;
      font-weight: 500 !important;
      cursor: pointer;
      box-shadow: 0 1px 0 rgba(17, 24, 39, 0.03) !important;
    }
    .ps-bp-bra-btn-selected {
      background: var(--ps-accent) !important;
      border-color: var(--ps-accent) !important;
      color: #FFFFFF !important;
      font-weight: 650 !important;
      box-shadow: 0 8px 18px -12px rgba(33, 84, 239, 0.75) !important;
    }
  }

  /* ════════════════════════════════════════════════════════════════
     MobileSectionDetail (.ps-msd-*) — section detail view on mobile.
     Layout: scroll container with rich blueprint rows matching the
     reference (number prefix, description, USER/SIZE labels, badge).
     ════════════════════════════════════════════════════════════════ */
  .ps-msd-root {
    display: flex; flex-direction: column;
    height: 100%; min-height: 0;
    margin: 0 -16px;
  }
  .ps-msd-scroll {
    flex: 1; min-height: 0;
    overflow-y: auto; -webkit-overflow-scrolling: touch;
    display: flex; flex-direction: column;
    gap: 18px; padding: 8px 16px 18px;
  }
  /* Topbar: back arrow + section name in uppercase */
  .ps-msd-topbar {
    display: flex; align-items: center; justify-content: space-between;
    padding: 8px 0 4px;
    margin-bottom: 4px;
  }
  .ps-msd-back {
    background: none; border: none;
    color: var(--ps-text-primary);
    font-family: inherit;
    padding: 6px; cursor: pointer;
    display: flex; align-items: center; gap: 4px;
    transition: opacity 0.15s;
    flex-shrink: 0;
  }
  .ps-msd-back:hover { opacity: 0.7; }
  .ps-msd-back-arrow { font-size: 16px; line-height: 1; }
  .ps-msd-topbar-title {
    font-size: 12px; font-weight: 700;
    letter-spacing: 0.16em; text-transform: uppercase;
    color: var(--ps-text-primary);
    text-align: center;
    flex: 1;
  }
  .ps-msd-topbar-spacer { width: 32px; flex-shrink: 0; }

  /* Footer paragraph (italic, small, muted) */
  .ps-msd-footer-note {
    font-size: 11px; line-height: 1.6;
    color: var(--ps-text-muted);
    text-align: center; font-style: italic;
    margin: 14px 12px 0;
  }

  /* ════════════════════════════════════════════════════════════════
     MySizingProfilesView (.ps-msp-*) — full profile management screen
     that replaces the old profile drawer. Grid of profile cards
     matching the ATELIER reference design.
     ════════════════════════════════════════════════════════════════ */
  .ps-msp-root {
    display: flex; flex-direction: column;
    height: 100%; min-height: 0;
  }
  .ps-msp-scroll {
    flex: 1; min-height: 0;
    overflow-y: auto; -webkit-overflow-scrolling: touch;
    padding: 4px;
  }
  .ps-msp-home {
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: max(12px, 0.95vw);
  }
  .ps-msp-welcome-panel,
  .ps-msp-cards-panel {
    min-width: 0;
    min-height: 0;
    background: var(--ps-bg-primary);
  }
  .ps-msp-welcome-panel {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: max(12px, 1vw);
    padding: max(12px, 1vw) 0 max(12px, 0.95vw);
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-msp-cards-panel {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
  }
  .ps-msp-cards-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: max(4px, 0.35vw) 0 max(8px, 0.65vw);
  }
  .ps-msp-header { margin-bottom: max(10px, 0.85vw); }
  .ps-msp-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: max(10px, 0.8vw);
  }
  .ps-msp-header-copy { min-width: 0; }
  .ps-msp-kicker {
    font-size: max(9px, 0.58vw);
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--ps-accent);
    margin-bottom: max(4px, 0.32vw);
  }
  .ps-msp-title {
    font-size: max(13px, 0.95vw);
    font-weight: 700;
    color: var(--ps-text-primary);
    margin: 0 0 max(2px, 0.2vw);
    letter-spacing: -0.005em;
  }
  .ps-msp-subtitle {
    font-size: max(11px, 0.72vw);
    color: var(--ps-text-muted);
    margin: 0;
    line-height: 1.55;
    max-width: 54ch;
  }
  .ps-msp-header-actions {
    display: flex;
    align-items: center;
    gap: max(8px, 0.65vw);
    flex-shrink: 0;
  }
  .ps-msp-primary-create {
    border: 0;
    border-radius: 999px;
    background: var(--ps-accent);
    color: #FFFFFF;
    font-family: inherit;
    font-size: max(10px, 0.66vw);
    font-weight: 800;
    padding: max(7px, 0.52vw) max(11px, 0.8vw);
    cursor: pointer;
    transition: opacity 0.15s, transform 0.15s;
  }
  .ps-msp-primary-create:hover { opacity: 0.88; }
  .ps-msp-primary-create:active { transform: scale(0.98); }
  .ps-msp-logout {
    flex-shrink: 0;
    border: 1px solid var(--ps-border-color);
    border-radius: 999px;
    background: #FFFFFF;
    color: #DC2626;
    font-family: inherit;
    font-size: max(10px, 0.62vw);
    font-weight: 700;
    padding: max(6px, 0.42vw) max(9px, 0.68vw);
    cursor: pointer;
    transition: border-color 0.15s, color 0.15s, background 0.15s;
  }
  .ps-msp-logout:hover {
    border-color: #DC2626;
    color: #B91C1C;
    background: #FEF2F2;
  }

  /* Card grid — compact saved profile cards */
  .ps-msp-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(max(160px, 12vw), 1fr));
    gap: max(10px, 0.8vw);
    margin-bottom: max(14px, 1.2vw);
  }
  .ps-msp-card {
    background: var(--ps-bg-primary);
    border: 1px solid var(--ps-border-subtle);
    border-radius: max(8px, 0.6vw);
    padding: max(8px, 0.7vw);
    display: flex; flex-direction: column;
    transition: border-color 0.15s, transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);
    position: relative;
  }
  .ps-msp-card:hover {
    border-color: var(--ps-accent);
    box-shadow: 0 4px 12px rgba(33, 84, 239, 0.08);
  }
  .ps-msp-card.ps-active {
    border-color: var(--ps-accent);
    box-shadow: 0 4px 16px rgba(33,84,239,0.12);
  }

  .ps-msp-card-header {
    display: flex; align-items: center; justify-content: flex-start;
    margin-bottom: 8px;
  }
  .ps-msp-card-tag {
    font-size: 9px; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    background: var(--ps-bg-secondary);
    color: var(--ps-text-muted);
    padding: 4px 8px; border-radius: 4px;
    border: 1px solid var(--ps-border-subtle);
  }
  .ps-msp-card.ps-active .ps-msp-card-tag {
    background: var(--ps-accent); color: #FFFFFF;
    border-color: var(--ps-accent);
  }
  .ps-msp-avatar { color: var(--ps-accent); border-color: var(--ps-accent); }
  .ps-msp-avatar-tag { background: var(--ps-accent); }

  /* Compact circular profile avatar — vw-scaled. */
  .ps-msp-card-circle {
    width: max(56px, 4.5vw);
    height: max(56px, 4.5vw);
    border-radius: 50%;
    background: var(--ps-bg-secondary);
    border: 2px solid var(--ps-accent);
    box-shadow: 0 0.3vw 0.9vw rgba(33, 84, 239, 0.15);
    overflow: hidden;
    display: flex; align-items: center; justify-content: center;
    color: var(--ps-accent);
    margin: max(4px, 0.35vw) auto max(8px, 0.7vw);
  }
  .ps-msp-card-circle img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: 50% 12%;
  }
  .ps-msp-avatar {
    position: relative;
    display: flex; align-items: center; justify-content: center;
    width: 56px; height: 56px;
    border-radius: 50%;
    background: var(--ps-bg-primary);
    color: var(--ps-text-secondary);
    border: 1.5px solid var(--ps-border-subtle);
  }
  .ps-msp-avatar-tag {
    position: absolute; bottom: -2px; right: -2px;
    width: 18px; height: 18px; border-radius: 50%;
    background: var(--ps-accent); color: #FFFFFF;
    font-size: 10px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
    border: 2px solid var(--ps-bg-primary);
  }

  .ps-msp-card-name {
    font-size: max(12px, 0.85vw);
    font-weight: 700;
    color: var(--ps-text-primary);
    margin-bottom: max(4px, 0.4vw);
  }
  .ps-msp-card-meta {
    display: flex; flex-direction: column;
    gap: max(2px, 0.2vw);
    margin-bottom: max(6px, 0.55vw);
  }
  .ps-msp-meta-row {
    display: flex; align-items: center; justify-content: space-between;
    padding: max(2px, 0.2vw) 0;
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-msp-meta-row:last-child { border-bottom: none; }
  .ps-msp-meta-label {
    font-size: max(8px, 0.55vw);
    font-weight: 600;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-msp-meta-value {
    font-size: max(10px, 0.7vw);
    font-weight: 600;
    color: var(--ps-text-primary);
    font-feature-settings: "tnum" 1;
  }

  .ps-msp-card-actions {
    display: flex; gap: max(4px, 0.4vw);
    margin-top: auto;
  }
  .ps-msp-card-select {
    flex: 1;
    background: var(--ps-accent); color: #FFFFFF;
    border: none; border-radius: max(4px, 0.35vw);
    padding: max(6px, 0.55vw);
    font-family: inherit;
    font-size: max(9px, 0.65vw);
    font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.15s, transform 0.15s;
  }
  .ps-msp-card-select:hover { opacity: 0.85; }
  .ps-msp-card-select:active { transform: scale(0.97); }
  .ps-msp-card-select.ps-active {
    background: var(--ps-accent);
    box-shadow: 0 0 0 2px rgba(33, 84, 239, 0.18);
  }
  .ps-msp-card-edit {
    width: max(28px, 2.2vw); height: max(28px, 2.2vw);
    background: var(--ps-bg-primary);
    border: 1px solid var(--ps-border-subtle);
    border-radius: max(4px, 0.35vw);
    display: flex; align-items: center; justify-content: center;
    color: var(--ps-text-secondary); cursor: pointer;
    transition: border-color 0.15s, color 0.15s;
  }
  .ps-msp-card-edit:hover {
    border-color: var(--ps-accent);
    color: var(--ps-accent);
  }
  .ps-msp-card-delete {
    width: max(28px, 2.2vw); height: max(28px, 2.2vw);
    background: var(--ps-bg-primary);
    border: 1px solid var(--ps-border-subtle);
    border-radius: max(4px, 0.35vw);
    display: flex; align-items: center; justify-content: center;
    color: var(--ps-text-secondary); cursor: pointer;
    transition: border-color 0.15s, color 0.15s;
  }
  .ps-msp-card-delete:hover {
    border-color: #F87171;
    color: #F87171;
  }

  /* Edit measurements modal */
  .ps-msp-edit-overlay {
    position: absolute; inset: 0; z-index: 100;
    background: rgba(0,0,0,0.4); backdrop-filter: blur(4px);
    display: flex; align-items: center; justify-content: center;
    padding: 16px; animation: ps-fade-in 0.2s ease;
  }
  .ps-msp-edit-modal {
    background: var(--ps-bg-primary); border-radius: max(10px, 0.8vw);
    width: 100%; max-width: max(320px, 26vw);
    max-height: clamp(400px, 70vh, 600px);
    display: flex; flex-direction: column;
    box-shadow: 0 12px 40px rgba(0,0,0,0.15);
    animation: ps-slide-up 0.25s ease;
    overflow: hidden;
  }
  .ps-msp-edit-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: max(12px, 1vw) max(14px, 1.1vw);
    border-bottom: 1px solid var(--ps-border-color);
    flex-shrink: 0;
  }
  .ps-msp-edit-header h3 {
    font-size: max(13px, 0.95vw); font-weight: 600; color: var(--ps-text-primary); margin: 0;
  }
  .ps-msp-edit-close {
    background: none; border: none; color: var(--ps-text-secondary);
    cursor: pointer; padding: max(2px, 0.2vw);
  }
  .ps-msp-edit-grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: max(8px, 0.7vw);
    padding: max(12px, 1vw) max(14px, 1.1vw);
    overflow-y: auto; flex: 1;
  }
  .ps-msp-edit-field {
    display: flex; flex-direction: column; gap: max(3px, 0.25vw);
  }
  .ps-msp-edit-label {
    font-size: max(9px, 0.6vw); font-weight: 600; text-transform: uppercase;
    letter-spacing: 0.06em; color: var(--ps-text-muted);
  }
  .ps-msp-edit-input-wrap {
    display: flex; align-items: center;
    border: 1px solid var(--ps-border-color); border-radius: max(5px, 0.4vw);
    overflow: hidden; background: var(--ps-bg-secondary);
  }
  .ps-msp-edit-input {
    flex: 1; border: none; background: transparent; padding: max(6px, 0.5vw) max(7px, 0.6vw);
    font-size: max(12px, 0.85vw); color: var(--ps-text-primary); outline: none;
    min-width: 0; -moz-appearance: textfield;
  }
  .ps-msp-edit-input::-webkit-inner-spin-button,
  .ps-msp-edit-input::-webkit-outer-spin-button { -webkit-appearance: none; }
  .ps-msp-edit-input:focus { box-shadow: inset 0 0 0 1px var(--ps-accent); }
  .ps-msp-edit-unit {
    font-size: max(10px, 0.65vw); color: var(--ps-text-muted);
    padding-right: max(7px, 0.6vw);
    font-weight: 500; flex-shrink: 0;
  }
  .ps-msp-edit-actions {
    display: flex; gap: max(6px, 0.5vw); justify-content: flex-end;
    flex-shrink: 0;
    padding: max(10px, 0.8vw) max(14px, 1.1vw);
    border-top: 1px solid var(--ps-border-color);
    background: var(--ps-bg-primary);
  }
  .ps-msp-edit-cancel {
    padding: max(6px, 0.5vw) max(12px, 1vw);
    font-size: max(11px, 0.78vw); font-weight: 500;
    border: 1px solid var(--ps-border-color); border-radius: max(5px, 0.4vw);
    background: transparent; color: var(--ps-text-secondary); cursor: pointer;
  }
  .ps-msp-edit-save {
    padding: max(6px, 0.5vw) max(14px, 1.2vw);
    font-size: max(11px, 0.78vw); font-weight: 600;
    border: none; border-radius: max(5px, 0.4vw);
    background: var(--ps-accent); color: #fff; cursor: pointer;
  }
  .ps-msp-edit-save:hover { opacity: 0.9; }

  /* ── Custom delete confirmation modal (replaces browser confirm()) ── */
  .ps-confirm-overlay {
    position: absolute; inset: 0; z-index: 200;
    background: rgba(255,255,255,0.04); backdrop-filter: blur(8px);
    display: flex; align-items: center; justify-content: center;
    padding: 1vw; animation: ps-fade-in 0.18s ease;
    border-radius: inherit; overflow: hidden;
  }
  .ps-confirm-modal {
    background: var(--ps-bg-primary); border-radius: max(10px, 0.8vw);
    padding: max(16px, 1.4vw); width: max(220px, 18vw);
    box-shadow: 0 8px 32px rgba(0,0,0,0.18); animation: ps-slide-up 0.2s ease;
    text-align: center;
  }
  .ps-confirm-icon {
    width: max(32px, 2.6vw); height: max(32px, 2.6vw);
    background: #FEE2E2; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto max(8px, 0.6vw);
    color: #EF4444;
  }
  .ps-confirm-modal p {
    font-size: max(12px, 0.85vw); font-weight: 600;
    color: var(--ps-text-primary); margin: 0 0 max(4px, 0.35vw);
  }
  .ps-confirm-modal small {
    font-size: max(10px, 0.65vw); color: var(--ps-text-muted);
    display: block; margin-bottom: max(12px, 1vw);
  }
  .ps-confirm-actions {
    display: flex; gap: max(6px, 0.5vw); justify-content: center;
  }
  .ps-confirm-cancel {
    flex: 1; padding: max(6px, 0.5vw);
    font-size: max(11px, 0.75vw); font-weight: 500;
    border: 1px solid var(--ps-border-color); border-radius: max(5px, 0.4vw);
    background: transparent; color: var(--ps-text-secondary); cursor: pointer;
    transition: background 0.15s;
  }
  .ps-confirm-cancel:hover { background: var(--ps-bg-secondary); }
  .ps-confirm-delete {
    flex: 1; padding: max(6px, 0.5vw);
    font-size: max(11px, 0.75vw); font-weight: 600;
    border: none; border-radius: max(5px, 0.4vw);
    background: #EF4444; color: #fff; cursor: pointer;
    transition: opacity 0.15s;
  }
  .ps-confirm-delete:hover { opacity: 0.88; }

  /* "Create New Profile" empty card — same compact size as the saved
     profile cards (no min-height forcing it taller). */
  .ps-msp-card-create {
    background: var(--ps-bg-secondary);
    border: 2px dashed var(--ps-border-color);
    align-items: center; justify-content: center;
    text-align: center;
    cursor: pointer;
    min-height: 0;
    transition: border-color 0.15s, background 0.15s;
  }
  .ps-msp-card-create:hover {
    border-color: var(--ps-accent);
    background: rgba(33,84,239,0.04);
  }
  /* When create card is the only item (no saved profiles), make it wider */
  .ps-msp-grid > .ps-msp-card-create:only-child {
    grid-column: auto;
    width: max(150px, 12vw);
    min-height: max(96px, 7.4vw);
    max-width: max(150px, 12vw);
    margin: 0;
  }
  .ps-msp-create-icon {
    width: max(28px, 2.2vw);
    height: max(28px, 2.2vw);
    background: var(--ps-accent); color: #FFFFFF;
    border-radius: max(4px, 0.35vw);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: max(6px, 0.55vw);
  }
  .ps-msp-create-title {
    font-size: max(10px, 0.68vw);
    font-weight: 700;
    color: var(--ps-text-primary);
    margin-bottom: max(2px, 0.2vw);
  }
  .ps-msp-create-sub {
    font-size: max(7px, 0.46vw);
    font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }

  /* Social-only profile gate */
  .ps-profile-auth {
    height: 100%;
    min-height: 0;
    display: flex;
    align-items: stretch;
    justify-content: center;
    padding: max(6px, 0.5vw);
    background: #FFFFFF;
  }
  .ps-profile-auth-shell {
    width: 100%;
    height: 100%;
    min-height: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 0;
    align-items: stretch;
    background: #FFFFFF;
    overflow: hidden;
  }
  .ps-profile-auth-story,
  .ps-profile-auth-card {
    min-width: 0;
    background: #FFFFFF;
  }
  .ps-profile-auth-story {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: max(18px, 1.5vw) max(18px, 1.55vw);
  }
  .ps-profile-auth-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: max(18px, 1.5vw) max(18px, 1.55vw);
    border-left: 1px solid rgba(15,23,42,0.10);
  }
  .ps-profile-auth-visual {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: max(135px, 11vw);
    margin: max(-8px, -0.5vw) 0 max(6px, 0.45vw);
  }
  .ps-profile-auth-visual img {
    width: min(96%, max(230px, 18vw));
    height: auto;
    display: block;
  }
  .ps-profile-auth-story-copy {
    max-width: max(300px, 24vw);
  }
  .ps-profile-auth-badge,
  .ps-profile-auth-card-kicker {
    display: inline-flex;
    align-items: center;
    border: 0;
    border-radius: 999px;
    padding: max(4px, 0.32vw) max(9px, 0.7vw);
    color: var(--ps-accent);
    background: #FFFFFF;
    font-size: max(9px, 0.58vw);
    font-weight: 800;
    letter-spacing: 0.11em;
    text-transform: uppercase;
  }
  .ps-profile-auth-title {
    margin: max(10px, 0.8vw) 0 max(7px, 0.55vw);
    color: var(--ps-text-primary);
    font-size: max(21px, 1.55vw);
    line-height: 1.06;
    letter-spacing: -0.04em;
  }
  .ps-profile-auth-copy {
    margin: 0;
    color: var(--ps-text-secondary);
    font-size: max(12px, 0.76vw);
    line-height: 1.6;
  }
  .ps-profile-auth-card-header {
    margin-bottom: max(16px, 1.2vw);
  }
  .ps-profile-auth-card-title {
    margin: max(10px, 0.8vw) 0 max(5px, 0.4vw);
    color: var(--ps-text-primary);
    font-size: max(18px, 1.15vw);
    line-height: 1.12;
    letter-spacing: -0.03em;
  }
  .ps-profile-auth-card-copy {
    margin: 0;
    color: var(--ps-text-muted);
    font-size: max(11px, 0.7vw);
    line-height: 1.55;
  }
  .ps-profile-auth-icon-row {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: max(7px, 0.5vw);
  }
  .ps-profile-auth-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: max(6px, 0.42vw);
    min-width: 0;
    min-height: max(66px, 4.8vw);
    padding: max(8px, 0.62vw) max(4px, 0.35vw);
    border: 0;
    border-radius: max(11px, 0.8vw);
    background: #F8FAFF;
    color: var(--ps-text-primary);
    font-family: inherit;
    font-size: max(10px, 0.6vw);
    font-weight: 700;
    cursor: pointer;
    transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease, background 0.18s ease;
  }
  .ps-profile-auth-button:hover:not(:disabled) {
    box-shadow: 0 8px 18px rgba(15,23,42,0.08);
    transform: translateY(-1px);
  }
  .ps-profile-auth-button:disabled {
    cursor: wait;
    opacity: 0.68;
  }
  .ps-profile-auth-button.ps-consent-required:disabled {
    cursor: not-allowed;
    opacity: 0.42;
    box-shadow: none;
  }
  .ps-profile-auth-icon {
    width: max(24px, 1.75vw);
    height: max(24px, 1.75vw);
    display: block;
    object-fit: contain;
  }
  .ps-profile-auth-consent {
    display: flex;
    align-items: flex-start;
    gap: max(8px, 0.58vw);
    margin: max(14px, 1vw) 0 0;
    padding: max(10px, 0.72vw);
    border: 1px solid rgba(37,99,235,0.18);
    border-radius: max(10px, 0.72vw);
    background: #F8FAFF;
    color: var(--ps-text-secondary);
    font-size: max(10px, 0.64vw);
    line-height: 1.5;
    cursor: pointer;
  }
  .ps-profile-auth-consent input {
    flex: 0 0 auto;
    width: max(15px, 0.9vw);
    height: max(15px, 0.9vw);
    margin: max(2px, 0.14vw) 0 0;
    accent-color: var(--ps-accent);
    cursor: pointer;
  }
  .ps-profile-auth-consent a {
    color: var(--ps-accent);
    font-weight: 800;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
  .ps-profile-auth-error {
    margin: max(12px, 0.9vw) 0 0;
    padding: max(8px, 0.6vw) max(10px, 0.75vw);
    border-radius: max(8px, 0.65vw);
    background: #FEF2F2;
    border: 1px solid #FECACA;
    color: #B91C1C;
    font-size: max(11px, 0.72vw);
    line-height: 1.45;
  }
  .ps-profile-auth-note {
    margin: max(12px, 0.9vw) 0 0;
    color: var(--ps-text-muted);
    font-size: max(10px, 0.64vw);
    line-height: 1.5;
  }
  @container (max-width: 620px) {
    .ps-profile-auth {
      padding: 8px;
    }
    .ps-profile-auth-shell {
      grid-template-columns: 1fr;
    }
    .ps-profile-auth-story,
    .ps-profile-auth-card {
      padding: 14px;
    }
    .ps-profile-auth-card {
      border-left: 0;
      border-top: 1px solid rgba(15,23,42,0.10);
    }
    .ps-profile-auth-visual {
      min-height: 108px;
      margin: -8px 0 0;
    }
    .ps-profile-auth-visual img {
      width: min(82%, 260px);
    }
    .ps-profile-auth-title {
      font-size: 21px;
    }
    .ps-profile-auth-copy,
    .ps-profile-auth-card-copy {
      font-size: 12px;
    }
    .ps-profile-auth-icon-row {
      gap: 8px;
    }
    .ps-profile-auth-button {
      min-height: 62px;
      border-radius: 11px;
      font-size: 10px;
    }
    .ps-profile-auth-consent {
      gap: 8px;
      margin-top: 12px;
      padding: 10px;
      font-size: 11px;
    }
    .ps-profile-auth-consent input {
      width: 16px;
      height: 16px;
    }
    .ps-profile-auth-icon {
      width: 24px;
      height: 24px;
    }
  }

  /* Recent size calculations section */
  .ps-msp-history-section {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid var(--ps-border-subtle);
  }
  .ps-msp-history-title {
    font-size: 13px; font-weight: 700;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--ps-text-primary);
    margin: 0 0 14px;
  }
  .ps-msp-history-list {
    display: flex; flex-direction: column; gap: 8px;
  }
  .ps-msp-history-card {
    display: flex; align-items: center; gap: 12px;
    padding: 12px;
    background: var(--ps-bg-primary);
    border: 1px solid var(--ps-border-subtle);
    border-radius: 8px;
  }
  .ps-msp-history-thumb {
    width: 48px; height: 48px;
    border-radius: 6px;
    background: var(--ps-bg-secondary);
    overflow: hidden;
    flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
  }
  .ps-msp-history-thumb img {
    max-width: 100%; max-height: 100%; object-fit: contain;
  }
  .ps-msp-history-info {
    flex: 1; min-width: 0;
    display: flex; flex-direction: column; gap: 2px;
  }
  .ps-msp-history-name {
    font-size: 13px; font-weight: 600;
    color: var(--ps-text-primary);
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }
  .ps-msp-history-profile {
    font-size: 10px;
    color: var(--ps-text-muted);
  }
  .ps-msp-history-meta {
    font-size: 10px;
    color: var(--ps-text-muted);
    display: flex; align-items: center; gap: 4px;
  }
  .ps-msp-history-meta svg { color: var(--ps-text-muted); }
  .ps-msp-history-size {
    display: flex; flex-direction: column; align-items: flex-end;
    flex-shrink: 0;
  }
  .ps-msp-history-size-label {
    font-size: 9px; font-weight: 600;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-msp-history-size-value {
    font-size: 22px; font-weight: 700;
    color: var(--ps-text-primary);
    font-feature-settings: "tnum" 1;
    line-height: 1;
  }

  @media (max-width: 768px) {
    /* Profile card grid */
    .ps-msp-home {
      height: auto;
      gap: 3vw;
    }
    .ps-msp-welcome-panel {
      gap: 3vw;
      padding: 3vw 0;
    }
    .ps-msp-cards-scroll {
      max-height: 66vh;
      padding: 1vw 0 3vw;
    }
    .ps-msp-header-actions { width: 100%; gap: 2vw; }
    .ps-msp-primary-create { font-size: 3vw; padding: 2.4vw 3.4vw; }
    .ps-msp-header-actions .ps-msp-primary-create { flex: 1; }
    .ps-msp-grid { grid-template-columns: 1fr; gap: 3vw; }
    .ps-msp-card-create { min-height: 22vw; }
    .ps-msp-grid > .ps-msp-card-create:only-child {
      width: 46vw;
      max-width: 46vw;
      min-height: 30vw;
    }
    .ps-msp-header { margin-bottom: 3vw; }
    .ps-msp-header-row { align-items: flex-start; gap: 3vw; }
    .ps-msp-kicker { font-size: 2.4vw; margin-bottom: 1vw; }
    .ps-msp-title { font-size: 5.6vw; }
    .ps-msp-subtitle { font-size: 3vw; }
    .ps-msp-logout { font-size: 2.8vw; padding: 2vw 2.8vw; }
    .ps-msp-card { padding: 3.5vw; border-radius: 3vw; }
    .ps-msp-card-tag { font-size: 2.3vw; padding: 1vw 2vw; border-radius: 1vw; }
    .ps-msp-card-circle { width: 18vw; height: 18vw; margin: 2vw auto 3vw; }
    .ps-msp-card-name { font-size: 4.1vw; margin-bottom: 2vw; }
    .ps-msp-meta-label { font-size: 2.5vw; }
    .ps-msp-meta-value { font-size: 3.3vw; }
    .ps-msp-meta-row { padding: 1.5vw 0; }
    .ps-msp-card-actions { gap: 2vw; }
    .ps-msp-card-select { font-size: 2.6vw; padding: 2.5vw; border-radius: 1.5vw; }
    .ps-msp-card-edit, .ps-msp-card-delete { width: 10vw; height: 10vw; border-radius: 2vw; }

    /* Profile measurements view */
    .ps-pmv-hero { padding: 3vw 0 2vw; }
    .ps-pmv-hero-name { font-size: 6vw; }
    .ps-pmv-hero-eyebrow { font-size: 2.5vw; letter-spacing: 0.1em; }
    .ps-pmv-data { gap: 3vw; }
    .ps-pmv-basics { gap: 1.5vw; }
    .ps-pmv-basic-row { gap: 2.5vw; padding: 2.5vw 0; }
    .ps-pmv-basic-icon { width: 6vw; height: 6vw; }
    .ps-pmv-basic-label { font-size: 2.8vw; }
    .ps-pmv-basic-value { font-size: 3.6vw; }
    .ps-pmv-section-title { font-size: 2.5vw; letter-spacing: 0.12em; }
    .ps-pmv-measure-list { gap: 0; }
    .ps-pmv-measure-row { gap: 2.5vw; padding: 2.5vw 0; }
    .ps-pmv-measure-icon { width: 7vw; height: 7vw; }
    .ps-pmv-measure-label { font-size: 2.8vw; }
    .ps-pmv-measure-value { font-size: 3.3vw; }
    .ps-pmv-measure-input { font-size: 3.3vw; padding: 1.5vw; }
    .ps-pmv-measure-input-unit { font-size: 2.8vw; }
    .ps-pmv-inline-input { font-size: 3.3vw; width: 11vw; }
    .ps-pmv-inline-unit { font-size: 2.6vw; }
    .ps-pmv-inline-select { font-size: 3.3vw; }
    .ps-pmv-actions { gap: 2.5vw; padding-top: 3vw; flex-wrap: wrap; }
    .ps-pmv-actions-right { gap: 2vw; flex-wrap: wrap; }
    .ps-pmv-btn-primary, .ps-pmv-btn-secondary {
      padding: 3.5vw 4vw; font-size: 3vw; border-radius: 2vw;
    }
    .ps-pmv-btn-edit, .ps-pmv-btn-delete {
      padding: 3vw 3.5vw; font-size: 2.8vw; border-radius: 2vw;
    }

    /* Delete confirmation modal — mobile sizing */
    .ps-confirm-modal { width: 85vw; padding: 5vw; border-radius: 3vw; }
    .ps-confirm-icon { width: 10vw; height: 10vw; margin-bottom: 3vw; }
    .ps-confirm-modal p { font-size: 4vw; }
    .ps-confirm-modal small { font-size: 3.3vw; margin-bottom: 4vw; }
    .ps-confirm-actions { gap: 2.5vw; }
    .ps-confirm-cancel, .ps-confirm-delete { padding: 3.5vw 4vw; font-size: 3.3vw; border-radius: 2vw; }

    /* Edit measurements modal — bottom sheet on mobile */
    .ps-msp-edit-overlay { padding: 0; align-items: flex-end; }
    .ps-msp-edit-modal {
      width: 100%; max-width: 100%;
      border-radius: 4vw 4vw 0 0;
      max-height: 85dvh;
    }
    .ps-msp-edit-header { padding: 3.5vw 4vw; }
    .ps-msp-edit-header h3 { font-size: 4.6vw; }
    .ps-msp-edit-grid { padding: 3vw 4vw; gap: 3vw; }
    .ps-msp-edit-label { font-size: 2.8vw; }
    .ps-msp-edit-input { font-size: 3.3vw; padding: 2vw 2.5vw; }
    .ps-msp-edit-unit { font-size: 3vw; padding-right: 2vw; }
    .ps-msp-edit-actions { padding: 3vw 4vw; gap: 2.5vw; }
    .ps-msp-edit-cancel, .ps-msp-edit-save { padding: 3.5vw 5vw; font-size: 3.3vw; border-radius: 2vw; }
  }

  /* ════════════════════════════════════════════════════════════════
     CreateProfileWizard (.ps-cpw-*) — multi-step profile creation
     wizard matching the ATELIER reference but themed with --ps-accent
     instead of monochrome black.
     ════════════════════════════════════════════════════════════════ */
  .ps-cpw-root {
    display: flex; flex-direction: column;
    height: 100%; min-height: 0;
    width: 100%; max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  .ps-cpw-upload-view-shell {
    position: relative;
    flex: 0 0 auto;
  }

  /* Step header — single tiny title + a thin progress bar inline.
     All sizing is vw-based with sensible clamps so the wizard scales
     proportionally from a 320px phone all the way up to a 5000px display
     without losing its ratios. */
  .ps-cpw-step-head {
    display: flex; align-items: center; justify-content: space-between;
    gap: clamp(8px, 0.75vw, 16px);
    padding: clamp(4px, 0.4vw, 10px) clamp(12px, 1vw, 22px);
    border-bottom: 1px solid var(--ps-border-subtle);
    flex-shrink: 0;
  }
  .ps-cpw-eyebrow { display: none; }
  .ps-cpw-step-title {
    font-size: clamp(10px, 0.7vw, 14px);
    font-weight: 600;
    color: var(--ps-text-primary);
    letter-spacing: 0.02em;
    margin: 0;
    text-transform: uppercase;
  }
  .ps-cpw-progress {
    display: flex; flex-direction: column; align-items: flex-end;
    gap: 0; flex-shrink: 0;
    min-width: clamp(60px, 5vw, 100px);
  }
  .ps-cpw-progress-track {
    width: 100%; height: clamp(2px, 0.12vw, 3px);
    background: var(--ps-border-color); border-radius: 2px;
    overflow: hidden;
  }
  .ps-cpw-progress-fill {
    height: 100%; background: var(--ps-accent);
    transition: width 0.4s cubic-bezier(0.32, 0.72, 0, 1);
  }
  .ps-cpw-progress-label { display: none; }

  .ps-cpw-body {
    display: flex; flex-direction: column;
    gap: max(10px, 0.85vw);
    flex: 1; min-height: 0;
    width: 100%; max-width: 100%;
    box-sizing: border-box;
    overflow-y: auto; overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    padding: max(10px, 0.9vw) max(12px, 1vw);
  }
  .ps-cpw-photo-step,
  .ps-cpw-photo-details-col,
  .ps-cpw-profile-fields-shell,
  .ps-msp-scroll {
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  /* Step 1 — Identity form (compact, vw-scaled) */
  .ps-cpw-identity {
    display: flex; flex-direction: column;
    gap: max(8px, 0.7vw);
    flex: 1; min-height: 0;
    width: 100%; box-sizing: border-box;
  }
  .ps-cpw-field {
    display: flex; flex-direction: column;
    gap: max(4px, 0.4vw);
  }
  .ps-cpw-field-label {
    font-size: max(9px, 0.62vw);
    font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-cpw-input {
    background: transparent; border: none;
    border-bottom: 1px solid var(--ps-border-color);
    color: var(--ps-text-primary);
    font-family: inherit;
    font-size: max(13px, 0.95vw);
    font-weight: 500;
    padding: max(4px, 0.4vw) 0 max(6px, 0.55vw);
    outline: none;
    transition: border-color 0.15s;
  }
  .ps-cpw-input::placeholder { color: var(--ps-text-muted); font-weight: 500; opacity: 0.7; }
  .ps-cpw-input:focus { border-bottom-color: var(--ps-accent); }
  .ps-cpw-input::-webkit-outer-spin-button,
  .ps-cpw-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  .ps-cpw-input[type="number"] { -moz-appearance: textfield; }

  .ps-cpw-pill-row {
    display: flex; align-items: center;
    gap: max(6px, 0.5vw);
    flex-wrap: wrap;
  }
  .ps-cpw-pill-group {
    display: flex; align-items: center;
    background: var(--ps-bg-secondary);
    border: 1px solid var(--ps-border-color);
    border-radius: 999px;
    padding: max(2px, 0.15vw);
  }
  .ps-cpw-pill {
    background: none; border: none;
    padding: max(4px, 0.35vw) max(10px, 0.9vw);
    border-radius: 999px;
    font-family: inherit;
    font-size: max(10px, 0.7vw);
    font-weight: 600;
    color: var(--ps-text-secondary); cursor: pointer;
    transition: background 0.15s, color 0.15s;
  }
  .ps-cpw-pill.ps-active {
    background: var(--ps-accent); color: #FFFFFF;
  }

  .ps-cpw-field-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(max(140px, 11vw), 1fr));
    gap: max(14px, 1.2vw);
  }

  /* Two-column split: inputs stacked left, photo right */
  .ps-cpw-split {
    display: grid;
    grid-template-columns: 1fr max(180px, 14vw);
    gap: max(16px, 1.4vw);
    align-items: start;
  }
  .ps-cpw-split-left {
    display: flex; flex-direction: column;
    gap: max(14px, 1.2vw);
    min-width: 0;
  }
  .ps-cpw-split-right {
    display: flex; flex-direction: column;
    gap: max(6px, 0.55vw);
    min-width: 0;
  }
  .ps-cpw-error {
    font-size: max(10px, 0.72vw);
    color: var(--ps-error-color);
    margin-top: calc(max(4px, 0.4vw) * -1);
  }

  /* Optional photo upload (step 1) */
  .ps-cpw-photo {
    display: flex; flex-direction: column; gap: 8px;
    margin-top: 4px;
  }
  .ps-cpw-photo-upload {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 8px; padding: 38px 18px;
    min-height: 220px;
    background: var(--ps-bg-secondary);
    border: 2px dashed var(--ps-border-color);
    border-radius: 12px;
    color: var(--ps-text-secondary); cursor: pointer;
    font-family: inherit;
    transition: border-color 0.15s, background 0.15s;
  }
  .ps-cpw-photo-upload:hover {
    border-color: var(--ps-accent);
    background: rgba(33, 84, 239, 0.04);
  }
  .ps-cpw-photo-upload:disabled { opacity: 0.5; cursor: wait; }
  .ps-cpw-photo-upload svg { color: var(--ps-accent); }
  .ps-cpw-photo-upload-title {
    font-size: 13px; font-weight: 600;
    color: var(--ps-text-primary);
  }
  .ps-cpw-photo-upload-hint {
    font-size: 11px; font-weight: 400;
    color: var(--ps-text-muted);
  }
  .ps-cpw-photo-preview {
    position: relative;
    width: 100%;
    border-radius: 12px; overflow: hidden;
    background: var(--ps-bg-secondary);
    border: 1px solid var(--ps-border-subtle);
    aspect-ratio: 3 / 4;
    display: flex; align-items: center; justify-content: center;
  }
  .ps-cpw-photo-preview img {
    max-width: 100%; max-height: 100%;
    width: auto; height: 100%;
    object-fit: contain;
  }
  .ps-cpw-photo-remove {
    position: absolute; top: 8px; right: 8px;
    width: 28px; height: 28px; border-radius: 50%;
    background: rgba(0, 0, 0, 0.65); color: #FFFFFF;
    border: none; cursor: pointer;
    font-size: 18px; line-height: 1;
    display: flex; align-items: center; justify-content: center;
  }

  /* Step 2 — Silhouette (vw-scaled) */
  .ps-cpw-silhouette {
    display: flex; flex-direction: column;
    gap: clamp(16px, 1.4vw, 32px);
  }
  .ps-cpw-section {
    display: flex; flex-direction: column;
    gap: clamp(8px, 0.7vw, 16px);
  }
  .ps-cpw-section-head {
    display: flex; flex-direction: column;
    gap: clamp(2px, 0.2vw, 6px);
  }
  .ps-cpw-section-title {
    font-size: clamp(10px, 0.72vw, 14px);
    font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--ps-text-primary);
  }
  .ps-cpw-section-sub {
    font-size: clamp(10px, 0.7vw, 13px);
    font-weight: 400;
    color: var(--ps-text-muted);
  }
  .ps-cpw-card-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: clamp(8px, 0.75vw, 16px);
    /* Inside a flex parent (ProgressiveStep with flex:1), let the row
       claim leftover vertical space so the cards stretch to fill it. */
    flex: 1; min-height: 0;
  }
  .ps-cpw-bra-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: clamp(8px, 0.75vw, 16px);
  }
  .ps-cpw-bra-field {
    display: flex; flex-direction: column;
    gap: clamp(4px, 0.4vw, 10px);
  }
  .ps-cpw-card {
    display: flex; flex-direction: column; align-items: center;
    background: var(--ps-bg-primary);
    border: 2px solid var(--ps-border-subtle);
    border-radius: clamp(8px, 0.6vw, 14px);
    padding: clamp(10px, 0.85vw, 18px) clamp(6px, 0.5vw, 12px) clamp(8px, 0.65vw, 14px);
    cursor: pointer; font-family: inherit;
    transition: border-color 0.15s, transform 0.15s, box-shadow 0.15s;
    /* Stretch inside the grid track so all 3 cards in the row fill
       the available height equally. */
    min-width: 0; min-height: 0;
  }
  .ps-cpw-card:hover {
    border-color: rgba(33, 84, 239, 0.35);
  }
  .ps-cpw-card.ps-active {
    border-color: var(--ps-accent);
    box-shadow: 0 0.4vw 1.1vw rgba(33, 84, 239, 0.16);
    transform: translateY(-1px);
  }
  .ps-cpw-card-thumb {
    width: 100%;
    /* Fills whatever space the card has — combined with the card's
       min-height: 0, this lets the thumb image grow with viewport size
       and stretch to fill the wizard body. */
    flex: 1; min-height: 0;
    display: flex; align-items: center; justify-content: center;
    overflow: hidden;
    margin-bottom: clamp(4px, 0.4vw, 10px);
  }
  .ps-cpw-card-thumb img {
    max-width: 100%; max-height: 100%;
    object-fit: contain;
  }
  .ps-cpw-card-label {
    font-size: clamp(9px, 0.65vw, 12px);
    font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-cpw-card.ps-active .ps-cpw-card-label {
    color: var(--ps-accent);
  }

  /* Footer actions — vw-scaled */
  .ps-cpw-footer {
    display: flex; align-items: center; justify-content: space-between;
    gap: clamp(8px, 0.7vw, 14px);
    padding: clamp(6px, 0.55vw, 12px) clamp(12px, 1vw, 22px);
    border-top: 1px solid var(--ps-border-subtle);
    background: var(--ps-bg-primary);
    flex-shrink: 0;
  }
  .ps-cpw-footer-no-back {
    justify-content: flex-end;
  }
  .ps-cpw-back-btn {
    background: none; border: none;
    color: var(--ps-text-secondary);
    font-family: inherit;
    font-size: clamp(10px, 0.7vw, 13px);
    font-weight: 600;
    cursor: pointer;
    padding: clamp(6px, 0.55vw, 12px) clamp(2px, 0.2vw, 6px);
    transition: color 0.15s;
  }
  .ps-cpw-back-btn:hover { color: var(--ps-text-primary); }
  .ps-cpw-next-btn {
    background: var(--ps-accent); color: #FFFFFF;
    border: none; border-radius: clamp(4px, 0.35vw, 8px);
    padding: clamp(8px, 0.7vw, 14px) clamp(16px, 1.4vw, 28px);
    font-family: inherit;
    font-size: clamp(10px, 0.7vw, 13px);
    font-weight: 700;
    letter-spacing: 0.1em; text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.15s, transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 0.25vw 0.8vw rgba(33, 84, 239, 0.16);
  }
  .ps-cpw-next-btn:disabled {
    background: var(--ps-border-color);
    color: var(--ps-text-muted);
    box-shadow: none;
    cursor: default;
  }
  .ps-cpw-next-btn:hover { opacity: 0.92; }
  .ps-cpw-next-btn:active { transform: scale(0.98); }

  /* Gender pill — used inside the inline-row "GENDER" field. Sized to
     match the text inputs (compact, underlined-feel) so it doesn't tower
     over the other rows in the form. */
  .ps-cpw-gender-pill {
    appearance: none;
    background: transparent;
    color: var(--ps-text-secondary);
    border: 1px solid var(--ps-border-color);
    border-radius: clamp(6px, 0.45vw, 10px);
    padding: clamp(4px, 0.35vw, 8px) clamp(10px, 0.85vw, 18px);
    font-family: inherit;
    font-size: clamp(10px, 0.7vw, 13px);
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
  }
  .ps-cpw-gender-pill:hover {
    border-color: var(--ps-accent);
    color: var(--ps-accent);
  }
  .ps-cpw-gender-pill[data-active="true"] {
    background: #fff;
    color: #111;
    border-color: var(--ps-accent);
  }

  /* When the wizard is on the photo step, suppress the global
     ps-tryon-back-btn rendered by the modal shell — the wizard's own
     footer Back button is enough, and stacking two looks cluttered. The
     marker class is added by CreateProfileWizard's root and the rule
     reaches up to its preceding sibling via :has(). */
  .ps-tryon-body:has(.ps-cpw-hide-global-back) > .ps-tryon-back-btn {
    display: none;
  }

  @keyframes ps-cpw-shake {
    0%, 100% { transform: translateX(0); }
    15% { transform: translateX(-5px); }
    30% { transform: translateX(5px); }
    45% { transform: translateX(-4px); }
    60% { transform: translateX(4px); }
    75% { transform: translateX(-2px); }
    90% { transform: translateX(2px); }
  }
  .ps-cpw-shake {
    animation: ps-cpw-shake 0.5s ease;
    outline: 1.5px solid var(--ps-error, #ef4444) !important;
    outline-offset: 1px;
  }

  /* No wizard-specific @media (max-width: 768px) overrides anymore.
     Every ps-cpw-* rule is clamp/vw-driven, so the layout shrinks
     gracefully from 320px → 5000px without a hard breakpoint. */

  /* ── Progressive (one-question-at-a-time) flow ── */
  .ps-cpw-progressive {
    display: flex; flex-direction: column;
    gap: clamp(12px, 1vw, 22px);
    padding: clamp(6px, 0.5vw, 12px) 0;
    /* Fills the wizard body so the card row can stretch vertically */
    flex: 1; min-height: 0;
    width: 100%; box-sizing: border-box;
  }
  .ps-cpw-fade-in {
    animation: ps-cpw-fade-up 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes ps-cpw-fade-up {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* ── Method picker (initial step) — cards stretch to fill body ── */
  .ps-cpw-method-picker {
    display: flex; flex-direction: column;
    gap: clamp(8px, 0.7vw, 14px);
    padding: clamp(4px, 0.4vw, 10px) 0;
    flex: 1; min-height: 0;
    width: 100%; box-sizing: border-box;
  }
  .ps-cpw-method-intro { display: none; }
  /* Grid claims the picker's leftover height so the cards inside
     stretch vertically to fill it. */
  .ps-cpw-method-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: clamp(8px, 0.75vw, 16px);
    width: 100%; max-width: 100%;
    box-sizing: border-box;
    flex: 1; min-height: 0;
  }
  /* ── Editorial method card — Stripe / Linear / Notion style ──
     Single-block layout: small icon badge in the top-left, content
     below (eyebrow → title → description), corner number watermark in
     the top-right, hover arrow indicator in the bottom-right.
     No big image strip — minimal, professional. */
  .ps-cpw-method-card {
    position: relative;
    display: flex; flex-direction: column; align-items: flex-start;
    gap: clamp(6px, 0.55vw, 12px);
    min-width: 0; min-height: 0;
    width: 100%; max-width: 100%;
    box-sizing: border-box;
    background: var(--ps-bg-primary);
    border: 1px solid var(--ps-border-subtle);
    border-radius: clamp(10px, 0.75vw, 16px);
    padding: clamp(16px, 1.3vw, 28px) clamp(16px, 1.3vw, 28px) clamp(20px, 1.6vw, 34px);
    overflow: hidden;
    cursor: pointer; font-family: inherit; text-align: left;
    transition: border-color 0.22s, transform 0.22s, box-shadow 0.22s, background 0.22s;
    box-shadow: 0 0.1vw 0.4vw rgba(20, 30, 60, 0.04);
  }
  .ps-cpw-method-card::before {
    /* Thin top accent bar that scales in from the left on hover */
    content: ""; position: absolute; top: 0; left: 0; right: 0;
    height: clamp(2px, 0.15vw, 4px);
    background: var(--ps-accent);
    transform: scaleX(0); transform-origin: left center;
    transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    z-index: 3;
  }
  .ps-cpw-method-card:hover {
    border-color: var(--ps-accent);
    transform: translateY(-2px);
    box-shadow: 0 0.6vw 1.6vw rgba(33, 84, 239, 0.14);
  }
  .ps-cpw-method-card:hover::before { transform: scaleX(1); }

  /* Big editorial number watermark — top right */
  .ps-cpw-method-num {
    position: absolute;
    top: clamp(10px, 0.85vw, 18px);
    right: clamp(14px, 1.1vw, 22px);
    z-index: 2;
    font-family: inherit;
    font-size: clamp(22px, 1.8vw, 36px);
    font-weight: 800;
    line-height: 1;
    letter-spacing: -0.04em;
    color: var(--ps-text-primary);
    opacity: 0.08;
    pointer-events: none;
    transition: color 0.22s, opacity 0.22s, transform 0.22s;
  }
  .ps-cpw-method-card:hover .ps-cpw-method-num {
    color: var(--ps-accent);
    opacity: 0.32;
  }

  /* Small tinted icon badge — top-left of the card */
  .ps-cpw-method-icon-badge {
    width: clamp(40px, 3.2vw, 60px);
    height: clamp(40px, 3.2vw, 60px);
    border-radius: clamp(8px, 0.65vw, 14px);
    background: rgba(33, 84, 239, 0.08);
    display: flex; align-items: center; justify-content: center;
    padding: clamp(6px, 0.5vw, 10px);
    box-sizing: border-box;
    flex-shrink: 0;
    margin-bottom: clamp(8px, 0.7vw, 14px);
    transition: background 0.22s, transform 0.22s;
  }
  .ps-cpw-method-icon-badge img {
    width: 100%; height: 100%;
    object-fit: contain;
    display: block;
  }
  .ps-cpw-method-card:hover .ps-cpw-method-icon-badge {
    background: rgba(33, 84, 239, 0.14);
    transform: scale(1.05);
  }

  /* Content typography */
  .ps-cpw-method-eyebrow {
    font-size: clamp(8px, 0.55vw, 11px);
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-cpw-method-title {
    font-size: clamp(14px, 1vw, 19px);
    font-weight: 700;
    color: var(--ps-text-primary);
    letter-spacing: -0.015em;
    line-height: 1.2;
  }
  .ps-cpw-method-desc {
    font-size: clamp(10px, 0.72vw, 13px);
    line-height: 1.5;
    color: var(--ps-text-muted);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  /* Arrow pill — bottom right corner */
  .ps-cpw-method-arrow {
    position: absolute;
    right: clamp(14px, 1.1vw, 22px);
    bottom: clamp(14px, 1.1vw, 22px);
    width: clamp(24px, 1.8vw, 34px);
    height: clamp(24px, 1.8vw, 34px);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    background: var(--ps-bg-secondary);
    color: var(--ps-text-secondary);
    transition: background 0.22s, color 0.22s, transform 0.22s;
  }
  .ps-cpw-method-arrow svg {
    width: 55%; height: 55%;
  }
  .ps-cpw-method-card:hover .ps-cpw-method-arrow {
    background: var(--ps-accent);
    color: #FFFFFF;
    transform: translateX(0.2vw);
  }
  /* Wizard reuses the SDK basics screen's .ps-bp-inline-* row styles for
     parity. This wrapper just gives them a consistent gap and centers
     them inside the wizard body so all rows fit without scrolling. */
  .ps-cpw-inline-fields {
    width: 100%;
    margin-top: clamp(2px, 0.2vw, 6px);
    display: flex; flex-direction: column;
    gap: clamp(4px, 0.4vw, 10px);
  }
  .ps-cpw-inline-fields .ps-bp-inline-row {
    padding: clamp(10px, 0.9vw, 18px) clamp(1px, 0.1vw, 4px);
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-cpw-inline-fields .ps-bp-inline-row:last-child { border-bottom: none; }
  .ps-cpw-inline-fields .ps-bp-inline-label {
    flex: 0 0 clamp(56px, 4.5vw, 90px);
    font-size: clamp(9px, 0.62vw, 12px);
    font-weight: 700;
    color: var(--ps-text-primary);
    letter-spacing: 0.08em;
  }
  .ps-cpw-inline-fields .ps-bp-inline-input {
    font-size: clamp(12px, 0.85vw, 16px);
    padding-bottom: 0.2vw;
    border-bottom: 1px solid var(--ps-border-color);
    color: var(--ps-text-primary);
  }
  .ps-cpw-inline-fields .ps-bp-inline-unit {
    font-size: clamp(10px, 0.7vw, 13px);
    color: var(--ps-text-muted);
  }

  /* ── Image path — split layout with dropzone + photo guide ──
     Two columns: dropzone with silhouette placeholder on the LEFT,
     gender pills + name input + photo-guide checklist on the RIGHT.
     Collapses to single column on narrow viewports via flex-wrap. */
  .ps-cpw-image-split {
    display: grid;
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
    gap: clamp(14px, 1.2vw, 26px);
    flex: 1; min-height: 0;
    width: 100%; box-sizing: border-box;
  }
  .ps-cpw-image-left {
    display: flex; flex-direction: column;
    min-width: 0; min-height: 0;
  }
  .ps-cpw-image-right {
    display: flex; flex-direction: column;
    gap: clamp(10px, 0.9vw, 18px);
    min-width: 0; min-height: 0;
  }

  /* Dropzone — premium card with a faded body silhouette behind the
     upload prompt. Communicates "this is where the body photo goes". */
  .ps-cpw-dropzone {
    position: relative;
    display: flex; align-items: center; justify-content: center;
    flex: 1; min-height: 0;
    width: 100%; box-sizing: border-box;
    padding: clamp(14px, 1.2vw, 26px);
    border: 1.5px dashed var(--ps-border-color);
    border-radius: clamp(10px, 0.75vw, 16px);
    background:
      radial-gradient(ellipse at 50% 60%, rgba(33, 84, 239, 0.05) 0%, transparent 70%),
      var(--ps-bg-secondary);
    color: var(--ps-text-muted);
    cursor: pointer; font-family: inherit;
    overflow: hidden;
    transition: border-color 0.22s, background 0.22s, transform 0.22s;
  }
  .ps-cpw-dropzone:hover {
    border-color: var(--ps-accent);
    transform: translateY(-1px);
  }
  .ps-cpw-dropzone:disabled { opacity: 0.6; cursor: default; transform: none; }
  /* Faded body silhouette behind the upload prompt */
  .ps-cpw-dropzone-silhouette {
    position: absolute;
    left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    width: clamp(140px, 14vw, 260px);
    height: auto;
    object-fit: contain;
    opacity: 0.18;
    pointer-events: none;
  }
  .ps-cpw-dropzone-content {
    position: relative;
    z-index: 1;
    display: flex; flex-direction: column; align-items: center;
    gap: clamp(4px, 0.4vw, 10px);
  }
  .ps-cpw-dropzone-upload-icon {
    width: clamp(28px, 2vw, 40px);
    height: clamp(28px, 2vw, 40px);
    color: var(--ps-accent);
    margin-bottom: clamp(2px, 0.2vw, 6px);
  }
  .ps-cpw-dropzone-title {
    font-size: clamp(11px, 0.78vw, 14px);
    font-weight: 600;
    color: var(--ps-text-primary);
    text-align: center;
  }
  .ps-cpw-dropzone-hint {
    font-size: clamp(9px, 0.62vw, 12px);
    color: var(--ps-text-muted);
    letter-spacing: 0.04em;
  }

  /* Photo preview frame (after upload) */
  .ps-cpw-photo-preview-frame {
    position: relative;
    flex: 1; min-height: 0;
    width: 100%;
    background: var(--ps-bg-secondary);
    border-radius: clamp(10px, 0.75vw, 16px);
    overflow: hidden;
    border: 1px solid var(--ps-border-subtle);
    display: flex; align-items: center; justify-content: center;
  }
  .ps-cpw-photo-preview-img {
    width: 100%; height: 100%;
    object-fit: contain;
    display: block;
  }
  .ps-cpw-photo-retake-pill {
    position: absolute;
    bottom: clamp(8px, 0.7vw, 14px);
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255,255,255,0.95);
    border: 1px solid var(--ps-border-subtle);
    color: var(--ps-text-primary);
    padding: clamp(6px, 0.55vw, 12px) clamp(12px, 1vw, 20px);
    border-radius: 999px;
    font-family: inherit;
    font-size: clamp(10px, 0.7vw, 13px);
    font-weight: 600;
    cursor: pointer;
    backdrop-filter: blur(6px);
    transition: background 0.22s, color 0.22s;
  }
  .ps-cpw-photo-retake-pill:hover {
    background: var(--ps-accent);
    color: #FFFFFF;
    border-color: var(--ps-accent);
  }
  .ps-cpw-photo-remove {
    position: absolute;
    top: clamp(8px, 0.7vw, 14px);
    right: clamp(8px, 0.7vw, 14px);
    width: clamp(24px, 1.8vw, 34px);
    height: clamp(24px, 1.8vw, 34px);
    border-radius: 50%;
    background: rgba(28, 29, 30, 0.7);
    color: #FFFFFF;
    border: none;
    cursor: pointer;
    font-size: clamp(14px, 1.1vw, 18px);
    font-weight: 600;
    display: flex; align-items: center; justify-content: center;
    backdrop-filter: blur(6px);
    transition: background 0.18s;
  }
  .ps-cpw-photo-remove:hover { background: rgba(28, 29, 30, 0.9); }

  /* Photo guide checklist — soft tinted card on the right column */
  .ps-cpw-photo-guide {
    background: var(--ps-bg-secondary);
    border: 1px solid var(--ps-border-subtle);
    border-radius: clamp(10px, 0.75vw, 16px);
    padding: clamp(12px, 1vw, 20px) clamp(14px, 1.1vw, 22px);
    display: flex; flex-direction: column;
    gap: clamp(6px, 0.55vw, 12px);
    margin-top: auto;
  }
  .ps-cpw-photo-guide-title {
    font-size: clamp(9px, 0.62vw, 11px);
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--ps-text-primary);
  }
  .ps-cpw-photo-guide-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex; flex-direction: column;
    gap: clamp(4px, 0.4vw, 10px);
  }
  .ps-cpw-photo-guide-list li {
    display: flex; align-items: flex-start;
    gap: clamp(6px, 0.55vw, 12px);
    font-size: clamp(10px, 0.72vw, 13px);
    line-height: 1.45;
    color: var(--ps-text-secondary);
  }
  .ps-cpw-photo-guide-list li svg {
    flex-shrink: 0;
    width: clamp(12px, 0.9vw, 16px);
    height: clamp(12px, 0.9vw, 16px);
    color: var(--ps-accent);
    margin-top: 0.15em;
  }
  .ps-cpw-photo-frame-img {
    width: 100%; height: 100%;
    object-fit: contain;
    display: block;
  }
  .ps-cpw-photo-retake {
    align-self: center;
    padding: clamp(8px, 0.7vw, 14px) clamp(16px, 1.4vw, 28px);
    border-radius: 999px;
    background: transparent;
    color: var(--ps-accent);
    border: 2px solid var(--ps-accent);
    font-weight: 700;
    font-size: clamp(10px, 0.7vw, 13px);
    text-transform: uppercase; letter-spacing: 0.08em;
    cursor: pointer; font-family: inherit;
    transition: background 0.18s;
  }
  .ps-cpw-photo-retake:hover { background: rgba(33, 84, 239, 0.08); }

  /* ── Age-gate overlay on the dropzone ──
     Dropzone stays visible but blurred; overlay shows a premium card
     with the 18+ confirmation question and two pill buttons. */
  .ps-cpw-dropzone-wrap {
    position: relative;
    flex: 1; min-height: 0;
    width: 100%; box-sizing: border-box;
    display: flex; flex-direction: column;
  }
  .ps-cpw-dropzone-blurred {
    filter: blur(6px) saturate(0.7);
    pointer-events: none;
    user-select: none;
  }
  .ps-cpw-age-gate {
    position: absolute; inset: 0;
    display: flex; align-items: center; justify-content: center;
    padding: clamp(12px, 1vw, 24px);
    border-radius: clamp(10px, 0.75vw, 16px);
    background: rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 2;
    animation: ps-cpw-age-gate-in 0.28s ease-out both;
  }
  @keyframes ps-cpw-age-gate-in {
    0%   { opacity: 0; transform: scale(0.97); }
    100% { opacity: 1; transform: scale(1); }
  }
  .ps-cpw-age-gate-card {
    width: 100%; max-width: clamp(240px, 24vw, 420px);
    padding: clamp(16px, 1.4vw, 28px) clamp(18px, 1.6vw, 32px);
    background: #FFFFFF;
    border: 1px solid var(--ps-border-subtle);
    border-radius: clamp(10px, 0.9vw, 18px);
    box-shadow: 0 20px 40px -12px rgba(17, 24, 39, 0.25),
                0 8px 16px -8px rgba(17, 24, 39, 0.15);
    display: flex; flex-direction: column;
    align-items: center; text-align: center;
    gap: clamp(8px, 0.7vw, 14px);
  }
  .ps-cpw-age-gate-eyebrow {
    font-size: clamp(9px, 0.62vw, 11px);
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-cpw-age-gate-eyebrow-blocked { color: #C02626; }
  .ps-cpw-age-gate-question {
    font-size: clamp(13px, 0.95vw, 18px);
    font-weight: 600;
    line-height: 1.35;
    color: var(--ps-text-primary);
    margin: 0;
  }
  .ps-cpw-age-gate-actions {
    display: flex; gap: clamp(8px, 0.65vw, 14px);
    width: 100%;
    margin-top: clamp(4px, 0.35vw, 8px);
  }
  .ps-cpw-age-gate-btn {
    flex: 1;
    padding: clamp(9px, 0.75vw, 14px) clamp(12px, 1vw, 18px);
    border-radius: 999px;
    font-family: inherit;
    font-size: clamp(11px, 0.78vw, 14px);
    font-weight: 700;
    letter-spacing: 0.02em;
    cursor: pointer;
    transition: transform 0.18s, background 0.18s, border-color 0.18s, color 0.18s;
  }
  .ps-cpw-age-gate-btn:hover { transform: translateY(-1px); }
  .ps-cpw-age-gate-btn-primary {
    background: var(--ps-accent);
    color: #FFFFFF;
    border: 1.5px solid var(--ps-accent);
  }
  .ps-cpw-age-gate-btn-primary:hover { background: color-mix(in srgb, var(--ps-accent) 88%, #000); }
  .ps-cpw-age-gate-btn-secondary {
    background: transparent;
    color: var(--ps-text-primary);
    border: 1.5px solid var(--ps-border-color);
  }
  .ps-cpw-age-gate-btn-secondary:hover {
    background: var(--ps-bg-secondary);
    border-color: var(--ps-text-muted);
  }
  .ps-cpw-age-gate-card-blocked { border-color: rgba(192, 38, 38, 0.35); }

  /* ── Legal notice card on the right column ──
     Soft neutral card with a small shield icon; matches photo-guide width. */
  .ps-cpw-legal-notice {
    background: rgba(33, 84, 239, 0.04);
    border: 1px solid rgba(33, 84, 239, 0.16);
    border-radius: clamp(10px, 0.75vw, 16px);
    padding: clamp(10px, 0.9vw, 18px) clamp(12px, 1vw, 20px);
    display: flex; flex-direction: column;
    gap: clamp(5px, 0.45vw, 10px);
  }
  .ps-cpw-legal-notice-head {
    display: flex; align-items: center;
    gap: clamp(6px, 0.5vw, 10px);
    font-size: clamp(9px, 0.62vw, 11px);
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-cpw-legal-notice-head svg {
    width: clamp(12px, 0.85vw, 15px);
    height: clamp(12px, 0.85vw, 15px);
  }
  .ps-cpw-legal-notice-body {
    margin: 0;
    font-size: clamp(10px, 0.7vw, 12.5px);
    line-height: 1.5;
    color: var(--ps-text-secondary);
  }

  .ps-cpw-hint {
    font-size: clamp(10px, 0.72vw, 13px);
    line-height: 1.6;
    color: var(--ps-text-muted);
    margin: clamp(4px, 0.4vw, 10px) 0 0;
    padding: clamp(8px, 0.7vw, 14px) clamp(10px, 0.85vw, 16px);
    background: rgba(33, 84, 239, 0.05);
    border-left: 3px solid var(--ps-accent);
    border-radius: clamp(4px, 0.35vw, 8px);
  }

  /* ════════════════════════════════════════════════════════════════
     ProfileMeasurementsView (.ps-pmv-*) — minimal monoline-icon
     redesign. Two-column body: silhouette diagram on the left,
     basics + measurements list (each with an inline line-art icon)
     on the right. No avatar, no card boxes — just typography, icons
     and a body diagram, all vw/clamp scaled.
     ════════════════════════════════════════════════════════════════ */
  .ps-pmv-root {
    display: flex; flex-direction: column;
    gap: clamp(14px, 1.3vw, 28px);
    padding: clamp(2px, 0.25vw, 6px) clamp(2px, 0.25vw, 6px) 0;
  }

  /* Hero — name + eyebrow only, no avatar */
  .ps-pmv-hero {
    display: flex; flex-direction: column;
    gap: clamp(4px, 0.35vw, 10px);
    padding-bottom: clamp(10px, 0.95vw, 20px);
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-pmv-hero-eyebrow {
    font-size: clamp(9px, 0.6vw, 12px); font-weight: 700;
    letter-spacing: 0.18em; text-transform: uppercase;
    color: var(--ps-accent);
  }
  .ps-pmv-hero-name {
    font-size: clamp(18px, 1.5vw, 32px); font-weight: 700;
    color: var(--ps-text-primary);
    margin: 0;
    letter-spacing: -0.01em;
    line-height: 1.1;
  }

  /* Full-width data column (body diagram removed) */
  .ps-pmv-data {
    display: flex; flex-direction: column;
    gap: max(14px, 1.2vw);
    min-width: 0; width: 100%;
    padding-bottom: clamp(78px, 5.4vw, 104px);
  }

  /* Basics list — height / weight / age, inline icon + label + value */
  .ps-pmv-basics {
    display: flex; flex-direction: column;
    gap: clamp(6px, 0.55vw, 14px);
    padding-bottom: clamp(10px, 0.9vw, 18px);
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-pmv-basic-row {
    display: flex; align-items: center;
    gap: max(8px, 0.7vw);
  }
  .ps-pmv-basic-icon {
    flex-shrink: 0;
    width: max(24px, 1.6vw);
    height: max(24px, 1.6vw);
    display: inline-flex; align-items: center; justify-content: center;
  }
  .ps-pmv-basic-icon img {
    width: 100%; height: 100%; object-fit: contain; display: block;
  }
  .ps-pmv-basic-label {
    flex: 1; min-width: 0;
    font-size: clamp(9px, 0.65vw, 12px);
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-pmv-basic-value {
    font-size: clamp(13px, 0.95vw, 18px);
    font-weight: 700;
    color: var(--ps-text-primary);
    font-feature-settings: "tnum" 1;
    text-align: right;
  }

  /* Section blocks (BODY MEASUREMENTS) */
  .ps-pmv-section {
    display: flex; flex-direction: column;
    gap: clamp(8px, 0.7vw, 16px);
  }
  .ps-pmv-section-head {
    display: flex; flex-direction: column; gap: clamp(2px, 0.2vw, 6px);
  }
  .ps-pmv-section-title {
    font-size: clamp(9px, 0.65vw, 12px);
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--ps-text-primary);
  }
  .ps-pmv-section-title-row {
    display: flex; align-items: center; justify-content: space-between;
    gap: clamp(8px, 0.7vw, 14px);
  }
  .ps-pmv-loading-pill {
    display: inline-flex; align-items: center;
    gap: clamp(4px, 0.4vw, 10px);
    padding: clamp(3px, 0.3vw, 7px) clamp(7px, 0.6vw, 14px);
    background: rgba(33, 84, 239, 0.08);
    color: var(--ps-accent);
    border-radius: 999px;
    font-size: clamp(8px, 0.55vw, 11px);
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .ps-pmv-loading-spinner {
    width: clamp(8px, 0.65vw, 14px);
    height: clamp(8px, 0.65vw, 14px);
    border: 1.5px solid rgba(33, 84, 239, 0.25);
    border-top-color: var(--ps-accent);
    border-radius: 50%;
    animation: ps-pmv-spin 0.8s linear infinite;
  }
  @keyframes ps-pmv-spin {
    to { transform: rotate(360deg); }
  }

  /* Body measurements list — single column, icon + label + value rows */
  .ps-pmv-measure-list {
    display: flex; flex-direction: column;
  }
  .ps-pmv-measure-row {
    display: flex; align-items: center;
    gap: clamp(8px, 0.7vw, 16px);
    padding: clamp(8px, 0.7vw, 14px) 0;
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-pmv-measure-row:last-child { border-bottom: none; }
  .ps-pmv-measure-icon {
    flex-shrink: 0;
    width: max(26px, 1.8vw);
    height: max(26px, 1.8vw);
    display: inline-flex; align-items: center; justify-content: center;
  }
  .ps-pmv-measure-icon img {
    width: 100%; height: 100%; object-fit: contain; display: block;
  }
  .ps-pmv-measure-label {
    flex: 1; min-width: 0;
    font-size: clamp(9px, 0.65vw, 12px);
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-pmv-measure-value {
    font-size: clamp(12px, 0.85vw, 16px);
    font-weight: 700;
    color: var(--ps-text-primary);
    font-feature-settings: "tnum" 1;
    text-align: right;
  }
  .ps-pmv-measure-value.ps-loading {
    color: var(--ps-border-color);
    animation: ps-pmv-shimmer 1.4s ease-in-out infinite;
  }
  .ps-pmv-measure-row.ps-loading .ps-pmv-measure-icon,
  .ps-pmv-measure-row.ps-loading .ps-pmv-measure-label {
    opacity: 0.55;
  }
  @keyframes ps-pmv-shimmer {
    0%, 100% { opacity: 0.5; }
    50%      { opacity: 1; }
  }

  /* Inline measurement edit inputs */
  .ps-pmv-measure-row.ps-editing {
    background: rgba(33, 84, 239, 0.04);
  }
  .ps-pmv-measure-edit {
    display: flex; align-items: baseline;
    gap: clamp(2px, 0.2vw, 6px);
  }
  .ps-pmv-measure-input {
    width: clamp(40px, 3vw, 70px);
    background: transparent;
    border: none;
    border-bottom: 1px solid var(--ps-border-color);
    outline: none;
    font-family: inherit;
    font-size: clamp(12px, 0.85vw, 16px);
    font-weight: 700;
    color: var(--ps-text-primary);
    padding: clamp(2px, 0.15vw, 4px) 0;
    text-align: right;
    font-feature-settings: "tnum" 1;
  }
  .ps-pmv-measure-input:focus {
    border-bottom-color: var(--ps-accent);
  }
  .ps-pmv-measure-input::-webkit-outer-spin-button,
  .ps-pmv-measure-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  .ps-pmv-measure-input[type="number"] { -moz-appearance: textfield; }
  .ps-pmv-measure-input-unit {
    font-size: clamp(8px, 0.55vw, 11px);
    color: var(--ps-text-muted);
    font-weight: 500;
  }

  /* Inline-editable value wrapper */
  .ps-pmv-inline-edit {
    display: inline-flex; align-items: baseline;
    gap: clamp(2px, 0.2vw, 5px);
  }
  /* Input styled to look like a plain text value — only a dashed underline
     reveals that it is editable. On focus the underline turns solid/accent. */
  .ps-pmv-inline-input {
    width: clamp(38px, 3vw, 68px);
    background: transparent;
    border: none;
    border-bottom: 1px dashed color-mix(in srgb, var(--ps-border-color) 60%, transparent);
    outline: none;
    font-family: inherit;
    font-size: clamp(12px, 0.85vw, 16px);
    font-weight: 700;
    color: var(--ps-text-primary);
    padding: clamp(1px, 0.1vw, 3px) 0;
    text-align: right;
    font-feature-settings: "tnum" 1;
    cursor: text;
    transition: border-color 0.15s;
  }
  .ps-pmv-inline-input:hover {
    border-bottom-style: solid;
    border-bottom-color: var(--ps-border-color);
  }
  .ps-pmv-inline-input:focus {
    border-bottom-style: solid;
    border-bottom-color: var(--ps-accent);
  }
  .ps-pmv-inline-input::-webkit-outer-spin-button,
  .ps-pmv-inline-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  .ps-pmv-inline-input[type="number"] { -moz-appearance: textfield; }
  .ps-pmv-inline-unit {
    font-size: clamp(8px, 0.55vw, 11px);
    color: var(--ps-text-muted);
    font-weight: 500;
    user-select: none;
  }
  /* Inline select (bra band/cup) — same dashed underline as inputs */
  .ps-pmv-inline-select {
    background: transparent;
    border: none;
    border-bottom: 1px dashed color-mix(in srgb, var(--ps-border-color) 60%, transparent);
    outline: none;
    font-family: inherit;
    font-size: clamp(12px, 0.85vw, 16px);
    font-weight: 700;
    color: var(--ps-text-primary);
    padding: clamp(1px, 0.1vw, 3px) 0;
    cursor: pointer;
    transition: border-color 0.15s;
    -webkit-appearance: none;
    appearance: none;
    text-align: right;
  }
  .ps-pmv-inline-select:hover {
    border-bottom-style: solid;
    border-bottom-color: var(--ps-border-color);
  }
  .ps-pmv-inline-select:focus {
    border-bottom-style: solid;
    border-bottom-color: var(--ps-accent);
  }

  /* Actions — sticky bottom nav */
  .ps-pmv-actions {
    display: flex; align-items: center; justify-content: space-between;
    gap: clamp(8px, 0.7vw, 14px);
    position: sticky;
    bottom: 0;
    background: color-mix(in srgb, var(--ps-bg-primary) 96%, #FFFFFF);
    border-top: 1px solid var(--ps-border-subtle);
    padding: clamp(10px, 0.8vw, 16px) clamp(4px, 0.35vw, 8px) calc(clamp(10px, 0.8vw, 16px) + env(safe-area-inset-bottom, 0px));
    z-index: 5;
    margin-top: auto;
    box-shadow: 0 -14px 30px -28px rgba(17, 24, 39, 0.35);
  }
  .ps-pmv-actions-right {
    display: flex; align-items: center;
    gap: clamp(6px, 0.5vw, 12px);
  }
  .ps-pmv-btn-secondary,
  .ps-pmv-btn-edit,
  .ps-pmv-btn-delete {
    background: none;
    border: 1px solid var(--ps-border-color);
    border-radius: clamp(4px, 0.35vw, 8px);
    padding: clamp(6px, 0.55vw, 12px) clamp(13px, 1.05vw, 24px);
    font-family: inherit;
    font-size: clamp(9px, 0.65vw, 12px);
    font-weight: 600;
    letter-spacing: 0.08em;
    color: var(--ps-text-secondary);
    cursor: pointer;
    transition: border-color 0.15s, color 0.15s;
  }
  .ps-pmv-btn-secondary:hover,
  .ps-pmv-btn-edit:hover {
    border-color: var(--ps-accent);
    color: var(--ps-accent);
  }
  .ps-pmv-btn-delete:hover {
    border-color: var(--ps-error-color);
    color: var(--ps-error-color);
  }
  .ps-pmv-btn-primary {
    background: var(--ps-accent); color: #FFFFFF;
    border: none;
    border-radius: clamp(4px, 0.35vw, 8px);
    padding: clamp(7px, 0.65vw, 14px) clamp(15px, 1.15vw, 26px);
    font-family: inherit;
    font-size: clamp(9px, 0.65vw, 12px);
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.15s, transform 0.15s, background 0.2s;
    box-shadow: 0 0.3vw 1vw rgba(33, 84, 239, 0.18);
    display: inline-flex; align-items: center;
    gap: clamp(4px, 0.4vw, 10px);
    justify-content: center;
  }
  .ps-pmv-btn-primary:hover:not(:disabled) { opacity: 0.92; }
  .ps-pmv-btn-primary:active:not(:disabled) { transform: scale(0.98); }
  .ps-pmv-btn-primary:disabled {
    background: var(--ps-text-muted);
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.65;
  }
  .ps-pmv-btn-spinner {
    width: clamp(8px, 0.65vw, 14px);
    height: clamp(8px, 0.65vw, 14px);
    border: 1.5px solid rgba(255, 255, 255, 0.35);
    border-top-color: #FFFFFF;
    border-radius: 50%;
    animation: ps-pmv-spin 0.8s linear infinite;
  }

  /* Big product / try-on image */
  .ps-msd-image {
    /* position: relative is required so the absolute children
       (.ps-msr-fit-toggle, .ps-tryon-badge) anchor to the image instead of
       the viewport. Without it the Show Fit pill rendered bottom-left of
       the screen on mobile. */
    position: relative;
    width: 100%; height: 420px;
    border-radius: 12px; overflow: hidden;
    background: var(--ps-bg-secondary);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
  }
  .ps-msd-image-img {
    width: 100%; height: 100%;
    object-fit: contain; display: block;
  }

  .ps-msd-actions {
    position: sticky;
    bottom: -1px;
    z-index: 5;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    margin: auto -16px -18px;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    background: rgba(255,255,255,0.96);
    border-top: 1px solid var(--ps-border-subtle);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
  .ps-msd-action-back {
    flex: 0 0 auto;
    font-size: 13px !important;
    padding: 10px 6px !important;
  }
  .ps-msd-primary-cta {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 16px;
    border: 0;
    border-radius: 10px;
    background: var(--ps-accent);
    color: #fff;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
  }
  .ps-msd-primary-cta.ps-compact {
    flex: 0 0 auto;
    min-width: 88px;
    padding: 10px 14px;
    font-size: 13px;
  }
  .ps-msd-primary-cta:disabled {
    opacity: 0.6;
    cursor: default;
  }
  .ps-msd-result-action-group {
    flex: 1 1 0;
    justify-content: flex-end;
  }
  .ps-msd-result-action-group .ps-tryon-v2-cta {
    flex: 1 1 0;
    min-width: 0;
  }

  /* SUGGESTED SIZE card */
  .ps-msd-card {
    background: var(--ps-bg-primary);
    border: 1px solid var(--ps-border-subtle);
    border-radius: 12px;
    padding: 22px 22px 18px;
    display: flex; flex-direction: column; gap: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  }
  .ps-msd-card-eyebrow {
    font-size: 10px; font-weight: 700;
    letter-spacing: 0.16em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-msd-card-size-row {
    display: flex; align-items: baseline; gap: 12px;
    margin-top: 2px;
  }
  .ps-msd-card-size {
    font-size: 56px; font-weight: 700;
    color: var(--ps-text-primary);
    line-height: 1; letter-spacing: -0.02em;
    font-feature-settings: "tnum" 1;
  }
  .ps-msd-card-size-meta {
    font-size: 12px; font-weight: 600;
    letter-spacing: 0.05em;
    color: var(--ps-text-muted);
  }
  /* Mobile: long labels like "MISSY 12 / Standard" wrap to a second line
     at 36 px in a ~280 px card. Drop further to 28 px and let the size
     pill take the full card width so wrapping doesn't strand the meta
     value awkwardly to the side. */
	  @media (max-width: 768px) {
	    .ps-msd-card-size {
	      font-size: 28px;
	      letter-spacing: -0.015em;
	      line-height: 1.1;
	    }
	    .ps-msd-card-size-meta { font-size: 11px; }
	  }
	  .ps-msd-card-divider {
	    height: 1px; background: var(--ps-border-subtle);
	    margin: 6px 0;
	  }
	  .ps-msd-card-note {
	    font-size: 11px; color: var(--ps-text-muted);
	    line-height: 1.5; margin: 2px 0 0;
	  }
	  /* MEASUREMENT BLUEPRINT — rich rows with number, description, USER/SIZE
     labeled values, status badge with check icon */
  .ps-msd-blueprint {
    display: flex; flex-direction: column; gap: 6px;
    padding-top: 6px;
  }
  .ps-msd-blueprint-title {
    font-size: 13px; font-weight: 800;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--ps-text-primary);
    margin-bottom: 0;
  }
  .ps-msd-blueprint-underline {
    width: 36px; height: 2px;
    background: var(--ps-text-primary);
    margin-bottom: 8px;
  }
  .ps-msd-rows {
    display: flex; flex-direction: column;
  }
  .ps-msd-row {
    display: flex; flex-direction: column;
    padding: 22px 0 24px;
    border-bottom: 1px solid var(--ps-border-subtle);
  }
  .ps-msd-row:last-child { border-bottom: none; }
  .ps-msd-row-num {
    font-size: 11px; font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--ps-text-primary);
    margin-bottom: 4px;
  }
  .ps-msd-row-desc {
    font-size: 12px; font-weight: 400;
    color: var(--ps-text-muted);
    margin: 0 0 14px;
    line-height: 1.5;
  }
  .ps-msd-row-cells {
    display: flex; justify-content: space-between; align-items: flex-end;
    gap: 16px; margin-bottom: 14px;
  }
  .ps-msd-row-cell {
    display: flex; flex-direction: column; gap: 4px;
    min-width: 0;
  }
  .ps-msd-row-cell.ps-right { text-align: right; }
  .ps-msd-cell-label {
    font-size: 9px; font-weight: 600;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--ps-text-muted);
  }
  .ps-msd-cell-value {
    font-size: 18px; font-weight: 700;
    color: var(--ps-text-primary);
    font-feature-settings: "tnum" 1;
    line-height: 1.1;
  }
  .ps-msd-row-badge {
    align-self: flex-end;
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 10px; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    white-space: nowrap;
  }
  .ps-msd-row-badge svg { flex-shrink: 0; }
  .ps-msd-row-badge.ps-good {
    color: var(--ps-accent);
  }
  .ps-msd-row-badge.ps-tight {
    color: #dc2626;
  }
  .ps-msd-row-badge.ps-loose {
    color: #d97706;
  }

  /* TRY ANOTHER SIZE picker */
  .ps-msd-sizes {
    display: flex; flex-direction: column; gap: 10px;
    padding-top: 18px;
  }
  .ps-msd-sizes-label {
    font-size: 11px; font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--ps-text-muted);
    text-align: center;
  }
  .ps-msd-sizes-pills {
    display: flex; flex-wrap: wrap; gap: 8px;
    justify-content: center;
  }
  .ps-msd-size-pill {
    min-width: 48px;
    max-width: 100%;
    padding: 10px 14px;
    background: transparent;
    border: 1.5px solid var(--ps-border-color);
    border-radius: 8px;
    font-family: inherit; font-size: 13px; font-weight: 600;
    color: var(--ps-text-primary);
    cursor: pointer;
    transition: all 0.15s;
    /* Long compound labels like "MISSY 8 / Standard" need to wrap or
       shrink rather than overflow the row. */
    white-space: normal;
    line-height: 1.2;
    word-break: keep-all;
  }
  @media (max-width: 768px) {
    .ps-msd-size-pill { font-size: 12px; padding: 9px 11px; min-width: 0; }
  }
  .ps-msd-size-pill:hover {
    border-color: var(--ps-accent);
  }
  .ps-msd-size-pill.ps-active {
    background: var(--ps-accent); color: #FFFFFF;
    border-color: var(--ps-accent);
  }

  /* Bottom action area — Next button + tab bar grouped together,
     pushed to the bottom of the modal body by .ps-bpm-spacer above. */
  .ps-bpm-bottom {
    display: flex; flex-direction: column;
    margin: 0 -16px;
    border-top: 1px solid var(--ps-border-subtle);
    background: var(--ps-bg-primary);
    flex-shrink: 0;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .ps-bpm-next-btn {
    margin: max(14px, 3.5vw) max(16px, 4.1vw) max(12px, 3vw);
    padding: max(14px, 3.5vw) max(18px, 4.6vw);
    background: var(--ps-accent); color: #FFFFFF;
    border: none; border-radius: max(10px, 2.5vw);
    font-family: inherit; font-size: max(14px, 3.6vw); font-weight: 700;
    cursor: pointer; transition: opacity 0.15s, transform 0.15s;
    letter-spacing: 0.02em;
  }
  .ps-bpm-next-btn:active { transform: scale(0.98); }
  .ps-bpm-next-btn:disabled { opacity: 0.4; cursor: not-allowed; }
  .ps-bpm-bottom-tabs {
    display: flex; align-items: stretch;
    border-top: 1px solid var(--ps-border-subtle);
    background: var(--ps-bg-primary);
  }
  .ps-bpm-bottom-tab {
    flex: 1; background: none; border: none;
    padding: max(14px, 3.5vw) max(8px, 2vw) max(12px, 3vw);
    font-family: inherit; font-size: max(10px, 2.5vw); font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--ps-text-muted); cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: color 0.15s, border-color 0.15s;
    display: flex; align-items: center; justify-content: center; gap: max(6px, 1.5vw);
  }
  .ps-bpm-bottom-tab.ps-active {
    color: var(--ps-accent);
    border-bottom-color: var(--ps-accent);
  }
  .ps-bpm-bottom-tab svg { width: max(13px, 3.3vw); height: max(13px, 3.3vw); flex-shrink: 0; }

  .ps-bp-optional { font-weight: 400; color: var(--ps-text-muted); }

  /* Bra size step — vertically centered */
  .ps-bp-bra-step { display: flex; flex-direction: column; justify-content: center; flex: 1; }
  .ps-bp-bra-step .ps-bp-title { text-align: center; margin-bottom: 1.5vw; }

  /* Bra size selector */
  .ps-bp-bra-section { margin-bottom: 1.2vw; }
  .ps-bp-bra-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 0.5vw;
  }
  .ps-bp-bra-label {
    font-size: 0.6vw; font-weight: 600; color: rgba(255,255,255,0.45);
    letter-spacing: 0.08em; text-transform: uppercase;
  }
  /* Region dropdown */
  /* ── Photo upload overlay (shown during compress + age-check) ── */
  .ps-bp-photo-overlay {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.92);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.9vw;
    z-index: 10;
    border-radius: inherit;
    backdrop-filter: blur(2px);
    animation: ps-bp-fade 0.18s ease both;
  }
  .ps-bp-photo-overlay-spinner {
    width: 2.2vw;
    height: 2.2vw;
    min-width: 28px;
    min-height: 28px;
    border-radius: 50%;
    border: 2.5px solid rgba(33, 84, 239, 0.18);
    border-top-color: var(--ps-accent);
    animation: ps-bp-spin 0.7s linear infinite;
  }
  @keyframes ps-bp-spin {
    to { transform: rotate(360deg); }
  }
  .ps-bp-photo-overlay-label {
    font-size: max(12px, 0.85vw);
    font-weight: 600;
    color: var(--ps-text-primary);
    letter-spacing: 0.01em;
  }

  /* ── Photo-help popover (Do / Don't / Tip) — desktop default ── */
  .ps-bp-photo-help-backdrop { display: none; }
  .ps-bp-photo-help {
    position: absolute; top: 2.2vw; right: 0;
    width: min(520px, 34vw);
    background: #FFFFFF;
    border: 1px solid var(--ps-border-subtle);
    border-radius: 0.8vw;
    box-shadow: 0 20px 40px -12px rgba(17,24,39,0.25), 0 8px 16px -8px rgba(17,24,39,0.15);
    padding: 0.8vw 1vw;
    display: flex; flex-direction: column; gap: 0.6vw;
    max-height: min(70dvh, 520px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 5;
  }
  .ps-bp-photo-help-upload {
    top: clamp(46px, 3.2vw, 58px);
    left: clamp(12px, 0.85vw, 16px);
    right: auto;
    width: min(620px, calc(100% - clamp(24px, 1.7vw, 32px)));
    max-height: calc(100% - clamp(64px, 4.5vw, 82px));
    overflow-y: auto;
  }
  .ps-bp-photo-help-handle { display: none; }
  .ps-bp-photo-help-header { display: flex; align-items: center; justify-content: space-between; }
  .ps-bp-photo-help-title { font-size: 0.8vw; font-weight: 700; color: var(--ps-text-primary); }
  .ps-bp-photo-help-close {
    width: 1.4vw; height: 1.4vw; border-radius: 50%;
    background: transparent; border: none; color: var(--ps-text-muted);
    cursor: pointer; font-size: 1vw; line-height: 1;
  }
  .ps-bp-photo-help-section { border-radius: 0.5vw; padding: 0.55vw 0.75vw; }
  .ps-bp-photo-help-section-label { font-size: 0.7vw; font-weight: 700; margin-bottom: 0.3vw; }
  .ps-bp-photo-help-section-body { font-size: 0.6vw; color: var(--ps-text-primary); line-height: 1.6; }
  .ps-bp-photo-help-do { background: #ddfbe7; }
  .ps-bp-photo-help-do .ps-bp-photo-help-section-label { color: #1c9d4c; }
  .ps-bp-photo-help-dont { background: #ffe2e2; }
  .ps-bp-photo-help-dont .ps-bp-photo-help-section-label { color: #e7000b; }
  .ps-bp-photo-help-tip {
    background: #c6e1f7; font-size: 0.6vw; line-height: 1.55;
    color: var(--ps-text-primary);
  }
  .ps-bp-photo-help-tip strong { color: #3267c3; }

  /* ── MiniSelect: compact animated dropdown for inline bra inputs ── */
  .ps-bp-mini-select {
    position: relative;
    display: inline-flex;
    width: 100%;
    z-index: 1;
  }
  .ps-bp-mini-select[data-open="true"] {
    z-index: 450;
  }
  .ps-bp-mini-select-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.4vw;
    width: 100%;
    min-width: 4vw;
    padding: 0.45vw 0.7vw;
    background: var(--ps-bg-secondary, #fff);
    border: 1.5px solid rgba(0, 0, 0, 0.12);
    border-radius: 0.4vw;
    color: var(--ps-text-primary);
    font-size: max(11px, 0.78vw);
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: border-color 0.18s, background 0.18s, transform 0.12s;
  }
  .ps-bp-mini-select-trigger:hover {
    border-color: var(--ps-accent);
  }
  .ps-bp-mini-select[data-open="true"] .ps-bp-mini-select-trigger {
    border-color: var(--ps-accent);
    background: rgba(33, 84, 239, 0.04);
  }
  .ps-bp-mini-select-value { display: inline-flex; align-items: center; }
  .ps-bp-mini-select-placeholder {
    color: var(--ps-text-secondary);
    opacity: 0.7;
    font-weight: 500;
  }
  .ps-bp-mini-select-arrow {
    font-size: 0.55vw;
    color: var(--ps-text-secondary);
    transition: transform 0.22s ease;
  }
  .ps-bp-mini-select-arrow.ps-open {
    transform: rotate(180deg);
    color: var(--ps-accent);
  }
  .ps-bp-mini-select-panel {
    position: absolute;
    left: 0;
    right: 0;
    max-height: 9vw;
    overflow-y: auto;
    background: var(--ps-bg-secondary, #fff);
    border: 1.5px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.45vw;
    box-shadow:
      0 0.25vw 0.55vw rgba(15, 23, 42, 0.08),
      0 0.85vw 2.0vw rgba(15, 23, 42, 0.14);
    padding: 0.25vw;
    z-index: 460;
  }
  .ps-bp-mini-select[data-dir="down"] .ps-bp-mini-select-panel {
    top: calc(100% + 0.3vw);
    transform-origin: top center;
    animation: ps-bp-mini-slide-down 0.18s cubic-bezier(0.2, 0.8, 0.4, 1) both;
  }
  .ps-bp-mini-select[data-dir="up"] .ps-bp-mini-select-panel {
    bottom: calc(100% + 0.3vw);
    transform-origin: bottom center;
    animation: ps-bp-mini-slide-up 0.18s cubic-bezier(0.2, 0.8, 0.4, 1) both;
  }
  @keyframes ps-bp-mini-slide-down {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes ps-bp-mini-slide-up {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  .ps-bp-mini-select-item {
    display: block;
    width: 100%;
    padding: 0.45vw 0.7vw;
    background: transparent;
    border: none;
    border-radius: 0.35vw;
    color: var(--ps-text-secondary);
    font-size: max(11px, 0.78vw);
    font-weight: 600;
    font-family: inherit;
    text-align: left;
    cursor: pointer;
    transition: background 0.12s, color 0.12s, transform 0.12s;
  }
  .ps-bp-mini-select-item:hover {
    background: rgba(33, 84, 239, 0.06);
    color: var(--ps-text-primary);
  }
  .ps-bp-mini-select-item.ps-selected {
    background: rgba(33, 84, 239, 0.12);
    color: var(--ps-accent);
  }

  /* Mobile px-based override — desktop rules use vw units which collapse
     to 1–4 px on a 375 px viewport. */
  @media (max-width: 768px) {
    .ps-bp-inline-bra-fields {
      position: relative;
      z-index: 20;
      overflow: visible;
    }
    .ps-bp-inline-bra-fields:has(.ps-bp-mini-select[data-open="true"]) {
      z-index: 2147482400;
    }
    .ps-bp-wrapper:has(.ps-bp-inline-bra-fields .ps-bp-mini-select[data-open="true"]),
    .ps-bp-layout:has(.ps-bp-inline-bra-fields .ps-bp-mini-select[data-open="true"]),
    .ps-bp-root:has(.ps-bp-inline-bra-fields .ps-bp-mini-select[data-open="true"]),
    .ps-bp-scan-details-center:has(.ps-bp-inline-bra-fields .ps-bp-mini-select[data-open="true"]),
    .ps-bp-inline-fields:has(.ps-bp-inline-bra-fields .ps-bp-mini-select[data-open="true"]) {
      overflow: visible !important;
    }
    .ps-bp-inline-bra-fields .ps-bp-inline-row,
    .ps-bp-inline-bra-fields .ps-bp-inline-input-group {
      position: relative;
      overflow: visible;
    }
    .ps-bp-inline-bra-fields .ps-bp-inline-row:has(.ps-bp-mini-select[data-open="true"]),
    .ps-bp-inline-bra-fields .ps-bp-inline-input-group:has(.ps-bp-mini-select[data-open="true"]) {
      z-index: 2147482450;
    }
    .ps-bp-mini-select-trigger {
      padding: 10px 14px;
      font-size: 14px;
      border-radius: 8px;
      gap: 8px;
      min-width: 0;
    }
    .ps-bp-mini-select-arrow { font-size: 10px; }
    .ps-bp-mini-select-panel {
      max-height: min(220px, 38svh);
      border-radius: 10px;
      padding: 4px;
      z-index: 2147482500;
      box-shadow:
        0 4px 12px rgba(15, 23, 42, 0.10),
        0 12px 32px rgba(15, 23, 42, 0.16);
    }
    .ps-bp-mini-select[data-dir="down"] .ps-bp-mini-select-panel { top: calc(100% + 6px); }
    .ps-bp-mini-select[data-dir="up"]   .ps-bp-mini-select-panel { bottom: calc(100% + 6px); }
    .ps-bp-mini-select-item {
      padding: 10px 12px;
      font-size: 14px;
      border-radius: 6px;
    }
  }

  .ps-bp-bra-region-wrap { position: relative; z-index: 100; }
  .ps-bp-bra-region-trigger {
    display: flex; align-items: center; gap: 0.35vw;
    padding: 0.45vw 0.9vw; border: 1.5px solid rgba(0,0,0,0.1);
    border-radius: 0.4vw; background: transparent;
    color: var(--ps-text-secondary); font-size: 0.8vw; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: all 0.25s;
  }
  .ps-bp-bra-region-trigger:hover { border-color: var(--ps-accent); color: var(--ps-accent); }
  .ps-bp-bra-region-arrow {
    font-size: 0.55vw; transition: transform 0.25s;
  }
  .ps-bp-bra-region-arrow.ps-open { transform: rotate(180deg); }
  .ps-bp-bra-region-dropdown {
    position: absolute; top: calc(100% + 0.3vw); right: 0;
    min-width: 5vw; background: var(--ps-bg-secondary);
    border: 1.5px solid rgba(0,0,0,0.08); border-radius: 0.4vw;
    box-shadow: 0 0.5vw 1.5vw rgba(0,0,0,0.5);
    overflow: hidden; animation: ps-bp-fade 0.2s ease both;
    padding: 0.25vw; z-index: 200;
  }
  .ps-bp-bra-region-item {
    display: block; width: 100%; padding: 0.4vw 0.7vw;
    background: transparent; border: none; border-radius: 0.3vw;
    color: var(--ps-text-secondary); font-size: 0.75vw; font-weight: 600;
    cursor: pointer; font-family: inherit; text-align: left;
    transition: all 0.15s;
  }
  .ps-bp-bra-region-item:hover { background: rgba(0,0,0,0.04); color: var(--ps-text-primary); }
  .ps-bp-bra-region-item.ps-selected { color: var(--ps-accent); background: rgba(33,84,239,0.1); }
  .ps-bp-bra-grid {
    display: grid; grid-template-columns: repeat(7, 1fr); gap: 0.35vw;
  }
  .ps-bp-bra-btn {
    padding: 0.4vw 0; text-align: center;
    background: transparent; border: 1px solid rgba(0,0,0,0.08);
    border-radius: 0.35vw; color: var(--ps-text-secondary);
    font-size: 0.65vw; font-weight: 500; cursor: pointer;
    font-family: inherit; transition: all 0.2s;
  }
  .ps-bp-bra-btn:hover { border-color: rgba(0,0,0,0.3); color: var(--ps-text-primary); }
  .ps-bp-bra-btn-selected {
    background: var(--ps-accent) !important; border-color: var(--ps-accent) !important;
    color: #fff !important; font-weight: 700;
  }
  /* Bra inline result — shown in header next to region switcher */
  .ps-bp-bra-inline-result {
    margin-left: auto; font-size: max(11px, 0.75vw); color: var(--ps-accent);
    font-weight: 600; white-space: nowrap;
  }
  .ps-bp-bra-inline-result strong {
    font-weight: 700;
  }

  /* Profile option rows — WAIR style stacked list */
  .ps-bp-options {
    display: flex; flex-direction: column; gap: 0.5vw;
    margin-top: 0.8vw;
  }
  .ps-bp-option {
    display: flex; align-items: center; gap: 0.8vw;
    padding: 0.35vw 1vw 0.35vw 0.35vw;
    background: #fff; border: 1.5px solid rgba(0,0,0,0.06);
    border-radius: 0.6vw; cursor: pointer;
    transition: all 0.25s ease; font-family: inherit;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  }
  .ps-bp-option:hover {
    border-color: rgba(33,84,239,0.5);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    transform: translateY(-1px);
  }
  .ps-bp-option:hover .ps-bp-illust svg { transform: scale(1.05); }
  .ps-bp-option-selected {
    border-color: var(--ps-accent) !important;
    box-shadow: 0 4px 12px rgba(33,84,239,0.18) !important;
  }
  .ps-bp-option-icon {
    width: 6vw; height: 6vw; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    border-radius: 0.4vw; overflow: hidden;
  }
  .ps-bp-illust { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
  .ps-bp-illust svg { width: 100%; height: 100%; transition: transform 0.25s ease; }
  .ps-bp-option-label {
    flex: 1; font-size: 0.73vw; font-weight: 500;
    color: #555; text-align: center;
  }
  .ps-bp-option-selected .ps-bp-option-label { color: var(--ps-accent); font-weight: 600; }
  .ps-bp-option::after {
    content: "›"; font-size: 1.1vw; color: var(--ps-text-secondary); flex-shrink: 0;
    transition: all 0.25s ease;
  }
  .ps-bp-option:hover::after { color: var(--ps-accent); transform: translateX(2px); }
  .ps-bp-option-selected::after { color: var(--ps-accent); }

  /* Single question step — 3 cards centered */
  .ps-bp-single-q { display: flex; flex-direction: column; flex: 1; justify-content: center; align-items: center; }
  .ps-bp-single-q .ps-bp-title { margin-bottom: 1vw; width: 100%; text-align: center; font-size: 1.05vw; font-weight: 700; letter-spacing: 0.01em; }
  .ps-bp-shape-row-full { width: 100%; margin: 1.5vw auto 0; }
  .ps-bp-shape-row-full .ps-bp-img-card { max-height: 18vw; padding: 0.8vw 0.6vw 0; }
  .ps-bp-shape-row-full .ps-bp-img-card-thumb { height: 13vw; }

  /* Body shapes screen — fit all questions without scrolling */
  .ps-bp-shapes-fit { display: flex; flex-direction: column; flex: 1; overflow: hidden; gap: 0.4vw; justify-content: flex-start !important; }

  /* Body shapes combined screen */
  .ps-bp-shape-section {
    margin-bottom: 0.4vw; flex: 1; display: flex; flex-direction: column; min-height: 0;
  }
  .ps-bp-shape-label {
    font-size: 0.55vw; font-weight: 500; color: rgba(255,255,255,0.7);
    margin-bottom: 0.3vw; display: flex; align-items: center; gap: 0.6vw;
    text-transform: uppercase; letter-spacing: 0.05em;
  }
  .ps-bp-shape-label::after {
    content: ""; flex: 1; height: 1px;
    background: linear-gradient(to right, rgba(0,0,0,0.08), transparent);
  }
  .ps-bp-shape-row {
    display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 0.5vw;
    flex: 1; min-height: 0;
  }
  .ps-bp-img-card {
    display: flex; flex-direction: column; align-items: center;
    background: transparent; border: 2px solid rgba(0,0,0,0.08);
    border-radius: 0.5vw; overflow: hidden; cursor: pointer;
    transition: all 0.2s ease; padding: 0; font-family: inherit;
    position: relative;
  }
  .ps-bp-img-card:hover {
    border-color: rgba(33,84,239,0.4);
    transform: translateY(-0.1vw);
  }
  .ps-bp-img-card-selected {
    border-color: var(--ps-accent) !important;
    border-width: 2.5px !important;
  }
  .ps-bp-img-card-selected .ps-bp-img-card-label {
    font-weight: 700; color: var(--ps-accent);
  }
  .ps-bp-img-card-check {
    display: none; position: absolute; top: 0.3vw; right: 0.3vw;
    width: 1.1vw; height: 1.1vw; border-radius: 50%;
    background: var(--ps-accent); align-items: center; justify-content: center;
    z-index: 1;
  }
  .ps-bp-img-card-check svg { width: 0.6vw; height: 0.6vw; }
  .ps-bp-img-card-selected .ps-bp-img-card-check { display: flex; }
  .ps-bp-img-card .ps-bp-img-card-thumb { opacity: 1; }
  .ps-bp-img-card-thumb {
    width: 100%; flex: 1; min-height: 0; overflow: hidden;
    display: flex; align-items: center; justify-content: center;
    background: transparent;
  }
  .ps-bp-img-card-img {
    width: 100%; height: 100%; object-fit: contain;
  }
  .ps-bp-img-card .ps-bp-illust { width: 80%; height: 80%; }
  .ps-bp-img-card .ps-bp-illust svg { width: 100%; height: 100%; }
  .ps-bp-img-card-label {
    padding: 0.3vw 0.2vw; font-size: 0.6vw; font-weight: 600;
    color: var(--ps-text-secondary); text-align: center; width: 100%;
    transition: opacity 0.2s;
  }
  /* Hover hint text below cards */
  .ps-bp-hover-hint {
    text-align: center; font-size: 0.8vw; color: rgba(0,0,0,0.45);
    margin: 0.15vw 0 0; min-height: 1em; transition: opacity 0.2s;
    font-weight: 400; letter-spacing: 0.01em;
  }

  /* Photo upload */
  .ps-bp-photo-upload {
    display: flex; align-items: center; gap: 0.6vw;
    width: 100%; padding: 0.7vw 0.8vw;
    background: transparent; border: 1.5px dashed var(--ps-border-color);
    border-radius: 0.5vw; cursor: pointer;
    transition: all 0.2s; color: var(--ps-text-muted);
    font-family: inherit; text-align: left;
  }
  .ps-bp-photo-upload:hover {
    border-color: var(--ps-accent); background: rgba(33,84,239,0.04);
    color: var(--ps-text-secondary);
  }
  .ps-bp-photo-upload svg { flex-shrink: 0; opacity: 0.6; }
  .ps-bp-photo-upload-text { font-size: 0.78vw; font-weight: 500; }
  .ps-bp-photo-upload-hint { font-size: 0.62vw; color: var(--ps-text-muted); margin-left: auto; }

  .ps-bp-photo-preview {
    display: flex; align-items: center; gap: 0.6vw;
    padding: 0.5vw; border: 1.5px solid var(--ps-accent);
    border-radius: 0.5vw; background: rgba(33,84,239,0.06);
  }
  .ps-bp-photo-thumb {
    width: 2.8vw; height: 2.8vw; object-fit: cover;
    border-radius: 0.4vw; flex-shrink: 0;
  }
  .ps-bp-photo-info { display: flex; flex-direction: column; gap: 0.1vw; flex: 1; min-width: 0; }
  .ps-bp-photo-status {
    font-size: 0.73vw; font-weight: 600; color: var(--ps-text-primary);
    display: flex; align-items: center; gap: 0.3vw;
  }
  .ps-bp-photo-hint { font-size: 0.62vw; color: var(--ps-text-muted); }
  .ps-bp-photo-remove {
    width: 1.5vw; height: 1.5vw; display: flex; align-items: center; justify-content: center;
    background: none; border: none; color: var(--ps-text-muted);
    cursor: pointer; font-size: 1vw; line-height: 1; border-radius: 0.25vw;
    transition: all 0.15s; flex-shrink: 0;
  }
  .ps-bp-photo-remove:hover { background: rgba(0,0,0,0.06); color: var(--ps-text-primary); }

  /* Error */
  .ps-bp-error {
    color: var(--ps-error-color); font-size: 0.73vw; margin: 0;
  }

  /* Photo step → manual measurements escape hatch (desktop only — mobile
     uses MobileBottomTabs). Subtle inline link, sits just above the
     back/analyze nav row. */
  .ps-bp-photo-manual-switch {
    text-align: center; padding: 0.5vw 0 0.3vw;
    font-size: 0.78vw; color: var(--ps-text-muted);
  }
  .ps-bp-photo-manual-link {
    background: none; border: none; padding: 0;
    color: var(--ps-accent); font-weight: 600; cursor: pointer;
    font-size: inherit; font-family: inherit; text-decoration: underline;
    text-underline-offset: 2px;
  }
  .ps-bp-photo-manual-link:hover { color: var(--ps-accent-hover); }

  /* Navigation — back left, next right */
  .ps-bp-nav {
    display: flex; align-items: center; margin-top: auto;
    justify-content: space-between;
  }
  .ps-bp-back-btn {
    background: none; border: none; padding: 0;
    color: var(--ps-text-muted); cursor: pointer;
    font-size: 0.83vw; font-weight: 500; font-family: inherit;
    white-space: nowrap; display: flex; align-items: center; gap: 0.3vw;
    transition: color 0.2s;
  }
  .ps-bp-back-btn:hover { color: var(--ps-text-primary); }
  .ps-bp-back-arrow {
    display: inline-block; font-size: 1.1vw; transition: transform 0.25s ease;
  }
  .ps-bp-back-btn:hover .ps-bp-back-arrow { transform: translateX(-4px); }
  .ps-bp-next-btn {
    display: flex; align-items: center; gap: 0.5vw;
    padding: 0.45vw 1.2vw;
    background: var(--ps-accent); border: none; border-radius: 0.35vw;
    color: #fff; font-size: 0.73vw; font-weight: 700;
    cursor: pointer; transition: all 0.15s; font-family: inherit;
    white-space: nowrap;
  }
  .ps-bp-next-btn svg { width: 0.75vw; height: 0.75vw; }
  .ps-bp-next-btn:hover { background: var(--ps-accent-hover); }
  .ps-bp-btn-disabled {
    opacity: 0.35; cursor: not-allowed; pointer-events: none;
  }

  /* ── Mobile responsive ── */
  @media (max-width: 768px) {
    .ps-bp-layout { flex-direction: column; height: auto; gap: 0; overflow: visible; }
    /* Desktop layout's product image — hidden on mobile because BasicsStepMobile
       has its own minimal layout. The other steps (chest/midsection/hips) don't
       need the giant left-column image on a phone either. */
    .ps-bp-image { display: none !important; }
    .ps-bp-wrapper { overflow-y: auto; -webkit-overflow-scrolling: touch; flex: 1; min-height: 0; display: flex; flex-direction: column; }
    .ps-bp-layout { flex: 1; min-height: 0; }
    /* Override desktop justify-content:center so BasicsStepMobile can
       stretch to the bottom of the modal — its bottom action bar (Next +
       tabs) needs to land at the bottom edge, not floating in the middle. */
    .ps-bp-root {
      justify-content: stretch !important;
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
      flex: 1 !important;
    }
    .ps-bp-upload-placeholder svg { width: 32px; height: 32px; }
    .ps-bp-upload-text { font-size: 14px; }
    .ps-bp-upload-hint { font-size: 11px; }
    .ps-bp-root { padding: 16px; gap: 14px; overflow: visible; }
    .ps-bp-dots { gap: 6px; }
    .ps-bp-dot { width: 6px; height: 6px; }
    .ps-bp-dot-active { width: 18px; border-radius: 4px; }
    .ps-bp-title { font-size: 18px; }
    .ps-bp-subtitle { font-size: 13px; margin-top: -4px; }
    .ps-bp-system-toggle { gap: 20px; margin: 4px 0; }
    .ps-bp-system-btn { font-size: 13px; }
    .ps-bp-inline-row { padding: 14px 0; gap: 12px; }
    .ps-bp-inline-label { flex: 0 0 85px; font-size: 11px; white-space: nowrap; }
    .ps-bp-inline-input { font-size: 18px; }
    .ps-bp-inline-unit { font-size: 12px; }
    .ps-shoe-ref-desktop {
      flex: 1;
      align-items: stretch;
    }
    .ps-shoe-ref {
      gap: 14px;
      padding: 2px 0 0;
    }
    .ps-shoe-stage {
      gap: 14px;
    }
    .ps-shoe-stage.ps-active {
      max-height: 760px;
    }
    .ps-shoe-stage.ps-hidden {
      transform: translateY(8px);
    }
    .ps-shoe-ref-head,
    .ps-shoe-size-head {
      gap: 4px;
    }
    .ps-shoe-ref-kicker {
      font-size: 10px;
      letter-spacing: 0.14em;
    }
    .ps-shoe-ref-title {
      font-size: 17px;
    }
    .ps-shoe-ref-copy {
      font-size: 12px;
    }
    .ps-shoe-brand-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }
    .ps-shoe-brand-card {
      min-height: 54px;
      gap: 9px;
      padding: 9px;
      border-radius: 12px;
    }
    .ps-shoe-brand-logo {
      width: 34px;
      height: 34px;
      border-radius: 9px;
      padding: 6px;
    }
    .ps-shoe-brand-name {
      font-size: 12px;
    }
    .ps-shoe-size-toolbar {
      gap: 12px;
    }
    .ps-shoe-size-controls {
      gap: 8px;
    }
    .ps-shoe-back-brand {
      gap: 6px;
      font-size: 12px;
    }
    .ps-shoe-country-select {
      gap: 7px;
      font-size: 10px;
      letter-spacing: 0.1em;
    }
    .ps-shoe-country-select select {
      min-width: 82px;
      padding: 8px 10px;
      font-size: 12px;
    }
    .ps-shoe-unit-toggle {
      padding: 2px;
    }
    .ps-shoe-unit-toggle button {
      font-size: 11px;
      min-width: 30px;
      padding: 7px 9px;
    }
    .ps-shoe-selected-brand {
      gap: 10px;
      padding: 10px 12px;
      border-radius: 14px;
    }
    .ps-shoe-selected-logo {
      width: 36px;
      height: 36px;
      border-radius: 10px;
      padding: 7px;
    }
    .ps-shoe-selected-brand small {
      font-size: 10px;
    }
    .ps-shoe-selected-brand strong {
      font-size: 14px;
    }
    .ps-shoe-size-panel {
      gap: 10px;
      padding: 12px;
      border-radius: 14px;
    }
    .ps-shoe-size-grid {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 8px;
    }
    .ps-shoe-size-chip {
      min-height: 38px;
      font-size: 13px;
    }
    .ps-shoe-ref-summary {
      gap: 4px;
      padding: 12px;
      border-radius: 14px;
    }
    .ps-shoe-ref-summary span {
      font-size: 10px;
    }
    .ps-shoe-ref-summary strong {
      font-size: 14px;
    }
    .ps-shoe-ref-summary small {
      font-size: 12px;
    }
    .ps-bp-photo-cta { font-size: 13px; gap: 6px; margin-top: 4px; }
    .ps-bp-photo-cta svg { width: 16px; height: 16px; }
    .ps-bp-options { gap: 6px; }
    .ps-bp-option { border-radius: 10px; padding: 6px 12px 6px 6px; gap: 10px; }
    .ps-bp-option-icon { width: 70px; height: 70px; }
    .ps-bp-option-label { font-size: 14px; }
    .ps-bp-option::after { font-size: 18px; }
    .ps-bp-option { padding: 14px 8px; border-radius: 10px; gap: 8px; }
    .ps-bp-option-icon { width: 56px; height: 56px; }
    .ps-bp-option-label { font-size: 13px; }
    .ps-bp-error { font-size: 12px; }
    .ps-bp-shape-section { margin-bottom: 12px; }
    .ps-bp-shape-label { font-size: 13px; margin-bottom: 6px; }
    .ps-bp-shape-row { gap: 6px; }
    .ps-bp-img-card { border-radius: 8px; border-width: 2px; }
    .ps-bp-img-card-label { font-size: 11px; padding: 4px 2px; }
    .ps-bp-hover-hint { font-size: 10px; margin-top: 6px; }
    .ps-bp-single-q .ps-bp-title { font-size: 13px; font-weight: 400; }
    .ps-bp-photo-upload { padding: 10px 12px; gap: 8px; border-radius: 8px; }
    .ps-bp-photo-upload-text { font-size: 13px; }
    .ps-bp-photo-upload-hint { font-size: 10px; }
    .ps-bp-photo-preview { padding: 8px; gap: 8px; border-radius: 8px; }
    .ps-bp-photo-thumb { width: 40px; height: 40px; border-radius: 6px; }
    .ps-bp-photo-status { font-size: 12px; gap: 4px; }
    .ps-bp-photo-hint { font-size: 10px; }
    .ps-bp-photo-remove { width: 22px; height: 22px; font-size: 16px; }
    .ps-bp-wrapper .ps-bsm-root {
      height: 100% !important;
      min-height: 0 !important;
      display: flex !important;
      flex-direction: column !important;
      overflow: hidden !important;
      padding: 18px 6px 0 !important;
    }
    .ps-bp-wrapper .ps-bsm-options-center {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch !important;
      justify-content: center !important;
      padding: 14px 0 18px !important;
    }
    .ps-bp-wrapper .ps-bp-nav {
      position: sticky !important;
      bottom: 0 !important;
      z-index: 80 !important;
      flex: 0 0 auto !important;
      display: grid !important;
      grid-template-columns: minmax(74px, auto) minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 12px !important;
      margin: 0 calc(-1 * var(--ps-mobile-x, 16px)) !important;
      padding: 12px var(--ps-mobile-x, 16px) calc(12px + env(safe-area-inset-bottom)) !important;
      min-height: calc(58px + env(safe-area-inset-bottom)) !important;
      border-top: 1px solid var(--ps-border-subtle) !important;
      background: #fff !important;
      box-shadow: 0 -10px 24px -24px rgba(17, 24, 39, 0.45) !important;
    }
    .ps-bp-wrapper .ps-bp-back-btn {
      justify-self: start !important;
      min-height: 40px !important;
      padding: 0 !important;
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      color: var(--ps-text-secondary) !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      letter-spacing: 0 !important;
    }
    .ps-bp-wrapper .ps-bp-back-arrow { font-size: 18px; }
    .ps-bp-wrapper .ps-bp-next-btn {
      justify-self: end !important;
      min-height: 40px !important;
      min-width: 62px !important;
      padding: 0 14px !important;
      border-radius: 8px !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
    }
    .ps-bp-root { padding: 12px; overflow: hidden; }
    /* Accessory sizing inputs — mobile */
    .ps-acc-input { padding: 3vw; font-size: 3.6vw; border-radius: 2vw; }
    .ps-acc-label { font-size: 2.8vw; margin-bottom: 1.5vw; }
    .ps-acc-field { margin: 3vw 0; }
    .ps-acc-error { font-size: 2.8vw; }
    .ps-acc-hint { font-size: 2.5vw; }
    .ps-tryon-unit-toggle { border-radius: 2vw; }
    .ps-tryon-unit-btn { padding: 2vw 4vw; font-size: 3vw; }
  }

  /* Upload hover overlay */
  .ps-tryon-upload-hover:hover .ps-tryon-upload-hover-overlay { opacity: 1 !important; }

  /* ─────────── Unified PhotoUploadZone ─────────── */
  .ps-photo-zone {
    flex: 1; min-height: 220px;
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    border: 2px dashed var(--ps-border-color);
    border-radius: 0.5vw;
    background: var(--ps-bg-secondary);
    cursor: pointer; position: relative; overflow: hidden;
    transition: border-color 0.18s, background 0.18s, transform 0.18s;
  }
  .ps-photo-zone:hover { border-color: var(--ps-accent); background: rgba(33,84,239,0.02); }
  .ps-photo-zone.ps-photo-zone-drag {
    border-color: var(--ps-accent); border-style: solid;
    background: rgba(33,84,239,0.06);
    transform: scale(1.005);
  }
  .ps-photo-zone.ps-photo-zone-has { border: none; cursor: default; padding: 0; }
  .ps-photo-zone.ps-photo-zone-inline { min-height: 100%; height: 100%; }

  .ps-photo-zone-empty {
    display: flex; flex-direction: column; align-items: center; gap: 0.4vw;
    padding: 1vw; text-align: center; pointer-events: none;
  }
  .ps-photo-zone-title { font-size: 0.85vw; font-weight: 600; color: var(--ps-text-primary); }
  .ps-photo-zone-hint  { font-size: 0.6vw; color: var(--ps-text-muted); line-height: 1.4; max-width: 24vw; }

  .ps-photo-zone-img {
    width: 100%; height: 100%; object-fit: contain;
    display: block; cursor: pointer;
  }
  .ps-photo-zone-hover-overlay {
    position: absolute; inset: 0;
    display: flex; align-items: center; justify-content: center;
    background: rgba(0,0,0,0.4); opacity: 0; transition: opacity 0.2s;
    color: #fff; font-size: 0.8vw; font-weight: 600;
    border-radius: 0.5vw; cursor: pointer;
  }
  .ps-photo-zone:hover .ps-photo-zone-hover-overlay { opacity: 1; }
  .ps-photo-zone-remove {
    position: absolute; top: 0.5vw; right: 0.5vw;
    background: rgba(0,0,0,0.55); color: #fff; border: none; border-radius: 50%;
    width: 24px; height: 24px; min-width: 24px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: background 0.15s;
    z-index: 2;
  }
  .ps-photo-zone-remove:hover { background: rgba(239,68,68,0.85); }

  .ps-photo-zone-processing {
    display: flex; flex-direction: column; align-items: center; gap: 0.5vw;
    padding: 1vw;
  }
  .ps-photo-zone-spinner {
    width: 28px; height: 28px;
    border: 3px solid rgba(33,84,239,0.18);
    border-top-color: var(--ps-accent);
    border-radius: 50%;
    animation: ps-spin 0.7s linear infinite;
  }
  .ps-photo-zone-status { font-size: 0.7vw; color: var(--ps-text-secondary); }

  .ps-photo-zone-rejection {
    display: flex; flex-direction: column; align-items: center; gap: 0.5vw;
    padding: 1vw 1.2vw; max-width: 22vw; text-align: center;
    cursor: default;
  }
  .ps-photo-zone-rejection-icon {
    width: 36px; height: 36px; border-radius: 50%;
    background: rgba(239,68,68,0.12); color: #dc2626;
    display: flex; align-items: center; justify-content: center;
    font-size: 18px; font-weight: 700;
  }
  .ps-photo-zone-rejection-title { font-size: 0.85vw; font-weight: 700; color: var(--ps-text-primary); }
  .ps-photo-zone-rejection-msg   { font-size: 0.65vw; color: var(--ps-text-secondary); line-height: 1.5; }
  .ps-photo-zone-rejection-cta {
    margin-top: 0.3vw; padding: 0.55vw 1vw;
    background: var(--ps-accent); color: #fff; border: none;
    border-radius: 0.4vw; font-family: inherit;
    font-size: 0.7vw; font-weight: 600; cursor: pointer;
    transition: opacity 0.15s;
  }
  .ps-photo-zone-rejection-cta:hover { opacity: 0.9; }

  .ps-photo-zone-error {
    position: absolute; bottom: 0.6vw; left: 0.6vw; right: 0.6vw;
    background: rgba(239,68,68,0.08); color: #dc2626;
    border: 1px solid rgba(239,68,68,0.2); border-radius: 0.4vw;
    padding: 0.4vw 0.6vw; font-size: 0.6vw; line-height: 1.4;
    text-align: center; pointer-events: none;
  }

  @media (max-width: 700px) {
    .ps-photo-zone { min-height: 200px; border-radius: 12px; }
    .ps-photo-zone-title { font-size: 14px; }
    .ps-photo-zone-hint  { font-size: 11px; max-width: 90%; }
    .ps-photo-zone-hover-overlay { font-size: 13px; }
    .ps-photo-zone-status { font-size: 12px; }
    .ps-photo-zone-rejection { max-width: 90%; gap: 8px; padding: 14px; }
    .ps-photo-zone-rejection-title { font-size: 14px; }
    .ps-photo-zone-rejection-msg   { font-size: 12px; }
    .ps-photo-zone-rejection-cta   { font-size: 13px; padding: 10px 16px; border-radius: 8px; }
    .ps-photo-zone-error { font-size: 11px; padding: 8px 10px; border-radius: 8px; }
  }

  /* ════════════════════════════════════════════════════════════════
     Mobile stability pass.
     Keep this block last: older mobile patches above mix vw/px/svh and
     compete with each other. These rules define the final phone layout
     contract for every SDK modal screen.
     ════════════════════════════════════════════════════════════════ */
  @media (max-width: 768px) {
    .ps-tryon-overlay {
      --ps-mobile-x: clamp(14px, 4vw, 18px);
      --ps-mobile-y: clamp(10px, 3vw, 14px);
      --ps-mobile-footer-gap: 72px;
      padding: 0 !important;
      overflow: hidden !important;
      align-items: stretch !important;
      justify-content: stretch !important;
    }

    .ps-tryon-modal,
    .ps-tryon-modal-wide {
      width: 100dvw !important;
      max-width: 100dvw !important;
      height: 100svh !important;
      min-height: 100svh !important;
      max-height: 100svh !important;
      border-radius: 0 !important;
      display: flex !important;
      flex-direction: column !important;
      overflow: hidden !important;
      box-shadow: none !important;
      padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left) !important;
      background: var(--ps-bg-primary) !important;
    }

    .ps-tryon-header {
      min-height: 48px !important;
      padding: 8px var(--ps-mobile-x) !important;
      border-radius: 0 !important;
      flex: 0 0 auto !important;
      gap: 8px !important;
    }
    .ps-tryon-powered-by {
      min-width: 0 !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
    }
    .ps-tryon-close,
    .ps-tryon-header-mobile-menu-btn,
    .ps-tryon-header-icon {
      width: 36px !important;
      height: 36px !important;
      min-width: 36px !important;
      min-height: 36px !important;
    }
    .ps-tryon-close svg,
    .ps-tryon-header-mobile-menu-btn svg,
    .ps-tryon-header-icon svg {
      width: 18px !important;
      height: 18px !important;
    }

    .ps-tryon-body {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      height: auto !important;
      padding: var(--ps-mobile-y) var(--ps-mobile-x) 0 !important;
      overflow: hidden !important;
      display: flex !important;
      flex-direction: column !important;
      background: var(--ps-bg-primary) !important;
    }
    .ps-tryon-body > .ps-tryon-back-btn {
      flex: 0 0 auto !important;
      margin: 0 0 8px !important;
      min-height: 34px !important;
      font-size: 13px !important;
    }
    .ps-tryon-view-enter {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      width: 100% !important;
      overflow: hidden !important;
      display: flex !important;
      flex-direction: column !important;
    }
    .ps-tryon-view-enter > * {
      min-width: 0 !important;
    }

    /* Shared mobile screen primitives */
    .ps-bp-wrapper,
    .ps-bp-root,
    .ps-bp-layout,
    .ps-bpm-root,
    .ps-pm-root,
    .ps-tryon-sr,
    .ps-msr-root,
    .ps-msd-root,
    .ps-msp-root,
    .ps-cpw-root,
    .ps-pmv-root,
    .ps-profile-auth,
    .ps-acc-mobile-wrap,
    .ps-acc-mobile-photo,
    .ps-acc-mobile-details {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }
    .ps-bp-wrapper,
    .ps-bp-root,
    .ps-bpm-root,
    .ps-pm-root,
    .ps-tryon-sr,
    .ps-msr-root,
    .ps-msd-root,
    .ps-msp-root,
    .ps-cpw-root,
    .ps-profile-auth {
      display: flex !important;
      flex-direction: column !important;
      overflow: hidden !important;
    }

    /* Body details / manual flow */
    .ps-bp-layout {
      height: 100% !important;
      overflow: hidden !important;
      gap: 0 !important;
    }
    .ps-bp-root {
      padding: 0 !important;
      gap: 10px !important;
      justify-content: stretch !important;
      max-height: none !important;
    }
    .ps-bpm-root {
      padding: 0 !important;
      gap: 10px !important;
    }
    .ps-bpm-header {
      flex: 0 0 auto !important;
      margin: 0 !important;
      text-align: center !important;
    }
    .ps-bpm-title,
    .ps-bp-scan-details-title {
      font-size: 20px !important;
      line-height: 1.18 !important;
      letter-spacing: 0 !important;
    }
    .ps-bpm-subtitle,
    .ps-bp-scan-details-sub {
      display: block !important;
      margin-top: 6px !important;
      font-size: 12px !important;
      line-height: 1.4 !important;
      color: var(--ps-text-muted) !important;
    }
    .ps-bpm-toggle,
    .ps-bp-system-toggle,
    .ps-accm-toggle {
      flex: 0 0 auto !important;
      margin: 8px auto 10px !important;
      gap: 26px !important;
    }
    .ps-bpm-toggle-btn,
    .ps-bp-system-btn {
      font-size: 13px !important;
      min-height: 30px !important;
      padding: 4px 0 !important;
    }
    .ps-bpm-fields,
    .ps-accm-fields,
    .ps-bp-inline-fields {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch !important;
      padding-bottom: 8px !important;
    }
    .ps-bpm-row,
    .ps-bp-inline-row,
    .ps-accm-row {
      padding: 14px 0 !important;
      gap: 12px !important;
    }
    .ps-bpm-label,
    .ps-bp-inline-label,
    .ps-accm-label {
      font-size: 11px !important;
      letter-spacing: 0.12em !important;
      line-height: 1.25 !important;
    }
    .ps-bpm-value-display {
      font-size: 14px !important;
      line-height: 1.2 !important;
      font-weight: 600 !important;
    }
    .ps-bp-inline-input,
    .ps-accm-input {
      font-size: 19px !important;
      line-height: 1.2 !important;
    }
    .ps-bp-profile-card {
      flex: 0 0 auto !important;
      padding: 8px 10px !important;
      min-height: 0 !important;
      border-radius: 10px !important;
      gap: 8px !important;
      align-items: center !important;
    }
    .ps-bp-profile-card-copy {
      gap: 2px !important;
      min-width: 0 !important;
    }
    .ps-bp-profile-card-eyebrow {
      font-size: 9px !important;
      line-height: 1 !important;
      letter-spacing: 0.12em !important;
    }
    .ps-bp-profile-card-copy strong {
      font-size: 13px !important;
      line-height: 1.1 !important;
      font-weight: 600 !important;
    }
    .ps-bp-profile-card-copy span:last-child {
      display: none !important;
    }
    .ps-bp-profile-card-action {
      min-height: 30px !important;
      padding: 0 10px !important;
      border-radius: 999px !important;
      font-size: 9.5px !important;
      letter-spacing: 0.1em !important;
      white-space: nowrap !important;
    }

    .ps-bpm-spacer {
      flex: 1 1 auto !important;
      min-height: 6px !important;
    }
    .ps-bpm-bottom,
    .ps-msr-bottom,
    .ps-msd-actions,
    .ps-cpw-footer,
    .ps-pmv-actions {
      flex: 0 0 auto !important;
      margin-left: calc(-1 * var(--ps-mobile-x)) !important;
      margin-right: calc(-1 * var(--ps-mobile-x)) !important;
      padding: 10px var(--ps-mobile-x) calc(10px + env(safe-area-inset-bottom)) !important;
      border-top: 1px solid var(--ps-border-subtle) !important;
      background: rgba(255,255,255,0.98) !important;
      box-shadow: 0 -14px 30px -28px rgba(17,24,39,0.35) !important;
      backdrop-filter: blur(10px) !important;
      -webkit-backdrop-filter: blur(10px) !important;
      z-index: 8 !important;
    }
    .ps-bpm-next-btn,
    .ps-pm-primary-btn,
    .ps-msr-tryon-cta,
    .ps-msd-primary-cta,
    .ps-cpw-next-btn,
    .ps-pmv-btn-primary,
    .ps-tryon-v2-cta {
      min-height: 42px !important;
      border-radius: 10px !important;
      font-size: 12px !important;
      line-height: 1.1 !important;
      letter-spacing: 0.08em !important;
      padding: 0 14px !important;
      white-space: nowrap !important;
    }
    .ps-bpm-bottom-tabs {
      min-height: 38px !important;
      margin-left: calc(-1 * var(--ps-mobile-x)) !important;
      margin-right: calc(-1 * var(--ps-mobile-x)) !important;
    }
    .ps-bpm-bottom-tab {
      min-height: 38px !important;
      font-size: 10px !important;
      letter-spacing: 0.12em !important;
    }

    /* AI scan / photo flow */
    .ps-bp-scan-progress {
      flex: 0 0 auto !important;
      padding: 6px 4px 0 !important;
      margin: 0 0 10px !important;
      gap: 6px !important;
    }
    .ps-bp-scan-progress-track {
      gap: 9px !important;
      max-width: calc(100% - 48px) !important;
    }
    .ps-bp-scan-progress-label {
      font-size: 10.5px !important;
      letter-spacing: 0.08em !important;
    }
    .ps-bp-scan-progress-line {
      flex-basis: 28px !important;
    }
    .ps-bp-scan-details-center {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      justify-content: flex-start !important;
      overflow-y: auto !important;
      padding: 6px 0 10px !important;
      gap: 10px !important;
    }
    .ps-bp-scan-details-center:not(.ps-shoe-scan-details) .ps-bp-system-toggle {
      margin-top: 14px !important;
      margin-bottom: 8px !important;
    }
    .ps-pm-root {
      padding: 0 !important;
      gap: 10px !important;
    }
    .ps-pm-header {
      flex: 0 0 auto !important;
      margin: 0 !important;
    }
    .ps-pm-title {
      font-size: 18px !important;
      line-height: 1.2 !important;
      margin: 0 0 4px !important;
    }
    .ps-pm-subtitle {
      font-size: 12px !important;
      line-height: 1.4 !important;
      margin: 0 !important;
    }
    .ps-pm-preview {
      flex: 1 1 auto !important;
      min-height: 240px !important;
      max-height: none !important;
      height: auto !important;
      border-radius: 14px !important;
    }
    .ps-bp-scan-progress ~ .ps-pm-root .ps-pm-preview.ps-pm-preview-tall {
      flex: 1 1 auto !important;
      min-height: min(54svh, 330px) !important;
      height: auto !important;
    }
    .ps-pm-preview-img,
    .ps-photo-zone-img,
    .ps-cpw-photo-preview-img,
    .ps-cpw-photo-frame-img {
      object-fit: contain !important;
      object-position: center center !important;
    }
    .ps-pm-age-chip {
      flex: 0 0 auto !important;
      margin: 8px 0 0 !important;
      padding: 9px 11px !important;
    }
    .ps-pm-age-chip-q {
      font-size: 12px !important;
    }
    .ps-pm-age-chip-btn {
      min-height: 30px !important;
      padding: 0 13px !important;
    }
    .ps-pm-checklist,
    .ps-pm-legal-notice,
    .ps-pm-dodonts-grid,
    .ps-pm-dodonts-tip {
      flex: 0 0 auto !important;
    }
    .ps-bp-photo-help {
      max-height: 82svh !important;
      overflow-y: auto !important;
    }

    /* Size result / try-on result mobile */
    .ps-tryon-sr {
      min-height: 0 !important;
    }
    .ps-msr-root,
    .ps-msd-root {
      margin: 0 calc(-1 * var(--ps-mobile-x)) !important;
    }
    .ps-msr-scroll,
    .ps-msd-scroll,
    .ps-msp-scroll,
    .ps-cpw-body,
    .ps-pmv-root {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      -webkit-overflow-scrolling: touch !important;
    }
    .ps-msr-scroll,
    .ps-msd-scroll {
      padding: 8px var(--ps-mobile-x) calc(92px + env(safe-area-inset-bottom)) !important;
      gap: 12px !important;
    }
    .ps-msr-eyebrow {
      font-size: 10px !important;
      margin: 0 !important;
    }
    .ps-msr-product {
      gap: 10px !important;
    }
    .ps-msr-product-img-wrap,
    .ps-msd-image {
      width: 100% !important;
      height: auto !important;
      min-height: 260px !important;
      max-height: 52svh !important;
      aspect-ratio: 3 / 4 !important;
      border-radius: 14px !important;
    }
    .ps-msr-product-img,
    .ps-msd-image-img {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      object-position: center center !important;
    }
    .ps-msr-product-name {
      font-size: 14px !important;
      line-height: 1.25 !important;
    }
    .ps-msr-sections {
      margin-top: 2px !important;
    }
    .ps-msr-section-card {
      min-height: 92px !important;
      padding: 13px 14px !important;
      gap: 6px !important;
    }
    .ps-msr-section-icon-lg {
      width: 42px !important;
      height: 42px !important;
      margin-bottom: 2px !important;
    }
    .ps-msr-section-size {
      font-size: 28px !important;
    }
    .ps-msr-bottom-row,
    .ps-tryon-v2-action-group,
    .ps-msd-result-action-group {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
      gap: 8px !important;
      width: 100% !important;
      align-items: stretch !important;
    }
    .ps-tryon-v2-action-group-history {
      grid-template-columns: minmax(0, auto) !important;
      justify-content: end !important;
    }
    .ps-tryon-v2-action-group > .ps-tryon-v2-cta,
    .ps-msr-commerce-row .ps-tryon-v2-cta,
    .ps-msd-result-action-group .ps-tryon-v2-cta {
      width: 100% !important;
      min-width: 0 !important;
      flex: 1 1 auto !important;
      gap: 6px !important;
      letter-spacing: 0.07em !important;
    }
    .ps-tryon-v2-history-product-cta {
      width: auto !important;
      min-width: 0 !important;
      padding: 0 13px !important;
    }
    .ps-tryon-v2-add-bag-cta svg,
    .ps-tryon-v2-history-product-cta svg {
      width: 17px !important;
      height: 17px !important;
    }
    .ps-msr-media-actions {
      right: 8px !important;
      bottom: 8px !important;
      gap: 6px !important;
    }
    .ps-msr-feedback-slot {
      left: 8px !important;
      bottom: 8px !important;
      max-width: calc(100% - 16px) !important;
    }

    /* Single-section detail */
    .ps-msd-topbar {
      flex: 0 0 auto !important;
      padding: 2px 0 4px !important;
      margin: 0 !important;
    }
    .ps-msd-card {
      padding: 16px !important;
      border-radius: 14px !important;
      gap: 9px !important;
    }
    .ps-msd-card-size-row {
      align-items: center !important;
      gap: 9px !important;
      flex-wrap: wrap !important;
    }
    .ps-msd-card-size {
      font-size: clamp(18px, 5.8vw, 24px) !important;
      font-weight: 600 !important;
      line-height: 1.05 !important;
      overflow-wrap: anywhere !important;
    }
    .ps-msd-row {
      padding: 13px 0 !important;
      gap: 8px !important;
    }
    .ps-msd-row-cells {
      gap: 10px !important;
    }
    .ps-msd-cell-value {
      font-size: 17px !important;
      overflow-wrap: anywhere !important;
    }
    .ps-msd-sizes-pills {
      gap: 8px !important;
    }
    .ps-msd-size-pill {
      min-height: 36px !important;
      padding: 0 12px !important;
      border-radius: 999px !important;
    }
    .ps-msd-actions {
      position: static !important;
      margin: 12px 0 0 !important;
      padding: 10px 0 0 !important;
      border-top: 1px solid var(--ps-border-subtle) !important;
      box-shadow: none !important;
      background: transparent !important;
      backdrop-filter: none !important;
      -webkit-backdrop-filter: none !important;
    }

    /* Product carousel: always compact, always square, never footer-sized. */
    .ps-tryon-photo-strip {
      flex: 0 0 auto !important;
      margin-top: 10px !important;
      gap: 7px !important;
    }
    .ps-tryon-photo-strip-head {
      min-height: 14px !important;
    }
    .ps-tryon-photo-strip-badge {
      font-size: 10px !important;
      letter-spacing: 0.12em !important;
    }
    .ps-tryon-photo-strip-row {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 8px !important;
    }
    .ps-tryon-photo-strip-row.ps-count-1 {
      grid-template-columns: minmax(0, calc((100% - 8px) / 2)) !important;
      justify-content: center !important;
    }
    .ps-tryon-photo-strip-row.ps-count-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      justify-content: stretch !important;
    }
    .ps-tryon-photo-strip-cell {
      aspect-ratio: 1 / 1 !important;
      max-height: 31vw !important;
      border-radius: 11px !important;
    }
    .ps-tryon-photo-strip-cell > img {
      object-fit: cover !important;
      object-position: center center !important;
      width: 100% !important;
      height: 100% !important;
    }

    /* Profile management and auth */
    .ps-msp-scroll {
      padding: 0 !important;
    }
    .ps-msp-home {
      height: auto !important;
      min-height: 100% !important;
      gap: 12px !important;
    }
    .ps-msp-welcome-panel {
      flex: 0 0 auto !important;
      flex-direction: column !important;
      gap: 10px !important;
      padding: 4px 0 12px !important;
    }
    .ps-msp-kicker {
      font-size: 10px !important;
      letter-spacing: 0.12em !important;
    }
    .ps-msp-title {
      font-size: 22px !important;
      line-height: 1.15 !important;
    }
    .ps-msp-subtitle {
      font-size: 12.5px !important;
      line-height: 1.45 !important;
    }
    .ps-msp-header-actions {
      width: 100% !important;
      display: grid !important;
      grid-template-columns: 1fr auto !important;
      gap: 8px !important;
    }
    .ps-msp-primary-create,
    .ps-msp-logout {
      min-height: 38px !important;
      font-size: 12px !important;
      padding: 0 13px !important;
      border-radius: 999px !important;
    }
    .ps-msp-cards-panel,
    .ps-msp-cards-scroll {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      max-height: none !important;
      overflow-y: auto !important;
    }
    .ps-msp-grid {
      grid-template-columns: 1fr !important;
      gap: 12px !important;
      margin: 0 0 14px !important;
    }
    .ps-msp-card {
      padding: 14px !important;
      border-radius: 14px !important;
    }
    .ps-msp-card-circle {
      width: 72px !important;
      height: 72px !important;
      margin: 8px auto 12px !important;
    }
    .ps-msp-card-name {
      font-size: 16px !important;
      line-height: 1.25 !important;
    }
    .ps-msp-meta-label {
      font-size: 10px !important;
    }
    .ps-msp-meta-value {
      font-size: 13px !important;
    }
    .ps-msp-card-actions {
      gap: 8px !important;
    }
    .ps-msp-card-select {
      min-height: 38px !important;
      padding: 0 12px !important;
      font-size: 11px !important;
      border-radius: 9px !important;
    }
    .ps-msp-card-edit,
    .ps-msp-card-delete {
      width: 38px !important;
      height: 38px !important;
      border-radius: 9px !important;
    }
    .ps-profile-auth {
      padding: 0 !important;
      overflow-y: auto !important;
    }
    .ps-profile-auth-shell {
      display: flex !important;
      flex-direction: column !important;
      height: auto !important;
      min-height: 100% !important;
      overflow: visible !important;
    }
    .ps-profile-auth-story,
    .ps-profile-auth-card {
      padding: 14px 0 !important;
      border: 0 !important;
    }
    .ps-profile-auth-story {
      border-bottom: 1px solid var(--ps-border-subtle) !important;
    }
    .ps-profile-auth-visual {
      min-height: 110px !important;
      margin: 0 !important;
    }
    .ps-profile-auth-title {
      font-size: 22px !important;
      line-height: 1.12 !important;
    }
    .ps-profile-auth-copy,
    .ps-profile-auth-card-copy {
      font-size: 12.5px !important;
      line-height: 1.45 !important;
    }
    .ps-profile-auth-icon-row {
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 9px !important;
    }
    .ps-profile-auth-button {
      min-height: 58px !important;
      font-size: 12px !important;
      border-radius: 12px !important;
    }

    /* Profile creation wizard and profile detail */
    .ps-cpw-body {
      padding: 0 !important;
    }
    .ps-cpw-step-head {
      flex: 0 0 auto !important;
      margin: 0 0 10px !important;
    }
    .ps-cpw-step-title,
    .ps-cpw-section-title {
      font-size: 20px !important;
      line-height: 1.2 !important;
    }
    .ps-cpw-section-sub {
      font-size: 12px !important;
      line-height: 1.4 !important;
    }
    .ps-cpw-image-split,
    .ps-cpw-photo-step {
      flex-direction: column !important;
      height: auto !important;
      min-height: 0 !important;
      gap: 12px !important;
      padding: 0 !important;
      overflow-y: auto !important;
    }
    .ps-cpw-image-left,
    .ps-cpw-image-right {
      width: 100% !important;
      min-width: 0 !important;
      min-height: 0 !important;
    }
    .ps-cpw-dropzone,
    .ps-cpw-photo-preview-frame,
    .ps-cpw-photo-preview {
      min-height: 250px !important;
      height: min(48svh, 360px) !important;
      border-radius: 14px !important;
    }
    .ps-cpw-inline-fields .ps-bp-inline-row {
      padding: 11px 0 !important;
    }
    .ps-cpw-pill-row {
      gap: 10px !important;
      flex-wrap: wrap !important;
    }
    .ps-cpw-pill {
      min-height: 34px !important;
      padding: 0 13px !important;
      font-size: 12px !important;
      border-radius: 999px !important;
    }
    .ps-pmv-root {
      height: 100% !important;
      min-height: 0 !important;
      display: flex !important;
      flex-direction: column !important;
      overflow: hidden !important;
      padding: 0 !important;
    }
    .ps-pmv-data {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch !important;
      padding-bottom: 12px !important;
    }
    .ps-pmv-hero {
      flex: 0 0 auto !important;
      padding: 4px 0 12px !important;
    }
    .ps-pmv-section-title-row {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) auto !important;
      align-items: center !important;
      gap: 10px !important;
    }
    .ps-pmv-section-title {
      min-width: 0 !important;
      font-size: 9px !important;
      line-height: 1.2 !important;
      letter-spacing: 0.14em !important;
      white-space: nowrap !important;
    }
    .ps-pmv-section-title-row > .ps-cpw-pill-group {
      width: 154px !important;
      min-width: 154px !important;
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 4px !important;
      padding: 3px !important;
      margin-left: 0 !important;
    }
    .ps-pmv-section-title-row > .ps-cpw-pill-group .ps-cpw-pill {
      min-height: 28px !important;
      width: 100% !important;
      padding: 0 8px !important;
      font-size: 11px !important;
      line-height: 1 !important;
    }
    .ps-pmv-hero-name {
      font-size: 22px !important;
      line-height: 1.15 !important;
    }
    .ps-pmv-measure-row,
    .ps-pmv-basic-row {
      padding: 12px 0 !important;
      gap: 10px !important;
    }
    .ps-pmv-measure-icon,
    .ps-pmv-basic-icon {
      width: 28px !important;
      height: 28px !important;
    }
    .ps-pmv-measure-label,
    .ps-pmv-basic-label {
      font-size: 11px !important;
    }
    .ps-pmv-measure-value,
    .ps-pmv-basic-value,
    .ps-pmv-inline-input,
    .ps-pmv-inline-select {
      font-size: 15px !important;
    }
    .ps-pmv-inline-input {
      width: 54px !important;
    }
    .ps-pmv-actions {
      display: grid !important;
      grid-template-columns: minmax(74px, auto) minmax(0, 1fr) !important;
      align-items: center !important;
      position: sticky !important;
      bottom: 0 !important;
      flex: 0 0 auto !important;
      gap: 12px !important;
      padding: 9px var(--ps-mobile-x) calc(9px + env(safe-area-inset-bottom)) !important;
      min-height: calc(50px + env(safe-area-inset-bottom)) !important;
      border-top: 1px solid var(--ps-border-subtle) !important;
      background: #fff !important;
      box-shadow: 0 -10px 24px -24px rgba(17, 24, 39, 0.45) !important;
      z-index: 80 !important;
    }
    .ps-pmv-actions-right {
      width: 100% !important;
      justify-content: flex-end !important;
      margin-left: 0 !important;
    }
    .ps-pmv-btn-primary,
    .ps-pmv-btn-edit,
    .ps-pmv-btn-delete {
      min-height: 40px !important;
      padding: 0 12px !important;
      border-radius: 10px !important;
      font-size: 11px !important;
      white-space: nowrap !important;
    }
    .ps-pmv-actions > .ps-pmv-btn-secondary {
      justify-self: start !important;
      display: inline-flex !important;
      align-items: center !important;
      gap: 6px !important;
      min-height: 40px !important;
      padding: 0 !important;
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      color: var(--ps-text-secondary) !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
    }
    .ps-pmv-actions > .ps-pmv-btn-secondary::before {
      content: "\\2190";
      font-size: 20px;
      line-height: 1;
      color: currentColor;
    }
    .ps-pmv-actions-right .ps-pmv-btn-primary {
      min-width: 58px !important;
      padding: 0 14px !important;
    }

    /* History drawer = real mobile gallery sheet */
    .ps-tryon-drawer,
    .ps-tryon-history-drawer {
      position: absolute !important;
      inset: 0 !important;
      width: auto !important;
      max-width: none !important;
      height: auto !important;
      max-height: none !important;
      border-radius: 0 !important;
      transform: translateY(100%) !important;
      display: flex !important;
      flex-direction: column !important;
      padding: 0 !important;
      background: var(--ps-bg-primary) !important;
      z-index: 40 !important;
    }
    .ps-tryon-drawer-open {
      transform: translateY(0) !important;
    }
    .ps-tryon-drawer-header {
      flex: 0 0 auto !important;
      min-height: 52px !important;
      padding: 10px var(--ps-mobile-x) !important;
      margin: 0 !important;
      gap: 10px !important;
      border-bottom: 1px solid var(--ps-border-subtle) !important;
    }
    .ps-tryon-drawer-title {
      font-size: 17px !important;
      line-height: 1.25 !important;
      font-weight: 700 !important;
    }
    .ps-tryon-drawer-back,
    .ps-tryon-drawer-close,
    .ps-tryon-drawer-add-btn {
      width: 36px !important;
      height: 36px !important;
      min-width: 36px !important;
      border-radius: 10px !important;
    }
    .ps-tryon-drawer-list {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch !important;
      padding: 14px var(--ps-mobile-x) calc(14px + env(safe-area-inset-bottom)) !important;
      gap: 12px !important;
    }
    .ps-tryon-history-gallery {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 12px !important;
      align-items: start !important;
    }
    .ps-tryon-history-card {
      border-radius: 14px !important;
      overflow: hidden !important;
      background: #FFFFFF !important;
    }
    .ps-tryon-history-card-main {
      padding: 0 !important;
      gap: 8px !important;
      text-align: left !important;
    }
    .ps-tryon-history-card-media {
      width: 100% !important;
      height: auto !important;
      aspect-ratio: 3 / 4 !important;
      border-radius: 13px !important;
      background: #f3f5f9 !important;
    }
    .ps-tryon-history-card-img,
    .ps-tryon-history-card-placeholder {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      object-position: center center !important;
    }
    .ps-tryon-history-card-product {
      width: 38px !important;
      height: 38px !important;
      right: 8px !important;
      bottom: 8px !important;
      object-fit: cover !important;
    }
    .ps-tryon-history-card-title {
      font-size: 12px !important;
      line-height: 1.25 !important;
      padding: 0 2px !important;
    }
    .ps-tryon-history-card-meta,
    .ps-tryon-history-card-sections {
      font-size: 10.5px !important;
      padding: 0 2px !important;
    }
    .ps-tryon-history-card-size {
      margin: 0 2px 2px !important;
      font-size: 16px !important;
    }
    .ps-tryon-history-delete.ps-card-delete {
      top: 8px !important;
      right: 8px !important;
      width: 32px !important;
      height: 32px !important;
      border-radius: 10px !important;
    }
    .ps-tryon-drawer-clear {
      min-height: 40px !important;
      font-size: 12px !important;
      margin-top: 2px !important;
    }

    /* Generic safety: never let long words/labels force horizontal scroll. */
    .ps-tryon-overlay button,
    .ps-tryon-overlay span,
    .ps-tryon-overlay p,
    .ps-tryon-overlay h1,
    .ps-tryon-overlay h2,
    .ps-tryon-overlay h3,
    .ps-tryon-overlay div {
      min-width: 0;
    }
  }

  @media (max-width: 768px) and (max-height: 720px) {
    .ps-tryon-overlay {
      --ps-mobile-y: 8px;
    }
    .ps-bpm-title,
    .ps-bp-scan-details-title {
      font-size: 18px !important;
    }
    .ps-bpm-subtitle,
    .ps-bp-scan-details-sub {
      display: none !important;
    }
    .ps-bpm-toggle,
    .ps-bp-system-toggle,
    .ps-accm-toggle {
      margin: 5px auto 7px !important;
    }
    .ps-bpm-row,
    .ps-bp-inline-row,
    .ps-accm-row {
      padding: 9px 0 !important;
      gap: 8px !important;
    }
    .ps-bpm-value-display {
      font-size: 17px !important;
    }
    .ps-bpm-step-btn {
      width: 30px !important;
      height: 30px !important;
    }
    .ps-bpm-or {
      margin: 6px 0 !important;
    }
    .ps-bpm-upload-link {
      min-height: 76px !important;
      padding: 12px !important;
    }
    .ps-bpm-bottom,
    .ps-msr-bottom,
    .ps-msd-actions,
    .ps-cpw-footer,
    .ps-pmv-actions {
      padding-top: 8px !important;
      padding-bottom: calc(8px + env(safe-area-inset-bottom)) !important;
    }
    .ps-bpm-next-btn,
    .ps-pm-primary-btn,
    .ps-msr-tryon-cta,
    .ps-msd-primary-cta,
    .ps-cpw-next-btn,
    .ps-pmv-btn-primary,
    .ps-tryon-v2-cta {
      min-height: 40px !important;
    }
    .ps-bpm-bottom-tabs {
      min-height: 34px !important;
    }
    .ps-bpm-bottom-tab {
      min-height: 34px !important;
      padding: 6px !important;
    }
  }

  /* Final mobile ergonomics patch: keep body-detail inputs readable, keep
     commerce CTAs from crowding, and give feedback a real mobile sheet. */
  @media (max-width: 768px) {
    .ps-bp-scan-details-title {
      margin: 4px 0 0 !important;
    }
    .ps-bp-scan-details-sub {
      margin: 4px 0 0 !important;
    }
    .ps-bp-scan-details-center:not(.ps-shoe-scan-details) .ps-bp-system-toggle,
    .ps-bp-photo-details-head .ps-bp-system-toggle,
    .ps-bp-system-toggle.ps-bp-system-toggle-compact {
      margin: 6px auto 8px !important;
      gap: 14px !important;
    }
    .ps-bp-photo-details-head {
      align-items: flex-start !important;
      gap: 8px !important;
      padding-bottom: 8px !important;
    }
    .ps-bp-photo-details-head h3 {
      font-size: 16px !important;
      line-height: 1.2 !important;
      padding-top: 3px !important;
    }
    .ps-bp-inline-fields {
      padding-top: 4px !important;
      padding-bottom: 14px !important;
    }
    .ps-bp-inline-row {
      display: grid !important;
      grid-template-columns: minmax(72px, 0.34fr) minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 14px !important;
      padding: 16px 0 !important;
      min-height: 66px !important;
    }
    .ps-bp-inline-label {
      flex-basis: auto !important;
      min-width: 0 !important;
      font-size: 11px !important;
      letter-spacing: 0.13em !important;
    }
    .ps-bp-inline-input-group {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto !important;
      align-items: end !important;
      gap: 8px !important;
      min-width: 0 !important;
      width: 100% !important;
    }
    .ps-bp-inline-row:not(:first-child) .ps-bp-inline-input-group,
    .ps-bp-inline-row .ps-bp-inline-input-group:has(input:only-child) {
      grid-template-columns: minmax(0, 1fr) auto !important;
    }
    .ps-bp-inline-input {
      min-height: 34px !important;
      font-size: 20px !important;
      line-height: 1.2 !important;
      padding-bottom: 7px !important;
      text-align: left !important;
    }
    .ps-bp-inline-unit {
      align-self: center !important;
      font-size: 12px !important;
      line-height: 1 !important;
      padding-bottom: 8px !important;
    }

    .ps-msr-bottom,
    .ps-msd-actions {
      padding-top: 9px !important;
      padding-bottom: calc(9px + env(safe-area-inset-bottom)) !important;
      height: auto !important;
      min-height: 0 !important;
    }
    .ps-tryon-v2-result-actions {
      display: grid !important;
      grid-template-columns: auto minmax(0, 1fr) !important;
      align-items: end !important;
      gap: 10px !important;
      min-height: 0 !important;
      padding-top: 10px !important;
      padding-bottom: calc(10px + env(safe-area-inset-bottom)) !important;
    }
    .ps-tryon-v2-result-actions > .ps-tryon-v2-action-group,
    .ps-tryon-v2-result-actions > .ps-tryon-v2-cta {
      width: 100% !important;
      max-width: none !important;
      flex: 1 1 auto !important;
      margin-left: 0 !important;
    }
    .ps-msr-bottom-row,
    .ps-tryon-v2-action-group,
    .ps-msd-result-action-group {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) !important;
      gap: 9px !important;
      align-items: stretch !important;
      width: 100% !important;
    }
    .ps-tryon-v2-action-group-history {
      display: flex !important;
      justify-content: flex-end !important;
    }
    .ps-tryon-v2-action-group > .ps-tryon-v2-cta,
    .ps-msr-commerce-row .ps-tryon-v2-cta,
    .ps-msd-result-action-group .ps-tryon-v2-cta {
      min-height: 48px !important;
      padding: 0 14px !important;
      border-radius: 11px !important;
      font-size: 13px !important;
      line-height: 1.15 !important;
      letter-spacing: 0.045em !important;
      gap: 8px !important;
      overflow: visible !important;
      text-overflow: clip !important;
      white-space: normal !important;
    }
    .ps-tryon-v2-action-group > .ps-tryon-v2-cta span,
    .ps-msr-commerce-row .ps-tryon-v2-cta span,
    .ps-msd-result-action-group .ps-tryon-v2-cta span {
      min-width: 0 !important;
      overflow: visible !important;
      text-overflow: clip !important;
      white-space: normal !important;
      overflow-wrap: normal !important;
    }
    .ps-tryon-v2-add-bag-cta svg,
    .ps-tryon-v2-history-product-cta svg {
      width: 20px !important;
      height: 20px !important;
      flex: 0 0 auto !important;
    }
    .ps-tryon-v2-history-product-cta {
      width: auto !important;
      min-height: 42px !important;
      padding: 0 13px !important;
      font-size: 12px !important;
      white-space: nowrap !important;
    }
    @media (max-width: 374px) {
      .ps-msr-bottom-row,
      .ps-tryon-v2-action-group,
      .ps-msd-result-action-group {
        grid-template-columns: 1fr !important;
      }
      .ps-tryon-v2-action-group > .ps-tryon-v2-cta,
      .ps-msr-commerce-row .ps-tryon-v2-cta,
      .ps-msd-result-action-group .ps-tryon-v2-cta {
        min-height: 46px !important;
        font-size: 12px !important;
      }
    }

    .ps-tryon-feedback-toggle.ps-mobile {
      min-height: 30px !important;
      padding: 0 10px !important;
      border-radius: 999px !important;
      border-color: rgba(226, 232, 240, 0.95) !important;
      background: rgba(255, 255, 255, 0.96) !important;
      box-shadow: 0 8px 18px rgba(15, 23, 42, 0.14) !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      letter-spacing: 0 !important;
      gap: 6px !important;
    }
    .ps-tryon-feedback-toggle.ps-mobile svg {
      width: 14px !important;
      height: 14px !important;
      stroke-width: 2 !important;
    }
    .ps-tryon-feedback-backdrop.ps-mobile {
      position: fixed !important;
      inset: 0 !important;
      z-index: 2147483000 !important;
      border: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      background: rgba(15, 23, 42, 0.24) !important;
      backdrop-filter: blur(3px) !important;
      -webkit-backdrop-filter: blur(3px) !important;
      cursor: pointer !important;
      animation: ps-feedback-backdrop-in 0.18s ease-out both !important;
    }
    .ps-tryon-feedback-backdrop.ps-mobile.ps-closing {
      pointer-events: none !important;
      animation: ps-feedback-backdrop-out 0.18s ease-in both !important;
    }
    .ps-tryon-feedback.ps-mobile {
      position: fixed !important;
      left: 12px !important;
      right: 12px !important;
      bottom: calc(12px + env(safe-area-inset-bottom)) !important;
      width: auto !important;
      max-width: 520px !important;
      max-height: min(430px, 64svh) !important;
      margin: 0 auto !important;
      z-index: 2147483001 !important;
      padding: 14px !important;
      border-radius: 18px !important;
      gap: 11px !important;
      background: #FFFFFF !important;
      box-shadow: 0 22px 60px rgba(15, 23, 42, 0.28) !important;
      backdrop-filter: none !important;
      -webkit-backdrop-filter: none !important;
      overflow: hidden !important;
      transform-origin: bottom center !important;
      animation: ps-feedback-sheet-in 0.22s cubic-bezier(0.16, 1, 0.3, 1) both !important;
    }
    .ps-tryon-feedback.ps-mobile.ps-closing {
      pointer-events: none !important;
      animation: ps-feedback-sheet-out 0.18s ease-in both !important;
    }
    @keyframes ps-feedback-backdrop-in {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes ps-feedback-backdrop-out {
      from { opacity: 1; }
      to { opacity: 0; }
    }
    @keyframes ps-feedback-sheet-in {
      from { opacity: 0; transform: translateY(18px) scale(0.985); }
      to { opacity: 1; transform: translateY(0) scale(1); }
    }
    @keyframes ps-feedback-sheet-out {
      from { opacity: 1; transform: translateY(0) scale(1); }
      to { opacity: 0; transform: translateY(16px) scale(0.985); }
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-top {
      gap: 10px !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-title {
      font-size: 16px !important;
      line-height: 1.2 !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-close {
      width: 34px !important;
      height: 34px !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-stars {
      gap: 7px !important;
      padding-top: 2px !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-star {
      width: 32px !important;
      height: 32px !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-form {
      grid-template-columns: 1fr auto !important;
      gap: 9px !important;
      align-items: end !important;
      min-height: 0 !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-note {
      min-height: 48px !important;
      max-height: min(120px, 24svh) !important;
      border-radius: 12px !important;
      font-size: 14px !important;
      padding: 12px !important;
      overflow-y: auto !important;
      resize: none !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-submit {
      min-height: 48px !important;
      padding: 0 16px !important;
      border-radius: 12px !important;
      font-size: 13px !important;
    }
  }

  /* Mobile v3 polish layer: scoped to phones only. Keeps desktop untouched
     while normalizing SDK screens into scrollable content + compact footer. */
  @media (max-width: 768px) {
    .ps-tryon-overlay {
      --ps-mobile-x: 16px;
      --ps-mobile-footer-h: 64px;
    }

    /* Shared mobile typography and form rhythm */
    .ps-bpm-title,
    .ps-bp-scan-details-title,
    .ps-cpw-step-title,
    .ps-cpw-section-title,
    .ps-pmv-hero-name,
    .ps-msp-title {
      font-size: 20px !important;
      line-height: 1.18 !important;
      letter-spacing: 0 !important;
    }
    .ps-bpm-subtitle,
    .ps-bp-scan-details-sub,
    .ps-cpw-section-sub,
    .ps-msp-subtitle {
      font-size: 12px !important;
      line-height: 1.38 !important;
    }
    .ps-bpm-toggle,
    .ps-bp-system-toggle,
    .ps-accm-toggle,
    .ps-cpw-pill-group {
      gap: 20px !important;
    }
    .ps-bpm-toggle-btn,
    .ps-bp-system-btn,
    .ps-cpw-pill {
      font-size: 13px !important;
      min-height: 32px !important;
      padding: 4px 0 !important;
    }
    .ps-bp-inline-fields,
    .ps-accm-fields,
    .ps-cpw-inline-fields {
      padding-top: 2px !important;
      padding-bottom: 10px !important;
    }
    .ps-bp-inline-row,
    .ps-accm-row,
    .ps-cpw-inline-fields .ps-bp-inline-row {
      min-height: 56px !important;
      padding: 10px 0 !important;
      gap: 10px !important;
    }
    .ps-bp-inline-label,
    .ps-accm-label,
    .ps-cpw-field-label {
      font-size: 10px !important;
      line-height: 1.2 !important;
      letter-spacing: 0.12em !important;
    }
    .ps-bp-inline-input,
    .ps-accm-input,
    .ps-bpm-value-display,
    .ps-cpw-input {
      font-size: 17px !important;
      line-height: 1.2 !important;
      font-style: normal !important;
      letter-spacing: 0 !important;
    }
    .ps-bp-inline-input::placeholder,
    .ps-accm-input::placeholder,
    .ps-cpw-input::placeholder {
      font-size: 17px !important;
      font-style: normal !important;
      opacity: 0.45 !important;
    }
	    .ps-bp-inline-unit,
	    .ps-accm-unit {
	      font-size: 12px !important;
	      font-weight: 600 !important;
	    }
	    .ps-bpm-value-empty {
	      color: var(--ps-text-muted) !important;
	      opacity: 0.58 !important;
	      font-weight: 650 !important;
	    }

	    /* Body details / accessories: same mobile hierarchy as the hat flow. */
    .ps-accm-root {
      display: flex !important;
      flex-direction: column !important;
      height: 100% !important;
      min-height: 0 !important;
      padding: 0 !important;
    }
    .ps-accm-header {
      padding: 4px var(--ps-mobile-x) 0 !important;
      text-align: center !important;
    }
    .ps-accm-toggle {
      margin: 8px auto 12px !important;
      padding: 0 var(--ps-mobile-x) !important;
    }
    .ps-accm-fields {
      flex: 1 1 auto !important;
      min-height: 0 !important;
      overflow-y: auto !important;
      padding: 0 var(--ps-mobile-x) 12px !important;
    }
    .ps-accm-row {
      grid-template-columns: minmax(74px, 0.34fr) minmax(0, 1fr) !important;
      align-items: center !important;
    }
    .ps-accm-input-group {
      justify-content: flex-end !important;
    }
    .ps-accm-input {
      text-align: right !important;
      max-width: none !important;
    }
    .ps-acc-scan-details {
      justify-content: flex-start !important;
      padding-top: 8px !important;
    }

    /* Animated mobile selector for size-detail country/standard choices. */
    .ps-mobile-choice-select {
      position: relative !important;
      display: inline-flex !important;
      min-width: 92px !important;
      z-index: 20 !important;
      font-family: inherit !important;
    }
    .ps-mobile-choice-trigger {
      width: 100% !important;
      min-height: 36px !important;
      padding: 0 10px !important;
      border: 1px solid rgba(33, 84, 239, 0.18) !important;
      border-radius: 9px !important;
      background: #FFFFFF !important;
      color: var(--ps-text-primary) !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: 8px !important;
      font-family: inherit !important;
      font-size: 12px !important;
      font-weight: 700 !important;
      cursor: pointer !important;
      box-shadow: 0 7px 18px -16px rgba(33,84,239,0.45) !important;
    }
    .ps-mobile-choice-trigger svg {
      width: 16px !important;
      height: 16px !important;
      fill: none !important;
      stroke: currentColor !important;
      stroke-width: 2 !important;
      stroke-linecap: round !important;
      stroke-linejoin: round !important;
      transition: transform 0.16s ease !important;
      flex: 0 0 auto !important;
    }
    .ps-mobile-choice-select[data-open="true"] .ps-mobile-choice-trigger svg {
      transform: rotate(180deg) !important;
    }
    .ps-mobile-choice-menu {
      position: absolute !important;
      left: 0 !important;
      top: calc(100% + 7px) !important;
      min-width: 100% !important;
      width: max-content !important;
      max-width: 210px !important;
      max-height: 212px !important;
      overflow-y: auto !important;
      z-index: 99999 !important;
      padding: 5px !important;
      border: 1px solid rgba(33,84,239,0.14) !important;
      border-radius: 12px !important;
      background: #FFFFFF !important;
      box-shadow: 0 18px 42px -24px rgba(15,23,42,0.42) !important;
      animation: ps-mobile-choice-in 0.16s ease-out both !important;
    }
    @keyframes ps-mobile-choice-in {
      from { opacity: 0; transform: translateY(-4px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .ps-mobile-choice-option {
      width: 100% !important;
      min-height: 34px !important;
      padding: 0 10px !important;
      border: 0 !important;
      border-radius: 8px !important;
      background: transparent !important;
      color: var(--ps-text-primary) !important;
      text-align: left !important;
      font-family: inherit !important;
      font-size: 12px !important;
      font-weight: 650 !important;
      cursor: pointer !important;
      white-space: nowrap !important;
    }
    .ps-mobile-choice-option.ps-selected {
      background: rgba(33,84,239,0.09) !important;
      color: var(--ps-accent) !important;
    }

    /* Size/result detail pages */
    .ps-result-image-action-bar {
      width: 100% !important;
      display: flex !important;
      flex-wrap: nowrap !important;
      gap: 6px !important;
      margin: 0 0 8px !important;
    }
    .ps-result-image-action {
      flex: 1 1 0 !important;
      min-width: 0 !important;
      min-height: 34px !important;
      padding: 0 8px !important;
      border-radius: 8px !important;
      font-size: 11px !important;
      line-height: 1 !important;
      white-space: nowrap !important;
      gap: 5px !important;
    }
    .ps-result-image-action svg {
      width: 14px !important;
      height: 14px !important;
      flex: 0 0 auto !important;
    }
    .ps-msr-scroll,
    .ps-msd-scroll {
      display: flex !important;
      flex-direction: column !important;
      padding: 8px var(--ps-mobile-x) calc(var(--ps-mobile-footer-h) + 14px + env(safe-area-inset-bottom)) !important;
    }
    .ps-msd-topbar {
      min-height: 34px !important;
      padding: 0 0 8px !important;
    }
    .ps-msd-topbar-title {
      font-size: 12px !important;
      letter-spacing: 0.13em !important;
      line-height: 1.2 !important;
    }
    .ps-msd-card {
      padding: 14px 16px !important;
      border-radius: 13px !important;
      gap: 8px !important;
    }
    .ps-msd-card-eyebrow,
    .ps-msd-blueprint-title,
    .ps-msd-sizes-label {
      font-size: 10px !important;
      letter-spacing: 0.14em !important;
    }
    .ps-msd-card-size {
      font-size: clamp(18px, 5.8vw, 22px) !important;
      font-weight: 600 !important;
      line-height: 1.1 !important;
      letter-spacing: 0 !important;
      overflow-wrap: anywhere !important;
    }
    .ps-msd-card-size-meta {
      font-size: 10px !important;
    }
    .ps-msd-row {
      padding: 12px 0 !important;
    }
    .ps-msd-row-num {
      font-size: 11px !important;
      letter-spacing: 0.13em !important;
    }
    .ps-msd-row-desc {
      font-size: 12px !important;
      line-height: 1.35 !important;
    }
    .ps-msd-cell-label {
      font-size: 10px !important;
      letter-spacing: 0.11em !important;
    }
    .ps-msd-cell-value {
      font-size: 17px !important;
      line-height: 1.18 !important;
    }
    .ps-msd-row-badge {
      font-size: 11px !important;
      letter-spacing: 0.11em !important;
    }
    .ps-msd-size-pill {
      min-width: 42px !important;
      min-height: 36px !important;
      padding: 0 12px !important;
      font-size: 13px !important;
    }
    .ps-msd-footer-note {
      font-size: 12px !important;
      line-height: 1.45 !important;
      margin: 14px auto 0 !important;
      max-width: 260px !important;
    }
    .ps-msd-actions,
    .ps-msr-bottom,
    .ps-cpw-footer,
    .ps-pmv-actions {
      position: sticky !important;
      bottom: 0 !important;
      flex: 0 0 auto !important;
      min-height: 0 !important;
      margin: auto calc(-1 * var(--ps-mobile-x)) 0 !important;
      padding: 9px var(--ps-mobile-x) calc(9px + env(safe-area-inset-bottom)) !important;
      border-top: 1px solid var(--ps-border-subtle) !important;
      background: rgba(255,255,255,0.98) !important;
      box-shadow: 0 -14px 32px -30px rgba(17,24,39,0.38) !important;
      backdrop-filter: blur(10px) !important;
      -webkit-backdrop-filter: blur(10px) !important;
      z-index: 30 !important;
    }
    .ps-msd-actions,
    .ps-tryon-v2-result-actions {
      display: grid !important;
      grid-template-columns: auto minmax(0, 1fr) !important;
      align-items: center !important;
      gap: 10px !important;
    }
    .ps-msd-action-back,
    .ps-bp-back-btn,
    .ps-cpw-back-btn,
    .ps-pmv-btn-secondary {
      min-height: 38px !important;
      width: auto !important;
      padding: 0 4px !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      color: var(--ps-text-secondary) !important;
      white-space: nowrap !important;
    }
    .ps-msd-result-action-group,
    .ps-tryon-v2-result-actions > .ps-tryon-v2-action-group,
    .ps-tryon-v2-action-group-single {
      width: auto !important;
      min-width: min(178px, 62vw) !important;
      margin-left: auto !important;
      justify-self: end !important;
      display: flex !important;
      justify-content: flex-end !important;
      gap: 8px !important;
    }
    .ps-tryon-v2-action-group:not(.ps-tryon-v2-action-group-single):not(.ps-tryon-v2-action-group-history) {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
      width: 100% !important;
      gap: 8px !important;
    }
    .ps-tryon-v2-cta,
    .ps-msd-primary-cta,
    .ps-cpw-next-btn,
    .ps-pmv-btn-primary,
    .ps-bpm-next-btn {
      min-height: 42px !important;
      border-radius: 10px !important;
      padding: 0 12px !important;
      font-size: 12px !important;
      line-height: 1.1 !important;
      letter-spacing: 0.07em !important;
      white-space: nowrap !important;
      gap: 7px !important;
    }
    .ps-tryon-v2-cta span {
      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
    }
    .ps-tryon-v2-add-bag-cta svg {
      width: 18px !important;
      height: 18px !important;
    }
    .ps-tryon-v2-cta-secondary {
      background: #FFFFFF !important;
    }

    /* Profile list and profile creation */
    .ps-msp-card-create {
      display: none !important;
    }
    .ps-msp-welcome-panel {
      padding: 2px 0 10px !important;
      gap: 9px !important;
    }
    .ps-msp-header-actions {
      grid-template-columns: minmax(0, 1fr) auto !important;
      align-items: center !important;
      gap: 8px !important;
    }
    .ps-msp-primary-create {
      min-height: 40px !important;
      border-radius: 999px !important;
      font-size: 12px !important;
      letter-spacing: 0.02em !important;
    }
    .ps-msp-logout {
      min-height: 40px !important;
      padding: 0 13px !important;
      border-radius: 999px !important;
      font-size: 12px !important;
      white-space: nowrap !important;
    }
    .ps-msp-card {
      padding: 13px !important;
      border-radius: 13px !important;
    }
    .ps-msp-card-circle {
      width: 68px !important;
      height: 68px !important;
    }

    .ps-cpw-method-grid {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 10px !important;
    }
    .ps-cpw-method-card {
      min-height: 116px !important;
      height: auto !important;
      padding: 14px !important;
      border-radius: 14px !important;
      display: grid !important;
      grid-template-columns: 40px minmax(0, 1fr) 30px !important;
      grid-template-areas:
        "icon eyebrow num"
        "icon title arrow"
        "icon desc arrow" !important;
      align-items: center !important;
      gap: 4px 11px !important;
    }
    .ps-cpw-method-icon-badge {
      grid-area: icon !important;
      width: 38px !important;
      height: 38px !important;
      margin: 0 !important;
    }
    .ps-cpw-method-eyebrow {
      grid-area: eyebrow !important;
      font-size: 9px !important;
      letter-spacing: 0.12em !important;
      margin: 0 !important;
    }
    .ps-cpw-method-title {
      grid-area: title !important;
      font-size: 16px !important;
      line-height: 1.12 !important;
      margin: 0 !important;
    }
    .ps-cpw-method-desc {
      grid-area: desc !important;
      font-size: 11px !important;
      line-height: 1.35 !important;
      max-width: none !important;
    }
    .ps-cpw-method-num {
      grid-area: num !important;
      justify-self: end !important;
      position: static !important;
      font-size: 22px !important;
      line-height: 1 !important;
    }
    .ps-cpw-method-arrow {
      grid-area: arrow !important;
      justify-self: end !important;
      align-self: end !important;
      width: 30px !important;
      height: 30px !important;
    }
    .ps-cpw-photo-step,
    .ps-cpw-image-split {
      display: flex !important;
      flex-direction: column !important;
      gap: 11px !important;
      padding: 0 !important;
      min-height: 0 !important;
      height: auto !important;
    }
    .ps-cpw-dropzone,
    .ps-cpw-photo-preview-frame,
    .ps-cpw-photo-preview {
      height: min(46svh, 330px) !important;
      min-height: 230px !important;
      border-radius: 14px !important;
    }
    .ps-cpw-footer {
      display: grid !important;
      grid-template-columns: auto minmax(0, 1fr) !important;
      gap: 10px !important;
      align-items: center !important;
    }
	    .ps-cpw-footer-no-back {
	      grid-template-columns: minmax(0, 1fr) !important;
	    }

	    .ps-cpw-photo-step {
	      flex: 1 1 auto !important;
	      min-height: 0 !important;
	      height: 100% !important;
	      overflow-y: auto !important;
	      -webkit-overflow-scrolling: touch !important;
	      padding: 0 var(--ps-mobile-x) 10px !important;
	    }
	    .ps-cpw-photo-step > div[aria-hidden="true"] {
	      display: none !important;
	    }
	    .ps-cpw-photo-upload-col,
	    .ps-cpw-photo-details-col {
	      flex: 0 0 auto !important;
	      width: 100% !important;
	      min-width: 0 !important;
	    }
	    .ps-cpw-photo-details-col {
	      gap: 8px !important;
	      padding-top: 2px !important;
	    }
	    .ps-cpw-profile-fields-shell {
	      flex: 1 1 auto !important;
	      min-height: 0 !important;
	      margin-top: 0 !important;
	      margin-bottom: 0 !important;
	      overflow-y: auto !important;
	      overflow-x: visible !important;
	      -webkit-overflow-scrolling: touch !important;
	      padding-bottom: calc(var(--ps-mobile-footer-h, 56px) + 18px + env(safe-area-inset-bottom)) !important;
	    }
	    .ps-cpw-photo-details-col h3 {
	      font-size: 16px !important;
	      line-height: 1.2 !important;
	    }
	    .ps-cpw-photo-details-col p {
	      font-size: 12px !important;
	      line-height: 1.35 !important;
	    }
	    .ps-cpw-photo-details-col .ps-bp-system-toggle {
	      margin: 5px auto 8px !important;
	    }
	    .ps-cpw-photo-details-col .ps-bp-inline-fields {
	      flex: 0 0 auto !important;
	      overflow: visible !important;
	      padding-bottom: 0 !important;
	    }
	    .ps-cpw-photo-details-col .ps-bp-inline-row,
	    .ps-cpw-inline-fields .ps-bp-inline-row {
	      min-height: 54px !important;
	      padding: 10px 0 !important;
	    }
	    .ps-cpw-pill-row {
	      display: grid !important;
	      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
	      gap: 8px !important;
	      width: 100% !important;
	    }
	    .ps-cpw-pill-group {
	      display: grid !important;
	      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
	      gap: 6px !important;
	      width: 100% !important;
	      min-width: 0 !important;
	    }
	    .ps-cpw-pill {
	      width: 100% !important;
	      min-width: 0 !important;
	      padding: 0 6px !important;
	      font-size: 12px !important;
	      white-space: nowrap !important;
	    }
	    .ps-cpw-gender-group {
	      display: inline-flex !important;
	      grid-template-columns: none !important;
	      gap: 6px !important;
	      align-items: center !important;
	      justify-content: flex-end !important;
	      width: auto !important;
	      min-width: 0 !important;
	      margin-left: auto !important;
	    }
	    .ps-cpw-gender-pill {
	      width: auto !important;
	      min-width: 0 !important;
	      min-height: 32px !important;
	      padding: 0 13px !important;
	      font-size: 12px !important;
	      border-radius: 9px !important;
	      white-space: nowrap !important;
	    }

    /* Final mobile footer/dropdown fixes.
       Keep sticky action bars in normal layout, compact the bottom tabs,
       and stop profile scroll content from getting artificial footer space. */
    .ps-tryon-overlay {
      --ps-mobile-footer-h: 56px;
    }
    .ps-pmv-data,
    .ps-cpw-body {
      padding-bottom: calc(var(--ps-mobile-footer-h) + 8px + env(safe-area-inset-bottom)) !important;
    }
    .ps-msp-scroll {
      padding-bottom: 12px !important;
    }
    .ps-bpm-bottom,
    .ps-msr-bottom,
    .ps-msd-actions,
    .ps-cpw-footer,
    .ps-pmv-actions {
      position: sticky !important;
      bottom: 0 !important;
      z-index: 80 !important;
      flex: 0 0 auto !important;
      margin-left: calc(-1 * var(--ps-mobile-x)) !important;
      margin-right: calc(-1 * var(--ps-mobile-x)) !important;
      padding: 8px var(--ps-mobile-x) calc(8px + env(safe-area-inset-bottom)) !important;
      border-top: 1px solid var(--ps-border-subtle) !important;
      background: #FFFFFF !important;
      box-shadow: 0 -10px 24px -24px rgba(17, 24, 39, 0.45) !important;
      backdrop-filter: none !important;
      -webkit-backdrop-filter: none !important;
    }
    .ps-bpm-bottom {
      gap: 5px !important;
      padding-top: 8px !important;
      padding-bottom: max(20px, calc(14px + env(safe-area-inset-bottom))) !important;
    }
    .ps-bpm-bottom-tabs {
      min-height: 34px !important;
      margin: 5px calc(-1 * var(--ps-mobile-x)) 0 !important;
      border-top: 1px solid var(--ps-border-subtle) !important;
    }
    .ps-bpm-bottom-tab {
      min-height: 34px !important;
      padding: 7px 4px 8px !important;
      font-size: 10px !important;
      line-height: 1 !important;
    }
    .ps-bpm-next-btn,
    .ps-pm-primary-btn,
    .ps-msr-tryon-cta,
    .ps-msd-primary-cta,
    .ps-cpw-next-btn,
    .ps-pmv-btn-primary,
    .ps-tryon-v2-cta {
      min-height: 42px !important;
    }
	    .ps-msr-scroll,
	    .ps-msd-scroll {
	      padding-bottom: 10px !important;
	    }
	    .ps-msd-root > .ps-msd-scroll {
	      flex: 1 1 auto !important;
	      min-height: 0 !important;
	      padding-bottom: 12px !important;
	    }
	    .ps-msd-root > .ps-msd-actions {
	      position: static !important;
	      bottom: auto !important;
	      flex: 0 0 auto !important;
	      margin: 0 !important;
	      padding: 8px var(--ps-mobile-x) calc(8px + env(safe-area-inset-bottom)) !important;
	      display: grid !important;
	      grid-template-columns: auto minmax(0, 1fr) !important;
	      align-items: center !important;
	      gap: 10px !important;
	      border-top: 1px solid var(--ps-border-subtle) !important;
	      background: #FFFFFF !important;
	      box-shadow: 0 -10px 24px -24px rgba(17, 24, 39, 0.45) !important;
	      backdrop-filter: none !important;
	      -webkit-backdrop-filter: none !important;
	    }
	    .ps-msd-root > .ps-msd-actions .ps-msd-result-action-group {
	      width: 100% !important;
	      min-width: 0 !important;
	      margin-left: 0 !important;
	      justify-self: stretch !important;
	    }
    .ps-cpw-photo-details-col .ps-bp-inline-fields,
	    .ps-cpw-inline-fields,
	    .ps-bp-inline-input-group {
	      overflow: visible !important;
	    }
	    .ps-cpw-photo-details-col {
	      overflow: visible !important;
	    }
    .ps-cpw-photo-details-col .ps-bp-mini-select {
      z-index: 120 !important;
    }
    .ps-cpw-photo-details-col .ps-bp-mini-select-panel {
      z-index: 2147482500 !important;
      max-height: min(220px, 42svh) !important;
    }
    .ps-cpw-photo-details-col .ps-bp-mini-select[data-dir="up"] .ps-bp-mini-select-panel {
      top: calc(100% + 6px) !important;
      bottom: auto !important;
      transform-origin: top center !important;
      animation: ps-bp-mini-slide-down 0.18s cubic-bezier(0.2, 0.8, 0.4, 1) both !important;
    }
    .ps-cpw-mobile-profile-flow {
      min-height: 0 !important;
    }
    .ps-cpw-mobile-profile-body {
      padding: 0 !important;
      overflow: hidden !important;
    }
    .ps-cpw-mobile-profile-details {
      flex: 0 0 auto !important;
      padding: 8px 0 2px !important;
      gap: 8px !important;
    }
    .ps-cpw-mobile-profile-details .ps-bp-system-toggle {
      margin: 6px auto 8px !important;
    }
    .ps-cpw-mobile-profile-fields {
      flex: 0 0 auto !important;
      overflow: visible !important;
      padding-bottom: 2px !important;
    }
    .ps-cpw-mobile-profile-fields .ps-bp-inline-row {
      min-height: 54px !important;
      padding: 10px 0 !important;
    }
    .ps-cpw-mobile-profile-fields .ps-cpw-height-parts {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto !important;
      align-items: end !important;
      gap: 8px !important;
      min-width: 0 !important;
      width: 100% !important;
    }
    .ps-cpw-mobile-profile-fields .ps-cpw-height-parts .ps-bp-inline-input {
      width: 100% !important;
      min-width: 0 !important;
    }
    .ps-cpw-mobile-profile-fields .ps-bp-mini-select {
      z-index: 120 !important;
    }
    .ps-cpw-mobile-profile-fields .ps-bp-mini-select-panel {
      z-index: 2147482500 !important;
      max-height: min(220px, 42svh) !important;
    }
    .ps-pmv-actions-right {
      margin-left: auto !important;
    }
    .ps-pmv-btn-delete,
    .ps-pmv-btn-use-profile {
      display: none !important;
    }
    .ps-tryon-feedback.ps-mobile {
      bottom: calc(var(--ps-mobile-footer-h) + 16px + env(safe-area-inset-bottom)) !important;
      padding: 13px !important;
      border-radius: 17px !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-form {
      grid-template-columns: minmax(0, 1fr) auto !important;
    }
    .ps-tryon-feedback.ps-mobile .ps-tryon-feedback-note {
      min-width: 0 !important;
    }
    body.ps-tryon-mobile-feedback-open .ps-msd-actions,
    body.ps-tryon-mobile-feedback-open .ps-msr-bottom,
    body.ps-tryon-mobile-feedback-open .ps-tryon-v2-result-actions {
      display: none !important;
    }
    .ps-tryon-v2-add-bag-cta {
      min-height: 38px !important;
      padding: 0 10px !important;
      border-radius: 9px !important;
      font-size: 11px !important;
      line-height: 1.05 !important;
      letter-spacing: 0.055em !important;
      gap: 6px !important;
    }
    .ps-tryon-v2-add-bag-cta svg {
      width: 15px !important;
      height: 15px !important;
      stroke-width: 2 !important;
    }
    .ps-msd-actions,
    .ps-tryon-v2-result-actions {
      grid-template-columns: max-content minmax(0, 1fr) !important;
      gap: 12px !important;
      align-items: center !important;
      width: 100% !important;
    }
    .ps-msd-actions {
      display: flex !important;
      justify-content: space-between !important;
    }
    .ps-msd-actions > .ps-msd-action-back,
    .ps-tryon-v2-result-actions > .ps-bp-back-btn {
      min-height: 34px !important;
      padding: 0 !important;
      gap: 4px !important;
      font-size: 12px !important;
      line-height: 1 !important;
      font-weight: 500 !important;
      justify-self: start !important;
    }
    .ps-msd-actions > .ps-msd-action-back .ps-bp-back-arrow,
    .ps-tryon-v2-result-actions > .ps-bp-back-btn .ps-bp-back-arrow {
      width: 18px !important;
      height: 18px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      transform: none !important;
    }
    .ps-msd-actions > .ps-msd-action-back .ps-bp-back-arrow svg,
    .ps-tryon-v2-result-actions > .ps-bp-back-btn .ps-bp-back-arrow svg {
      width: 18px !important;
      height: 18px !important;
      stroke-width: 2.2 !important;
    }
    .ps-msd-actions > .ps-msd-result-action-group.ps-tryon-v2-action-group {
      flex: 1 1 auto !important;
      width: auto !important;
      min-width: 0 !important;
      max-width: none !important;
      display: flex !important;
      justify-content: flex-end !important;
      justify-self: auto !important;
      margin-left: auto !important;
    }
    .ps-msd-actions .ps-msd-result-action-group,
    .ps-msd-actions .ps-tryon-v2-action-group-single,
    .ps-tryon-v2-result-actions > .ps-tryon-v2-action-group,
    .ps-tryon-v2-result-actions > .ps-tryon-v2-action-group-single {
      width: auto !important;
      min-width: 0 !important;
      max-width: max-content !important;
      margin-left: auto !important;
      justify-self: end !important;
      display: flex !important;
      justify-content: flex-end !important;
    }
    .ps-msd-actions .ps-tryon-v2-add-bag-cta,
    .ps-tryon-v2-result-actions .ps-tryon-v2-add-bag-cta {
      width: max-content !important;
      min-width: 0 !important;
      max-width: min(138px, 40vw) !important;
      min-height: 36px !important;
      padding: 0 12px !important;
      border-radius: 8px !important;
      font-size: 11px !important;
      letter-spacing: 0.03em !important;
      gap: 6px !important;
      white-space: nowrap !important;
    }
    .ps-msd-actions .ps-tryon-v2-add-bag-cta svg,
    .ps-tryon-v2-result-actions .ps-tryon-v2-add-bag-cta svg {
      width: 15px !important;
      height: 15px !important;
      flex: 0 0 auto !important;
    }
    .ps-msd-actions .ps-tryon-v2-add-bag-cta span,
    .ps-tryon-v2-result-actions .ps-tryon-v2-add-bag-cta span {
      min-width: 0 !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
    }

    .ps-bp-style-wrapper {
      min-height: min(680px, calc(100vh - 24px));
      background: #fff;
    }
    .ps-bp-style-stage {
      display: grid;
      grid-template-columns: minmax(280px, 0.86fr) minmax(320px, 1.08fr);
      gap: clamp(16px, 2vw, 28px);
      width: 100%;
      min-height: 0;
      flex: 1 1 auto;
      padding: clamp(18px, 2.2vw, 28px) clamp(18px, 2.4vw, 32px) 86px;
      overflow: hidden;
    }
    .ps-bp-style-anchor,
    .ps-bp-style-list-panel {
      position: relative;
      min-height: 0;
      border-radius: 14px;
      overflow: hidden;
      background: #f3f3f4;
    }
    .ps-bp-style-anchor {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ps-bp-style-anchor-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
      padding: clamp(18px, 3vw, 42px);
    }
    .ps-bp-style-anchor-copy {
      position: absolute;
      left: clamp(18px, 2vw, 26px);
      top: clamp(18px, 2vw, 26px);
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: var(--ps-accent);
      text-transform: uppercase;
      pointer-events: none;
    }
    .ps-bp-style-anchor-title {
      max-width: 180px;
      font-size: clamp(17px, 2.2vw, 28px);
      line-height: 0.9;
      font-weight: 800;
      letter-spacing: 0;
    }
    .ps-bp-style-anchor-rule {
      width: 48px;
      height: 2px;
      margin: 10px 0 8px;
      background: currentColor;
      opacity: 0.85;
    }
    .ps-bp-style-anchor-sub {
      font-size: clamp(10px, 1vw, 12px);
      line-height: 1;
      font-weight: 800;
      letter-spacing: 0.04em;
    }
    .ps-bp-style-list-panel {
      background: #fff;
      border: 1px solid rgba(37, 85, 255, 0.18);
      padding: clamp(16px, 2vw, 26px) clamp(16px, 2.2vw, 30px);
      display: flex;
      flex-direction: column;
    }
    .ps-bp-style-status {
      margin: 0 0 12px;
      color: var(--ps-text-muted);
      font-size: 12px;
      font-weight: 700;
      text-align: right;
    }
    .ps-bp-style-loader {
      min-height: 100%;
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      padding: clamp(28px, 4vw, 54px) clamp(16px, 3vw, 42px);
      text-align: center;
      color: #111827;
    }
    .ps-bp-style-loader-kicker {
      color: var(--ps-accent);
      font-size: clamp(10px, 0.86vw, 12px);
      font-weight: 850;
      letter-spacing: 0.12em;
      line-height: 1;
      text-transform: uppercase;
    }
    .ps-bp-style-loader-title {
      max-width: 260px;
      color: #111827;
      font-size: clamp(18px, 2.1vw, 28px);
      font-weight: 850;
      letter-spacing: 0;
      line-height: 0.95;
      text-transform: uppercase;
    }
    .ps-bp-style-loader-line {
      width: 96px;
      height: 2px;
      overflow: hidden;
      background: rgba(37, 85, 255, 0.14);
    }
    .ps-bp-style-loader-line::before {
      content: "";
      display: block;
      width: 42%;
      height: 100%;
      background: var(--ps-accent);
      animation: ps-style-loader 1.05s ease-in-out infinite;
    }
    .ps-bp-style-loader-muted .ps-bp-style-loader-title {
      font-size: clamp(14px, 1.35vw, 18px);
      line-height: 1.15;
      text-transform: none;
      color: var(--ps-text-muted);
    }
    @keyframes ps-style-loader {
      0% { transform: translateX(-110%); }
      100% { transform: translateX(250%); }
    }
    .ps-bp-style-list {
      height: 100%;
      overflow-y: auto;
      padding-right: 10px;
      scrollbar-width: thin;
      scrollbar-color: rgba(37, 85, 255, 0.24) transparent;
    }
    .ps-bp-style-item {
      position: relative;
      display: grid;
      grid-template-columns: minmax(112px, 150px) minmax(140px, 1fr) 26px;
      align-items: center;
      gap: clamp(18px, 3vw, 42px);
      min-height: 132px;
      padding: 0 0 clamp(18px, 2.2vw, 28px);
      margin: 0 0 clamp(18px, 2.2vw, 28px);
      border-bottom: 1px dashed rgba(17, 24, 39, 0.24);
      touch-action: pan-y;
      user-select: none;
      cursor: grab;
    }
    .ps-bp-style-item:last-child {
      border-bottom: 0;
      margin-bottom: 0;
    }
    .ps-bp-style-img-frame {
      position: relative;
      width: 100%;
      height: 126px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background: #f1f1f2;
    }
    .ps-bp-style-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
      mix-blend-mode: multiply;
    }
    .ps-bp-style-item-label {
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      color: #1c1f25;
    }
    .ps-bp-style-item-color,
    .ps-bp-style-item-type {
      display: block;
      font-size: clamp(14px, 1.14vw, 17px);
      line-height: 1.1;
      font-weight: 800;
      letter-spacing: 0;
    }
    .ps-bp-style-size {
      display: block;
      margin-top: -2px;
      color: var(--ps-text-muted);
      font-size: 11px;
      font-weight: 700;
    }
    .ps-bp-style-swipe-hint {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      border: 0;
      background: transparent;
      padding: 0;
      color: #5b6370;
      font-size: 11px;
      font-weight: 800;
      cursor: pointer;
      font-family: inherit;
      text-align: left;
    }
    .ps-bp-style-swipe-hint:disabled {
      cursor: default;
      opacity: 0.6;
    }
    .ps-bp-style-swipe-mark {
      position: relative;
      width: 54px;
      height: 1px;
      background: #7a828f;
    }
    .ps-bp-style-swipe-mark::before {
      content: "";
      position: absolute;
      left: -1px;
      top: 50%;
      width: 5px;
      height: 5px;
      border-radius: 999px;
      background: #5f6671;
      transform: translateY(-50%);
    }
    .ps-bp-style-swipe-mark::after {
      content: "";
      position: absolute;
      right: -1px;
      top: 50%;
      width: 7px;
      height: 7px;
      border-right: 1px solid #7a828f;
      border-top: 1px solid #7a828f;
      transform: translateY(-50%) rotate(45deg);
    }
    .ps-bp-style-select {
      width: 18px;
      height: 18px;
      border-radius: 999px;
      border: 1px solid rgba(37, 85, 255, 0.45);
      background: #fff;
      color: #fff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      cursor: pointer;
      align-self: start;
      margin-top: 8px;
    }
    .ps-bp-style-select[aria-pressed="true"] {
      background: var(--ps-accent);
      border-color: var(--ps-accent);
    }
    .ps-bp-style-select span {
      width: 7px;
      height: 4px;
      border-left: 1.5px solid currentColor;
      border-bottom: 1.5px solid currentColor;
      transform: rotate(-45deg) translateY(-1px);
    }
    .ps-bp-style-bottom {
      display: grid !important;
      grid-template-columns: 1fr minmax(160px, 220px);
      align-items: center;
      gap: 14px;
      min-height: 68px !important;
      padding: 10px clamp(18px, 2.4vw, 32px) max(12px, env(safe-area-inset-bottom)) !important;
    }
    .ps-bpm-back-btn {
      justify-self: start;
      display: inline-flex;
      align-items: center;
      gap: 7px;
      min-height: 38px;
      padding: 0 10px;
      border: 0;
      background: transparent;
      color: #8a919d;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
    }
    .ps-bp-style-submit {
      margin: 0 !important;
      width: 100% !important;
      min-height: 42px !important;
    }

    @media (max-width: 720px) {
      .ps-bp-style-stage {
        grid-template-columns: minmax(112px, 0.72fr) minmax(174px, 1fr);
        gap: 8px;
        padding: 8px 8px 70px;
        overflow: hidden;
      }
      .ps-bp-style-anchor {
        min-height: 0;
        height: 100%;
        border-radius: 10px;
      }
      .ps-bp-style-anchor-img {
        padding: 12px 6px;
      }
      .ps-bp-style-anchor-copy {
        left: 10px;
        top: 12px;
      }
      .ps-bp-style-anchor-title {
        max-width: 96px;
        font-size: 17px;
      }
      .ps-bp-style-anchor-rule {
        width: 32px;
        margin: 7px 0 6px;
      }
      .ps-bp-style-anchor-sub {
        font-size: 9px;
      }
      .ps-bp-style-list-panel {
        min-height: 0;
        height: 100%;
        padding: 10px 8px 10px 10px;
        border-radius: 10px;
      }
      .ps-bp-style-list {
        padding-right: 4px;
      }
      .ps-bp-style-item {
        grid-template-columns: 70px minmax(0, 1fr) 18px;
        gap: 8px;
        min-height: 96px;
        padding-bottom: 14px;
        margin-bottom: 14px;
      }
      .ps-bp-style-img-frame {
        height: 90px;
      }
      .ps-bp-style-item-label {
        gap: 6px;
      }
      .ps-bp-style-item-color,
      .ps-bp-style-item-type {
        font-size: 12px;
      }
      .ps-bp-style-size,
      .ps-bp-style-swipe-hint {
        font-size: 9px;
      }
      .ps-bp-style-swipe-mark {
        width: 32px;
      }
      .ps-bp-style-select {
        width: 16px;
        height: 16px;
        margin-top: 4px;
      }
      .ps-bp-style-bottom {
        grid-template-columns: 1fr 1.4fr;
        min-height: 58px !important;
        padding: 8px 10px max(10px, env(safe-area-inset-bottom)) !important;
      }
    }

    @media (max-width: 374px) {
      .ps-tryon-overlay {
        --ps-mobile-x: 12px;
      }
      .ps-tryon-v2-action-group:not(.ps-tryon-v2-action-group-single):not(.ps-tryon-v2-action-group-history) {
        grid-template-columns: 1fr !important;
      }
      .ps-tryon-v2-cta,
      .ps-msd-primary-cta,
      .ps-cpw-next-btn,
      .ps-pmv-btn-primary,
      .ps-bpm-next-btn {
        min-height: 40px !important;
        font-size: 11px !important;
      }
      .ps-cpw-method-card {
        grid-template-columns: 36px minmax(0, 1fr) 28px !important;
      }
    }
  }

  /* Complete Your Style preview must work at modal width too, not only under
     the mobile breakpoint above. */
  .ps-bp-style-wrapper {
    min-height: min(680px, calc(100vh - 24px));
    background: #fff;
  }
  .ps-bp-style-stage {
    display: grid !important;
    grid-template-columns: minmax(280px, 0.86fr) minmax(320px, 1.08fr) !important;
    gap: clamp(16px, 2vw, 28px);
    width: 100%;
    min-height: 0;
    flex: 1 1 auto;
    padding: clamp(18px, 2.2vw, 28px) clamp(18px, 2.4vw, 32px) 86px;
    overflow: hidden;
  }
  .ps-bp-style-anchor,
  .ps-bp-style-list-panel {
    position: relative;
    min-height: 0;
    border-radius: 14px;
    overflow: hidden;
    background: #f3f3f4;
  }
  .ps-bp-style-anchor {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ps-bp-style-anchor-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    padding: clamp(18px, 3vw, 42px);
  }
  .ps-bp-style-anchor-copy {
    position: absolute;
    left: clamp(18px, 2vw, 26px);
    top: clamp(18px, 2vw, 26px);
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: var(--ps-accent);
    text-transform: uppercase;
    pointer-events: none;
  }
  .ps-bp-style-anchor-title {
    max-width: 180px;
    font-size: clamp(17px, 2.2vw, 28px);
    line-height: 0.9;
    font-weight: 800;
    letter-spacing: 0;
  }
  .ps-bp-style-anchor-rule {
    width: 48px;
    height: 2px;
    margin: 10px 0 8px;
    background: currentColor;
    opacity: 0.85;
  }
  .ps-bp-style-anchor-sub {
    font-size: clamp(10px, 1vw, 12px);
    line-height: 1;
    font-weight: 800;
    letter-spacing: 0.04em;
  }
  .ps-bp-style-list-panel {
    background: #fff;
    border: 1px solid rgba(37, 85, 255, 0.18);
    padding: clamp(16px, 2vw, 26px) clamp(16px, 2.2vw, 30px);
    display: flex;
    flex-direction: column;
  }
  .ps-bp-style-status {
    margin: 0 0 12px;
    color: var(--ps-text-muted);
    font-size: 12px;
    font-weight: 700;
    text-align: right;
  }
  .ps-bp-style-loader {
    min-height: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: clamp(28px, 4vw, 54px) clamp(16px, 3vw, 42px);
    text-align: center;
    color: #111827;
  }
  .ps-bp-style-loader-kicker {
    color: var(--ps-accent);
    font-size: clamp(10px, 0.86vw, 12px);
    font-weight: 850;
    letter-spacing: 0.12em;
    line-height: 1;
    text-transform: uppercase;
  }
  .ps-bp-style-loader-title {
    max-width: 260px;
    color: #111827;
    font-size: clamp(18px, 2.1vw, 28px);
    font-weight: 850;
    letter-spacing: 0;
    line-height: 0.95;
    text-transform: uppercase;
  }
  .ps-bp-style-loader-line {
    width: 96px;
    height: 2px;
    overflow: hidden;
    background: rgba(37, 85, 255, 0.14);
  }
  .ps-bp-style-loader-line::before {
    content: "";
    display: block;
    width: 42%;
    height: 100%;
    background: var(--ps-accent);
    animation: ps-style-loader 1.05s ease-in-out infinite;
  }
  .ps-bp-style-loader-muted .ps-bp-style-loader-title {
    font-size: clamp(14px, 1.35vw, 18px);
    line-height: 1.15;
    text-transform: none;
    color: var(--ps-text-muted);
  }
  @keyframes ps-style-loader {
    0% { transform: translateX(-110%); }
    100% { transform: translateX(250%); }
  }
  .ps-bp-style-list {
    height: 100%;
    overflow-y: auto;
    padding-right: 10px;
    scrollbar-width: thin;
    scrollbar-color: rgba(37, 85, 255, 0.24) transparent;
  }
  .ps-bp-style-item {
    position: relative;
    display: grid;
    grid-template-columns: minmax(132px, 168px) minmax(140px, 1fr) 26px;
    align-items: center;
    gap: clamp(18px, 2.6vw, 36px);
    min-height: 148px;
    padding: 0 0 clamp(18px, 2.2vw, 28px);
    margin: 0 0 clamp(18px, 2.2vw, 28px);
    border-bottom: 1px dashed rgba(17, 24, 39, 0.24);
    touch-action: pan-y;
    user-select: none;
    cursor: grab;
  }
  .ps-bp-style-item:last-child {
    border-bottom: 0;
    margin-bottom: 0;
  }
  .ps-bp-style-img-frame {
    position: relative;
    width: 100%;
    height: 142px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
    background: transparent;
  }
  .ps-bp-style-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    mix-blend-mode: normal;
    filter: drop-shadow(0 12px 18px rgba(15, 23, 42, 0.10));
    transform: scale(1.08);
    transform-origin: center;
  }
  .ps-bp-style-item-label {
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    color: #1c1f25;
  }
  .ps-bp-style-item-color,
  .ps-bp-style-item-type {
    display: block;
    font-size: clamp(14px, 1.14vw, 17px);
    line-height: 1.1;
    font-weight: 800;
    letter-spacing: 0;
  }
  .ps-bp-style-size {
    display: block;
    margin-top: -2px;
    color: var(--ps-text-muted);
    font-size: 11px;
    font-weight: 700;
  }
  .ps-bp-style-swipe-hint {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 0;
    background: transparent;
    padding: 0;
    color: #5b6370;
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
  }
  .ps-bp-style-swipe-hint:disabled {
    cursor: default;
    opacity: 0.6;
  }
  .ps-bp-style-swipe-mark {
    position: relative;
    width: 54px;
    height: 1px;
    background: #7a828f;
  }
  .ps-bp-style-swipe-mark::before {
    content: "";
    position: absolute;
    left: -1px;
    top: 50%;
    width: 5px;
    height: 5px;
    border-radius: 999px;
    background: #5f6671;
    transform: translateY(-50%);
  }
  .ps-bp-style-swipe-mark::after {
    content: "";
    position: absolute;
    right: -1px;
    top: 50%;
    width: 7px;
    height: 7px;
    border-right: 1px solid #7a828f;
    border-top: 1px solid #7a828f;
    transform: translateY(-50%) rotate(45deg);
  }
  .ps-bp-style-select {
    width: 18px;
    height: 18px;
    border-radius: 999px;
    border: 1px solid rgba(37, 85, 255, 0.45);
    background: #fff;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
    align-self: start;
    margin-top: 8px;
  }
  .ps-bp-style-select[aria-pressed="true"] {
    background: var(--ps-accent);
    border-color: var(--ps-accent);
  }
  .ps-bp-style-select span {
    width: 7px;
    height: 4px;
    border-left: 1.5px solid currentColor;
    border-bottom: 1.5px solid currentColor;
    transform: rotate(-45deg) translateY(-1px);
  }
  .ps-bp-style-bottom {
    display: grid !important;
    grid-template-columns: 1fr minmax(160px, 220px);
    align-items: center;
    gap: 14px;
    min-height: 68px !important;
    padding: 10px clamp(18px, 2.4vw, 32px) max(12px, env(safe-area-inset-bottom)) !important;
  }
  .ps-bpm-back-btn {
    justify-self: start;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-height: 38px;
    padding: 0 10px;
    border: 0;
    background: transparent;
    color: #8a919d;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
  .ps-bp-style-submit {
    margin: 0 !important;
    width: 100% !important;
    min-height: 42px !important;
  }

  @media (max-width: 720px) {
    .ps-bp-style-stage {
      grid-template-columns: minmax(112px, 0.72fr) minmax(174px, 1fr) !important;
      gap: 8px;
      padding: 8px 8px 70px;
      overflow: hidden;
    }
    .ps-bp-style-anchor {
      min-height: 0;
      height: 100%;
      border-radius: 10px;
    }
    .ps-bp-style-anchor-img {
      padding: 12px 6px;
    }
    .ps-bp-style-anchor-copy {
      left: 10px;
      top: 12px;
    }
    .ps-bp-style-anchor-title {
      max-width: 96px;
      font-size: 17px;
    }
    .ps-bp-style-anchor-rule {
      width: 32px;
      margin: 7px 0 6px;
    }
    .ps-bp-style-anchor-sub {
      font-size: 9px;
    }
    .ps-bp-style-list-panel {
      min-height: 0;
      height: 100%;
      padding: 10px 8px 10px 10px;
      border-radius: 10px;
    }
    .ps-bp-style-list {
      padding-right: 4px;
    }
    .ps-bp-style-item {
      grid-template-columns: 90px minmax(0, 1fr) 18px;
      gap: 10px;
      min-height: 112px;
      padding-bottom: 14px;
      margin-bottom: 14px;
    }
    .ps-bp-style-img-frame {
      height: 106px;
    }
    .ps-bp-style-item-label {
      gap: 6px;
    }
    .ps-bp-style-item-color,
    .ps-bp-style-item-type {
      font-size: 12px;
    }
    .ps-bp-style-size,
    .ps-bp-style-swipe-hint {
      font-size: 9px;
    }
    .ps-bp-style-swipe-mark {
      width: 32px;
    }
    .ps-bp-style-select {
      width: 16px;
      height: 16px;
      margin-top: 4px;
    }
    .ps-bp-style-bottom {
      grid-template-columns: 1fr 1.4fr;
      min-height: 58px !important;
      padding: 8px 10px max(10px, env(safe-area-inset-bottom)) !important;
    }
  }

  .ps-bp-style-wrapper {
    display: flex !important;
    flex-direction: column !important;
    height: min(620px, calc(100dvh - 54px)) !important;
    min-height: 0 !important;
    max-height: calc(100dvh - 54px) !important;
    overflow: hidden !important;
    background: #fff !important;
  }
  .ps-bp-style-wrapper .ps-bp-style-stage {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    height: auto !important;
    padding: 18px 24px 12px !important;
    overflow: hidden !important;
  }
  .ps-bp-style-wrapper .ps-bp-style-anchor,
  .ps-bp-style-wrapper .ps-bp-style-list-panel {
    height: 100% !important;
    min-height: 0 !important;
  }
  .ps-bp-style-wrapper .ps-bp-style-anchor {
    background: transparent !important;
    border-radius: 0 !important;
  }
  .ps-bp-style-wrapper .ps-bp-style-anchor-img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    object-position: center top !important;
    padding: 0 !important;
  }
  .ps-bp-style-wrapper .ps-bp-style-list {
    height: 100% !important;
    max-height: 100% !important;
    overflow-y: auto !important;
  }
  .ps-bp-style-wrapper .ps-bp-style-bottom {
    flex: 0 0 66px !important;
    display: grid !important;
    grid-template-columns: 1fr 190px !important;
    align-items: center !important;
    gap: 14px !important;
    min-height: 66px !important;
    height: 66px !important;
    margin: 0 !important;
    padding: 10px 24px max(10px, env(safe-area-inset-bottom)) !important;
    border-top: 1px solid rgba(17, 24, 39, 0.08) !important;
    background: #fff !important;
  }
  .ps-bp-style-wrapper .ps-bpm-back-btn {
    width: auto !important;
    min-height: 36px !important;
    height: 36px !important;
    margin: 0 !important;
    padding: 0 8px !important;
    font-size: 14px !important;
    line-height: 1 !important;
  }
  .ps-bp-style-wrapper .ps-bp-style-submit,
  .ps-bp-style-wrapper .ps-bpm-next-btn.ps-bp-style-submit {
    width: 190px !important;
    min-width: 0 !important;
    max-width: 190px !important;
    min-height: 42px !important;
    height: 42px !important;
    margin: 0 !important;
    padding: 0 18px !important;
    border-radius: 8px !important;
    font-size: 14px !important;
    line-height: 1 !important;
    font-weight: 700 !important;
    letter-spacing: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    justify-self: end !important;
    white-space: nowrap !important;
  }

  @media (max-width: 720px) {
    .ps-bp-style-wrapper {
      height: min(620px, calc(100dvh - 54px)) !important;
    }
    .ps-bp-style-wrapper .ps-bp-style-stage {
      grid-template-columns: minmax(112px, 0.72fr) minmax(174px, 1fr) !important;
      padding: 8px 8px 8px !important;
    }
    .ps-bp-style-wrapper .ps-bp-style-bottom {
      grid-template-columns: 1fr 150px !important;
      padding: 8px 10px max(10px, env(safe-area-inset-bottom)) !important;
    }
    .ps-bp-style-wrapper .ps-bp-style-submit,
    .ps-bp-style-wrapper .ps-bpm-next-btn.ps-bp-style-submit {
      width: 150px !important;
      max-width: 150px !important;
      min-height: 40px !important;
      height: 40px !important;
      font-size: 13px !important;
    }
  }

  .ps-tryon-modal:has(.ps-bp-fitting-room),
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room) {
    width: min(1120px, 96vw) !important;
    max-width: min(1120px, 96vw) !important;
    height: min(700px, 92dvh) !important;
    max-height: min(700px, 92dvh) !important;
    border-radius: 18px !important;
    background: #e8e8e8 !important;
    overflow: hidden !important;
  }
  .ps-bp-fitting-room {
    height: 100% !important;
    max-height: none !important;
    min-height: 0 !important;
    overflow: hidden !important;
    background: #e8e8e8 !important;
    color: #101010;
  }
  .ps-tryon-modal:has(.ps-bp-fitting-room .ps-bp-style-loader),
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room .ps-bp-style-loader) {
    width: min(55vw, calc(92dvh * 1.6)) !important;
    max-width: min(55vw, calc(92dvh * 1.6)) !important;
    height: min(82dvh, calc(55vw / 1.35)) !important;
    max-height: min(92dvh, calc(55vw / 1.35)) !important;
    background: #fff !important;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) {
    background: #fff !important;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-shell {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: clamp(18px, 3vw, 48px);
    padding: clamp(14px, 1.6vw, 22px);
    background: #fff !important;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-stage {
    grid-template-rows: minmax(0, 1fr);
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-topbar,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-detail,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-zoom,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-orbit,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-hanger,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-params-card,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-card-head,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-cta {
    display: none !important;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-visual,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-panel,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-wearing-card {
    min-height: 0;
    height: 100%;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-person {
    width: 100%;
    max-width: none;
    max-height: none;
    border-radius: 8px;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-panel {
    grid-template-rows: minmax(0, 1fr);
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-wearing-card {
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    justify-content: center;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-style-loader {
    min-height: 100%;
    padding: 0 clamp(16px, 2vw, 32px);
  }
  .ps-bp-fitting-shell {
    display: grid;
    grid-template-columns: minmax(0, 1fr) clamp(320px, 32%, 390px);
    gap: 14px;
    height: 100%;
    min-height: 0;
    padding: 18px;
    background: #e8e8e8;
  }
  .ps-bp-fitting-stage {
    position: relative;
    min-width: 0;
    min-height: 0;
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) 142px;
    gap: 12px;
  }
  .ps-bp-fitting-topbar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    min-height: 46px;
  }
  .ps-bp-fitting-topbar h2 {
    margin: 0 0 5px;
    color: #111;
    font-size: clamp(19px, 1.65vw, 28px);
    line-height: 1;
    font-weight: 850;
    letter-spacing: -0.02em;
  }
  .ps-bp-fitting-back {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: 0;
    background: transparent;
    color: #111;
    padding: 0;
    font: inherit;
    font-size: 12px;
    font-weight: 650;
    cursor: pointer;
  }
  .ps-bp-fitting-back svg {
    width: 14px;
    height: 14px;
  }
  .ps-bp-fitting-count {
    min-width: 54px;
    padding: 7px 12px;
    border-radius: 999px;
    background: #fff;
    color: #111;
    font-size: 12px;
    font-weight: 800;
    text-align: center;
    box-shadow: 0 1px 0 rgba(0,0,0,0.05);
  }
  .ps-bp-fitting-visual {
    position: relative;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .ps-bp-fitting-person {
    width: min(54%, 360px);
    height: 100%;
    max-height: 470px;
    object-fit: contain;
    object-position: center bottom;
    display: block;
    filter: drop-shadow(0 18px 30px rgba(0,0,0,0.12));
  }
  .ps-bp-fitting-detail {
    position: absolute;
    top: 8px;
    right: 4%;
    width: clamp(150px, 16vw, 190px);
    aspect-ratio: 1;
    border-radius: 999px;
    border: 1.5px solid #111;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .ps-bp-fitting-detail .ps-bp-style-img {
    width: 88%;
    height: 88%;
    object-fit: contain;
    transform: none;
    filter: none;
  }
  .ps-bp-fitting-zoom {
    position: absolute;
    left: 0;
    z-index: 2;
    width: 30px;
    height: 30px;
    border: 0;
    border-radius: 999px;
    background: #fff;
    color: #111;
    font-size: 19px;
    font-weight: 800;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 0 rgba(0,0,0,0.04);
  }
  .ps-bp-fitting-zoom.ps-top { top: 44%; }
  .ps-bp-fitting-zoom.ps-bottom { top: calc(44% + 38px); }
  .ps-bp-fitting-orbit {
    position: absolute;
    bottom: 21%;
    width: 112px;
    height: 64px;
    border: 0;
    background: transparent;
    cursor: pointer;
    opacity: 0.75;
  }
  .ps-bp-fitting-orbit span {
    display: block;
    width: 100%;
    height: 100%;
    border-top: 1.5px solid #111;
    border-radius: 50%;
  }
  .ps-bp-fitting-orbit.ps-left {
    left: 11%;
    transform: rotate(-20deg);
  }
  .ps-bp-fitting-orbit.ps-right {
    right: 10%;
    transform: rotate(200deg);
  }
  .ps-bp-fitting-hanger {
    min-height: 0;
    border-radius: 24px;
    background: rgba(255,255,255,0.76);
    backdrop-filter: blur(18px);
    padding: 18px 20px 16px;
    border: 1px solid rgba(17, 17, 17, 0.04);
    box-shadow: 0 8px 24px rgba(0,0,0,0.05);
    overflow: hidden;
  }
  .ps-bp-fitting-hanger-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .ps-bp-fitting-hanger-head h3 {
    margin: 0;
    color: #111;
    font-size: 17px;
    line-height: 1;
    font-weight: 850;
  }
  .ps-bp-fitting-hanger-head button {
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: #111;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .ps-bp-fitting-hanger-row {
    display: grid;
    grid-template-columns: 30px minmax(0, 1fr) 30px;
    align-items: center;
    gap: 8px;
  }
  .ps-bp-fitting-hanger-nav {
    width: 30px;
    height: 46px;
    border: 0;
    background: transparent;
    color: #111;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .ps-bp-fitting-hanger-nav svg {
    width: 15px;
    height: 15px;
  }
  .ps-bp-fitting-hanger-nav span {
    font-size: 26px;
    line-height: 1;
  }
  .ps-bp-fitting-hanger-track {
    display: flex;
    gap: 12px;
    overflow-x: auto;
    overscroll-behavior-x: contain;
    scrollbar-width: none;
    padding: 0 2px 2px;
  }
  .ps-bp-fitting-hanger-track::-webkit-scrollbar { display: none; }
  .ps-bp-fitting-thumb {
    flex: 0 0 70px;
    height: 70px;
    border: 0;
    border-radius: 19px;
    background: rgba(255,255,255,0.74);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    cursor: pointer;
    transition: transform 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
  }
  .ps-bp-fitting-thumb.ps-active {
    background: #fff;
    box-shadow: 0 14px 26px rgba(0,0,0,0.16);
    transform: translateY(-3px);
  }
  .ps-bp-fitting-thumb .ps-bp-style-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: none;
    filter: none;
  }
  .ps-bp-fitting-panel {
    min-width: 0;
    min-height: 0;
    display: grid;
    grid-template-rows: minmax(0, 1fr);
    gap: 14px;
  }
  .ps-params-card {
    display: none !important;
  }
  .ps-bp-fitting-card {
    border-radius: 25px;
    background: #fff;
    padding: 18px;
    border: 1px solid rgba(17, 17, 17, 0.04);
    box-shadow: 0 8px 24px rgba(0,0,0,0.05);
  }
  .ps-bp-fitting-card h3 {
    margin: 0 0 15px;
    color: #111;
    font-size: 20px;
    line-height: 1;
    font-weight: 850;
    letter-spacing: -0.01em;
  }
  .ps-bp-fitting-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 13px;
  }
  .ps-bp-fitting-card-head h3 {
    margin: 0;
  }
  .ps-bp-fitting-outfit-pager {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 999px;
    background: #f1f1f1;
    padding: 3px;
    color: #111;
  }
  .ps-bp-fitting-outfit-pager button {
    width: 24px;
    height: 24px;
    border: 0;
    border-radius: 999px;
    background: #fff;
    color: #111;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
  }
  .ps-bp-fitting-outfit-pager button svg {
    width: 13px;
    height: 13px;
  }
  .ps-bp-fitting-outfit-pager button span {
    font-size: 20px;
    line-height: 1;
    transform: translateY(-1px);
  }
  .ps-bp-fitting-outfit-pager > span {
    min-width: 44px;
    color: #111;
    font-size: 11px;
    font-weight: 850;
    text-align: center;
  }
  .ps-bp-fitting-param-grid {
    display: grid;
    grid-template-columns: 1fr minmax(76px, 1.2fr) 1fr minmax(76px, 1.2fr);
    gap: 10px 12px;
    align-items: center;
  }
  .ps-bp-fitting-param-grid span {
    color: #111;
    font-size: 11px;
    font-weight: 800;
    white-space: nowrap;
  }
  .ps-bp-fitting-param-grid strong {
    min-height: 28px;
    border-radius: 999px;
    background: #eeeeee;
    color: #111;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    font-size: 12px;
    font-weight: 850;
    white-space: nowrap;
  }
  .ps-bp-fitting-confirm,
  .ps-bp-fitting-cta {
    width: 100% !important;
    height: 34px !important;
    min-height: 34px !important;
    margin-top: 14px !important;
    border: 0 !important;
    border-radius: 999px !important;
    background: #eeeeee !important;
    color: #111 !important;
    font-size: 12px !important;
    font-weight: 850 !important;
    box-shadow: none !important;
    cursor: pointer;
  }
  .ps-wearing-card {
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: hidden;
  }
  .ps-bp-fitting-wearing-list {
    min-height: 0;
    flex: 1 1 auto;
    overflow-y: auto;
    padding-right: 4px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .ps-bp-fitting-wearing-item {
    position: relative;
    flex: 1 1 0;
    display: grid;
    grid-template-columns: 78px minmax(0, 1fr);
    gap: 12px;
    align-items: center;
    min-height: 96px;
    padding: 10px 44px 10px 10px;
    border-radius: 18px;
    border: 1.5px solid transparent;
    background: #f3f3f3;
    touch-action: pan-y;
  }
  .ps-bp-fitting-wearing-item.ps-selected {
    border-color: #111;
    background: #fff;
  }
  .ps-bp-fitting-select {
    position: absolute;
    right: 11px;
    top: 11px;
    z-index: 2;
    width: 22px;
    height: 22px;
    border: 1.5px solid rgba(17, 17, 17, 0.28);
    border-radius: 999px;
    background: #fff;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
  }
  .ps-bp-fitting-select[aria-pressed="true"] {
    border-color: var(--ps-accent);
    background: var(--ps-accent);
  }
  .ps-bp-fitting-select svg {
    width: 13px;
    height: 13px;
  }
  .ps-bp-fitting-wearing-img {
    width: 78px;
    height: 78px;
    border-radius: 16px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .ps-bp-fitting-wearing-img .ps-bp-style-img {
    width: 86%;
    height: 86%;
    object-fit: contain;
    transform: none;
    filter: none;
  }
  .ps-bp-fitting-wearing-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: #111;
  }
  .ps-bp-fitting-wearing-copy strong {
    max-width: 100%;
    color: #111;
    font-size: 12px;
    line-height: 1.15;
    font-weight: 850;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ps-bp-fitting-wearing-copy small,
  .ps-bp-fitting-wearing-copy span {
    color: #4d4d4d;
    font-size: 11px;
    line-height: 1.1;
    font-weight: 650;
  }
  .ps-bp-fitting-swap {
    position: absolute;
    right: 8px;
    bottom: 8px;
    border: 0;
    border-radius: 999px;
    background: #ededed;
    color: #111;
    min-height: 25px;
    max-width: calc(100% - 104px);
    padding: 0 9px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 10px;
    font-weight: 850;
    cursor: pointer;
  }
  .ps-bp-fitting-swap span:first-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ps-bp-fitting-swap:disabled {
    opacity: 0.45;
    cursor: default;
  }
  .ps-bp-fitting-cta {
    flex: 0 0 auto;
    margin: 12px 0 0 !important;
    background: var(--ps-accent) !important;
    color: #fff !important;
  }
  .ps-bp-fitting-room .ps-bp-style-loader {
    min-height: 220px;
    background: transparent;
  }

  @media (max-width: 860px) {
    .ps-tryon-modal:has(.ps-bp-fitting-room),
    .ps-tryon-modal-wide:has(.ps-bp-fitting-room) {
      width: 100vw !important;
      max-width: 100vw !important;
      height: 100dvh !important;
      max-height: 100dvh !important;
      border-radius: 0 !important;
    }
    .ps-bp-fitting-shell {
      grid-template-columns: 1fr;
      grid-template-rows: minmax(0, 1fr) auto;
      gap: 10px;
      padding: 10px;
      overflow-y: auto;
    }
    .ps-bp-fitting-stage {
      grid-template-rows: auto minmax(260px, 1fr) 122px;
      min-height: 520px;
    }
    .ps-bp-fitting-person {
      width: min(72%, 280px);
      max-height: 330px;
    }
    .ps-bp-fitting-detail {
      width: 124px;
      right: 2%;
    }
    .ps-bp-fitting-hanger {
      border-radius: 20px;
      padding: 14px;
    }
    .ps-bp-fitting-thumb {
      flex-basis: 58px;
      height: 58px;
      border-radius: 15px;
    }
    .ps-bp-fitting-panel {
      grid-template-rows: auto auto;
    }
    .ps-bp-fitting-card {
      border-radius: 20px;
      padding: 14px;
    }
    .ps-bp-fitting-param-grid {
      grid-template-columns: 1fr minmax(72px, 1fr);
    }
    .ps-bp-fitting-wearing-list {
      max-height: 280px;
    }
  }

  /* Outfit Builder — pinned piece, category columns, and confirmed look */
  .ps-tryon-modal:has(.ps-bp-fitting-room),
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room),
  .ps-tryon-modal:has(.ps-bp-fitting-room .ps-bp-style-loader),
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room .ps-bp-style-loader) {
    width: min(1480px, 94vw) !important;
    max-width: min(1480px, 94vw) !important;
    height: min(900px, calc(100dvh - 24px)) !important;
    max-height: min(900px, calc(100dvh - 24px)) !important;
    border-radius: 18px !important;
    background: #fff !important;
    overflow: hidden !important;
  }
  .ps-tryon-modal:has(.ps-bp-fitting-room) > .ps-tryon-header-minimal,
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room) > .ps-tryon-header-minimal {
    flex: 0 0 64px !important;
    min-height: 64px !important;
    height: 64px !important;
    padding: 0 34px !important;
    border-radius: 18px 18px 0 0 !important;
    background: #fff !important;
  }
  .ps-tryon-modal:has(.ps-bp-fitting-room) > .ps-tryon-body,
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room) > .ps-tryon-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
  }
  .ps-tryon-modal:has(.ps-bp-fitting-room) .ps-tryon-powered-by,
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room) .ps-tryon-powered-by {
    color: #9aa1aa !important;
    display: inline-flex !important;
    align-items: baseline !important;
    gap: 4px !important;
    font-size: 10px !important;
    line-height: 1 !important;
    font-weight: 500 !important;
    letter-spacing: 0.1em !important;
    text-transform: uppercase !important;
  }
  .ps-tryon-modal:has(.ps-bp-fitting-room) .ps-tryon-powered-by strong,
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room) .ps-tryon-powered-by strong {
    color: #4b5563 !important;
    font-size: 12px !important;
    line-height: 1 !important;
    font-weight: 700 !important;
    letter-spacing: 0.01em !important;
    text-transform: none !important;
  }
  .ps-tryon-modal:has(.ps-bp-fitting-room) .ps-tryon-lang-trigger,
  .ps-tryon-modal:has(.ps-bp-fitting-room) .ps-tryon-header-icon,
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room) .ps-tryon-lang-trigger,
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room) .ps-tryon-header-icon {
    min-height: 44px !important;
    height: 44px !important;
    border-color: transparent !important;
    border-radius: 8px !important;
    background: transparent !important;
    box-shadow: none !important;
    font-size: 14px !important;
  }
  .ps-tryon-modal:has(.ps-bp-fitting-room) .ps-tryon-close,
  .ps-tryon-modal-wide:has(.ps-bp-fitting-room) .ps-tryon-close {
    width: 40px !important;
    height: 40px !important;
    border: 0 !important;
    background: transparent !important;
  }
  .ps-bp-fitting-room,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) {
    height: 100% !important;
    max-height: none !important;
    min-height: 0 !important;
    overflow: hidden !important;
    background: #fbfbfb !important;
    color: #111;
  }
  .ps-bp-fitting-shell,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-shell {
    width: 100%;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 34px 50px 58px;
    background: #fbfbfb !important;
    overflow: hidden;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-topbar {
    display: flex !important;
  }
  .ps-bp-fitting-topbar {
    position: relative;
    flex: 0 0 82px;
    min-height: 0;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0;
  }
  .ps-bp-fitting-topbar > div {
    min-width: 0;
  }
  .ps-bp-fitting-topbar h2 {
    margin: 0;
    color: #111;
    font-size: 34px;
    line-height: 1.08;
    font-weight: 850;
    letter-spacing: -0.035em;
  }
  .ps-bp-fitting-topbar p {
    margin: 8px 0 0;
    color: #6b7280;
    font-size: 14px;
    line-height: 1.3;
    font-weight: 500;
  }
  .ps-bp-fitting-back {
    display: none;
    flex: 0 0 auto;
    width: 29px;
    height: 29px;
    margin: 1px 0 0 -7px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: #111;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
  }
  .ps-bp-fitting-back:hover {
    background: #f0f0f0;
  }
  .ps-bp-fitting-back svg {
    width: 17px;
    height: 17px;
  }
  .ps-bp-fitting-room .ps-bp-fitting-back {
    display: none !important;
  }
  .ps-bp-outfit-grid {
    flex: 1 1 auto;
    min-height: 0;
    display: grid;
    grid-template-columns: minmax(270px, 29fr) minmax(455px, 47fr) minmax(225px, 24fr);
    gap: 30px;
  }
  .ps-bp-outfit-preview {
    position: relative;
    min-width: 0;
    min-height: 0;
    border-radius: 8px;
    background: #f2eee8;
    height: 100%;
    max-height: none;
    align-self: stretch;
  }
  .ps-bp-outfit-preview .ps-bp-fitting-person,
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-outfit-preview .ps-bp-fitting-person {
    width: 100%;
    height: 100%;
    max-width: none;
    max-height: none;
    display: block;
    border-radius: 8px;
    object-fit: cover;
    object-position: center top;
    filter: none;
  }
  .ps-bp-outfit-anchor {
    position: absolute;
    left: -30px;
    bottom: 70px;
    z-index: 3;
    width: 205px;
    min-height: 185px;
    display: grid;
    grid-template-columns: 56px minmax(0, 1fr);
    gap: 12px;
    align-items: start;
    padding: 17px 17px 16px;
    border: 1px solid #e6e6e6;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 10px 30px rgba(17, 24, 39, 0.09);
    backdrop-filter: blur(14px);
  }
  .ps-bp-outfit-anchor-image {
    width: 56px;
    height: 95px;
    border-radius: 7px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .ps-bp-outfit-anchor-image .ps-bp-style-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: none;
    transform: scale(1.12);
  }
  .ps-bp-outfit-anchor-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .ps-bp-outfit-pinned {
    color: var(--ps-accent);
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    line-height: 1;
    font-weight: 800;
  }
  .ps-bp-outfit-anchor-copy strong {
    color: #111;
    font-size: 12px;
    line-height: 1.25;
    font-weight: 760;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .ps-bp-outfit-anchor-copy small {
    color: #4b5563;
    font-size: 11px;
    line-height: 1.2;
  }
  .ps-bp-outfit-anchor-note {
    grid-column: 1 / -1;
    border-top: 1px solid #e7e7e7;
    padding-top: 12px;
    color: #4b5563;
    font-size: 11px;
    line-height: 1.4;
  }
  .ps-bp-outfit-preview-note {
    position: absolute;
    left: 50%;
    bottom: -31px;
    transform: translateX(-50%);
    z-index: 4;
    width: max-content;
    max-width: calc(100% - 12px);
    color: #6b7280;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 13px;
    line-height: 1;
    white-space: nowrap;
  }
  .ps-bp-outfit-preview-note svg {
    color: var(--ps-accent);
  }
  .ps-bp-outfit-builder {
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    border: 1px solid #eeeeee;
    border-radius: 17px;
    background: #fff;
    box-shadow: 0 10px 30px rgba(17, 24, 39, 0.035);
    padding: 24px 15px 22px;
  }
  .ps-bp-outfit-columns {
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
  }
  .ps-bp-outfit-columns::-webkit-scrollbar {
    display: none;
  }
  .ps-bp-outfit-column {
    flex: 1 1 0;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
  }
  .ps-bp-outfit-column + .ps-bp-outfit-column {
    border-left: 1px solid #e6e7e9;
  }
  .ps-bp-outfit-column-head {
    flex: 0 0 38px;
    min-width: 0;
    display: flex;
    align-items: flex-start;
    gap: 6px;
    color: #111;
  }
  .ps-bp-outfit-column-head svg {
    flex: 0 0 auto;
  }
  .ps-bp-outfit-category-illustration {
    flex: 0 0 auto;
    width: 27px;
    height: 27px;
    margin-top: -5px;
    border-radius: 7px;
    object-fit: contain;
    mix-blend-mode: multiply;
  }
  .ps-bp-outfit-column-head h3 {
    margin: 1px 0 0;
    color: #111;
    font-size: 13px;
    line-height: 1.1;
    font-weight: 760;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ps-bp-outfit-primary {
    position: relative;
    flex: 0 0 210px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 11px 10px 9px;
    border: 1.5px solid #dedede;
    border-radius: 11px;
    background: #fff;
    overflow: hidden;
  }
  .ps-bp-outfit-primary.ps-selected {
    border-color: var(--ps-accent);
    box-shadow: inset 0 0 0 0.5px var(--ps-accent);
  }
  .ps-bp-outfit-primary .ps-bp-fitting-select {
    position: absolute;
    top: 9px;
    right: 9px;
    z-index: 3;
  }
  .ps-bp-fitting-select {
    width: 20px;
    height: 20px;
    border: 1.5px solid #d0d4d9;
    border-radius: 999px;
    background: #fff;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
  }
  .ps-bp-fitting-select[aria-pressed="true"] {
    border-color: var(--ps-accent);
    background: var(--ps-accent);
  }
  .ps-bp-fitting-select svg {
    width: 12px;
    height: 12px;
  }
  .ps-bp-outfit-primary-image {
    width: 100%;
    height: 142px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .ps-bp-outfit-primary-image .ps-bp-style-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: scale(1.28);
    filter: none;
  }
  .ps-bp-outfit-primary > strong {
    width: 100%;
    margin-top: 4px;
    color: #111;
    font-size: 13px;
    line-height: 1.25;
    font-weight: 720;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ps-bp-outfit-primary > small {
    width: 100%;
    margin-top: 4px;
    color: #4b5563;
    font-size: 12px;
    line-height: 1.1;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ps-bp-outfit-alternatives {
    min-height: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 16px;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .ps-bp-outfit-alternative {
    flex: 0 0 82px;
    min-width: 0;
    display: grid;
    grid-template-columns: 70px minmax(0, 1fr);
    align-items: center;
    gap: 10px;
    padding: 5px 8px;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    background: #fff;
    color: #111;
    font: inherit;
    text-align: left;
    cursor: pointer;
  }
  .ps-bp-outfit-alternative:hover {
    border-color: #b8c8ff;
    background: #fbfcff;
  }
  .ps-bp-outfit-alternative > span:first-child {
    width: 70px;
    height: 70px;
    border-radius: 6px;
    background: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .ps-bp-outfit-alternative .ps-bp-style-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: scale(1.28);
    filter: none;
  }
  .ps-bp-outfit-alternative > span:last-child {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .ps-bp-outfit-alternative strong,
  .ps-bp-outfit-alternative small {
    display: block;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ps-bp-outfit-alternative strong {
    color: #313131;
    font-size: 11px;
    line-height: 1.15;
    font-weight: 650;
  }
  .ps-bp-outfit-alternative small {
    color: #6b7280;
    font-size: 10px;
    line-height: 1;
  }
  .ps-bp-outfit-summary {
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #eeeeee;
    border-radius: 17px;
    background: #fff;
    box-shadow: 0 10px 30px rgba(17, 24, 39, 0.035);
    padding: 30px 22px 14px;
  }
  .ps-bp-outfit-look-head {
    flex: 0 0 74px;
    border-bottom: 1px solid #e6e7e9;
  }
  .ps-bp-outfit-look-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .ps-bp-outfit-look-title > strong {
    display: block;
    color: #111;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 760;
  }
  .ps-bp-outfit-carousel-controls {
    display: inline-flex;
    align-items: center;
    gap: 7px;
  }
  .ps-bp-outfit-carousel-controls button {
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 1px solid #e4e6ea;
    border-radius: 999px;
    background: #fff;
    color: #111;
    cursor: pointer;
    transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease;
  }
  .ps-bp-outfit-carousel-controls button:hover:not(:disabled) {
    border-color: var(--ps-accent);
    background: #f7f9ff;
    color: var(--ps-accent);
  }
  .ps-bp-outfit-carousel-controls button:disabled {
    opacity: 0.35;
    cursor: default;
  }
  .ps-bp-outfit-carousel-controls button svg {
    width: 15px;
    height: 15px;
  }
  .ps-bp-outfit-carousel-controls button.ps-next svg {
    transform: rotate(180deg);
  }
  .ps-bp-outfit-dots {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-top: 23px;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .ps-bp-outfit-dots::-webkit-scrollbar {
    display: none;
  }
  .ps-bp-outfit-dots button {
    flex: 0 0 7px;
    width: 7px;
    height: 7px;
    border: 0;
    border-radius: 999px;
    background: #c9cbd0;
    padding: 0;
    cursor: pointer;
  }
  .ps-bp-outfit-dots button.ps-active {
    width: 9px;
    height: 9px;
    flex-basis: 9px;
    background: var(--ps-accent);
  }
  .ps-bp-outfit-summary-body {
    min-height: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    padding: 22px 0 12px;
    overflow: hidden;
  }
  .ps-bp-outfit-summary-body h3 {
    flex: 0 0 auto;
    margin: 0 0 14px;
    color: #111;
    font-size: 17px;
    line-height: 1.2;
    font-weight: 760;
  }
  .ps-bp-outfit-summary-list {
    min-height: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .ps-bp-outfit-summary-list article {
    position: relative;
    min-width: 0;
    flex: 0 0 66px;
    display: grid;
    grid-template-columns: 58px minmax(0, 1fr);
    align-items: center;
    gap: 12px;
    padding-right: 2px;
  }
  .ps-bp-outfit-summary-image {
    width: 58px;
    height: 58px;
    border-radius: 7px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .ps-bp-outfit-summary-image .ps-bp-style-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: scale(1.14);
    filter: none;
  }
  .ps-bp-outfit-summary-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .ps-bp-outfit-summary-copy strong {
    color: #222;
    font-size: 13px;
    line-height: 1.25;
    font-weight: 650;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .ps-bp-outfit-summary-copy small {
    color: #6b7280;
    font-size: 11px;
    line-height: 1.1;
  }
  .ps-bp-outfit-summary-pinned {
    position: absolute;
    right: 0;
    bottom: 7px;
    color: var(--ps-accent);
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 10px;
    font-weight: 760;
  }
  .ps-bp-outfit-summary-footer {
    flex: 0 0 138px;
    border-top: 1px solid #e6e7e9;
    padding-top: 17px;
  }
  .ps-bp-outfit-total {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
  }
  .ps-bp-outfit-total > strong {
    color: #111;
    font-size: 17px;
    line-height: 1.2;
  }
  .ps-bp-outfit-total > strong small {
    color: #4b5563;
    font-size: 11px;
    font-weight: 500;
  }
  .ps-bp-outfit-total > span {
    color: #111;
    font-size: 13px;
    font-weight: 700;
  }
  .ps-bp-fitting-cta,
  .ps-bp-outfit-summary-footer .ps-bp-fitting-cta {
    width: 100% !important;
    height: 48px !important;
    min-height: 48px !important;
    margin: 20px 0 0 !important;
    border: 0 !important;
    border-radius: 7px !important;
    background: var(--ps-accent) !important;
    color: #fff !important;
    font-size: 15px !important;
    line-height: 1 !important;
    font-weight: 760 !important;
    box-shadow: none !important;
    cursor: pointer;
  }
  .ps-bp-fitting-cta:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  .ps-bp-outfit-summary-footer > small {
    display: block;
    margin-top: 9px;
    color: #777e88;
    font-size: 10px;
    line-height: 1.25;
    text-align: center;
  }
  .ps-bp-outfit-loading-panel {
    grid-column: 2 / 4;
    min-width: 0;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eeeeee;
    border-radius: 17px;
    background: #fff;
  }
  .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-outfit-loading-panel {
    height: auto;
  }
  .ps-bp-fitting-room .ps-bp-outfit-loading-panel .ps-bp-style-loader {
    width: min(430px, 86%);
    min-height: 220px;
    padding: 28px;
    background: transparent;
  }
  .ps-bp-fitting-retry {
    min-width: 120px;
    height: 40px;
    margin-top: 18px;
    border: 0;
    border-radius: 7px;
    background: var(--ps-accent);
    color: #fff;
    font: inherit;
    font-size: 12px;
    font-weight: 760;
    cursor: pointer;
  }

  @media (max-width: 1020px) and (min-width: 861px) {
    .ps-bp-fitting-shell,
    .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-shell {
      padding-inline: 18px;
    }
    .ps-bp-outfit-grid {
      grid-template-columns: minmax(235px, 28fr) minmax(415px, 48fr) minmax(205px, 24fr);
      gap: 12px;
    }
    .ps-bp-outfit-column {
      padding-inline: 7px;
    }
  }

  @media (max-height: 820px) and (min-width: 861px) {
    .ps-tryon-modal:has(.ps-bp-fitting-room),
    .ps-tryon-modal-wide:has(.ps-bp-fitting-room),
    .ps-tryon-modal:has(.ps-bp-fitting-room .ps-bp-style-loader),
    .ps-tryon-modal-wide:has(.ps-bp-fitting-room .ps-bp-style-loader) {
      height: min(760px, calc(100dvh - 16px)) !important;
      max-height: min(760px, calc(100dvh - 16px)) !important;
    }
    .ps-tryon-modal:has(.ps-bp-fitting-room) > .ps-tryon-header-minimal,
    .ps-tryon-modal-wide:has(.ps-bp-fitting-room) > .ps-tryon-header-minimal {
      flex-basis: 56px !important;
      min-height: 56px !important;
      height: 56px !important;
    }
    .ps-bp-fitting-shell,
    .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-shell {
      padding: 18px 32px 20px;
    }
    .ps-bp-fitting-topbar {
      flex-basis: 68px;
    }
    .ps-bp-fitting-topbar h2 {
      font-size: 30px;
    }
    .ps-bp-fitting-topbar p {
      margin-top: 6px;
      font-size: 13px;
    }
    .ps-bp-outfit-grid {
      gap: 22px;
    }
    .ps-bp-outfit-preview {
      height: 100%;
      max-height: 100%;
    }
    .ps-bp-outfit-anchor {
      left: -18px;
      bottom: 28px;
      width: 188px;
      min-height: 156px;
      grid-template-columns: 48px minmax(0, 1fr);
      padding: 13px;
    }
    .ps-bp-outfit-anchor-image {
      width: 48px;
      height: 70px;
    }
    .ps-bp-outfit-anchor-note {
      padding-top: 8px;
      font-size: 10px;
    }
    .ps-bp-outfit-preview-note {
      bottom: -22px;
      font-size: 11px;
    }
    .ps-bp-outfit-builder {
      padding: 17px 11px 14px;
    }
    .ps-bp-outfit-column {
      padding-inline: 7px;
    }
    .ps-bp-outfit-column-head {
      flex-basis: 32px;
    }
    .ps-bp-outfit-category-illustration {
      width: 27px;
      height: 27px;
      margin-top: -5px;
    }
    .ps-bp-outfit-primary {
      flex-basis: 174px;
      padding: 8px 8px 7px;
    }
    .ps-bp-outfit-primary-image {
      height: 112px;
    }
    .ps-bp-outfit-primary > strong {
      font-size: 11px;
    }
    .ps-bp-outfit-primary > small {
      font-size: 10px;
    }
    .ps-bp-outfit-alternatives {
      gap: 7px;
      margin-top: 10px;
      overflow-y: auto;
    }
    .ps-bp-outfit-alternative {
      flex-basis: 76px;
      grid-template-columns: 64px minmax(0, 1fr);
      gap: 8px;
      padding: 4px 6px;
    }
    .ps-bp-outfit-alternative > span:first-child {
      width: 64px;
      height: 64px;
    }
    .ps-bp-outfit-alternative strong,
    .ps-bp-outfit-alternative small {
      font-size: 8px;
    }
    .ps-bp-outfit-summary {
      padding: 20px 17px 11px;
    }
    .ps-bp-outfit-look-head {
      flex-basis: 60px;
    }
    .ps-bp-outfit-look-title > strong {
      font-size: 13px;
    }
    .ps-bp-outfit-carousel-controls button {
      width: 25px;
      height: 25px;
    }
    .ps-bp-outfit-dots {
      gap: 7px;
      margin-top: 12px;
    }
    .ps-bp-outfit-dots button {
      width: 6px;
      height: 6px;
      flex-basis: 6px;
    }
    .ps-bp-outfit-summary-body {
      padding: 14px 0 8px;
    }
    .ps-bp-outfit-summary-body h3 {
      margin-bottom: 8px;
      font-size: 14px;
    }
    .ps-bp-outfit-summary-list {
      gap: 6px;
      overflow-y: auto;
    }
    .ps-bp-outfit-summary-list article {
      flex-basis: 49px;
      grid-template-columns: 43px minmax(0, 1fr);
      gap: 8px;
    }
    .ps-bp-outfit-summary-image {
      width: 43px;
      height: 43px;
    }
    .ps-bp-outfit-summary-copy {
      gap: 3px;
    }
    .ps-bp-outfit-summary-copy strong {
      font-size: 10px;
      -webkit-line-clamp: 1;
    }
    .ps-bp-outfit-summary-copy small {
      font-size: 9px;
    }
    .ps-bp-outfit-summary-pinned {
      bottom: 4px;
      font-size: 8px;
    }
    .ps-bp-outfit-summary-footer {
      flex-basis: 104px;
      padding-top: 10px;
    }
    .ps-bp-outfit-total > strong {
      font-size: 13px;
    }
    .ps-bp-outfit-total > span {
      font-size: 10px;
    }
    .ps-bp-fitting-cta,
    .ps-bp-outfit-summary-footer .ps-bp-fitting-cta {
      height: 38px !important;
      min-height: 38px !important;
      margin-top: 11px !important;
      font-size: 12px !important;
    }
    .ps-bp-outfit-summary-footer > small {
      margin-top: 5px;
      font-size: 8px;
    }
  }

  @media (max-height: 700px) and (min-width: 861px) {
    .ps-tryon-modal:has(.ps-bp-fitting-room) > .ps-tryon-body,
    .ps-tryon-modal-wide:has(.ps-bp-fitting-room) > .ps-tryon-body,
    .ps-bp-fitting-room {
      overflow-y: auto !important;
    }
    .ps-bp-fitting-shell,
    .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-shell {
      height: auto;
      min-height: 610px;
      overflow: visible;
    }
  }

  /* Mix & Match selected-piece sizing — three-column desktop detail */
  .ps-tryon-modal:has(.ps-outfit-piece-detail-layout),
  .ps-tryon-modal-wide:has(.ps-outfit-piece-detail-layout) {
    width: min(1460px, 94vw) !important;
    max-width: min(1460px, 94vw) !important;
    height: min(900px, 92dvh) !important;
    max-height: min(900px, 92dvh) !important;
    border-radius: 18px !important;
    overflow: hidden !important;
  }
  .ps-tryon-modal:has(.ps-outfit-piece-detail-layout) > .ps-tryon-header-minimal,
  .ps-tryon-modal-wide:has(.ps-outfit-piece-detail-layout) > .ps-tryon-header-minimal {
    flex: 0 0 64px !important;
    min-height: 64px !important;
    height: 64px !important;
    padding: 0 28px !important;
  }
  .ps-tryon-modal:has(.ps-outfit-piece-detail-layout) > .ps-tryon-body,
  .ps-tryon-modal-wide:has(.ps-outfit-piece-detail-layout) > .ps-tryon-body {
    padding: 20px 28px 24px !important;
    overflow: hidden !important;
  }
  .ps-outfit-piece-detail-layout {
    display: grid !important;
    grid-template-columns: minmax(280px, 30fr) minmax(455px, 44fr) minmax(245px, 26fr);
    align-items: stretch !important;
    gap: clamp(18px, 1.55vw, 28px) !important;
    height: 100% !important;
    min-height: 0 !important;
    overflow: hidden !important;
  }
  .ps-outfit-piece-detail-layout .ps-tryon-v2-media-stack {
    width: auto;
    min-width: 0;
    height: 100%;
    min-height: 0;
    gap: 0;
    border: 1px solid rgba(15,23,42,0.1);
    border-radius: 11px;
    background: #fff;
    overflow: hidden;
  }
  .ps-outfit-piece-detail-layout .ps-tryon-v2-media-stack .ps-tryon-v2-bg {
    flex: 1 1 auto;
    min-height: 0;
    border-radius: 0;
    background: #f2eee8;
  }
  .ps-outfit-piece-detail-layout .ps-tryon-v2-bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
  }
  .ps-outfit-piece-photo-note {
    flex: 0 0 54px;
    display: flex;
    align-items: center;
    padding: 0 22px;
    border-top: 1px solid rgba(15,23,42,0.08);
    color: #6f7785;
    background: #fff;
    font-size: clamp(11px, 0.72vw, 13px);
    line-height: 1.35;
  }
  .ps-outfit-piece-detail-layout > .ps-tryon-v2-panel {
    height: 100%;
    min-height: 0;
    padding: 0;
    justify-content: stretch;
    border: 1px solid rgba(15,23,42,0.1);
    border-radius: 11px;
    background: #fff;
    overflow: hidden;
  }
  .ps-outfit-size-detail {
    width: 100%;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
  }
  .ps-outfit-size-detail-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: clamp(24px, 1.85vw, 34px) clamp(24px, 2vw, 36px) 20px;
    scrollbar-width: thin;
    scrollbar-color: rgba(15,23,42,0.14) transparent;
  }
  .ps-outfit-size-eyebrow {
    display: block;
    color: #2154ef;
    font-size: clamp(12px, 0.84vw, 15px);
    line-height: 1;
    font-weight: 780;
    letter-spacing: 0.13em;
    text-transform: uppercase;
  }
  .ps-outfit-size-recommendation {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: clamp(112px, 9vw, 144px);
    margin-top: clamp(14px, 1vw, 18px);
    padding: 18px;
    border: 1px solid rgba(15,23,42,0.11);
    border-radius: 11px;
    background: #fff;
  }
  .ps-outfit-size-value {
    display: inline-flex;
    align-items: baseline;
    gap: clamp(12px, 1vw, 18px);
    color: #111;
  }
  .ps-outfit-size-value span {
    font-size: clamp(25px, 2vw, 34px);
    line-height: 1;
    font-weight: 760;
    letter-spacing: -0.035em;
  }
  .ps-outfit-size-value strong {
    color: #2154ef;
    font-size: clamp(44px, 4.2vw, 68px);
    line-height: 0.95;
    font-weight: 760;
    letter-spacing: -0.055em;
  }
  .ps-outfit-size-recommendation p {
    display: flex;
    align-items: center;
    gap: 9px;
    margin: 17px 0 0;
    color: #4f5663;
    font-size: clamp(12px, 0.86vw, 15px);
    font-weight: 500;
  }
  .ps-outfit-size-check {
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 18px;
    border-radius: 50%;
    background: #19b96b;
    color: #fff;
  }
  .ps-outfit-size-picker-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: clamp(24px, 1.9vw, 34px);
  }
  .ps-outfit-size-picker-head > span,
  .ps-outfit-fit-section > h3 {
    margin: 0;
    color: #3d434c;
    font-size: clamp(11px, 0.73vw, 13px);
    line-height: 1.1;
    font-weight: 720;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .ps-outfit-size-units {
    display: inline-flex;
    align-items: center;
    padding: 2px;
    border-radius: 999px;
    background: #f1f2f4;
  }
  .ps-outfit-size-units button {
    min-width: 34px;
    height: 28px;
    padding: 0 9px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: #777f8b;
    font: 700 11px/1 inherit;
    text-transform: uppercase;
    cursor: pointer;
  }
  .ps-outfit-size-units button.ps-active {
    background: #2154ef;
    color: #fff;
    box-shadow: 0 4px 12px rgba(33,84,239,0.22);
  }
  .ps-outfit-size-options {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: clamp(9px, 0.75vw, 13px);
    margin-top: 16px;
  }
  .ps-outfit-size-options button {
    height: clamp(50px, 4vw, 64px);
    padding: 0 8px;
    border: 1px solid rgba(15,23,42,0.13);
    border-radius: 9px;
    background: #fff;
    color: #343943;
    font: 700 clamp(15px, 1.08vw, 19px)/1 inherit;
    cursor: pointer;
    transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
  }
  .ps-outfit-size-options button:hover {
    border-color: rgba(33,84,239,0.55);
  }
  .ps-outfit-size-options button.ps-active {
    border-color: #2154ef;
    background: #2154ef;
    color: #fff;
    box-shadow: 0 10px 20px -14px rgba(33,84,239,0.85);
  }
  .ps-outfit-fit-section {
    margin-top: clamp(26px, 2vw, 36px);
  }
  .ps-outfit-fit-table-wrap {
    margin-top: 12px;
    border: 1px solid rgba(15,23,42,0.1);
    border-radius: 9px;
    overflow: hidden;
  }
  .ps-outfit-fit-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  .ps-outfit-fit-table th {
    padding: 11px 14px;
    border-bottom: 1px solid rgba(15,23,42,0.08);
    background: #fff;
    color: #565e6b;
    font-size: clamp(9px, 0.58vw, 10px);
    line-height: 1.2;
    font-weight: 720;
    letter-spacing: 0.1em;
    text-align: left;
    text-transform: uppercase;
  }
  .ps-outfit-fit-table th:last-child,
  .ps-outfit-fit-table td:last-child {
    text-align: right;
  }
  .ps-outfit-fit-table td {
    padding: 13px 14px;
    border-bottom: 1px solid rgba(15,23,42,0.07);
    color: #5f6672;
    font-size: clamp(11px, 0.76vw, 13px);
    line-height: 1.2;
    vertical-align: middle;
  }
  .ps-outfit-fit-table tr:last-child td {
    border-bottom: 0;
  }
  .ps-outfit-fit-table td:first-child {
    color: #22262d;
    font-weight: 650;
  }
  .ps-outfit-fit-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    padding: 4px 10px;
    border-radius: 999px;
    color: #2154ef;
    background: rgba(33,84,239,0.08);
    font-size: clamp(9px, 0.62vw, 11px);
    font-weight: 650;
    white-space: nowrap;
  }
  .ps-outfit-fit-pill.ps-good {
    color: #079657;
    background: rgba(25,185,107,0.1);
  }
  .ps-outfit-fit-pill.ps-tight {
    color: #c33b3b;
    background: rgba(195,59,59,0.09);
  }
  .ps-outfit-fit-pill.ps-loose {
    color: #b56a16;
    background: rgba(181,106,22,0.1);
  }
  .ps-outfit-size-note {
    display: grid;
    grid-template-columns: 22px minmax(0, 1fr);
    gap: 10px;
    align-items: start;
    margin-top: 18px;
    padding: 14px 16px;
    border: 1px solid rgba(33,84,239,0.13);
    border-radius: 9px;
    background: rgba(33,84,239,0.025);
    color: #2154ef;
  }
  .ps-outfit-size-note > span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-top: 1px;
  }
  .ps-outfit-size-note p {
    margin: 0;
    color: #2f3540;
    font-size: clamp(11px, 0.75vw, 13px);
    line-height: 1.45;
  }
  .ps-outfit-size-footer {
    flex: 0 0 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 10px 0 0;
    margin: 0 clamp(24px, 2vw, 36px) 8px;
    border-top: 1px solid rgba(15,23,42,0.08);
  }
  .ps-outfit-size-footer > .ps-tryon-v2-action-group {
    flex: 0 1 220px;
    min-width: 0;
    margin-left: auto;
  }
  .ps-outfit-size-footer .ps-tryon-v2-cta {
    min-height: 52px;
    border-radius: 9px;
    font-size: 12px;
    letter-spacing: 0.09em;
    text-transform: uppercase;
  }
  .ps-outfit-product-panel {
    width: auto;
    min-width: 0;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: clamp(22px, 1.7vw, 30px);
    border: 1px solid rgba(15,23,42,0.1);
    border-radius: 11px;
    background: linear-gradient(180deg, #fbfbfc 0%, #f7f8fa 100%);
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .ps-outfit-product-image-wrap {
    flex: 0 0 clamp(220px, 22vw, 320px);
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 -8px;
    border-radius: 10px;
    background: rgba(255,255,255,0.72);
    overflow: hidden;
  }
  .ps-outfit-product-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
    object-position: center;
    mix-blend-mode: normal;
  }
  .ps-outfit-product-copy {
    padding: clamp(20px, 1.5vw, 26px) 0;
    border-bottom: 1px solid rgba(15,23,42,0.1);
  }
  .ps-outfit-product-color {
    display: block;
    margin-bottom: 8px;
    color: #697180;
    font-size: clamp(10px, 0.66vw, 12px);
    line-height: 1;
    font-weight: 680;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .ps-outfit-product-copy h3 {
    margin: 0;
    color: #13161b;
    font-size: clamp(21px, 1.55vw, 27px);
    line-height: 1.08;
    font-weight: 760;
    letter-spacing: -0.025em;
  }
  .ps-outfit-product-copy p {
    margin: 9px 0 0;
    color: #727b89;
    font-size: clamp(11px, 0.76vw, 13px);
    line-height: 1.45;
  }
  .ps-outfit-product-copy a {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 17px;
    color: #2154ef;
    font-size: clamp(12px, 0.8vw, 14px);
    line-height: 1;
    font-weight: 680;
    text-decoration: none;
  }
  .ps-outfit-product-copy a:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  .ps-outfit-product-link-unavailable {
    display: block;
    margin-top: 17px;
    color: #9aa1ac;
    font-size: 12px;
  }
  .ps-outfit-product-details {
    display: grid;
    gap: 16px;
    margin: 22px 0 0;
  }
  .ps-outfit-product-details > div {
    display: grid;
    grid-template-columns: minmax(72px, auto) minmax(0, 1fr);
    gap: 12px;
    align-items: baseline;
  }
  .ps-outfit-product-details dt,
  .ps-outfit-product-details dd {
    margin: 0;
    font-size: clamp(10px, 0.72vw, 12px);
    line-height: 1.35;
  }
  .ps-outfit-product-details dt {
    color: #59616d;
    font-weight: 620;
  }
  .ps-outfit-product-details dd {
    color: #7b8390;
    text-align: right;
    overflow-wrap: anywhere;
  }

  @media (max-width: 1120px) and (min-width: 861px) {
    .ps-outfit-piece-detail-layout {
      grid-template-columns: minmax(235px, 28fr) minmax(390px, 46fr) minmax(210px, 26fr);
      gap: 14px !important;
    }
    .ps-outfit-size-detail-scroll {
      padding-inline: 20px;
    }
    .ps-outfit-product-panel {
      padding: 18px;
    }
    .ps-outfit-product-image-wrap {
      flex-basis: 210px;
    }
  }

  @media (max-width: 860px) {
    .ps-tryon-modal:has(.ps-bp-fitting-room),
    .ps-tryon-modal-wide:has(.ps-bp-fitting-room),
    .ps-tryon-modal:has(.ps-bp-fitting-room .ps-bp-style-loader),
    .ps-tryon-modal-wide:has(.ps-bp-fitting-room .ps-bp-style-loader) {
      width: 100vw !important;
      max-width: 100vw !important;
      height: 100dvh !important;
      max-height: 100dvh !important;
      border-radius: 0 !important;
    }
    .ps-bp-fitting-room {
      overflow-y: auto !important;
    }
    .ps-bp-fitting-shell,
    .ps-bp-fitting-room:has(.ps-bp-style-loader) .ps-bp-fitting-shell {
      height: auto;
      min-height: 100%;
      padding: 18px 14px 28px;
      overflow: visible;
    }
    .ps-bp-fitting-topbar {
      flex-basis: 76px;
    }
    .ps-bp-fitting-topbar h2 {
      font-size: 26px;
    }
    .ps-bp-outfit-grid {
      display: flex;
      flex-direction: column;
      gap: 16px;
      overflow: visible;
    }
    .ps-bp-outfit-preview {
      flex: 0 0 430px;
      min-height: 430px;
      margin-inline: 14px;
    }
    .ps-bp-outfit-anchor {
      left: -14px;
    }
    .ps-bp-outfit-preview-note {
      bottom: 10px;
      padding: 7px 10px;
      border-radius: 999px;
      background: rgba(255,255,255,0.9);
    }
    .ps-bp-outfit-builder {
      flex: 0 0 520px;
      min-height: 520px;
    }
    .ps-bp-outfit-column {
      flex: 0 0 190px;
    }
    .ps-bp-outfit-primary {
      flex-basis: 205px;
    }
    .ps-bp-outfit-summary {
      flex: 0 0 520px;
      min-height: 520px;
    }
    .ps-bp-outfit-loading-panel {
      flex: 0 0 360px;
      min-height: 360px;
    }
  }
`;
